module.exports = [
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Baby Girl",
		"nl": "Unknown",
		"url": "https://www.findagrave.com/memorial/155270310/baby_girl-unknown",
		"id": 155270310,
		"lng": -77.38704686,
		"lat": 37.53784583,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 30,
		"by": 1963,
		"bd": 31,
		"bm": 3,
		"nm": "",
		"nf": "Lola",
		"nl": "Abernathy",
		"url": "https://findagrave.com/memorial/169041371",
		"id": 169041371,
		"lng": -77.386152508,
		"lat": 37.537460999,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 18,
		"by": 1964,
		"bd": 20,
		"bm": 12,
		"nm": "",
		"nf": "Darrell",
		"nl": "Adams",
		"url": "https://findagrave.com/memorial/142796944",
		"id": 142796944,
		"lng": -77.386068908,
		"lat": 37.537454709,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 8,
		"dd": 15,
		"by": 1920,
		"bd": 5,
		"bm": 6,
		"nm": "Lobo",
		"nf": "Robert",
		"nl": "Adams",
		"url": "https://findagrave.com/memorial/185378955",
		"id": 185378955,
		"lng": -77.3874743,
		"lat": 37.537668402,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 9,
		"dd": 28,
		"by": 1884,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Adams",
		"url": "https://findagrave.com/memorial/154283374",
		"id": 154283374,
		"lng": -77.386854074,
		"lat": 37.535531612,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 1,
		"dd": 15,
		"by": 1880,
		"bd": 25,
		"bm": 5,
		"nm": "J.",
		"nf": "William",
		"nl": "Adams",
		"url": "https://findagrave.com/memorial/114466920",
		"id": 114466920,
		"lng": -77.385820357,
		"lat": 37.536833578,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 28,
		"by": 1911,
		"bd": 18,
		"bm": 5,
		"nm": "Simms",
		"nf": "Estelle",
		"nl": "Aikens",
		"url": "https://findagrave.com/memorial/155506511",
		"id": 155506511,
		"lng": -77.38736667,
		"lat": 37.537384737,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 5,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matt",
		"nl": "Alberts",
		"url": "https://findagrave.com/memorial/188810577",
		"id": 188810577,
		"lng": -77.38800633,
		"lat": 37.53702129,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 1,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Jane",
		"nf": "Mary",
		"nl": "Albright",
		"url": "https://findagrave.com/memorial/154264550",
		"id": 154264550,
		"lng": -77.387250785,
		"lat": 37.535530537,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 1,
		"dd": 22,
		"by": 1896,
		"bd": 7,
		"bm": 7,
		"nm": "Emily",
		"nf": "Alease",
		"nl": "Alexander",
		"url": "https://findagrave.com/memorial/154043010",
		"id": 154043010,
		"lng": -77.386712322,
		"lat": 37.537518334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 9,
		"dd": 8,
		"by": 1885,
		"bd": 23,
		"bm": 2,
		"nm": "",
		"nf": "Artress",
		"nl": "Alexander",
		"url": "https://findagrave.com/memorial/144064095",
		"id": 144064095,
		"lng": -77.385975648,
		"lat": 37.537194428,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 5,
		"dd": 27,
		"by": 1916,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "James",
		"nl": "Alford",
		"url": "https://findagrave.com/memorial/146682148",
		"id": 146682148,
		"lng": -77.386173332,
		"lat": 37.535749862,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 3,
		"dd": 20,
		"by": 1880,
		"bd": 23,
		"bm": 9,
		"nm": "M.",
		"nf": "Alberta",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/128096187",
		"id": 128096187,
		"lng": -77.385617374,
		"lat": 37.537021978,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 7,
		"dd": 10,
		"by": 1912,
		"bd": 12,
		"bm": 4,
		"nm": "",
		"nf": "Albertha",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/173471630",
		"id": 173471630,
		"lng": -77.387303081,
		"lat": 37.537097442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 9,
		"dd": 13,
		"by": 1898,
		"bd": 20,
		"bm": 9,
		"nm": "Mitchell",
		"nf": "Alvin",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/168676299",
		"id": 168676299,
		"lng": -77.386309719,
		"lat": 37.537085595,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 11,
		"dd": 12,
		"by": 1900,
		"bd": 5,
		"bm": 6,
		"nm": "A.",
		"nf": "Andrew",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/173773043",
		"id": 173773043,
		"lng": -77.38715277,
		"lat": 37.5371808,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 8,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/154283390",
		"id": 154283390,
		"lng": -77.387000669,
		"lat": 37.535458599,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ethel",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/170839007",
		"id": 170839007,
		"lng": -77.38650962,
		"lat": 37.53715816,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 11,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/130967985",
		"id": 130967985,
		"lng": -77.38564077,
		"lat": 37.53722248,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 2,
		"dd": 24,
		"by": 1890,
		"bd": 3,
		"bm": 4,
		"nm": "H.",
		"nf": "Flemming",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/155506520",
		"id": 155506520,
		"lng": -77.38734121,
		"lat": 37.5374229,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 12,
		"dd": 12,
		"by": 1910,
		"bd": 10,
		"bm": 7,
		"nm": "",
		"nf": "Fred",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/150078571",
		"id": 150078571,
		"lng": -77.38702856,
		"lat": 37.53708191,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 5,
		"dd": 20,
		"by": 1890,
		"bd": 25,
		"bm": 12,
		"nm": "Lee H.",
		"nf": "Ida",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/155506529",
		"id": 155506529,
		"lng": -77.38734052,
		"lat": 37.53743073,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 5,
		"dd": 25,
		"by": 1913,
		"bd": 8,
		"bm": 6,
		"nm": "Clayton",
		"nf": "James",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/149201559",
		"id": 149201559,
		"lng": -77.38627182,
		"lat": 37.5352661,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joshua",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/161171179",
		"id": 161171179,
		"lng": -77.38651589,
		"lat": 37.53701817,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 8,
		"by": 1907,
		"bd": 2,
		"bm": 1,
		"nm": "",
		"nf": "Joshua",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/156612745",
		"id": 156612745,
		"lng": -77.38638818,
		"lat": 37.53715143,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 8,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lena",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/154283397",
		"id": 154283397,
		"lng": -77.38700275,
		"lat": 37.53545274,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 5,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Leola",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/169397068",
		"id": 169397068,
		"lng": -77.38659257,
		"lat": 37.53686137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 11,
		"dd": 30,
		"by": 1902,
		"bd": 17,
		"bm": 11,
		"nm": "",
		"nf": "Louise",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/11125428",
		"id": 11125428,
		"lng": -77.38671742,
		"lat": 37.53691496,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Jane",
		"nf": "Mary",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/160921611",
		"id": 160921611,
		"lng": -77.38670395,
		"lat": 37.53671223,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 11,
		"dd": 24,
		"by": 1930,
		"bd": 6,
		"bm": 2,
		"nm": "",
		"nf": "Mildred",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/186917529",
		"id": 186917529,
		"lng": -77.38748132,
		"lat": 37.53694017,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 31,
		"by": 1880,
		"bd": 31,
		"bm": 10,
		"nm": "",
		"nf": "Missouri",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/163904711",
		"id": 163904711,
		"lng": -77.3868874,
		"lat": 37.53682034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/166485803",
		"id": 166485803,
		"lng": -77.38781943,
		"lat": 37.53712426,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 7,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/154259086",
		"id": 154259086,
		"lng": -77.38647383,
		"lat": 37.53559144,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 1,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sophia",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/166104941",
		"id": 166104941,
		"lng": -77.38741381,
		"lat": 37.53652972,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 31,
		"by": 1921,
		"bd": 16,
		"bm": 4,
		"nm": "Deborah",
		"nf": "Susie",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/138561608",
		"id": 138561608,
		"lng": -77.38630235,
		"lat": 37.53664748,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 3,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Washington",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/130691678",
		"id": 130691678,
		"lng": -77.38564209,
		"lat": 37.5372126,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 4,
		"dd": 1,
		"by": 1885,
		"bd": 30,
		"bm": 6,
		"nm": "E.",
		"nf": "Arthur",
		"nl": "Alston",
		"url": "https://findagrave.com/memorial/155979473",
		"id": 155979473,
		"lng": -77.38711659,
		"lat": 37.53548975,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 2,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Major",
		"nl": "Alston",
		"url": "https://findagrave.com/memorial/185357147",
		"id": 185357147,
		"lng": -77.38737713,
		"lat": 37.536761,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 29,
		"by": 1904,
		"bd": 16,
		"bm": 9,
		"nm": "",
		"nf": "Mary",
		"nl": "Alston",
		"url": "https://findagrave.com/memorial/138561615",
		"id": 138561615,
		"lng": -77.38625432,
		"lat": 37.53712471,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 12,
		"dd": 3,
		"by": 1898,
		"bd": 12,
		"bm": 12,
		"nm": "",
		"nf": "Charles",
		"nl": "Ampey",
		"url": "https://findagrave.com/memorial/132641032",
		"id": 132641032,
		"lng": -77.38576418,
		"lat": 37.53725065,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1999,
		"dm": 4,
		"dd": 18,
		"by": 1929,
		"bd": 24,
		"bm": 6,
		"nm": "",
		"nf": "Emily",
		"nl": "Ampey",
		"url": "https://findagrave.com/memorial/76587674",
		"id": 76587674,
		"lng": -77.38630228,
		"lat": 37.53720626,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 1,
		"dd": 9,
		"by": 1940,
		"bd": 20,
		"bm": 9,
		"nm": "Charles",
		"nf": "Irving",
		"nl": "Ampey",
		"url": "https://findagrave.com/memorial/176097671",
		"id": 176097671,
		"lng": -77.3873405,
		"lat": 37.53691827,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 9,
		"dd": 1,
		"by": 1889,
		"bd": 12,
		"bm": 12,
		"nm": "",
		"nf": "Georgianna",
		"nl": "Ampy",
		"url": "https://findagrave.com/memorial/157897043",
		"id": 157897043,
		"lng": -77.38676425,
		"lat": 37.53753151,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 27,
		"by": 1906,
		"bd": 7,
		"bm": 7,
		"nm": "",
		"nf": "Annie",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/185246554",
		"id": 185246554,
		"lng": -77.38724838,
		"lat": 37.5373334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 4,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Augustus",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/155782155",
		"id": 155782155,
		"lng": -77.38718282,
		"lat": 37.53561478,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 7,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Betty",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/155761138",
		"id": 155761138,
		"lng": -77.38788343,
		"lat": 37.53709855,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 6,
		"dd": 17,
		"by": 1891,
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Clarence",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/186818159",
		"id": 186818159,
		"lng": -77.38743342,
		"lat": 37.53696405,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 1,
		"dd": 18,
		"by": 1905,
		"bd": 13,
		"bm": 10,
		"nm": "Alice",
		"nf": "Elizabeth",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/159661364",
		"id": 159661364,
		"lng": -77.38617335,
		"lat": 37.53738936,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 12,
		"dd": 30,
		"by": 1964,
		"bd": 19,
		"bm": 4,
		"nm": "",
		"nf": "Felecia",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/159661367",
		"id": 159661367,
		"lng": -77.38614304,
		"lat": 37.53733202,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 6,
		"dd": 7,
		"by": "",
		"bd": 27,
		"bm": 7,
		"nm": "",
		"nf": "Helen",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/166117080",
		"id": 166117080,
		"lng": -77.38713036,
		"lat": 37.53679647,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 3,
		"by": 1914,
		"bd": 28,
		"bm": 5,
		"nm": "",
		"nf": "James",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/145989312",
		"id": 145989312,
		"lng": -77.38644618,
		"lat": 37.53662879,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 23,
		"by": 1889,
		"bd": 10,
		"bm": 1,
		"nm": "J.",
		"nf": "John",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/185151317",
		"id": 185151317,
		"lng": -77.38698254,
		"lat": 37.53759098,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 7,
		"dd": 31,
		"by": 1852,
		"bd": "",
		"bm": 4,
		"nm": "T.",
		"nf": "John",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/149165811",
		"id": 149165811,
		"lng": -77.3860733,
		"lat": 37.53579743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 10,
		"dd": 20,
		"by": 1901,
		"bd": 8,
		"bm": 3,
		"nm": "",
		"nf": "Joseph",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/150493579",
		"id": 150493579,
		"lng": -77.38641609,
		"lat": 37.53602378,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 9,
		"by": 1935,
		"bd": 13,
		"bm": 6,
		"nm": "",
		"nf": "June",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/141798885",
		"id": 141798885,
		"lng": -77.3865886,
		"lat": 37.53722798,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 1,
		"dd": 20,
		"by": 1871,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillie",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/148748100",
		"id": 148748100,
		"lng": -77.38785109,
		"lat": 37.53718468,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 2,
		"dd": 2,
		"by": 1894,
		"bd": 5,
		"bm": 7,
		"nm": "",
		"nf": "Lloyd",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/160921637",
		"id": 160921637,
		"lng": -77.38689756,
		"lat": 37.53673152,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 25,
		"by": 1900,
		"bd": 20,
		"bm": 7,
		"nm": "",
		"nf": "Manuel",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/142525992",
		"id": 142525992,
		"lng": -77.38657298,
		"lat": 37.53705205,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 7,
		"dd": 12,
		"by": 1879,
		"bd": 1,
		"bm": 5,
		"nm": "",
		"nf": "Mary",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/187370085",
		"id": 187370085,
		"lng": -77.38741958,
		"lat": 37.53746467,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 4,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Mary",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/175611691",
		"id": 175611691,
		"lng": -77.38764801,
		"lat": 37.53708527,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 3,
		"dd": 10,
		"by": 1900,
		"bd": 1,
		"bm": 8,
		"nm": "",
		"nf": "Mary",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/177354152",
		"id": 177354152,
		"lng": -77.38631575,
		"lat": 37.53743338,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 20,
		"by": 1914,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Matt",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/158889108",
		"id": 158889108,
		"lng": -77.3872501,
		"lat": 37.53751837,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 10,
		"by": 1892,
		"bd": 27,
		"bm": 11,
		"nm": "R.",
		"nf": "Melvin",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/166485972",
		"id": 166485972,
		"lng": -77.38783059,
		"lat": 37.53714395,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 6,
		"dd": 27,
		"by": 1860,
		"bd": "",
		"bm": 5,
		"nm": "B.",
		"nf": "Sydney",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/149165815",
		"id": 149165815,
		"lng": -77.38606602,
		"lat": 37.53580241,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 2,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "William",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/126772032",
		"id": 126772032,
		"lng": -77.38786004,
		"lat": 37.53714408,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 12,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Robert",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/192407019",
		"id": 192407019,
		"lng": -77.38791943,
		"lat": 37.53686916,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 20,
		"by": 1902,
		"bd": 16,
		"bm": 3,
		"nm": "",
		"nf": "Gilbert",
		"nl": "Andrews",
		"url": "https://findagrave.com/memorial/176060580",
		"id": 176060580,
		"lng": -77.38746026,
		"lat": 37.53731666,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 15,
		"by": 1910,
		"bd": 5,
		"bm": 6,
		"nm": "",
		"nf": "Percy",
		"nl": "Anthony",
		"url": "https://findagrave.com/memorial/173314347",
		"id": 173314347,
		"lng": -77.38710767,
		"lat": 37.53725475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Archer",
		"url": "https://findagrave.com/memorial/146187826",
		"id": 146187826,
		"lng": -77.38641016,
		"lat": 37.53670082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 7,
		"dd": 27,
		"by": 1882,
		"bd": 16,
		"bm": 8,
		"nm": "",
		"nf": "Mary",
		"nl": "Archer",
		"url": "https://findagrave.com/memorial/161636470",
		"id": 161636470,
		"lng": -77.38685589,
		"lat": 37.53743117,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 29,
		"by": 1940,
		"bd": 25,
		"bm": 10,
		"nm": "Delores",
		"nf": "Eva",
		"nl": "Arnette",
		"url": "https://findagrave.com/memorial/142438621",
		"id": 142438621,
		"lng": -77.38568456,
		"lat": 37.53730474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 11,
		"by": 1937,
		"bd": 10,
		"bm": 11,
		"nm": "",
		"nf": "Victoria",
		"nl": "Arrington",
		"url": "https://findagrave.com/memorial/145167317",
		"id": 145167317,
		"lng": -77.38634087,
		"lat": 37.5371575,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 6,
		"dd": 28,
		"by": 1920,
		"bd": 25,
		"bm": 8,
		"nm": "Raymond",
		"nf": "James",
		"nl": "Ashby",
		"url": "https://findagrave.com/memorial/172297786",
		"id": 172297786,
		"lng": -77.38629476,
		"lat": 37.53529717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 19,
		"by": 1895,
		"bd": 5,
		"bm": 7,
		"nm": "",
		"nf": "Lottie",
		"nl": "Ashley",
		"url": "https://findagrave.com/memorial/171733155",
		"id": 171733155,
		"lng": -77.38692512,
		"lat": 37.53724435,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Abbie",
		"nl": "Athey",
		"url": "https://findagrave.com/memorial/175696515",
		"id": 175696515,
		"lng": -77.38628828,
		"lat": 37.53681136,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 4,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Hallie",
		"nl": "Atkinson",
		"url": "https://findagrave.com/memorial/76605558",
		"id": 76605558,
		"lng": -77.38552523,
		"lat": 37.53725019,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "William",
		"nl": "Atkinson",
		"url": "https://findagrave.com/memorial/38456780",
		"id": 38456780,
		"lng": -77.38547405,
		"lat": 37.53724834,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 2,
		"dd": 6,
		"by": 1887,
		"bd": 27,
		"bm": 10,
		"nm": "",
		"nf": "Frances",
		"nl": "Austin",
		"url": "https://findagrave.com/memorial/169713729",
		"id": 169713729,
		"lng": -77.38669879,
		"lat": 37.53696597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 5,
		"dd": 17,
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kate",
		"nl": "Austin",
		"url": "https://findagrave.com/memorial/145325092",
		"id": 145325092,
		"lng": -77.385852,
		"lat": 37.53707617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 17,
		"by": 1882,
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Sallie",
		"nl": "Austin",
		"url": "https://findagrave.com/memorial/154283404",
		"id": 154283404,
		"lng": -77.38692811,
		"lat": 37.5354951,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 12,
		"dd": 8,
		"by": 1898,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Ada",
		"nl": "Averett",
		"url": "https://findagrave.com/memorial/155506552",
		"id": 155506552,
		"lng": -77.38746267,
		"lat": 37.53751453,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 5,
		"dd": 9,
		"by": 1863,
		"bd": "",
		"bm": 5,
		"nm": "P.",
		"nf": "Ellen",
		"nl": "Bacchus",
		"url": "https://findagrave.com/memorial/143631812",
		"id": 143631812,
		"lng": -77.38619154,
		"lat": 37.53566247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 8,
		"dd": 21,
		"by": 1909,
		"bd": 22,
		"bm": 3,
		"nm": "",
		"nf": "David",
		"nl": "Bagby",
		"url": "https://findagrave.com/memorial/141446339",
		"id": 141446339,
		"lng": -77.38730132,
		"lat": 37.53776046,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 1,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Griffin",
		"nl": "Bagby",
		"url": "https://findagrave.com/memorial/181401036",
		"id": 181401036,
		"lng": -77.38797224,
		"lat": 37.53774761,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 5,
		"dd": 2,
		"by": 1909,
		"bd": 22,
		"bm": 3,
		"nm": "",
		"nf": "Jonathan",
		"nl": "Bagby",
		"url": "https://findagrave.com/memorial/142438629",
		"id": 142438629,
		"lng": -77.38728282,
		"lat": 37.53785175,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 4,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Martha",
		"nl": "Bagby",
		"url": "https://findagrave.com/memorial/143201742",
		"id": 143201742,
		"lng": -77.386355,
		"lat": 37.53536247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 12,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Anderson",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/150677860",
		"id": 150677860,
		"lng": -77.38628134,
		"lat": 37.53569381,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 12,
		"by": 1958,
		"bd": 27,
		"bm": 11,
		"nm": "",
		"nf": "Carl",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/183909854",
		"id": 183909854,
		"lng": -77.3864159,
		"lat": 37.53671334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 2,
		"dd": 28,
		"by": 1853,
		"bd": 1,
		"bm": 12,
		"nm": "",
		"nf": "Charles",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/146187836",
		"id": 146187836,
		"lng": -77.38653226,
		"lat": 37.53576103,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 25,
		"by": 1882,
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Clarence",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/142797026",
		"id": 142797026,
		"lng": -77.38609388,
		"lat": 37.53737503,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 23,
		"by": 1917,
		"bd": 19,
		"bm": 1,
		"nm": "Aubrey",
		"nf": "George",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/137429999",
		"id": 137429999,
		"lng": -77.38586716,
		"lat": 37.53700924,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 28,
		"by": 1896,
		"bd": 10,
		"bm": 3,
		"nm": "",
		"nf": "Lucinda",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/127096005",
		"id": 127096005,
		"lng": -77.38633269,
		"lat": 37.53661136,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 4,
		"dd": 19,
		"by": 1921,
		"bd": 20,
		"bm": 5,
		"nm": "",
		"nf": "William",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/161636472",
		"id": 161636472,
		"lng": -77.38605719,
		"lat": 37.53632383,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 3,
		"dd": 10,
		"by": 1908,
		"bd": 1,
		"bm": 8,
		"nm": "R.",
		"nf": "William",
		"nl": "Bailey",
		"url": "https://findagrave.com/memorial/166075720",
		"id": 166075720,
		"lng": -77.38595788,
		"lat": 37.53629337,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 19,
		"by": 1916,
		"bd": "16 (not present in the FindaGrave Record)",
		"bm": 2,
		"nm": "Lee",
		"nf": "Cary",
		"nl": "Baize",
		"url": "https://findagrave.com/memorial/177286503",
		"id": 177286503,
		"lng": -77.38745146,
		"lat": 37.53726877,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 12,
		"dd": 30,
		"by": 1913,
		"bd": 6,
		"bm": 7,
		"nm": "",
		"nf": "Horace",
		"nl": "Baker",
		"url": "https://findagrave.com/memorial/181157220",
		"id": 181157220,
		"lng": -77.38802949,
		"lat": 37.53740608,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 1,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Royal",
		"nl": "Baker",
		"url": "https://findagrave.com/memorial/167872241",
		"id": 167872241,
		"lng": -77.38778631,
		"lat": 37.53704845,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 5,
		"dd": 31,
		"by": 1884,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Susie",
		"nl": "Baker",
		"url": "https://findagrave.com/memorial/136304101",
		"id": 136304101,
		"lng": -77.38600216,
		"lat": 37.53694609,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 11,
		"dd": 16,
		"by": 1890,
		"bd": 29,
		"bm": 10,
		"nm": "Edward",
		"nf": "Alson",
		"nl": "Baldwin",
		"url": "https://findagrave.com/memorial/188056080",
		"id": 188056080,
		"lng": -77.38649411,
		"lat": 37.53573501,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 8,
		"dd": 27,
		"by": 1900,
		"bd": 28,
		"bm": 6,
		"nm": "Scott",
		"nf": "Hester",
		"nl": "Ball",
		"url": "https://findagrave.com/memorial/141798896",
		"id": 141798896,
		"lng": -77.38670048,
		"lat": 37.53725993,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 12,
		"dd": 1,
		"by": 1895,
		"bd": 8,
		"bm": 7,
		"nm": "Leoniss",
		"nf": "Luther",
		"nl": "Ball",
		"url": "https://findagrave.com/memorial/129208520",
		"id": 129208520,
		"lng": -77.38596928,
		"lat": 37.53665982,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 22,
		"by": 1873,
		"bd": 8,
		"bm": 7,
		"nm": "",
		"nf": "Spencer",
		"nl": "Ball",
		"url": "https://findagrave.com/memorial/123850429",
		"id": 123850429,
		"lng": -77.38601518,
		"lat": 37.53667007,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 27,
		"by": 1916,
		"bd": 19,
		"bm": 5,
		"nm": "E.",
		"nf": "Sudie",
		"nl": "Ball",
		"url": "https://findagrave.com/memorial/146772734",
		"id": 146772734,
		"lng": -77.38632573,
		"lat": 37.5371314,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 12,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Bessie",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/155475128",
		"id": 155475128,
		"lng": -77.38731407,
		"lat": 37.53550834,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 10,
		"dd": 31,
		"by": 1898,
		"bd": 16,
		"bm": 3,
		"nm": "M.",
		"nf": "Dora",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/140290776",
		"id": 140290776,
		"lng": -77.38731949,
		"lat": 37.53547529,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 12,
		"dd": 25,
		"by": 1902,
		"bd": 5,
		"bm": 5,
		"nm": "L.",
		"nf": "John",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/155476025",
		"id": 155476025,
		"lng": -77.38731646,
		"lat": 37.53549571,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 9,
		"dd": 9,
		"by": 1877,
		"bd": 15,
		"bm": 6,
		"nm": "Lee",
		"nf": "John",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/144314796",
		"id": 144314796,
		"lng": -77.38731698,
		"lat": 37.53548628,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillie",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/145989328",
		"id": 145989328,
		"lng": -77.38656111,
		"lat": 37.53636889,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 3,
		"dd": 30,
		"by": 1911,
		"bd": 18,
		"bm": 2,
		"nm": "H.",
		"nf": "Lillie",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/145989355",
		"id": 145989355,
		"lng": -77.386565,
		"lat": 37.53635302,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 7,
		"by": 1916,
		"bd": 25,
		"bm": 7,
		"nm": "L.",
		"nf": "Reese",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/155476130",
		"id": 155476130,
		"lng": -77.38731031,
		"lat": 37.53551279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 8,
		"dd": 7,
		"by": 1905,
		"bd": 21,
		"bm": 2,
		"nm": "B.",
		"nf": "William",
		"nl": "Ballard",
		"url": "https://findagrave.com/memorial/155476528",
		"id": 155476528,
		"lng": -77.38731528,
		"lat": 37.53550447,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/146207037",
		"id": 146207037,
		"lng": -77.38587384,
		"lat": 37.53671536,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 30,
		"by": 1910,
		"bd": 11,
		"bm": 11,
		"nm": "Henry",
		"nf": "Charles",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/159661368",
		"id": 159661368,
		"lng": -77.38627279,
		"lat": 37.5374963,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 8,
		"dd": 9,
		"by": 1912,
		"bd": 5,
		"bm": 2,
		"nm": "",
		"nf": "Clara",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/163905083",
		"id": 163905083,
		"lng": -77.38688963,
		"lat": 37.53685307,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Della",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/139403081",
		"id": 139403081,
		"lng": -77.38774514,
		"lat": 37.53691511,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 5,
		"dd": 10,
		"by": 1901,
		"bd": 1,
		"bm": 6,
		"nm": "",
		"nf": "Ethel",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/158942408",
		"id": 158942408,
		"lng": -77.38740843,
		"lat": 37.53758288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 1,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/148747921",
		"id": 148747921,
		"lng": -77.38800376,
		"lat": 37.53711593,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 7,
		"dd": 4,
		"by": 1901,
		"bd": 14,
		"bm": 5,
		"nm": "",
		"nf": "Howard",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/160048558",
		"id": 160048558,
		"lng": -77.38649694,
		"lat": 37.53751082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 6,
		"dd": 28,
		"by": 1870,
		"bd": 15,
		"bm": 3,
		"nm": "L.",
		"nf": "John",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/163441495",
		"id": 163441495,
		"lng": -77.38672354,
		"lat": 37.53684282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 4,
		"dd": 17,
		"by": 1927,
		"bd": 28,
		"bm": 12,
		"nm": "M.",
		"nf": "Leroy",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/179569572",
		"id": 179569572,
		"lng": -77.38792101,
		"lat": 37.53779008,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Marvin",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/175822202",
		"id": 175822202,
		"lng": -77.3877,
		"lat": 37.53715109,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 1,
		"dd": 4,
		"by": 1866,
		"bd": "",
		"bm": 4,
		"nm": "",
		"nf": "Rebecca",
		"nl": "Hunter",
		"url": "https://findagrave.com/memorial/127568675",
		"id": 127568675,
		"lng": -77.38606074,
		"lat": 37.53709056,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 4,
		"dd": 2,
		"by": 1872,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Ruth",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/163441497",
		"id": 163441497,
		"lng": -77.38675516,
		"lat": 37.53684493,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 7,
		"dd": 2,
		"by": 1898,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "Susie",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/187744243",
		"id": 187744243,
		"lng": -77.38772867,
		"lat": 37.53696413,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 9,
		"dd": 17,
		"by": 1896,
		"bd": 12,
		"bm": 9,
		"nm": "",
		"nf": "Warren",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/137835683",
		"id": 137835683,
		"lng": -77.38628599,
		"lat": 37.53707121,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 1,
		"dd": 2,
		"by": 1890,
		"bd": 18,
		"bm": 12,
		"nm": "Henry",
		"nf": "William",
		"nl": "Banks",
		"url": "https://findagrave.com/memorial/157757348",
		"id": 157757348,
		"lng": -77.38683088,
		"lat": 37.53751322,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 15,
		"by": 1897,
		"bd": 27,
		"bm": 10,
		"nm": "",
		"nf": "Beatrice",
		"nl": "Barber",
		"url": "https://findagrave.com/memorial/149485469",
		"id": 149485469,
		"lng": -77.38640245,
		"lat": 37.53683285,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 11,
		"dd": 7,
		"by": 1874,
		"bd": 6,
		"bm": 2,
		"nm": "",
		"nf": "Benjamin",
		"nl": "Barksdale",
		"url": "https://findagrave.com/memorial/180916152",
		"id": 180916152,
		"lng": -77.38706268,
		"lat": 37.53707689,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 11,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jordan",
		"nl": "Barksdale",
		"url": "https://findagrave.com/memorial/177020494",
		"id": 177020494,
		"lng": -77.38790236,
		"lat": 37.53717345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 7,
		"dd": 4,
		"by": 1911,
		"bd": 12,
		"bm": 6,
		"nm": "Henry",
		"nf": "John",
		"nl": "Barley",
		"url": "https://findagrave.com/memorial/172411382",
		"id": 172411382,
		"lng": -77.38635817,
		"lat": 37.5352667,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 6,
		"by": 1915,
		"bd": 16,
		"bm": 12,
		"nm": "",
		"nf": "Ruth",
		"nl": "Barley",
		"url": "https://findagrave.com/memorial/173773053",
		"id": 173773053,
		"lng": -77.38719958,
		"lat": 37.53736708,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 9,
		"dd": 14,
		"by": 1886,
		"bd": 25,
		"bm": 6,
		"nm": "Daniel",
		"nf": "William",
		"nl": "Barley",
		"url": "https://findagrave.com/memorial/177772011",
		"id": 177772011,
		"lng": -77.38778727,
		"lat": 37.53745746,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 5,
		"by": 1865,
		"bd": 1,
		"bm": 6,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Barnes",
		"url": "https://findagrave.com/memorial/177154704",
		"id": 177154704,
		"lng": -77.38781444,
		"lat": 37.53742331,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 5,
		"dd": 28,
		"by": 1905,
		"bd": 31,
		"bm": 5,
		"nm": "",
		"nf": "Grace",
		"nl": "Barnes",
		"url": "https://findagrave.com/memorial/172031008",
		"id": 172031008,
		"lng": -77.38708486,
		"lat": 37.53747068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 5,
		"dd": 25,
		"by": 1898,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Joseph",
		"nl": "Barnes",
		"url": "https://findagrave.com/memorial/163611727",
		"id": 163611727,
		"lng": -77.38743941,
		"lat": 37.53748055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 12,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Laura",
		"nl": "Barnes",
		"url": "https://findagrave.com/memorial/154294633",
		"id": 154294633,
		"lng": -77.38699425,
		"lat": 37.53544592,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 11,
		"dd": 8,
		"by": 1863,
		"bd": 12,
		"bm": 8,
		"nm": "",
		"nf": "Parthenia",
		"nl": "Barnes",
		"url": "https://findagrave.com/memorial/126772043",
		"id": 126772043,
		"lng": -77.38671301,
		"lat": 37.5365639,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 8,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Barnes",
		"url": "https://findagrave.com/memorial/154294636",
		"id": 154294636,
		"lng": -77.3869897,
		"lat": 37.53544842,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 1,
		"dd": 29,
		"by": 1879,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Barnum",
		"url": "https://findagrave.com/memorial/177019007",
		"id": 177019007,
		"lng": -77.38785517,
		"lat": 37.5371546,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 30,
		"by": 1910,
		"bd": 1,
		"bm": 12,
		"nm": "M.",
		"nf": "Lucille",
		"nl": "Barton",
		"url": "https://findagrave.com/memorial/152748049",
		"id": 152748049,
		"lng": -77.38640393,
		"lat": 37.53737588,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 6,
		"dd": 22,
		"by": 1852,
		"bd": 15,
		"bm": 7,
		"nm": "J.",
		"nf": "Richard",
		"nl": "Bass",
		"url": "https://findagrave.com/memorial/144314810",
		"id": 144314810,
		"lng": -77.38628618,
		"lat": 37.5359694,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 3,
		"dd": 1,
		"by": 1864,
		"bd": 30,
		"bm": 12,
		"nm": "F.",
		"nf": "Rosetta",
		"nl": "Bass",
		"url": "https://findagrave.com/memorial/144367825",
		"id": 144367825,
		"lng": -77.38628935,
		"lat": 37.53595949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 11,
		"dd": 17,
		"by": 1892,
		"bd": 24,
		"bm": 9,
		"nm": "Henry",
		"nf": "James",
		"nl": "Bates",
		"url": "https://findagrave.com/memorial/117431728",
		"id": 117431728,
		"lng": -77.38552049,
		"lat": 37.53720593,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 3,
		"dd": 2,
		"by": 1866,
		"bd": 4,
		"bm": 9,
		"nm": "E.",
		"nf": "Martha",
		"nl": "Bates",
		"url": "https://findagrave.com/memorial/145593243",
		"id": 145593243,
		"lng": -77.38553631,
		"lat": 37.53720232,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 9,
		"dd": 4,
		"by": 1895,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Rosa",
		"nl": "Bates",
		"url": "https://findagrave.com/memorial/117804333",
		"id": 117804333,
		"lng": -77.38552008,
		"lat": 37.5372003,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 4,
		"dd": 13,
		"by": 1900,
		"bd": 15,
		"bm": 10,
		"nm": "",
		"nf": "Russell",
		"nl": "Bates",
		"url": "https://findagrave.com/memorial/142438652",
		"id": 142438652,
		"lng": -77.38725494,
		"lat": 37.53785747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 20,
		"by": 1911,
		"bd": 31,
		"bm": 1,
		"nm": "",
		"nf": "Sidney",
		"nl": "Bates",
		"url": "https://findagrave.com/memorial/169904891",
		"id": 169904891,
		"lng": -77.38655139,
		"lat": 37.5371267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1986,
		"dm": 11,
		"dd": 3,
		"by": 1910,
		"bd": 5,
		"bm": 5,
		"nm": "P.",
		"nf": "Bettie",
		"nl": "Battle",
		"url": "https://findagrave.com/memorial/122020758",
		"id": 122020758,
		"lng": -77.38604075,
		"lat": 37.53659515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 10,
		"dd": 24,
		"by": 1905,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Robert",
		"nl": "Battle",
		"url": "https://findagrave.com/memorial/127719207",
		"id": 127719207,
		"lng": -77.38604624,
		"lat": 37.53658345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 6,
		"dd": 21,
		"by": 1914,
		"bd": 2,
		"bm": 11,
		"nm": "",
		"nf": "Isaac",
		"nl": "Baxter",
		"url": "https://findagrave.com/memorial/191402806",
		"id": 191402806,
		"lng": -77.38594577,
		"lat": 37.53740221,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 9,
		"dd": 15,
		"by": 1872,
		"bd": 3,
		"bm": 2,
		"nm": "",
		"nf": "John",
		"nl": "Baxter",
		"url": "https://findagrave.com/memorial/145167322",
		"id": 145167322,
		"lng": -77.38632394,
		"lat": 37.53710413,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 6,
		"dd": 11,
		"by": 1912,
		"bd": 5,
		"bm": 11,
		"nm": "",
		"nf": "Geneva",
		"nl": "Baylor",
		"url": "https://findagrave.com/memorial/179551236",
		"id": 179551236,
		"lng": -77.38802081,
		"lat": 37.53776476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 1,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Elizabeth",
		"nf": "Georgiana",
		"nl": "Baylor",
		"url": "https://findagrave.com/memorial/155979485",
		"id": 155979485,
		"lng": -77.3870974,
		"lat": 37.53553492,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 3,
		"dd": 6,
		"by": 1933,
		"bd": 16,
		"bm": 3,
		"nm": "C.",
		"nf": "Hazel",
		"nl": "Beard",
		"url": "https://findagrave.com/memorial/155021576",
		"id": 155021576,
		"lng": -77.38679668,
		"lat": 37.53730653,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 9,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Dinah",
		"nl": "Beasley",
		"url": "https://findagrave.com/memorial/192019522",
		"id": 192019522,
		"lng": -77.38783935,
		"lat": 37.53738851,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 4,
		"dd": 20,
		"by": 1923,
		"bd": 11,
		"bm": 4,
		"nm": "",
		"nf": "Roosevelt",
		"nl": "Beasley",
		"url": "https://findagrave.com/memorial/175610056",
		"id": 175610056,
		"lng": -77.38769341,
		"lat": 37.53709952,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 5,
		"dd": 31,
		"by": 1928,
		"bd": 17,
		"bm": 4,
		"nm": "Jones n",
		"nf": "Beatrice",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/173078680",
		"id": 173078680,
		"lng": -77.38702979,
		"lat": 37.53734539,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 6,
		"dd": 24,
		"by": 1905,
		"bd": 1,
		"bm": 6,
		"nm": "M.",
		"nf": "Estelle",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/125583653",
		"id": 125583653,
		"lng": -77.3861058,
		"lat": 37.53701256,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 9,
		"dd": 22,
		"by": 1921,
		"bd": 27,
		"bm": 9,
		"nm": "Alton",
		"nf": "James",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/76587692",
		"id": 76587692,
		"lng": -77.38610063,
		"lat": 37.53702482,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 2,
		"dd": 5,
		"by": 1909,
		"bd": 27,
		"bm": 1,
		"nm": "Evelyn",
		"nf": "Jessie",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/127545284",
		"id": 127545284,
		"lng": -77.38607642,
		"lat": 37.53708588,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 2,
		"dd": 3,
		"by": 1877,
		"bd": 22,
		"bm": 2,
		"nm": "Elizabeth",
		"nf": "Josephine",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/127428902",
		"id": 127428902,
		"lng": -77.38610566,
		"lat": 37.53709125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": 5,
		"dd": 31,
		"by": 1896,
		"bd": 10,
		"bm": 1,
		"nm": "Bernard",
		"nf": "Robert",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/76587708",
		"id": 76587708,
		"lng": -77.3860974,
		"lat": 37.53703154,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Bell",
		"url": "https://findagrave.com/memorial/158436729",
		"id": 158436729,
		"lng": -77.38644264,
		"lat": 37.53679123,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 9,
		"dd": 6,
		"by": 1877,
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Lucy",
		"nl": "Benjamin",
		"url": "https://findagrave.com/memorial/145989478",
		"id": 145989478,
		"lng": -77.38656249,
		"lat": 37.53638041,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 1,
		"dd": 25,
		"by": 1871,
		"bd": 4,
		"bm": 5,
		"nm": "William",
		"nf": "Walker",
		"nl": "Benjamin",
		"url": "https://findagrave.com/memorial/122020764",
		"id": 122020764,
		"lng": -77.3865615,
		"lat": 37.53638971,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 10,
		"dd": 4,
		"by": 1902,
		"bd": 7,
		"bm": 10,
		"nm": "Mae",
		"nf": "Annie",
		"nl": "Bennett",
		"url": "https://findagrave.com/memorial/138181463",
		"id": 138181463,
		"lng": -77.38641058,
		"lat": 37.53696611,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 24,
		"by": 1917,
		"bd": 15,
		"bm": 3,
		"nm": "M. Pulliam",
		"nf": "Beulah",
		"nl": "Bennett",
		"url": "https://findagrave.com/memorial/150348902",
		"id": 150348902,
		"lng": -77.38651543,
		"lat": 37.53725238,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Bennett",
		"url": "https://findagrave.com/memorial/155734401",
		"id": 155734401,
		"lng": -77.38644586,
		"lat": 37.53709541,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 29,
		"by": 1891,
		"bd": 1,
		"bm": 3,
		"nm": "",
		"nf": "Minerva",
		"nl": "Bennett",
		"url": "https://findagrave.com/memorial/183587358",
		"id": 183587358,
		"lng": -77.38635135,
		"lat": 37.53663508,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 23,
		"by": 1911,
		"bd": 30,
		"bm": 4,
		"nm": "P.",
		"nf": "Andrew",
		"nl": "Bentley",
		"url": "https://findagrave.com/memorial/153100485",
		"id": 153100485,
		"lng": -77.38622349,
		"lat": 37.5355303,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Annie",
		"nl": "Berkley",
		"url": "https://findagrave.com/memorial/141193839",
		"id": 141193839,
		"lng": -77.38629433,
		"lat": 37.5367255,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 16,
		"by": 1892,
		"bd": 20,
		"bm": 1,
		"nm": "A.",
		"nf": "James",
		"nl": "Berkley",
		"url": "https://findagrave.com/memorial/166047356",
		"id": 166047356,
		"lng": -77.38646763,
		"lat": 37.53670074,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 20,
		"by": 1896,
		"bd": 21,
		"bm": 9,
		"nm": "",
		"nf": "Frank",
		"nl": "Berry",
		"url": "https://findagrave.com/memorial/184094495",
		"id": 184094495,
		"lng": -77.38718879,
		"lat": 37.53758411,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 4,
		"dd": 29,
		"by": 1882,
		"bd": "",
		"bm": 9,
		"nm": "",
		"nf": "Frank",
		"nl": "Berry",
		"url": "https://findagrave.com/memorial/185715888",
		"id": 185715888,
		"lng": -77.3877196,
		"lat": 37.53740832,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 3,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lelia",
		"nl": "Berry",
		"url": "https://findagrave.com/memorial/156452656",
		"id": 156452656,
		"lng": -77.38638385,
		"lat": 37.5357604,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 15,
		"by": 1896,
		"bd": 5,
		"bm": 4,
		"nm": "",
		"nf": "Della",
		"nl": "Best",
		"url": "https://findagrave.com/memorial/187342798",
		"id": 187342798,
		"lng": -77.38620565,
		"lat": 37.53735448,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 1,
		"dd": 7,
		"by": 1873,
		"bd": 21,
		"bm": 10,
		"nm": "C.",
		"nf": "Mattie",
		"nl": "Beverley",
		"url": "https://findagrave.com/memorial/145838160",
		"id": 145838160,
		"lng": -77.38676148,
		"lat": 37.53575478,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 6,
		"by": 1885,
		"bd": 9,
		"bm": 10,
		"nm": "Adgers",
		"nf": "Clannie",
		"nl": "Beverly",
		"url": "https://findagrave.com/memorial/122785947",
		"id": 122785947,
		"lng": -77.38621194,
		"lat": 37.53634869,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 3,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Elmer",
		"nl": "Beverly",
		"url": "https://findagrave.com/memorial/128012909",
		"id": 128012909,
		"lng": -77.38621257,
		"lat": 37.53635677,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 2,
		"dd": 26,
		"by": 1888,
		"bd": "",
		"bm": 11,
		"nm": "Elizabeth",
		"nf": "Ollie",
		"nl": "Beverly",
		"url": "https://findagrave.com/memorial/127994249",
		"id": 127994249,
		"lng": -77.386213,
		"lat": 37.53635677,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 2,
		"dd": 1,
		"by": 1913,
		"bd": 17,
		"bm": 8,
		"nm": "Myrtle",
		"nf": "Sallie",
		"nl": "Beverly",
		"url": "https://findagrave.com/memorial/127994649",
		"id": 127994649,
		"lng": -77.38621235,
		"lat": 37.53635675,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Rosa",
		"nl": "Bickley",
		"url": "https://findagrave.com/memorial/138561623",
		"id": 138561623,
		"lng": -77.38630591,
		"lat": 37.53662765,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 7,
		"dd": 5,
		"by": 1921,
		"bd": 12,
		"bm": 2,
		"nm": "Bullocks",
		"nf": "Ernest",
		"nl": "Billups",
		"url": "https://findagrave.com/memorial/173314362",
		"id": 173314362,
		"lng": -77.38700718,
		"lat": 37.53720717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 30,
		"by": 1876,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Marcellus",
		"nl": "Bingham",
		"url": "https://findagrave.com/memorial/187342805",
		"id": 187342805,
		"lng": -77.38698467,
		"lat": 37.53686915,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 25,
		"by": 1887,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frank",
		"nl": "Birchett",
		"url": "https://findagrave.com/memorial/145638774",
		"id": 145638774,
		"lng": -77.38633287,
		"lat": 37.53737518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Blakey",
		"url": "https://findagrave.com/memorial/169485823",
		"id": 169485823,
		"lng": -77.3876919,
		"lat": 37.53697562,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 9,
		"by": 1905,
		"bd": 12,
		"bm": 8,
		"nm": "",
		"nf": "Fannie",
		"nl": "Bland",
		"url": "https://findagrave.com/memorial/184092019",
		"id": 184092019,
		"lng": -77.38590062,
		"lat": 37.53688693,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Thomas",
		"nf": "James",
		"nl": "Bland",
		"url": "https://findagrave.com/memorial/185378497",
		"id": 185378497,
		"lng": -77.3869628,
		"lat": 37.53761527,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 24,
		"by": 1889,
		"bd": 14,
		"bm": 5,
		"nm": "Elbert",
		"nf": "Louis",
		"nl": "Bland",
		"url": "https://findagrave.com/memorial/144367834",
		"id": 144367834,
		"lng": -77.38633612,
		"lat": 37.537366,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 7,
		"dd": 30,
		"by": 1901,
		"bd": 19,
		"bm": 12,
		"nm": "",
		"nf": "Raymond",
		"nl": "Bland",
		"url": "https://findagrave.com/memorial/160921643",
		"id": 160921643,
		"lng": -77.38678307,
		"lat": 37.53677142,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 4,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hannah",
		"nl": "Boisseau",
		"url": "https://findagrave.com/memorial/119240738",
		"id": 119240738,
		"lng": -77.38591717,
		"lat": 37.53672769,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 4,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "William",
		"nl": "Boisseau",
		"url": "https://findagrave.com/memorial/146207044",
		"id": 146207044,
		"lng": -77.38586504,
		"lat": 37.53673821,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 13,
		"by": 1908,
		"bd": 22,
		"bm": 6,
		"nm": "W.",
		"nf": "William",
		"nl": "Boisseau",
		"url": "https://findagrave.com/memorial/119240758",
		"id": 119240758,
		"lng": -77.38591198,
		"lat": 37.53673917,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 12,
		"by": 1909,
		"bd": 2,
		"bm": 5,
		"nm": "C.",
		"nf": "William",
		"nl": "Bolding",
		"url": "https://findagrave.com/memorial/185652129",
		"id": 185652129,
		"lng": -77.38741713,
		"lat": 37.53735268,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 19,
		"by": 1903,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "Willie",
		"nl": "Bolling",
		"url": "https://findagrave.com/memorial/177279883",
		"id": 177279883,
		"lng": -77.38732404,
		"lat": 37.53723569,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 29,
		"by": 1922,
		"bd": 17,
		"bm": 2,
		"nm": "Virginia",
		"nf": "Dorothy",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/169456739",
		"id": 169456739,
		"lng": -77.38781661,
		"lat": 37.53700397,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 7,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gertrude",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/155507981",
		"id": 155507981,
		"lng": -77.38765422,
		"lat": 37.53771551,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 9,
		"dd": 25,
		"by": 1890,
		"bd": 2,
		"bm": 6,
		"nm": "W.",
		"nf": "Henry",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/123587168",
		"id": 123587168,
		"lng": -77.38591131,
		"lat": 37.53669275,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 10,
		"dd": 17,
		"by": 1917,
		"bd": 5,
		"bm": 11,
		"nm": "Mae",
		"nf": "Katie",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/159760618",
		"id": 159760618,
		"lng": -77.38622792,
		"lat": 37.5375237,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 25,
		"by": 1892,
		"bd": 22,
		"bm": 6,
		"nm": "",
		"nf": "Lucy",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/127988059",
		"id": 127988059,
		"lng": -77.38591744,
		"lat": 37.53669451,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 1,
		"dd": 16,
		"by": 1887,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Mary",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/144188784",
		"id": 144188784,
		"lng": -77.38746433,
		"lat": 37.53778918,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 9,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Spencer",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/161097120",
		"id": 161097120,
		"lng": -77.38708659,
		"lat": 37.53705032,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 1,
		"dd": 13,
		"by": 1871,
		"bd": 10,
		"bm": 3,
		"nm": "",
		"nf": "William",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/156932637",
		"id": 156932637,
		"lng": -77.38696908,
		"lat": 37.5374805,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 2,
		"dd": 24,
		"by": 1885,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Rachel",
		"nl": "Boone",
		"url": "https://findagrave.com/memorial/119240774",
		"id": 119240774,
		"lng": -77.38579756,
		"lat": 37.53669961,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 24,
		"by": 1891,
		"bd": 14,
		"bm": 3,
		"nm": "Lee",
		"nf": "Rose",
		"nl": "Bosher",
		"url": "https://findagrave.com/memorial/147852958",
		"id": 147852958,
		"lng": -77.38698276,
		"lat": 37.53713191,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Roberta",
		"nl": "Bossieux",
		"url": "https://findagrave.com/memorial/125805373",
		"id": 125805373,
		"lng": -77.38593053,
		"lat": 37.53618782,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 5,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Bossieux",
		"url": "https://findagrave.com/memorial/188438663",
		"id": 188438663,
		"lng": -77.38790011,
		"lat": 37.537028,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 6,
		"dd": 20,
		"by": 1893,
		"bd": 5,
		"bm": 8,
		"nm": "Mae",
		"nf": "Annie",
		"nl": "Boulware",
		"url": "https://findagrave.com/memorial/117180381",
		"id": 117180381,
		"lng": -77.38580608,
		"lat": 37.53708224,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Dorothy",
		"nl": "Boulware",
		"url": "https://findagrave.com/memorial/145325103",
		"id": 145325103,
		"lng": -77.38582242,
		"lat": 37.53707805,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 8,
		"dd": 29,
		"by": 1883,
		"bd": 9,
		"bm": 7,
		"nm": "David",
		"nf": "Samuel",
		"nl": "Boulware",
		"url": "https://findagrave.com/memorial/117180413",
		"id": 117180413,
		"lng": -77.38581129,
		"lat": 37.53708347,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 2,
		"dd": 25,
		"by": 1917,
		"bd": 7,
		"bm": 12,
		"nm": "J.",
		"nf": "Samuel",
		"nl": "Boulware",
		"url": "https://findagrave.com/memorial/145325116",
		"id": 145325116,
		"lng": -77.38582516,
		"lat": 37.53707051,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 7,
		"by": 1880,
		"bd": 25,
		"bm": 12,
		"nm": "T.",
		"nf": "Silas",
		"nl": "Boulware",
		"url": "https://findagrave.com/memorial/122786030",
		"id": 122786030,
		"lng": -77.38575025,
		"lat": 37.53701619,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 9,
		"dd": 1,
		"by": 1881,
		"bd": 12,
		"bm": 10,
		"nm": "",
		"nf": "Victoria",
		"nl": "Bowen",
		"url": "https://findagrave.com/memorial/134454159",
		"id": 134454159,
		"lng": -77.38727275,
		"lat": 37.53650334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 14,
		"by": 1885,
		"bd": 15,
		"bm": 9,
		"nm": "A.",
		"nf": "Daniel",
		"nl": "Bowler",
		"url": "https://findagrave.com/memorial/155507986",
		"id": 155507986,
		"lng": -77.38761385,
		"lat": 37.53762055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 5,
		"dd": 30,
		"by": 1876,
		"bd": 18,
		"bm": 11,
		"nm": "",
		"nf": "Gezlla",
		"nl": "Bowler",
		"url": "https://findagrave.com/memorial/149165818",
		"id": 149165818,
		"lng": -77.38610749,
		"lat": 37.53575801,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 7,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Marcus",
		"nl": "Bowles",
		"url": "https://findagrave.com/memorial/158436744",
		"id": 158436744,
		"lng": -77.38663986,
		"lat": 37.53601496,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 4,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nannie",
		"nl": "Bowles",
		"url": "https://findagrave.com/memorial/143631816",
		"id": 143631816,
		"lng": -77.38602098,
		"lat": 37.53592362,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 6,
		"dd": 30,
		"by": 1878,
		"bd": 1,
		"bm": 1,
		"nm": "",
		"nf": "Emma",
		"nl": "Bowls",
		"url": "https://findagrave.com/memorial/170604687",
		"id": 170604687,
		"lng": -77.38684641,
		"lat": 37.53695973,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 12,
		"dd": 9,
		"by": 1873,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Washington",
		"nl": "Bowman",
		"url": "https://findagrave.com/memorial/125292189",
		"id": 125292189,
		"lng": -77.38801493,
		"lat": 37.53717515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 6,
		"dd": 29,
		"by": 1885,
		"bd": 29,
		"bm": 3,
		"nm": "Estelle",
		"nf": "Alice",
		"nl": "Bowser",
		"url": "https://findagrave.com/memorial/24865504",
		"id": 24865504,
		"lng": -77.38595954,
		"lat": 37.53645164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 7,
		"dd": 20,
		"by": 1881,
		"bd": 1,
		"bm": 12,
		"nm": "Logan",
		"nf": "Lena",
		"nl": "Bowser",
		"url": "https://findagrave.com/memorial/24865519",
		"id": 24865519,
		"lng": -77.38593859,
		"lat": 37.53643615,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 7,
		"dd": 5,
		"by": 1880,
		"bd": 10,
		"bm": 8,
		"nm": "Barrington Herndon",
		"nf": "Oswald",
		"nl": "Bowser",
		"url": "https://findagrave.com/memorial/24865396",
		"id": 24865396,
		"lng": -77.38595691,
		"lat": 37.53646039,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 2,
		"dd": 7,
		"by": 1855,
		"bd": 7,
		"bm": 1,
		"nm": "L.",
		"nf": "Rosa",
		"nl": "Bowser",
		"url": "https://findagrave.com/memorial/11255726",
		"id": 11255726,
		"lng": -77.38596423,
		"lat": 37.53643617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louise",
		"nl": "Boxley",
		"url": "https://findagrave.com/memorial/178924797",
		"id": 178924797,
		"lng": -77.38729994,
		"lat": 37.5362712,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 6,
		"dd": 14,
		"by": 1884,
		"bd": 3,
		"bm": 8,
		"nm": "",
		"nf": "Alec",
		"nl": "Boyd",
		"url": "https://findagrave.com/memorial/144102041",
		"id": 144102041,
		"lng": -77.38595788,
		"lat": 37.53738979,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 4,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Boyd",
		"url": "https://findagrave.com/memorial/176712949",
		"id": 176712949,
		"lng": -77.38755811,
		"lat": 37.5371711,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 13,
		"by": 1963,
		"bd": 23,
		"bm": 9,
		"nm": "",
		"nf": "Danny",
		"nl": "Boyd",
		"url": "https://findagrave.com/memorial/142797031",
		"id": 142797031,
		"lng": -77.38604308,
		"lat": 37.53745135,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 4,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Boyd",
		"url": "https://findagrave.com/memorial/176712609",
		"id": 176712609,
		"lng": -77.38755536,
		"lat": 37.5371802,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 3,
		"dd": 1,
		"by": 1910,
		"bd": 27,
		"bm": 7,
		"nm": "",
		"nf": "Virginia",
		"nl": "Boyd",
		"url": "https://findagrave.com/memorial/148455098",
		"id": 148455098,
		"lng": -77.38611957,
		"lat": 37.53618416,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 8,
		"dd": 17,
		"by": 1908,
		"bd": 21,
		"bm": 11,
		"nm": "",
		"nf": "Troy",
		"nl": "Braddy",
		"url": "https://findagrave.com/memorial/148285631",
		"id": 148285631,
		"lng": -77.38636972,
		"lat": 37.53730884,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 3,
		"dd": 8,
		"by": 1880,
		"bd": 14,
		"bm": 10,
		"nm": "James",
		"nf": "Daniel",
		"nl": "Bradford",
		"url": "https://findagrave.com/memorial/154243868",
		"id": 154243868,
		"lng": -77.38644476,
		"lat": 37.53550778,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 1,
		"dd": 22,
		"by": 1883,
		"bd": 3,
		"bm": 9,
		"nm": "Louise",
		"nf": "Edith",
		"nl": "Bradford",
		"url": "https://findagrave.com/memorial/154243791",
		"id": 154243791,
		"lng": -77.38645368,
		"lat": 37.53550887,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 26,
		"by": 1900,
		"bd": 28,
		"bm": 6,
		"nm": "",
		"nf": "Louise",
		"nl": "Bradford",
		"url": "https://findagrave.com/memorial/191417543",
		"id": 191417543,
		"lng": -77.38640975,
		"lat": 37.53746151,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 13,
		"by": 1924,
		"bd": 5,
		"bm": 2,
		"nm": "",
		"nf": "Josephine",
		"nl": "Bradley",
		"url": "https://findagrave.com/memorial/173078146",
		"id": 173078146,
		"lng": -77.38729704,
		"lat": 37.53737239,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 7,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mamie",
		"nl": "Bradley",
		"url": "https://findagrave.com/memorial/178152871",
		"id": 178152871,
		"lng": -77.38776302,
		"lat": 37.53716022,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1981,
		"dm": 2,
		"dd": 15,
		"by": 1898,
		"bd": 25,
		"bm": 8,
		"nm": "",
		"nf": "Sadie",
		"nl": "Bradley",
		"url": "https://findagrave.com/memorial/130692295",
		"id": 130692295,
		"lng": -77.38568732,
		"lat": 37.53718615,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 31,
		"by": 1883,
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Mary",
		"nl": "Bradshaw",
		"url": "https://findagrave.com/memorial/170129833",
		"id": 170129833,
		"lng": -77.38678534,
		"lat": 37.53690326,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 2,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mattie",
		"nl": "Bradshaw",
		"url": "https://findagrave.com/memorial/134454168",
		"id": 134454168,
		"lng": -77.3864825,
		"lat": 37.53699742,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 3,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Aaron",
		"nl": "Branch",
		"url": "https://findagrave.com/memorial/174688582",
		"id": 174688582,
		"lng": -77.38763138,
		"lat": 37.53710381,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 11,
		"dd": 10,
		"by": 1891,
		"bd": 24,
		"bm": 12,
		"nm": "Hundley",
		"nf": "George",
		"nl": "Branch",
		"url": "https://findagrave.com/memorial/160921652",
		"id": 160921652,
		"lng": -77.38649185,
		"lat": 37.53684997,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 11,
		"by": 1862,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Branch",
		"url": "https://findagrave.com/memorial/186818072",
		"id": 186818072,
		"lng": -77.3873942,
		"lat": 37.53768038,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": 1,
		"bm": 10,
		"nm": "R.",
		"nf": "John",
		"nl": "Branch",
		"url": "https://findagrave.com/memorial/185958399",
		"id": 185958399,
		"lng": -77.38633588,
		"lat": 37.53595919,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Branch",
		"url": "https://findagrave.com/memorial/166514675",
		"id": 166514675,
		"lng": -77.38764057,
		"lat": 37.53690764,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 3,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Talley",
		"nf": "Rosa",
		"nl": "Branch",
		"url": "https://findagrave.com/memorial/130539003",
		"id": 130539003,
		"lng": -77.38638439,
		"lat": 37.536911,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 5,
		"dd": 31,
		"by": 1962,
		"bd": 31,
		"bm": 7,
		"nm": "Melvin",
		"nf": "Eugene",
		"nl": "Brandon",
		"url": "https://findagrave.com/memorial/169042185",
		"id": 169042185,
		"lng": -77.38608591,
		"lat": 37.53748039,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 7,
		"dd": 9,
		"by": 1865,
		"bd": 1,
		"bm": 6,
		"nm": "",
		"nf": "Annie",
		"nl": "Branic",
		"url": "https://findagrave.com/memorial/76587717",
		"id": 76587717,
		"lng": -77.38610486,
		"lat": 37.53671729,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 12,
		"dd": 11,
		"by": 1861,
		"bd": "",
		"bm": 11,
		"nm": "Ann",
		"nf": "Celia",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/152528294",
		"id": 152528294,
		"lng": -77.38587576,
		"lat": 37.53641688,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 5,
		"dd": 22,
		"by": 1859,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cordelia",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/170129962",
		"id": 170129962,
		"lng": -77.38780701,
		"lat": 37.5371943,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 12,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edmonia",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/184094505",
		"id": 184094505,
		"lng": -77.38712884,
		"lat": 37.53758751,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 6,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eliza",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/177768005",
		"id": 177768005,
		"lng": -77.38781207,
		"lat": 37.53717287,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 6,
		"dd": 23,
		"by": 1885,
		"bd": 18,
		"bm": 2,
		"nm": "E.",
		"nf": "Florence",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/142438664",
		"id": 142438664,
		"lng": -77.38578961,
		"lat": 37.53734967,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 28,
		"by": 1887,
		"bd": 19,
		"bm": 7,
		"nm": "Nelson",
		"nf": "George",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/170129841",
		"id": 170129841,
		"lng": -77.38681968,
		"lat": 37.53693768,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 4,
		"dd": 16,
		"by": 1878,
		"bd": 3,
		"bm": 5,
		"nm": "",
		"nf": "Laura",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/125514725",
		"id": 125514725,
		"lng": -77.38591563,
		"lat": 37.53700167,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 10,
		"dd": 10,
		"by": 1899,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/173773061",
		"id": 173773061,
		"lng": -77.38722719,
		"lat": 37.53740573,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 5,
		"dd": 27,
		"by": 1890,
		"bd": 8,
		"bm": 2,
		"nm": "Thompson",
		"nf": "Noah",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/145989498",
		"id": 145989498,
		"lng": -77.38579526,
		"lat": 37.53689077,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Draper",
		"nf": "Pearl",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/158677664",
		"id": 158677664,
		"lng": -77.3868061,
		"lat": 37.53763431,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 7,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Peter",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/158432048",
		"id": 158432048,
		"lng": -77.38696767,
		"lat": 37.53757515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 12,
		"by": 1905,
		"bd": 5,
		"bm": 10,
		"nm": "T. H.",
		"nf": "Sadie",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/159885887",
		"id": 159885887,
		"lng": -77.3878215,
		"lat": 37.53752514,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 12,
		"dd": 8,
		"by": 1897,
		"bd": 9,
		"bm": 2,
		"nm": "Lee",
		"nf": "Vance",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/173773068",
		"id": 173773068,
		"lng": -77.38722769,
		"lat": 37.53739752,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 6,
		"dd": 24,
		"by": 1904,
		"bd": 7,
		"bm": 9,
		"nm": "B.",
		"nf": "William",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/125514734",
		"id": 125514734,
		"lng": -77.38590345,
		"lat": 37.5369993,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 3,
		"dd": 15,
		"by": 1904,
		"bd": 18,
		"bm": 9,
		"nm": "",
		"nf": "Mamie",
		"nl": "Brevard",
		"url": "https://findagrave.com/memorial/162131916",
		"id": 162131916,
		"lng": -77.3858136,
		"lat": 37.53714517,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 6,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mattie",
		"nl": "Brewer",
		"url": "https://findagrave.com/memorial/188244618",
		"id": 188244618,
		"lng": -77.38797241,
		"lat": 37.53718665,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 13,
		"by": 1907,
		"bd": 30,
		"bm": 8,
		"nm": "",
		"nf": "George",
		"nl": "Brice",
		"url": "https://findagrave.com/memorial/144820106",
		"id": 144820106,
		"lng": -77.38555936,
		"lat": 37.53727335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 20,
		"by": 1936,
		"bd": 22,
		"bm": 5,
		"nm": "",
		"nf": "John",
		"nl": "Bridy",
		"url": "https://findagrave.com/memorial/169905215",
		"id": 169905215,
		"lng": -77.38657192,
		"lat": 37.53712932,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 7,
		"dd": 23,
		"by": 1945,
		"bd": 25,
		"bm": 4,
		"nm": "",
		"nf": "Willie",
		"nl": "Bridy",
		"url": "https://findagrave.com/memorial/149486781",
		"id": 149486781,
		"lng": -77.3865306,
		"lat": 37.53684862,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 9,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Carrie",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/183697430",
		"id": 183697430,
		"lng": -77.38703147,
		"lat": 37.53693675,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 12,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A. J.",
		"nf": "Charles",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/144367998",
		"id": 144367998,
		"lng": -77.38640601,
		"lat": 37.53578473,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 1,
		"dd": 7,
		"by": 1850,
		"bd": "",
		"bm": 12,
		"nm": "",
		"nf": "Lavinia",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/127853281",
		"id": 127853281,
		"lng": -77.38638064,
		"lat": 37.53653427,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 10,
		"dd": 8,
		"by": 1927,
		"bd": 16,
		"bm": 6,
		"nm": "",
		"nf": "Leroy",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/155507997",
		"id": 155507997,
		"lng": -77.38768934,
		"lat": 37.53762692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 9,
		"dd": 21,
		"by": 1889,
		"bd": 12,
		"bm": 10,
		"nm": "Virginia",
		"nf": "Pearl",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/148460015",
		"id": 148460015,
		"lng": -77.38625397,
		"lat": 37.53543908,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/170604694",
		"id": 170604694,
		"lng": -77.38686001,
		"lat": 37.53695119,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Watson",
		"nl": "Briggs",
		"url": "https://findagrave.com/memorial/132046752",
		"id": 132046752,
		"lng": -77.38775248,
		"lat": 37.53656306,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "George",
		"nl": "Bright",
		"url": "https://findagrave.com/memorial/159880468",
		"id": 159880468,
		"lng": -77.38789485,
		"lat": 37.53697667,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Jane",
		"nf": "Sarah",
		"nl": "Bright",
		"url": "https://findagrave.com/memorial/166104345",
		"id": 166104345,
		"lng": -77.38708012,
		"lat": 37.53663349,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 5,
		"dd": 16,
		"by": 1883,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Brinkley",
		"url": "https://findagrave.com/memorial/173785238",
		"id": 173785238,
		"lng": -77.38735105,
		"lat": 37.53713026,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 15,
		"by": 1887,
		"bd": 1,
		"bm": 7,
		"nm": "",
		"nf": "Frederick",
		"nl": "Brinkley",
		"url": "https://findagrave.com/memorial/173782098",
		"id": 173782098,
		"lng": -77.38736365,
		"lat": 37.53710221,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 28,
		"by": 1931,
		"bd": 12,
		"bm": 9,
		"nm": "Mae",
		"nf": "Aurelia",
		"nl": "Bristow",
		"url": "https://findagrave.com/memorial/153511873",
		"id": 153511873,
		"lng": -77.38659511,
		"lat": 37.53719829,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 6,
		"dd": 4,
		"by": 1917,
		"bd": 3,
		"bm": 5,
		"nm": "",
		"nf": "Madie",
		"nl": "Britton",
		"url": "https://findagrave.com/memorial/185958402",
		"id": 185958402,
		"lng": -77.38635075,
		"lat": 37.53595851,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Britton",
		"url": "https://findagrave.com/memorial/173908763",
		"id": 173908763,
		"lng": -77.38758349,
		"lat": 37.53716322,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 4,
		"dd": 15,
		"by": 1917,
		"bd": 12,
		"bm": 9,
		"nm": "Elizabeth",
		"nf": "Mary",
		"nl": "Brockenborough",
		"url": "https://findagrave.com/memorial/157623533",
		"id": 157623533,
		"lng": -77.38666958,
		"lat": 37.53745504,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 4,
		"dd": 14,
		"by": 1895,
		"bd": 12,
		"bm": 10,
		"nm": "",
		"nf": "Samuel",
		"nl": "Bronson",
		"url": "https://findagrave.com/memorial/136171610",
		"id": 136171610,
		"lng": -77.38593256,
		"lat": 37.53633114,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 6,
		"dd": 27,
		"by": 1895,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Addie",
		"nl": "Bronston",
		"url": "https://findagrave.com/memorial/142106148",
		"id": 142106148,
		"lng": -77.38572557,
		"lat": 37.53743358,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 6,
		"dd": 8,
		"by": 1896,
		"bd": 20,
		"bm": 12,
		"nm": "",
		"nf": "Alexander",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/177490457",
		"id": 177490457,
		"lng": -77.38775402,
		"lat": 37.53735893,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/163925085",
		"id": 163925085,
		"lng": -77.38667852,
		"lat": 37.53681506,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 2,
		"by": 1922,
		"bd": 10,
		"bm": 11,
		"nm": "P.",
		"nf": "Benjamin",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/138561629",
		"id": 138561629,
		"lng": -77.38627257,
		"lat": 37.53658141,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 30,
		"by": 1920,
		"bd": 7,
		"bm": 12,
		"nm": "M.",
		"nf": "Jerry",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/154037657",
		"id": 154037657,
		"lng": -77.38656836,
		"lat": 37.53718545,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 6,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillian",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/186818009",
		"id": 186818009,
		"lng": -77.38740721,
		"lat": 37.53771295,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 11,
		"dd": 30,
		"by": 1832,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Lucy",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/145989513",
		"id": 145989513,
		"lng": -77.38664219,
		"lat": 37.53656031,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 2,
		"by": 1900,
		"bd": 29,
		"bm": 9,
		"nm": "W.",
		"nf": "Maria",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/145638778",
		"id": 145638778,
		"lng": -77.38628152,
		"lat": 37.53738095,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 6,
		"dd": 17,
		"by": 1892,
		"bd": 19,
		"bm": 5,
		"nm": "",
		"nf": "Mary",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/153511883",
		"id": 153511883,
		"lng": -77.38678694,
		"lat": 37.53728263,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 7,
		"by": 1886,
		"bd": 15,
		"bm": 9,
		"nm": "M.",
		"nf": "William",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/153511891",
		"id": 153511891,
		"lng": -77.38678048,
		"lat": 37.53729362,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Alice",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/171733158",
		"id": 171733158,
		"lng": -77.38688228,
		"lat": 37.53710454,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 3,
		"dd": 31,
		"by": 1924,
		"bd": 18,
		"bm": 6,
		"nm": "Beatrice",
		"nf": "Alma",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/166823755",
		"id": 166823755,
		"lng": -77.38802531,
		"lat": 37.53749292,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 1,
		"by": 1963,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alvin",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/187342810",
		"id": 187342810,
		"lng": -77.38610008,
		"lat": 37.53746972,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 2,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Anna",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/129208522",
		"id": 129208522,
		"lng": -77.3863226,
		"lat": 37.53687216,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 5,
		"dd": 14,
		"by": 1888,
		"bd": 4,
		"bm": 5,
		"nm": "Mae",
		"nf": "Annie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/169136555",
		"id": 169136555,
		"lng": -77.38568605,
		"lat": 37.53745067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 6,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Archie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/167182269",
		"id": 167182269,
		"lng": -77.38661121,
		"lat": 37.53680765,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ause",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/176055714",
		"id": 176055714,
		"lng": -77.38733921,
		"lat": 37.5370769,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 10,
		"dd": 30,
		"by": 1883,
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Carrie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/136171619",
		"id": 136171619,
		"lng": -77.3864407,
		"lat": 37.53640389,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 5,
		"dd": 25,
		"by": 1880,
		"bd": 2,
		"bm": 7,
		"nm": "C.",
		"nf": "Claude",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/127428916",
		"id": 127428916,
		"lng": -77.3864734,
		"lat": 37.53641214,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 3,
		"dd": 13,
		"by": 1897,
		"bd": "",
		"bm": 7,
		"nm": "",
		"nf": "Clinton",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/136171628",
		"id": 136171628,
		"lng": -77.38645007,
		"lat": 37.53637064,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 9,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Diana",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/166515917",
		"id": 166515917,
		"lng": -77.38766861,
		"lat": 37.53704162,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 8,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Dora",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/183194444",
		"id": 183194444,
		"lng": -77.38731455,
		"lat": 37.53705118,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 8,
		"dd": 30,
		"by": 1914,
		"bd": 4,
		"bm": 9,
		"nm": "William",
		"nf": "Eddie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/182090440",
		"id": 182090440,
		"lng": -77.38665365,
		"lat": 37.53767373,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Guy",
		"nf": "Edward",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/174622135",
		"id": 174622135,
		"lng": -77.38693885,
		"lat": 37.53725971,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 7,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/149771181",
		"id": 149771181,
		"lng": -77.38623861,
		"lat": 37.53590252,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ellen",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/187342816",
		"id": 187342816,
		"lng": -77.38775862,
		"lat": 37.53628293,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 5,
		"dd": 5,
		"by": 1862,
		"bd": 31,
		"bm": 8,
		"nm": "M.",
		"nf": "Ellen",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/138561645",
		"id": 138561645,
		"lng": -77.38647645,
		"lat": 37.53634744,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 20,
		"by": 1904,
		"bd": 2,
		"bm": 6,
		"nm": "L.",
		"nf": "Ernest",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/178723689",
		"id": 178723689,
		"lng": -77.38784941,
		"lat": 37.5374161,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 8,
		"dd": 4,
		"by": 1875,
		"bd": 13,
		"bm": 3,
		"nm": "P.",
		"nf": "Eugertha",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/154534360",
		"id": 154534360,
		"lng": -77.38639427,
		"lat": 37.53565259,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 7,
		"dd": 12,
		"by": 1920,
		"bd": "",
		"bm": "",
		"nm": "Louise",
		"nf": "Eva",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/117431772",
		"id": 117431772,
		"lng": -77.38549161,
		"lat": 37.53732971,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 6,
		"dd": 13,
		"by": 1976,
		"bd": 13,
		"bm": 6,
		"nm": "Edward",
		"nf": "Frederick",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/158025880",
		"id": 158025880,
		"lng": -77.38617947,
		"lat": 37.53728303,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 28,
		"by": 1895,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Garcine",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/170814996",
		"id": 170814996,
		"lng": -77.38636697,
		"lat": 37.53675939,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Garfield",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/144314822",
		"id": 144314822,
		"lng": -77.38773249,
		"lat": 37.53796106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 3,
		"dd": 21,
		"by": 1882,
		"bd": 5,
		"bm": 5,
		"nm": "",
		"nf": "Henretta",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/113750730",
		"id": 113750730,
		"lng": -77.3862588,
		"lat": 37.53686852,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 16,
		"by": 1895,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Henry",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/158433848",
		"id": 158433848,
		"lng": -77.38677797,
		"lat": 37.53758714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 11,
		"dd": 27,
		"by": 1950,
		"bd": 16,
		"bm": 7,
		"nm": "Eugene",
		"nf": "Horace",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/158432440",
		"id": 158432440,
		"lng": -77.38684881,
		"lat": 37.53761059,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 4,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ida",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/175421370",
		"id": 175421370,
		"lng": -77.38751393,
		"lat": 37.53712788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 30,
		"by": 1900,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Isaiah",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/185564826",
		"id": 185564826,
		"lng": -77.38678859,
		"lat": 37.53678565,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 11,
		"by": 1888,
		"bd": 5,
		"bm": 7,
		"nm": "",
		"nf": "Jacob",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/151943361",
		"id": 151943361,
		"lng": -77.38666508,
		"lat": 37.5357489,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 15,
		"by": 1901,
		"bd": 8,
		"bm": 8,
		"nm": "",
		"nf": "James",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/173773076",
		"id": 173773076,
		"lng": -77.38728536,
		"lat": 37.53734959,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 6,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "James",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/129208525",
		"id": 129208525,
		"lng": -77.3863265,
		"lat": 37.53686305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1984,
		"dm": 10,
		"dd": 27,
		"by": 1909,
		"bd": 28,
		"bm": 10,
		"nm": "L.",
		"nf": "James",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/115720549",
		"id": 115720549,
		"lng": -77.38603742,
		"lat": 37.53711824,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 7,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/151692128",
		"id": 151692128,
		"lng": -77.38659352,
		"lat": 37.53541846,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "John",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/159880279",
		"id": 159880279,
		"lng": -77.38772097,
		"lat": 37.53721898,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 3,
		"dd": 9,
		"by": 1874,
		"bd": 7,
		"bm": 5,
		"nm": "Allen",
		"nf": "John",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/117180425",
		"id": 117180425,
		"lng": -77.38589827,
		"lat": 37.53718454,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 6,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/188269709",
		"id": 188269709,
		"lng": -77.38791593,
		"lat": 37.53710242,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 24,
		"by": 1875,
		"bd": 1,
		"bm": 5,
		"nm": "Henry",
		"nf": "Joseph",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/145167325",
		"id": 145167325,
		"lng": -77.38623928,
		"lat": 37.53715146,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 5,
		"by": 1895,
		"bd": 23,
		"bm": 6,
		"nm": "L.",
		"nf": "Joseph",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/138366518",
		"id": 138366518,
		"lng": -77.38626978,
		"lat": 37.53674523,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 26,
		"by": 1894,
		"bd": 6,
		"bm": 10,
		"nm": "N.",
		"nf": "Lemuel",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/169810309",
		"id": 169810309,
		"lng": -77.38681202,
		"lat": 37.53698607,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 9,
		"dd": 22,
		"by": 1878,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lena",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/132046761",
		"id": 132046761,
		"lng": -77.38779337,
		"lat": 37.53648618,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 26,
		"by": 1887,
		"bd": 10,
		"bm": 4,
		"nm": "",
		"nf": "Lizzie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/161003050",
		"id": 161003050,
		"lng": -77.38705929,
		"lat": 37.53706176,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 10,
		"dd": 4,
		"by": 1895,
		"bd": 8,
		"bm": 7,
		"nm": "",
		"nf": "Louise",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/142441900",
		"id": 142441900,
		"lng": -77.38589878,
		"lat": 37.53727187,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 11,
		"dd": 30,
		"by": 1895,
		"bd": 11,
		"bm": 5,
		"nm": "",
		"nf": "Mable",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/159885477",
		"id": 159885477,
		"lng": -77.38785019,
		"lat": 37.53751602,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 10,
		"by": 1870,
		"bd": 22,
		"bm": 12,
		"nm": "",
		"nf": "Maria",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/176984239",
		"id": 176984239,
		"lng": -77.38747742,
		"lat": 37.53554401,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 6,
		"dd": 2,
		"by": 1892,
		"bd": 21,
		"bm": 1,
		"nm": "P.",
		"nf": "Marion",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/130692313",
		"id": 130692313,
		"lng": -77.38568338,
		"lat": 37.53716334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 5,
		"dd": 5,
		"by": 1859,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/155963906",
		"id": 155963906,
		"lng": -77.38706447,
		"lat": 37.53562085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/158625994",
		"id": 158625994,
		"lng": -77.38662164,
		"lat": 37.53574441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 28,
		"by": 1892,
		"bd": 22,
		"bm": 10,
		"nm": "Ellen",
		"nf": "Mary",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/173920098",
		"id": 173920098,
		"lng": -77.38732188,
		"lat": 37.53734388,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 9,
		"dd": 29,
		"by": 1906,
		"bd": 27,
		"bm": 10,
		"nm": "M.",
		"nf": "Mary",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/138926455",
		"id": 138926455,
		"lng": -77.38642213,
		"lat": 37.53653931,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 3,
		"dd": 8,
		"by": 1847,
		"bd": 4,
		"bm": 7,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/127428923",
		"id": 127428923,
		"lng": -77.38646472,
		"lat": 37.53643825,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 1,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Jane",
		"nf": "Mary",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/127096037",
		"id": 127096037,
		"lng": -77.38628924,
		"lat": 37.5364219,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Mary",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/125805382",
		"id": 125805382,
		"lng": -77.38610167,
		"lat": 37.53736395,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 7,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matthew",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/154534088",
		"id": 154534088,
		"lng": -77.3864354,
		"lat": 37.53565843,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 8,
		"by": 1896,
		"bd": "",
		"bm": 7,
		"nm": "",
		"nf": "Nye",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/184094516",
		"id": 184094516,
		"lng": -77.38717197,
		"lat": 37.53758085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 11,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pattie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/177768008",
		"id": 177768008,
		"lng": -77.38770358,
		"lat": 37.53755623,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 6,
		"dd": 25,
		"by": 1840,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Peter",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/155508011",
		"id": 155508011,
		"lng": -77.38667705,
		"lat": 37.53603037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 10,
		"by": 1904,
		"bd": 9,
		"bm": 4,
		"nm": "",
		"nf": "Philip",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/169193076",
		"id": 169193076,
		"lng": -77.38557124,
		"lat": 37.53727536,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 1,
		"dd": 15,
		"by": 1897,
		"bd": 12,
		"bm": 11,
		"nm": "Emanuel",
		"nf": "Philip",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/142441907",
		"id": 142441907,
		"lng": -77.38586258,
		"lat": 37.53728405,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Phyllis",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/145325126",
		"id": 145325126,
		"lng": -77.3855433,
		"lat": 37.53732269,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Priscilla",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/174713087",
		"id": 174713087,
		"lng": -77.3879365,
		"lat": 37.53704621,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 25,
		"by": 1903,
		"bd": 12,
		"bm": 5,
		"nm": "Ella",
		"nf": "Queen",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/144314838",
		"id": 144314838,
		"lng": -77.3874775,
		"lat": 37.53737589,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 5,
		"dd": 4,
		"by": 1925,
		"bd": 1,
		"bm": 12,
		"nm": "",
		"nf": "Richard",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/173076196",
		"id": 173076196,
		"lng": -77.38694739,
		"lat": 37.53733883,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 1,
		"dd": 11,
		"by": 1874,
		"bd": 12,
		"bm": 8,
		"nm": "E.",
		"nf": "Robert",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/127428936",
		"id": 127428936,
		"lng": -77.38648296,
		"lat": 37.53642615,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 1,
		"dd": 15,
		"by": 1879,
		"bd": 15,
		"bm": 11,
		"nm": "Hayes",
		"nf": "Sadie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/117804345",
		"id": 117804345,
		"lng": -77.38589129,
		"lat": 37.53718156,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 8,
		"by": 1871,
		"bd": 28,
		"bm": 10,
		"nm": "E.",
		"nf": "Sara",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/122027252",
		"id": 122027252,
		"lng": -77.38645956,
		"lat": 37.53642321,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Susan",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/129208531",
		"id": 129208531,
		"lng": -77.38632472,
		"lat": 37.5368675,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Susie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/182556656",
		"id": 182556656,
		"lng": -77.38758795,
		"lat": 37.53647658,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 4,
		"dd": 16,
		"by": 1868,
		"bd": 15,
		"bm": 6,
		"nm": "B.",
		"nf": "Susie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/173848381",
		"id": 173848381,
		"lng": -77.38736207,
		"lat": 37.5371397,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 12,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Virginia",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/127719215",
		"id": 127719215,
		"lng": -77.38627134,
		"lat": 37.53639727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1986,
		"dm": 2,
		"dd": 3,
		"by": 1914,
		"bd": 13,
		"bm": 12,
		"nm": "",
		"nf": "Vivian",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/115720563",
		"id": 115720563,
		"lng": -77.38603438,
		"lat": 37.53712497,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 23,
		"by": 1966,
		"bd": 25,
		"bm": 6,
		"nm": "",
		"nf": "Walter",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/144064197",
		"id": 144064197,
		"lng": -77.38597862,
		"lat": 37.53744668,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 2,
		"dd": 2,
		"by": 1901,
		"bd": 22,
		"bm": 7,
		"nm": "H.",
		"nf": "William",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/125514741",
		"id": 125514741,
		"lng": -77.38645103,
		"lat": 37.53636599,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1901,
		"dm": 3,
		"dd": 1,
		"by": 1845,
		"bd": "",
		"bm": 5,
		"nm": "F.",
		"nf": "William",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/127428943",
		"id": 127428943,
		"lng": -77.38646146,
		"lat": 37.53644756,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 7,
		"by": 1902,
		"bd": 14,
		"bm": 12,
		"nm": "F.",
		"nf": "William",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/136171634",
		"id": 136171634,
		"lng": -77.38644696,
		"lat": 37.53641,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 7,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "N.",
		"nf": "William",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/138561664",
		"id": 138561664,
		"lng": -77.38645781,
		"lat": 37.53634501,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 10,
		"dd": 8,
		"by": 1889,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "William",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/114466942",
		"id": 114466942,
		"lng": -77.38630124,
		"lat": 37.53687548,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willianna",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/154014296",
		"id": 154014296,
		"lng": -77.3867688,
		"lat": 37.53539476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/145084176",
		"id": 145084176,
		"lng": -77.38736104,
		"lat": 37.53782654,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 11,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Hayes",
		"nf": "Kate",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/192327153",
		"id": 192327153,
		"lng": -77.38675716,
		"lat": 37.53542134,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 3,
		"dd": 1,
		"by": 1903,
		"bd": 6,
		"bm": 5,
		"nm": "",
		"nf": "Arnita",
		"nl": "Brunson",
		"url": "https://findagrave.com/memorial/188162219",
		"id": 188162219,
		"lng": -77.38794325,
		"lat": 37.53724199,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 9,
		"by": 1897,
		"bd": "",
		"bm": "",
		"nm": "Perry",
		"nf": "Andrew",
		"nl": "Bryant",
		"url": "https://findagrave.com/memorial/183587371",
		"id": 183587371,
		"lng": -77.38634538,
		"lat": 37.5366458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 9,
		"dd": 23,
		"by": 1897,
		"bd": 15,
		"bm": 7,
		"nm": "Edward",
		"nf": "James",
		"nl": "Bryant",
		"url": "https://findagrave.com/memorial/168362525",
		"id": 168362525,
		"lng": -77.38680201,
		"lat": 37.53741173,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Bryson",
		"url": "https://findagrave.com/memorial/189218484",
		"id": 189218484,
		"lng": -77.38740916,
		"lat": 37.53738536,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 11,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lawrence",
		"nf": "Ernest",
		"nl": "Buchanan",
		"url": "https://findagrave.com/memorial/137332633",
		"id": 137332633,
		"lng": -77.38605562,
		"lat": 37.53692548,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 8,
		"dd": 22,
		"by": 1919,
		"bd": 23,
		"bm": 5,
		"nm": "E.",
		"nf": "Ernesteen",
		"nl": "Buchanan",
		"url": "https://findagrave.com/memorial/145084178",
		"id": 145084178,
		"lng": -77.38605071,
		"lat": 37.53693549,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Buchanan",
		"url": "https://findagrave.com/memorial/177763310",
		"id": 177763310,
		"lng": -77.38775158,
		"lat": 37.5374264,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 9,
		"dd": 12,
		"by": 1917,
		"bd": 23,
		"bm": 6,
		"nm": "Otto",
		"nf": "James",
		"nl": "Bullock",
		"url": "https://findagrave.com/memorial/76587728",
		"id": 76587728,
		"lng": -77.38613105,
		"lat": 37.53671356,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 17,
		"by": 1884,
		"bd": 12,
		"bm": 6,
		"nm": "Jim",
		"nf": "Moses",
		"nl": "Bullock",
		"url": "https://findagrave.com/memorial/158942421",
		"id": 158942421,
		"lng": -77.38688997,
		"lat": 37.53745088,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 10,
		"dd": 14,
		"by": 1918,
		"bd": 18,
		"bm": 1,
		"nm": "Plummer",
		"nf": "William",
		"nl": "Bullock",
		"url": "https://findagrave.com/memorial/183245305",
		"id": 183245305,
		"lng": -77.38723156,
		"lat": 37.53707092,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 1,
		"dd": 9,
		"by": 1859,
		"bd": 22,
		"bm": 8,
		"nm": "",
		"nf": "Edward",
		"nl": "Bunn",
		"url": "https://findagrave.com/memorial/149251886",
		"id": 149251886,
		"lng": -77.38641257,
		"lat": 37.53553133,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 4,
		"dd": 4,
		"by": 1882,
		"bd": 5,
		"bm": 9,
		"nm": "",
		"nf": "Mann",
		"nl": "Burchett",
		"url": "https://findagrave.com/memorial/125292203",
		"id": 125292203,
		"lng": -77.38592776,
		"lat": 37.53687946,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 11,
		"dd": 29,
		"by": 1933,
		"bd": 28,
		"bm": 10,
		"nm": "Henry",
		"nf": "William",
		"nl": "Burchett",
		"url": "https://findagrave.com/memorial/128399800",
		"id": 128399800,
		"lng": -77.38618906,
		"lat": 37.53726111,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 11,
		"dd": 5,
		"by": 1883,
		"bd": 23,
		"bm": 9,
		"nm": "",
		"nf": "Thomas",
		"nl": "Burhunce",
		"url": "https://findagrave.com/memorial/148285642",
		"id": 148285642,
		"lng": -77.38648403,
		"lat": 37.53723476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 9,
		"dd": 10,
		"by": 1963,
		"bd": 10,
		"bm": 7,
		"nm": "D.",
		"nf": "Cynthia",
		"nl": "Burnette",
		"url": "https://findagrave.com/memorial/169065891",
		"id": 169065891,
		"lng": -77.3862265,
		"lat": 37.53750738,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Robert",
		"nl": "Burnette",
		"url": "https://findagrave.com/memorial/146339012",
		"id": 146339012,
		"lng": -77.38638304,
		"lat": 37.53709366,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 2,
		"dd": 1,
		"by": 1924,
		"bd": 27,
		"bm": 7,
		"nm": "",
		"nf": "Gladys",
		"nl": "Burns",
		"url": "https://findagrave.com/memorial/155508023",
		"id": 155508023,
		"lng": -77.38762114,
		"lat": 37.53769596,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 4,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Burrell",
		"url": "https://findagrave.com/memorial/143825686",
		"id": 143825686,
		"lng": -77.38595068,
		"lat": 37.53725378,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pattie",
		"nl": "Burrell",
		"url": "https://findagrave.com/memorial/120725998",
		"id": 120725998,
		"lng": -77.38577615,
		"lat": 37.53688669,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 3,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Alice K.",
		"nf": "Sarah",
		"nl": "Burrell",
		"url": "https://findagrave.com/memorial/155979496",
		"id": 155979496,
		"lng": -77.38710714,
		"lat": 37.53551454,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 7,
		"dd": 14,
		"by": 1894,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Burrell",
		"url": "https://findagrave.com/memorial/142106150",
		"id": 142106150,
		"lng": -77.38669538,
		"lat": 37.53668164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 7,
		"dd": 21,
		"by": 1888,
		"bd": 26,
		"bm": 10,
		"nm": "Lee",
		"nf": "Bertha",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/38426041",
		"id": 38426041,
		"lng": -77.38615208,
		"lat": 37.53569214,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/171733166",
		"id": 171733166,
		"lng": -77.3871497,
		"lat": 37.53668364,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 8,
		"dd": 12,
		"by": 1891,
		"bd": 24,
		"bm": 1,
		"nm": "Jane",
		"nf": "Charlotte",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/38425986",
		"id": 38425986,
		"lng": -77.38615303,
		"lat": 37.53568871,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 19,
		"by": 1878,
		"bd": 27,
		"bm": 5,
		"nm": "Powell",
		"nf": "Hattie",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/173803808",
		"id": 173803808,
		"lng": -77.38753481,
		"lat": 37.53707234,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 3,
		"dd": 12,
		"by": 1859,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Jack",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/143631821",
		"id": 143631821,
		"lng": -77.38610856,
		"lat": 37.5356912,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 3,
		"dd": 4,
		"by": 1896,
		"bd": 5,
		"bm": 1,
		"nm": "Bernard",
		"nf": "Louis",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/159845252",
		"id": 159845252,
		"lng": -77.38798387,
		"lat": 37.53751714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 10,
		"dd": 28,
		"by": 1859,
		"bd": "",
		"bm": 12,
		"nm": "Mary",
		"nf": "Jane",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/143631830",
		"id": 143631830,
		"lng": -77.3861288,
		"lat": 37.53569542,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 10,
		"dd": 22,
		"by": 1922,
		"bd": 25,
		"bm": 8,
		"nm": "E.",
		"nf": "Pauline",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/177153819",
		"id": 177153819,
		"lng": -77.38781387,
		"lat": 37.53698926,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 10,
		"dd": 7,
		"by": 1852,
		"bd": "",
		"bm": 6,
		"nm": "",
		"nf": "Phyllis",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/119327969",
		"id": 119327969,
		"lng": -77.38551389,
		"lat": 37.53731766,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Adell",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/166047722",
		"id": 166047722,
		"lng": -77.38649363,
		"lat": 37.53669441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 20,
		"by": 1911,
		"bd": 17,
		"bm": 3,
		"nm": "",
		"nf": "Alice",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/137835700",
		"id": 137835700,
		"lng": -77.38626588,
		"lat": 37.53703051,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 14,
		"by": 1877,
		"bd": 12,
		"bm": 12,
		"nm": "",
		"nf": "Charles",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/117431857",
		"id": 117431857,
		"lng": -77.38581373,
		"lat": 37.53672669,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 11,
		"dd": 14,
		"by": 1912,
		"bd": 12,
		"bm": 3,
		"nm": "",
		"nf": "Charles",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/120726051",
		"id": 120726051,
		"lng": -77.38585774,
		"lat": 37.53673649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eddie",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/188301220",
		"id": 188301220,
		"lng": -77.38792156,
		"lat": 37.53705714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 4,
		"by": 1877,
		"bd": "",
		"bm": "",
		"nm": "Curtis",
		"nf": "Emma",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/117431795",
		"id": 117431795,
		"lng": -77.38581732,
		"lat": 37.53672783,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 11,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Harrison",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/144314847",
		"id": 144314847,
		"lng": -77.38705715,
		"lat": 37.5354991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 10,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Robert",
		"nf": "Henry",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/161180413",
		"id": 161180413,
		"lng": -77.38721303,
		"lat": 37.53717832,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "V.",
		"nf": "James",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/160039313",
		"id": 160039313,
		"lng": -77.38679622,
		"lat": 37.5375057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 6,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Alfred",
		"nf": "John",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/173807096",
		"id": 173807096,
		"lng": -77.38745271,
		"lat": 37.53710132,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 1,
		"dd": "",
		"by": 1903,
		"bd": "",
		"bm": 12,
		"nm": "A.",
		"nf": "Laurence",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/119593476",
		"id": 119593476,
		"lng": -77.38574528,
		"lat": 37.53669847,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 4,
		"dd": 7,
		"by": 1893,
		"bd": 1,
		"bm": 8,
		"nm": "Ellen",
		"nf": "Louise",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/116341545",
		"id": 116341545,
		"lng": -77.38747248,
		"lat": 37.53717479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 11,
		"dd": 11,
		"by": 1904,
		"bd": 20,
		"bm": 12,
		"nm": "",
		"nf": "Maurice",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/117431873",
		"id": 117431873,
		"lng": -77.38585939,
		"lat": 37.53672819,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 2,
		"dd": 8,
		"by": 1905,
		"bd": 5,
		"bm": 11,
		"nm": "M.",
		"nf": "Vernell",
		"nl": "Butler",
		"url": "https://findagrave.com/memorial/138181469",
		"id": 138181469,
		"lng": -77.38647289,
		"lat": 37.53697715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillie",
		"nl": "Bynum",
		"url": "https://findagrave.com/memorial/144013794",
		"id": 144013794,
		"lng": -77.38742085,
		"lat": 37.53761935,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Elaine",
		"nf": "Rita",
		"nl": "Byrd",
		"url": "https://findagrave.com/memorial/156934441",
		"id": 156934441,
		"lng": -77.38708581,
		"lat": 37.53764742,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 24,
		"by": 1889,
		"bd": 11,
		"bm": 6,
		"nm": "Burrell",
		"nf": "Susan",
		"nl": "Byrd",
		"url": "https://findagrave.com/memorial/143825843",
		"id": 143825843,
		"lng": -77.38594432,
		"lat": 37.53726489,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 8,
		"dd": 16,
		"by": 1923,
		"bd": 1,
		"bm": 3,
		"nm": "Edmond",
		"nf": "Landon",
		"nl": "Byrd",
		"url": "https://findagrave.com/memorial/192391489",
		"id": 192391489,
		"lng": -77.38762023,
		"lat": 37.53754203,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 7,
		"dd": 8,
		"by": 1881,
		"bd": 19,
		"bm": 10,
		"nm": "",
		"nf": "Nora",
		"nl": "Byron",
		"url": "https://findagrave.com/memorial/183193844",
		"id": 183193844,
		"lng": -77.38724976,
		"lat": 37.53706014,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 1,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennie",
		"nl": "Caesar",
		"url": "https://findagrave.com/memorial/122786273",
		"id": 122786273,
		"lng": -77.3858758,
		"lat": 37.53645878,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 9,
		"dd": 23,
		"by": 1935,
		"bd": 5,
		"bm": 12,
		"nm": "Lee",
		"nf": "Willie",
		"nl": "Caldwell",
		"url": "https://findagrave.com/memorial/161636474",
		"id": 161636474,
		"lng": -77.38611117,
		"lat": 37.53632553,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eva",
		"nl": "Calhoun",
		"url": "https://findagrave.com/memorial/142106152",
		"id": 142106152,
		"lng": -77.386749,
		"lat": 37.53670232,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 2,
		"dd": 18,
		"by": 1929,
		"bd": 24,
		"bm": 10,
		"nm": "Arthur",
		"nf": "Charles",
		"nl": "Callaham",
		"url": "https://findagrave.com/memorial/166812416",
		"id": 166812416,
		"lng": -77.38804315,
		"lat": 37.53751547,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 11,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Stubbs",
		"nf": "Robert",
		"nl": "Callahan",
		"url": "https://findagrave.com/memorial/176986675",
		"id": 176986675,
		"lng": -77.38784045,
		"lat": 37.53744319,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 13,
		"by": 1947,
		"bd": 12,
		"bm": 9,
		"nm": "Jean",
		"nf": "Thelma",
		"nl": "Callahan",
		"url": "https://findagrave.com/memorial/187347874",
		"id": 187347874,
		"lng": -77.3874418,
		"lat": 37.53740127,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 3,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Calloway",
		"url": "https://findagrave.com/memorial/173209804",
		"id": 173209804,
		"lng": -77.38742291,
		"lat": 37.53673055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 7,
		"dd": 13,
		"by": 1886,
		"bd": "",
		"bm": 10,
		"nm": "",
		"nf": "Earnestine",
		"nl": "Calloway",
		"url": "https://findagrave.com/memorial/127853297",
		"id": 127853297,
		"lng": -77.38649203,
		"lat": 37.53652416,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 1,
		"dd": 7,
		"by": 1885,
		"bd": 10,
		"bm": 11,
		"nm": "D.",
		"nf": "Samuel",
		"nl": "Calloway",
		"url": "https://findagrave.com/memorial/122027267",
		"id": 122027267,
		"lng": -77.38647876,
		"lat": 37.53655603,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 9,
		"dd": 1,
		"by": 1920,
		"bd": 30,
		"bm": 1,
		"nm": "",
		"nf": "Horace",
		"nl": "Calvin",
		"url": "https://findagrave.com/memorial/127988069",
		"id": 127988069,
		"lng": -77.385619,
		"lat": 37.53705374,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 5,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "William",
		"nl": "Calvin",
		"url": "https://findagrave.com/memorial/150348911",
		"id": 150348911,
		"lng": -77.38595713,
		"lat": 37.53636233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 12,
		"dd": 7,
		"by": 1901,
		"bd": 23,
		"bm": 11,
		"nm": "Archie",
		"nf": "Benjamin",
		"nl": "Cameron",
		"url": "https://findagrave.com/memorial/150493590",
		"id": 150493590,
		"lng": -77.38640306,
		"lat": 37.53595518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 10,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Wesley",
		"nf": "James",
		"nl": "Cameron",
		"url": "https://findagrave.com/memorial/174622136",
		"id": 174622136,
		"lng": -77.38696627,
		"lat": 37.5371292,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 2,
		"by": 1963,
		"bd": 18,
		"bm": 9,
		"nm": "J.",
		"nf": "James",
		"nl": "Camp",
		"url": "https://findagrave.com/memorial/159411324",
		"id": 159411324,
		"lng": -77.38617867,
		"lat": 37.53750668,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 21,
		"by": 1957,
		"bd": 12,
		"bm": 9,
		"nm": "",
		"nf": "Juanita",
		"nl": "Campbell",
		"url": "https://findagrave.com/memorial/145594992",
		"id": 145594992,
		"lng": -77.38609634,
		"lat": 37.53747919,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 4,
		"dd": 16,
		"by": 1888,
		"bd": 24,
		"bm": 7,
		"nm": "B.",
		"nf": "Theresa",
		"nl": "Capers",
		"url": "https://findagrave.com/memorial/126456372",
		"id": 126456372,
		"lng": -77.38583158,
		"lat": 37.53641127,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 12,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Capers",
		"url": "https://findagrave.com/memorial/126456382",
		"id": 126456382,
		"lng": -77.38583344,
		"lat": 37.53640616,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 28,
		"by": 1895,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Charles",
		"nl": "Capies",
		"url": "https://findagrave.com/memorial/176986901",
		"id": 176986901,
		"lng": -77.3878428,
		"lat": 37.53742544,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 8,
		"dd": 22,
		"by": 1905,
		"bd": 13,
		"bm": 9,
		"nm": "",
		"nf": "Alpheus",
		"nl": "Carey",
		"url": "https://findagrave.com/memorial/185658244",
		"id": 185658244,
		"lng": -77.38724006,
		"lat": 37.53774567,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 8,
		"dd": 6,
		"by": 1927,
		"bd": 2,
		"bm": 10,
		"nm": "Henry",
		"nf": "Rudolph",
		"nl": "Carey",
		"url": "https://findagrave.com/memorial/138181476",
		"id": 138181476,
		"lng": -77.38676042,
		"lat": 37.53688157,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 21,
		"by": 1917,
		"bd": 5,
		"bm": 7,
		"nm": "Hampton",
		"nf": "Walter",
		"nl": "Carey",
		"url": "https://findagrave.com/memorial/173156018",
		"id": 173156018,
		"lng": -77.38726968,
		"lat": 37.53720749,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 8,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bessie",
		"nl": "Carpenter",
		"url": "https://findagrave.com/memorial/76587741",
		"id": 76587741,
		"lng": -77.38618368,
		"lat": 37.53719112,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 12,
		"dd": 30,
		"by": 1910,
		"bd": 10,
		"bm": 6,
		"nm": "H.",
		"nf": "Joseph",
		"nl": "Carpenter",
		"url": "https://findagrave.com/memorial/178266029",
		"id": 178266029,
		"lng": -77.38803743,
		"lat": 37.53742953,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 1,
		"dd": 4,
		"by": 1914,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Cornelia",
		"nl": "Carr",
		"url": "https://findagrave.com/memorial/149165835",
		"id": 149165835,
		"lng": -77.38620755,
		"lat": 37.53595415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 9,
		"dd": 28,
		"by": 1858,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Ida",
		"nl": "Carr",
		"url": "https://findagrave.com/memorial/149439649",
		"id": 149439649,
		"lng": -77.3860361,
		"lat": 37.53584379,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 10,
		"dd": 4,
		"by": 1882,
		"bd": 10,
		"bm": 1,
		"nm": "J.",
		"nf": "Ella",
		"nl": "Carrington",
		"url": "https://findagrave.com/memorial/127545794",
		"id": 127545794,
		"lng": -77.38624183,
		"lat": 37.5369435,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 23,
		"by": 1875,
		"bd": 12,
		"bm": 7,
		"nm": "L.",
		"nf": "Julian",
		"nl": "Carrington",
		"url": "https://findagrave.com/memorial/127545785",
		"id": 127545785,
		"lng": -77.38624095,
		"lat": 37.53694621,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 11,
		"dd": 29,
		"by": 1908,
		"bd": 12,
		"bm": 7,
		"nm": "",
		"nf": "Rose",
		"nl": "Carrington",
		"url": "https://findagrave.com/memorial/162641861",
		"id": 162641861,
		"lng": -77.38683784,
		"lat": 37.53703527,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 12,
		"dd": 16,
		"by": 1933,
		"bd": 14,
		"bm": 2,
		"nm": "",
		"nf": "Geraldine",
		"nl": "Carroll",
		"url": "https://findagrave.com/memorial/172409718",
		"id": 172409718,
		"lng": -77.38643064,
		"lat": 37.53530458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 1,
		"dd": 17,
		"by": 1918,
		"bd": 2,
		"bm": 8,
		"nm": "",
		"nf": "Melvin",
		"nl": "Carroll",
		"url": "https://findagrave.com/memorial/170405395",
		"id": 170405395,
		"lng": -77.38600475,
		"lat": 37.53630945,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 2,
		"dd": 13,
		"by": 1897,
		"bd": 17,
		"bm": 4,
		"nm": "F.",
		"nf": "Joseph",
		"nl": "Carson",
		"url": "https://findagrave.com/memorial/176115625",
		"id": 176115625,
		"lng": -77.38608123,
		"lat": 37.53636299,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 7,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Bessie",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/174712858",
		"id": 174712858,
		"lng": -77.38760747,
		"lat": 37.53692398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 3,
		"dd": 31,
		"by": 1839,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "Bettie",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/151131226",
		"id": 151131226,
		"lng": -77.38673064,
		"lat": 37.53540629,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Bremmer",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/172682198",
		"id": 172682198,
		"lng": -77.38698253,
		"lat": 37.53719375,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Catherine",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/171762818",
		"id": 171762818,
		"lng": -77.38689133,
		"lat": 37.53666678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 7,
		"dd": 20,
		"by": 1880,
		"bd": 5,
		"bm": 7,
		"nm": "Boyd",
		"nf": "Charles",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/38425322",
		"id": 38425322,
		"lng": -77.38611214,
		"lat": 37.53572143,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 6,
		"dd": 13,
		"by": 1915,
		"bd": 6,
		"bm": 4,
		"nm": "N.",
		"nf": "David",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/166386383",
		"id": 166386383,
		"lng": -77.38747311,
		"lat": 37.5368498,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 7,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Delia",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/176270298",
		"id": 176270298,
		"lng": -77.38746936,
		"lat": 37.53687328,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 6,
		"dd": 25,
		"by": 1873,
		"bd": 22,
		"bm": 2,
		"nm": "Blackburn",
		"nf": "George",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/140624937",
		"id": 140624937,
		"lng": -77.38662147,
		"lat": 37.5356883,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 6,
		"dd": 18,
		"by": 1870,
		"bd": 1,
		"bm": 3,
		"nm": "W.",
		"nf": "George",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/132641043",
		"id": 132641043,
		"lng": -77.38549253,
		"lat": 37.53722073,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 2002,
		"dm": 6,
		"dd": 27,
		"by": 1932,
		"bd": 13,
		"bm": 8,
		"nm": "E.",
		"nf": "Gladys",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/114466951",
		"id": 114466951,
		"lng": -77.38631047,
		"lat": 37.5368613,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 5,
		"by": 1924,
		"bd": 25,
		"bm": 3,
		"nm": "",
		"nf": "Helen",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/169397240",
		"id": 169397240,
		"lng": -77.38653525,
		"lat": 37.53689605,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 15,
		"by": 1884,
		"bd": 25,
		"bm": 2,
		"nm": "Harvey",
		"nf": "James",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/178405026",
		"id": 178405026,
		"lng": -77.3864097,
		"lat": 37.53629826,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 31,
		"by": 1905,
		"bd": 13,
		"bm": 5,
		"nm": "H.",
		"nf": "James",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/113750893",
		"id": 113750893,
		"lng": -77.38628206,
		"lat": 37.53687407,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": "",
		"dd": "",
		"by": 1900,
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "John",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/161171355",
		"id": 161171355,
		"lng": -77.38644841,
		"lat": 37.53708408,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 8,
		"dd": 1,
		"by": 1914,
		"bd": 14,
		"bm": 9,
		"nm": "",
		"nf": "Joseph",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/125094142",
		"id": 125094142,
		"lng": -77.38673544,
		"lat": 37.53705135,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 22,
		"by": 1905,
		"bd": 13,
		"bm": 5,
		"nm": "",
		"nf": "Josephine",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/185739207",
		"id": 185739207,
		"lng": -77.38749209,
		"lat": 37.53736965,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Junius",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/187745588",
		"id": 187745588,
		"lng": -77.38781612,
		"lat": 37.53695039,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 5,
		"dd": 31,
		"by": 1901,
		"bd": 11,
		"bm": 5,
		"nm": "Cordelia",
		"nf": "Katharine",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/140624962",
		"id": 140624962,
		"lng": -77.38662371,
		"lat": 37.53568302,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 16,
		"by": 1903,
		"bd": 25,
		"bm": 3,
		"nm": "E.",
		"nf": "Katie",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/158678010",
		"id": 158678010,
		"lng": -77.38679383,
		"lat": 37.53757086,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1893,
		"bd": 29,
		"bm": 3,
		"nm": "Anna",
		"nf": "Lee",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/140624952",
		"id": 140624952,
		"lng": -77.38662068,
		"lat": 37.53569612,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 6,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louise",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/161096986",
		"id": 161096986,
		"lng": -77.38715191,
		"lat": 37.53703487,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 2,
		"dd": 14,
		"by": 1883,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/150910944",
		"id": 150910944,
		"lng": -77.38675228,
		"lat": 37.53582902,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 28,
		"by": 1910,
		"bd": 24,
		"bm": 3,
		"nm": "",
		"nf": "Margaret",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/142441918",
		"id": 142441918,
		"lng": -77.38587427,
		"lat": 37.53728715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 6,
		"dd": 27,
		"by": 1875,
		"bd": 5,
		"bm": 5,
		"nm": "Elizabeth",
		"nf": "Mary",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/140624947",
		"id": 140624947,
		"lng": -77.38663392,
		"lat": 37.53570545,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 10,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/113750900",
		"id": 113750900,
		"lng": -77.38628096,
		"lat": 37.53686451,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 27,
		"by": 1898,
		"bd": 6,
		"bm": 5,
		"nm": "Louise",
		"nf": "Nannie",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/177123343",
		"id": 177123343,
		"lng": -77.38637971,
		"lat": 37.53736649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 3,
		"dd": 30,
		"by": 1879,
		"bd": 2,
		"bm": 6,
		"nm": "",
		"nf": "Narcissa",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/38425727",
		"id": 38425727,
		"lng": -77.38610313,
		"lat": 37.53572779,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 21,
		"by": 1872,
		"bd": 3,
		"bm": 11,
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/191435949",
		"id": 191435949,
		"lng": -77.38660223,
		"lat": 37.53716715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 22,
		"by": 1967,
		"bd": 21,
		"bm": 9,
		"nm": "",
		"nf": "Orlandus",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/153380966",
		"id": 153380966,
		"lng": -77.38592224,
		"lat": 37.53744228,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 1,
		"dd": 1,
		"by": 1936,
		"bd": 27,
		"bm": 1,
		"nm": "L.",
		"nf": "Raymond",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/188245250",
		"id": 188245250,
		"lng": -77.38805253,
		"lat": 37.53735602,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 9,
		"dd": 28,
		"by": 1881,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/177037009",
		"id": 177037009,
		"lng": -77.38801016,
		"lat": 37.53724772,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/172214454",
		"id": 172214454,
		"lng": -77.38749958,
		"lat": 37.53684597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 9,
		"dd": 8,
		"by": 1906,
		"bd": 20,
		"bm": 9,
		"nm": "Gwyndoline",
		"nf": "V.",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/149165842",
		"id": 149165842,
		"lng": -77.38610608,
		"lat": 37.53574968,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 4,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Viola",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/142441926",
		"id": 142441926,
		"lng": -77.38578523,
		"lat": 37.53728784,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 6,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Irene",
		"nl": "Cary",
		"url": "https://findagrave.com/memorial/150919751",
		"id": 150919751,
		"lng": -77.38618178,
		"lat": 37.53556488,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 10,
		"dd": 1,
		"by": 1885,
		"bd": 16,
		"bm": 9,
		"nm": "E.",
		"nf": "James",
		"nl": "Cary",
		"url": "https://findagrave.com/memorial/156656231",
		"id": 156656231,
		"lng": -77.38655535,
		"lat": 37.53584775,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 3,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Louvenia",
		"nf": "Eunice",
		"nl": "Caster",
		"url": "https://findagrave.com/memorial/168775127",
		"id": 168775127,
		"lng": -77.38627104,
		"lat": 37.53697434,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 7,
		"dd": 8,
		"by": 1930,
		"bd": 7,
		"bm": 8,
		"nm": "H.",
		"nf": "James",
		"nl": "Caster",
		"url": "https://findagrave.com/memorial/133448289",
		"id": 133448289,
		"lng": -77.38624801,
		"lat": 37.53697045,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 3,
		"dd": 20,
		"by": 1869,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Dora",
		"nl": "Catlett",
		"url": "https://findagrave.com/memorial/182683456",
		"id": 182683456,
		"lng": -77.38759341,
		"lat": 37.53655356,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 8,
		"dd": 6,
		"by": 1868,
		"bd": 15,
		"bm": 4,
		"nm": "",
		"nf": "Eugene",
		"nl": "Catlett",
		"url": "https://findagrave.com/memorial/134359150",
		"id": 134359150,
		"lng": -77.38763612,
		"lat": 37.53655949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 7,
		"dd": 15,
		"by": 1926,
		"bd": 7,
		"bm": 6,
		"nm": "",
		"nf": "Irene",
		"nl": "Catlett",
		"url": "https://findagrave.com/memorial/182683525",
		"id": 182683525,
		"lng": -77.38761755,
		"lat": 37.53655643,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": "",
		"dd": "",
		"by": 1967,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby girl",
		"nl": "Caul??",
		"url": "https://findagrave.com/memorial/145838169",
		"id": 145838169,
		"lng": -77.38593373,
		"lat": 37.53744446,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 10,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Anna",
		"nl": "Cave",
		"url": "https://findagrave.com/memorial/153511895",
		"id": 153511895,
		"lng": -77.38641643,
		"lat": 37.53736772,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 10,
		"dd": 22,
		"by": 1910,
		"bd": 19,
		"bm": 9,
		"nm": "",
		"nf": "Eddie",
		"nl": "Cepers",
		"url": "https://findagrave.com/memorial/126652572",
		"id": 126652572,
		"lng": -77.38597362,
		"lat": 37.53637644,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 12,
		"dd": 5,
		"by": 1877,
		"bd": 20,
		"bm": 4,
		"nm": "",
		"nf": "Mary",
		"nl": "Cephas",
		"url": "https://findagrave.com/memorial/178089650",
		"id": 178089650,
		"lng": -77.38662766,
		"lat": 37.53537578,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Pauline",
		"nl": "Cephas",
		"url": "https://findagrave.com/memorial/142526002",
		"id": 142526002,
		"lng": -77.38657408,
		"lat": 37.53704517,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucinda",
		"nl": "Chaffin",
		"url": "https://findagrave.com/memorial/175609592",
		"id": 175609592,
		"lng": -77.38762914,
		"lat": 37.53712682,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 2,
		"by": 1898,
		"bd": 22,
		"bm": 4,
		"nm": "",
		"nf": "Royall",
		"nl": "Chaffin",
		"url": "https://findagrave.com/memorial/187347880",
		"id": 187347880,
		"lng": -77.38783043,
		"lat": 37.53715296,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 4,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Carrie",
		"nl": "Chambers",
		"url": "https://findagrave.com/memorial/179551998",
		"id": 179551998,
		"lng": -77.38802798,
		"lat": 37.53775501,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 10,
		"dd": 8,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Chambers",
		"url": "https://findagrave.com/memorial/150883180",
		"id": 150883180,
		"lng": -77.38657123,
		"lat": 37.53585991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 16,
		"by": 1894,
		"bd": "",
		"bm": "",
		"nm": "Eliza",
		"nf": "Mary",
		"nl": "Chambers",
		"url": "https://findagrave.com/memorial/147853130",
		"id": 147853130,
		"lng": -77.38637173,
		"lat": 37.53718423,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 24,
		"by": 1869,
		"bd": 6,
		"bm": 4,
		"nm": "Fannie",
		"nf": "Susie",
		"nl": "Chambers",
		"url": "https://findagrave.com/memorial/172031011",
		"id": 172031011,
		"lng": -77.38683307,
		"lat": 37.53717712,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 6,
		"dd": 7,
		"by": 1922,
		"bd": 31,
		"bm": 10,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Chancler",
		"url": "https://findagrave.com/memorial/147853139",
		"id": 147853139,
		"lng": -77.38595353,
		"lat": 37.53635649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 17,
		"by": 1907,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "John",
		"nl": "Chancler",
		"url": "https://findagrave.com/memorial/149352529",
		"id": 149352529,
		"lng": -77.38647874,
		"lat": 37.53711632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 15,
		"by": 1965,
		"bd": 9,
		"bm": 5,
		"nm": "Keith",
		"nf": "Haywood",
		"nl": "Chandler",
		"url": "https://findagrave.com/memorial/145638779",
		"id": 145638779,
		"lng": -77.38608963,
		"lat": 37.5374239,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 7,
		"by": 1965,
		"bd": 28,
		"bm": 5,
		"nm": "Denise",
		"nf": "Joan",
		"nl": "Chandler",
		"url": "https://findagrave.com/memorial/144102630",
		"id": 144102630,
		"lng": -77.38609557,
		"lat": 37.53740908,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 9,
		"dd": 9,
		"by": 1871,
		"bd": "",
		"bm": 9,
		"nm": "Arthur",
		"nf": "Benjamin",
		"nl": "Chapman",
		"url": "https://findagrave.com/memorial/127460963",
		"id": 127460963,
		"lng": -77.38647298,
		"lat": 37.53646052,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 7,
		"dd": 13,
		"by": 1869,
		"bd": 27,
		"bm": 5,
		"nm": "L.",
		"nf": "Cora",
		"nl": "Chapman",
		"url": "https://findagrave.com/memorial/127460973",
		"id": 127460973,
		"lng": -77.3864512,
		"lat": 37.53645417,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 10,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maggie",
		"nl": "Chapman",
		"url": "https://findagrave.com/memorial/149696105",
		"id": 149696105,
		"lng": -77.3869072,
		"lat": 37.53663817,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 3,
		"dd": 16,
		"by": 1919,
		"bd": 4,
		"bm": 10,
		"nm": "C.",
		"nf": "Raymond",
		"nl": "Chapman",
		"url": "https://findagrave.com/memorial/150078581",
		"id": 150078581,
		"lng": -77.38655922,
		"lat": 37.53695589,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 8,
		"dd": 15,
		"by": 1910,
		"bd": 19,
		"bm": 10,
		"nm": "McKline",
		"nf": "Haywood",
		"nl": "Charity",
		"url": "https://findagrave.com/memorial/158889110",
		"id": 158889110,
		"lng": -77.38708505,
		"lat": 37.5374072,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 6,
		"dd": 23,
		"by": 1885,
		"bd": 16,
		"bm": 9,
		"nm": "Pleasant",
		"nf": "Joseph",
		"nl": "Charity",
		"url": "https://findagrave.com/memorial/158731874",
		"id": 158731874,
		"lng": -77.38706672,
		"lat": 37.5375177,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 10,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Sarah",
		"nl": "Chatman",
		"url": "https://findagrave.com/memorial/144542850",
		"id": 144542850,
		"lng": -77.3868994,
		"lat": 37.5366357,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby girl",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/142106157",
		"id": 142106157,
		"lng": -77.38615686,
		"lat": 37.53745659,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 1,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edgar",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/175839463",
		"id": 175839463,
		"lng": -77.38767936,
		"lat": 37.53713963,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 4,
		"dd": 23,
		"by": 1905,
		"bd": 5,
		"bm": 11,
		"nm": "M.",
		"nf": "Felicia",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/127096242",
		"id": 127096242,
		"lng": -77.38650994,
		"lat": 37.53655287,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 4,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lansing",
		"nf": "Howard",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/187824855",
		"id": 187824855,
		"lng": -77.38757757,
		"lat": 37.53713242,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 12,
		"dd": 18,
		"by": 1862,
		"bd": 30,
		"bm": 1,
		"nm": "M.",
		"nf": "James",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/127096194",
		"id": 127096194,
		"lng": -77.38650928,
		"lat": 37.53655496,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 7,
		"dd": 7,
		"by": 1901,
		"bd": 28,
		"bm": 8,
		"nm": "Ann",
		"nf": "Lucy",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/127096230",
		"id": 127096230,
		"lng": -77.38650962,
		"lat": 37.53655385,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 8,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/142526022",
		"id": 142526022,
		"lng": -77.38642529,
		"lat": 37.53544124,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matilda",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/177018343",
		"id": 177018343,
		"lng": -77.38799005,
		"lat": 37.53722554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 9,
		"dd": 7,
		"by": 1897,
		"bd": 14,
		"bm": 2,
		"nm": "Lee",
		"nf": "Rosa",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/126868501",
		"id": 126868501,
		"lng": -77.38594155,
		"lat": 37.53664146,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 10,
		"dd": 4,
		"by": 1885,
		"bd": 14,
		"bm": 7,
		"nm": "LeRoy",
		"nf": "Andrew",
		"nl": "Cheesman",
		"url": "https://findagrave.com/memorial/144820112",
		"id": 144820112,
		"lng": -77.3862968,
		"lat": 37.53728205,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 3,
		"dd": 17,
		"by": 1885,
		"bd": 17,
		"bm": 7,
		"nm": "",
		"nf": "Madeline",
		"nl": "Cheesman",
		"url": "https://findagrave.com/memorial/154228729",
		"id": 154228729,
		"lng": -77.3863112,
		"lat": 37.53742369,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 10,
		"dd": 4,
		"by": 1872,
		"bd": 2,
		"bm": 2,
		"nm": "P.",
		"nf": "William",
		"nl": "Cheesman",
		"url": "https://findagrave.com/memorial/184094521",
		"id": 184094521,
		"lng": -77.38717986,
		"lat": 37.53761611,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 18,
		"by": 1964,
		"bd": 13,
		"bm": 10,
		"nm": "Foitane",
		"nf": "Benjamin",
		"nl": "Cherry",
		"url": "https://findagrave.com/memorial/145638782",
		"id": 145638782,
		"lng": -77.38597292,
		"lat": 37.53746974,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 29,
		"by": 1963,
		"bd": 2,
		"bm": 12,
		"nm": "Marie",
		"nf": "Zeegintis",
		"nl": "Childs",
		"url": "https://findagrave.com/memorial/169041553",
		"id": 169041553,
		"lng": -77.386116,
		"lat": 37.53746398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 14,
		"by": 1899,
		"bd": 25,
		"bm": 10,
		"nm": "",
		"nf": "Alexander",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/173920109",
		"id": 173920109,
		"lng": -77.38729493,
		"lat": 37.5373823,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 12,
		"dd": 14,
		"by": 1875,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Alice",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/175327979",
		"id": 175327979,
		"lng": -77.387409,
		"lat": 37.5370717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 4,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Allen",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/176769152",
		"id": 176769152,
		"lng": -77.38774521,
		"lat": 37.53703393,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 5,
		"dd": 1,
		"by": 1878,
		"bd": 16,
		"bm": 8,
		"nm": "A.",
		"nf": "Bernard",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/155021582",
		"id": 155021582,
		"lng": -77.38711652,
		"lat": 37.53769444,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 9,
		"dd": 28,
		"by": 1928,
		"bd": 14,
		"bm": 4,
		"nm": "L.",
		"nf": "Eleanor",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/116948299",
		"id": 116948299,
		"lng": -77.38574652,
		"lat": 37.53670692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 30,
		"by": 1900,
		"bd": 25,
		"bm": 8,
		"nm": "Garfield",
		"nf": "Ernest",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/116948323",
		"id": 116948323,
		"lng": -77.38575143,
		"lat": 37.53669902,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 3,
		"dd": 11,
		"by": 1900,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Gus",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/163518411",
		"id": 163518411,
		"lng": -77.3861823,
		"lat": 37.53727676,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1934,
		"bd": 8,
		"bm": 7,
		"nm": "Henry",
		"nf": "James",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/144102584",
		"id": 144102584,
		"lng": -77.3862359,
		"lat": 37.53747617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Cooper",
		"nf": "Jennie",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/125514752",
		"id": 125514752,
		"lng": -77.38603583,
		"lat": 37.53690787,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 30,
		"by": 1959,
		"bd": 5,
		"bm": 11,
		"nm": "Alexander",
		"nf": "John",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/153863147",
		"id": 153863147,
		"lng": -77.38622422,
		"lat": 37.53749753,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 2,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "John",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/151450674",
		"id": 151450674,
		"lng": -77.38676086,
		"lat": 37.53545612,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "John",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/144188794",
		"id": 144188794,
		"lng": -77.38751354,
		"lat": 37.53739165,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 7,
		"dd": 29,
		"by": 1843,
		"bd": 15,
		"bm": 8,
		"nm": "",
		"nf": "Josephine",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/127988076",
		"id": 127988076,
		"lng": -77.3864463,
		"lat": 37.53652466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kate",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/160907606",
		"id": 160907606,
		"lng": -77.38696774,
		"lat": 37.53703128,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 1,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lizzie",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/127853319",
		"id": 127853319,
		"lng": -77.38607063,
		"lat": 37.53655487,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 10,
		"dd": 21,
		"by": 1870,
		"bd": 12,
		"bm": 12,
		"nm": "",
		"nf": "Lucy",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/144102592",
		"id": 144102592,
		"lng": -77.38717282,
		"lat": 37.53777823,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 12,
		"dd": 9,
		"by": 1898,
		"bd": 15,
		"bm": 10,
		"nm": "Eliza",
		"nf": "Odell",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/136107502",
		"id": 136107502,
		"lng": -77.38563833,
		"lat": 37.53733484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 20,
		"by": 1900,
		"bd": 10,
		"bm": 5,
		"nm": "A.",
		"nf": "Raymond",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/160053463",
		"id": 160053463,
		"lng": -77.38654251,
		"lat": 37.53746472,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Robert",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/176060167",
		"id": 176060167,
		"lng": -77.38732909,
		"lat": 37.53705996,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 30,
		"by": 1963,
		"bd": 15,
		"bm": 8,
		"nm": "V.",
		"nf": "Sheila",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/153863739",
		"id": 153863739,
		"lng": -77.38622712,
		"lat": 37.53749185,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 11,
		"dd": 3,
		"by": 1906,
		"bd": 15,
		"bm": 12,
		"nm": "",
		"nf": "Susie",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/114080828",
		"id": 114080828,
		"lng": -77.38577451,
		"lat": 37.536711,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 30,
		"by": 1958,
		"bd": 19,
		"bm": 2,
		"nm": "Ann",
		"nf": "Vanessa",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/153378637",
		"id": 153378637,
		"lng": -77.38623061,
		"lat": 37.53748566,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 8,
		"dd": 10,
		"by": 1842,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Wallace",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/127853333",
		"id": 127853333,
		"lng": -77.38644875,
		"lat": 37.536517,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 11,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Bernard",
		"nf": "William",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/169281846",
		"id": 169281846,
		"lng": -77.38647075,
		"lat": 37.53683075,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 5,
		"by": 1898,
		"bd": 25,
		"bm": 12,
		"nm": "Major",
		"nf": "William",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/159760631",
		"id": 159760631,
		"lng": -77.38761005,
		"lat": 37.53786706,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 8,
		"dd": 15,
		"by": 1919,
		"bd": 19,
		"bm": 3,
		"nm": "C.",
		"nf": "Willie",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/150493598",
		"id": 150493598,
		"lng": -77.38637675,
		"lat": 37.53595936,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 12,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Blanche",
		"nl": "Claiborne",
		"url": "https://findagrave.com/memorial/144013799",
		"id": 144013799,
		"lng": -77.38725785,
		"lat": 37.53783867,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 10,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Jefferson",
		"nf": "Charles",
		"nl": "Claiborne",
		"url": "https://findagrave.com/memorial/173510614",
		"id": 173510614,
		"lng": -77.38752476,
		"lat": 37.53711045,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 12,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "John",
		"nl": "Claiborne",
		"url": "https://findagrave.com/memorial/146339032",
		"id": 146339032,
		"lng": -77.38665322,
		"lat": 37.53584396,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 10,
		"by": 1869,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Claiborne",
		"url": "https://findagrave.com/memorial/183587435",
		"id": 183587435,
		"lng": -77.38690585,
		"lat": 37.53694939,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 31,
		"by": 1922,
		"bd": 15,
		"bm": 8,
		"nm": "H.",
		"nf": "Ruth",
		"nl": "Clanton",
		"url": "https://findagrave.com/memorial/143825848",
		"id": 143825848,
		"lng": -77.38603349,
		"lat": 37.53731477,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 15,
		"by": 1917,
		"bd": 4,
		"bm": 1,
		"nm": "",
		"nf": "Samuel",
		"nl": "Clanton",
		"url": "https://findagrave.com/memorial/144314855",
		"id": 144314855,
		"lng": -77.38757101,
		"lat": 37.53732254,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 4,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Bell",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/133716093",
		"id": 133716093,
		"lng": -77.385977,
		"lat": 37.53613809,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 10,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emma",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/129208534",
		"id": 129208534,
		"lng": -77.38591912,
		"lat": 37.53678367,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 10,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eva",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/183909858",
		"id": 183909858,
		"lng": -77.38686322,
		"lat": 37.53688233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 7,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Evelina",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/149250576",
		"id": 149250576,
		"lng": -77.38645196,
		"lat": 37.53559765,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 1,
		"dd": 12,
		"by": 1892,
		"bd": 24,
		"bm": 7,
		"nm": "",
		"nf": "Martha",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/127568636",
		"id": 127568636,
		"lng": -77.386048,
		"lat": 37.53707755,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 3,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lipscomb",
		"nf": "Susie",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/125514780",
		"id": 125514780,
		"lng": -77.386167,
		"lat": 37.53680844,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 30,
		"by": 1881,
		"bd": 8,
		"bm": 3,
		"nm": "",
		"nf": "Wilbur",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/127568640",
		"id": 127568640,
		"lng": -77.38606482,
		"lat": 37.53708243,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 10,
		"dd": 13,
		"by": 1875,
		"bd": 21,
		"bm": 7,
		"nm": "",
		"nf": "Alberta",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/125408433",
		"id": 125408433,
		"lng": -77.38770943,
		"lat": 37.53674727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": "",
		"dd": "",
		"by": 1834,
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Ann",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/131428496",
		"id": 131428496,
		"lng": -77.38760175,
		"lat": 37.53661973,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 2,
		"dd": 22,
		"by": 1926,
		"bd": "",
		"bm": "",
		"nm": "Lee Violet",
		"nf": "Annie",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/158625556",
		"id": 158625556,
		"lng": -77.38668532,
		"lat": 37.53570207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 3,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Benjamin",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/133716100",
		"id": 133716100,
		"lng": -77.38597167,
		"lat": 37.53614299,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 3,
		"dd": 31,
		"by": 1951,
		"bd": 21,
		"bm": 9,
		"nm": "Alvin",
		"nf": "Edric",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/138040757",
		"id": 138040757,
		"lng": -77.38659982,
		"lat": 37.53696705,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Ellen",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/125805398",
		"id": 125805398,
		"lng": -77.38597206,
		"lat": 37.53615094,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 8,
		"dd": 10,
		"by": 1875,
		"bd": 14,
		"bm": 5,
		"nm": "Mary",
		"nf": "Elsie",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/156480497",
		"id": 156480497,
		"lng": -77.38645007,
		"lat": 37.535746,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 12,
		"dd": 17,
		"by": 1873,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "James",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/185564840",
		"id": 185564840,
		"lng": -77.38616261,
		"lat": 37.53680721,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/169479171",
		"id": 169479171,
		"lng": -77.38771809,
		"lat": 37.53709877,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 10,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/146012146",
		"id": 146012146,
		"lng": -77.38772874,
		"lat": 37.53675392,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 22,
		"by": 1900,
		"bd": 23,
		"bm": 10,
		"nm": "H.",
		"nf": "John",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/125514760",
		"id": 125514760,
		"lng": -77.38617195,
		"lat": 37.53680957,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 3,
		"dd": 31,
		"by": 1904,
		"bd": 1,
		"bm": 9,
		"nm": "E.",
		"nf": "Lonnie",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/153410137",
		"id": 153410137,
		"lng": -77.38595548,
		"lat": 37.53686846,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 6,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Turpin",
		"nf": "Philip",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/144542865",
		"id": 144542865,
		"lng": -77.38645116,
		"lat": 37.53573701,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 4,
		"dd": 11,
		"by": 1906,
		"bd": "",
		"bm": "",
		"nm": "Egbert",
		"nf": "Ramon",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/144820121",
		"id": 144820121,
		"lng": -77.38644764,
		"lat": 37.53575724,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": "",
		"dd": "",
		"by": 1853,
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Sallie",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/125514770",
		"id": 125514770,
		"lng": -77.3875876,
		"lat": 37.53662646,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 2,
		"dd": 19,
		"by": 1851,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Susan",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/154270046",
		"id": 154270046,
		"lng": -77.38645915,
		"lat": 37.53556964,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 8,
		"dd": 23,
		"by": 1897,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Albert",
		"nl": "Clay",
		"url": "https://findagrave.com/memorial/185435769",
		"id": 185435769,
		"lng": -77.38717725,
		"lat": 37.53581451,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Clay",
		"url": "https://findagrave.com/memorial/191555703",
		"id": 191555703,
		"lng": -77.38646402,
		"lat": 37.5358758,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 17,
		"by": 1895,
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Rosa",
		"nl": "Clay",
		"url": "https://findagrave.com/memorial/160433828",
		"id": 160433828,
		"lng": -77.386102,
		"lat": 37.53646218,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 8,
		"dd": 8,
		"by": 1887,
		"bd": 20,
		"bm": 12,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Clayton",
		"url": "https://findagrave.com/memorial/114080850",
		"id": 114080850,
		"lng": -77.38576537,
		"lat": 37.53672474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 11,
		"dd": 17,
		"by": 1877,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "William",
		"nl": "Clements",
		"url": "https://findagrave.com/memorial/120610671",
		"id": 120610671,
		"lng": -77.38720978,
		"lat": 37.53744011,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 9,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Clements",
		"url": "https://findagrave.com/memorial/139424324",
		"id": 139424324,
		"lng": -77.38797314,
		"lat": 37.53708627,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Clemmons",
		"url": "https://findagrave.com/memorial/143631831",
		"id": 143631831,
		"lng": -77.38597693,
		"lat": 37.53603949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 7,
		"dd": 24,
		"by": 1896,
		"bd": 12,
		"bm": 5,
		"nm": "Grims",
		"nf": "James",
		"nl": "Cole",
		"url": "https://findagrave.com/memorial/116728676",
		"id": 116728676,
		"lng": -77.3867207,
		"lat": 37.53705637,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 10,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/191383491",
		"id": 191383491,
		"lng": -77.38787018,
		"lat": 37.53692616,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 26,
		"by": 1916,
		"bd": 12,
		"bm": 10,
		"nm": "",
		"nf": "Archie",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/142446624",
		"id": 142446624,
		"lng": -77.38739455,
		"lat": 37.53783807,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": "",
		"dd": "",
		"by": 1905,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Christ",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/170839506",
		"id": 170839506,
		"lng": -77.38647654,
		"lat": 37.53712605,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 6,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Esther",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/151648400",
		"id": 151648400,
		"lng": -77.38619746,
		"lat": 37.53571355,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 11,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hester",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/130692443",
		"id": 130692443,
		"lng": -77.3857458,
		"lat": 37.53713475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/184514630",
		"id": 184514630,
		"lng": -77.38754018,
		"lat": 37.53679225,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1995,
		"dm": 12,
		"dd": 4,
		"by": 1914,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Jessie",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/38454719",
		"id": 38454719,
		"lng": -77.38570747,
		"lat": 37.53687988,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 6,
		"dd": 22,
		"by": 1905,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Johnnie",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/180054364",
		"id": 180054364,
		"lng": -77.38628583,
		"lat": 37.53529291,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 12,
		"by": 1887,
		"bd": 11,
		"bm": 4,
		"nm": "",
		"nf": "Lelia",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/128632059",
		"id": 128632059,
		"lng": -77.38572183,
		"lat": 37.537138,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 7,
		"dd": 20,
		"by": 1879,
		"bd": 10,
		"bm": 9,
		"nm": "M.",
		"nf": "Peter",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/151648552",
		"id": 151648552,
		"lng": -77.38616316,
		"lat": 37.5356925,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 10,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virgie",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/128399807",
		"id": 128399807,
		"lng": -77.38563072,
		"lat": 37.53701455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 12,
		"dd": 8,
		"by": 1896,
		"bd": 16,
		"bm": 12,
		"nm": "",
		"nf": "Alexander",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/144013896",
		"id": 144013896,
		"lng": -77.3871689,
		"lat": 37.53780031,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 6,
		"dd": 11,
		"by": 1894,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alfred",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/155984783",
		"id": 155984783,
		"lng": -77.38719131,
		"lat": 37.53553077,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 2,
		"dd": 20,
		"by": 1880,
		"bd": 6,
		"bm": 8,
		"nm": "William",
		"nf": "Archer",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/156119497",
		"id": 156119497,
		"lng": -77.38609608,
		"lat": 37.53701954,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 11,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Christie",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/141655616",
		"id": 141655616,
		"lng": -77.38670685,
		"lat": 37.53740275,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 1,
		"dd": 22,
		"by": 1922,
		"bd": 28,
		"bm": 9,
		"nm": "Lawrence",
		"nf": "Frank",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/156119500",
		"id": 156119500,
		"lng": -77.38609858,
		"lat": 37.53701479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 12,
		"dd": 28,
		"by": 1881,
		"bd": "",
		"bm": 5,
		"nm": "B.",
		"nf": "Georgia",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/146339046",
		"id": 146339046,
		"lng": -77.38569072,
		"lat": 37.53685337,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": 2,
		"dd": 15,
		"by": 1925,
		"bd": 9,
		"bm": 10,
		"nm": "Bell",
		"nf": "Harold",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/76587748",
		"id": 76587748,
		"lng": -77.38606638,
		"lat": 37.53702401,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 10,
		"dd": 19,
		"by": 1912,
		"bd": 11,
		"bm": 8,
		"nm": "Sadie",
		"nf": "Irietta",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/151889958",
		"id": 151889958,
		"lng": -77.38666898,
		"lat": 37.53572762,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 8,
		"dd": 22,
		"by": 1912,
		"bd": 15,
		"bm": 5,
		"nm": "Eddie",
		"nf": "John",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/144314863",
		"id": 144314863,
		"lng": -77.38648717,
		"lat": 37.53531647,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 8,
		"dd": 5,
		"by": 1891,
		"bd": 15,
		"bm": 7,
		"nm": "",
		"nf": "Joshua",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/155767945",
		"id": 155767945,
		"lng": -77.3871767,
		"lat": 37.53553041,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 5,
		"dd": 8,
		"by": 1894,
		"bd": 6,
		"bm": 9,
		"nm": "",
		"nf": "Mary",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/76587762",
		"id": 76587762,
		"lng": -77.38609094,
		"lat": 37.53703303,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 3,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/155984790",
		"id": 155984790,
		"lng": -77.38717131,
		"lat": 37.53551644,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 9,
		"dd": 18,
		"by": 1883,
		"bd": 5,
		"bm": 10,
		"nm": "A.",
		"nf": "William",
		"nl": "Coles",
		"url": "https://findagrave.com/memorial/141655626",
		"id": 141655626,
		"lng": -77.38670993,
		"lat": 37.53738961,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 7,
		"dd": 10,
		"by": 1886,
		"bd": 21,
		"bm": 11,
		"nm": "",
		"nf": "Rosa",
		"nl": "Collier",
		"url": "https://findagrave.com/memorial/156215155",
		"id": 156215155,
		"lng": -77.38662228,
		"lat": 37.53552299,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 8,
		"dd": 15,
		"by": 1897,
		"bd": 27,
		"bm": 11,
		"nm": "Camper",
		"nf": "Joseph",
		"nl": "Collins",
		"url": "https://findagrave.com/memorial/170129848",
		"id": 170129848,
		"lng": -77.3868115,
		"lat": 37.53696226,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 21,
		"by": 1894,
		"bd": 17,
		"bm": 11,
		"nm": "W.",
		"nf": "Joseph",
		"nl": "Collins",
		"url": "https://findagrave.com/memorial/136304115",
		"id": 136304115,
		"lng": -77.3858725,
		"lat": 37.5369927,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 11,
		"dd": 29,
		"by": 1924,
		"bd": 15,
		"bm": 2,
		"nm": "",
		"nf": "Allen",
		"nl": "Commander",
		"url": "https://findagrave.com/memorial/147853150",
		"id": 147853150,
		"lng": -77.38604107,
		"lat": 37.53627062,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 4,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Conway",
		"url": "https://findagrave.com/memorial/134359107",
		"id": 134359107,
		"lng": -77.38596067,
		"lat": 37.53606955,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 12,
		"by": 1898,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Conway",
		"url": "https://findagrave.com/memorial/143825855",
		"id": 143825855,
		"lng": -77.38597703,
		"lat": 37.53606328,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 1,
		"dd": 22,
		"by": 1875,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Martha",
		"nl": "Cook",
		"url": "https://findagrave.com/memorial/142598402",
		"id": 142598402,
		"lng": -77.38693177,
		"lat": 37.53709948,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 6,
		"dd": 14,
		"by": 1904,
		"bd": 16,
		"bm": 7,
		"nm": "",
		"nf": "Victoria",
		"nl": "Cook",
		"url": "https://findagrave.com/memorial/183697440",
		"id": 183697440,
		"lng": -77.38661372,
		"lat": 37.53749898,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 3,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Cooke",
		"url": "https://findagrave.com/memorial/184360373",
		"id": 184360373,
		"lng": -77.38790611,
		"lat": 37.53688984,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 7,
		"dd": 16,
		"by": 1896,
		"bd": 17,
		"bm": 12,
		"nm": "McCoy",
		"nf": "Leon",
		"nl": "Cooke",
		"url": "https://findagrave.com/memorial/142446642",
		"id": 142446642,
		"lng": -77.38590285,
		"lat": 37.53726029,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 4,
		"dd": 23,
		"by": 1869,
		"bd": 22,
		"bm": 5,
		"nm": "E.",
		"nf": "Sarah",
		"nl": "Cooke",
		"url": "https://findagrave.com/memorial/142446658",
		"id": 142446658,
		"lng": -77.38586647,
		"lat": 37.53724861,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 6,
		"dd": 14,
		"by": 1861,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Coombs",
		"url": "https://findagrave.com/memorial/176712121",
		"id": 176712121,
		"lng": -77.38767082,
		"lat": 37.53712375,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 12,
		"dd": 12,
		"by": 1901,
		"bd": 7,
		"bm": 3,
		"nm": "",
		"nf": "Bertha",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/145084180",
		"id": 145084180,
		"lng": -77.38555012,
		"lat": 37.53721379,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 3,
		"by": 1902,
		"bd": 26,
		"bm": 5,
		"nm": "",
		"nf": "Cornelius",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/76587771",
		"id": 76587771,
		"lng": -77.38615212,
		"lat": 37.5369988,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 6,
		"dd": 5,
		"by": 1878,
		"bd": 12,
		"bm": 4,
		"nm": "W.",
		"nf": "George",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/135741634",
		"id": 135741634,
		"lng": -77.38600161,
		"lat": 37.53689722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 1,
		"dd": 21,
		"by": 1916,
		"bd": 2,
		"bm": 7,
		"nm": "W.",
		"nf": "Herbert",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/125514791",
		"id": 125514791,
		"lng": -77.38604251,
		"lat": 37.53690089,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 12,
		"dd": 24,
		"by": 1898,
		"bd": 5,
		"bm": 3,
		"nm": "",
		"nf": "James",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/134454175",
		"id": 134454175,
		"lng": -77.38611266,
		"lat": 37.53699907,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 11,
		"by": 1896,
		"bd": 17,
		"bm": 5,
		"nm": "",
		"nf": "Jessie",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/146772740",
		"id": 146772740,
		"lng": -77.3863721,
		"lat": 37.53729744,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 6,
		"dd": 6,
		"by": 1885,
		"bd": 12,
		"bm": 5,
		"nm": "",
		"nf": "Lauretta",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/158889118",
		"id": 158889118,
		"lng": -77.38778455,
		"lat": 37.53768533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 10,
		"by": 1923,
		"bd": 8,
		"bm": 9,
		"nm": "",
		"nf": "Leroy",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/168728798",
		"id": 168728798,
		"lng": -77.38637031,
		"lat": 37.53709743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/139146794",
		"id": 139146794,
		"lng": -77.38601447,
		"lat": 37.53633711,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 9,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Minnie",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/149696165",
		"id": 149696165,
		"lng": -77.38657577,
		"lat": 37.53659107,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 12,
		"dd": 12,
		"by": 1893,
		"bd": 26,
		"bm": 2,
		"nm": "Lanzy",
		"nf": "Newton",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/117180453",
		"id": 117180453,
		"lng": -77.38603792,
		"lat": 37.53688446,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 10,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Isabelle",
		"nf": "Sarah",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/153410141",
		"id": 153410141,
		"lng": -77.38576808,
		"lat": 37.53685955,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 7,
		"dd": 7,
		"by": 1888,
		"bd": 2,
		"bm": 10,
		"nm": "",
		"nf": "Zephaninah",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/125514804",
		"id": 125514804,
		"lng": -77.38602223,
		"lat": 37.53689634,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 28,
		"by": 1862,
		"bd": "",
		"bm": 1,
		"nm": "M.",
		"nf": "Maggie",
		"nl": "Copeland",
		"url": "https://findagrave.com/memorial/150786801",
		"id": 150786801,
		"lng": -77.38640955,
		"lat": 37.53553125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 4,
		"dd": 11,
		"by": 1889,
		"bd": 10,
		"bm": 5,
		"nm": "Morton",
		"nf": "Robert",
		"nl": "Copeland",
		"url": "https://findagrave.com/memorial/158942431",
		"id": 158942431,
		"lng": -77.38759547,
		"lat": 37.53762752,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 11,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Dorothy",
		"nl": "Corbett",
		"url": "https://findagrave.com/memorial/113750909",
		"id": 113750909,
		"lng": -77.38625549,
		"lat": 37.536875,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 1,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Benjamin",
		"nl": "Corbin",
		"url": "https://findagrave.com/memorial/160933689",
		"id": 160933689,
		"lng": -77.38669653,
		"lat": 37.53674785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 11,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henrietta",
		"nl": "Corbin",
		"url": "https://findagrave.com/memorial/136304126",
		"id": 136304126,
		"lng": -77.38612455,
		"lat": 37.53637483,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 6,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillian",
		"nl": "Corbin",
		"url": "https://findagrave.com/memorial/160933691",
		"id": 160933691,
		"lng": -77.38669231,
		"lat": 37.53675504,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 1,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jesse",
		"nl": "Corley",
		"url": "https://findagrave.com/memorial/158889122",
		"id": 158889122,
		"lng": -77.38746867,
		"lat": 37.53760492,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 1,
		"dd": 8,
		"by": 1920,
		"bd": 19,
		"bm": 11,
		"nm": "L.",
		"nf": "Mamie",
		"nl": "Corley",
		"url": "https://findagrave.com/memorial/122786292",
		"id": 122786292,
		"lng": -77.38572565,
		"lat": 37.53700717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1986,
		"dm": 3,
		"dd": 12,
		"by": 1932,
		"bd": 12,
		"bm": 8,
		"nm": "Yvonne",
		"nf": "Grace",
		"nl": "Cosby",
		"url": "https://findagrave.com/memorial/38456405",
		"id": 38456405,
		"lng": -77.38550607,
		"lat": 37.53725754,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 12,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Lewis",
		"nl": "Cosby",
		"url": "https://findagrave.com/memorial/169425937",
		"id": 169425937,
		"lng": -77.38739271,
		"lat": 37.5367442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Phillis",
		"nl": "Cosby",
		"url": "https://findagrave.com/memorial/144102600",
		"id": 144102600,
		"lng": -77.3858897,
		"lat": 37.53739153,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 5,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Cotten",
		"url": "https://findagrave.com/memorial/119393044",
		"id": 119393044,
		"lng": -77.38589397,
		"lat": 37.53663852,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 1,
		"by": 1903,
		"bd": 11,
		"bm": 3,
		"nm": "H.",
		"nf": "Mary",
		"nl": "Council",
		"url": "https://findagrave.com/memorial/148285645",
		"id": 148285645,
		"lng": -77.386379,
		"lat": 37.53716193,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 2,
		"by": 1899,
		"bd": 16,
		"bm": 2,
		"nm": "Ronald",
		"nf": "Roland",
		"nl": "Council",
		"url": "https://findagrave.com/memorial/125805557",
		"id": 125805557,
		"lng": -77.38602122,
		"lat": 37.53740219,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 12,
		"by": 1919,
		"bd": 9,
		"bm": 4,
		"nm": "",
		"nf": "Sammie",
		"nl": "Cousar",
		"url": "https://findagrave.com/memorial/151261179",
		"id": 151261179,
		"lng": -77.38676529,
		"lat": 37.53763724,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 4,
		"dd": 24,
		"by": 1904,
		"bd": "",
		"bm": 11,
		"nm": "Horace",
		"nf": "Joseph",
		"nl": "Cousins",
		"url": "https://findagrave.com/memorial/191656663",
		"id": 191656663,
		"lng": -77.38652817,
		"lat": 37.53578267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 2,
		"dd": 20,
		"by": 1865,
		"bd": "",
		"bm": 3,
		"nm": "Gaines",
		"nf": "Elizabeth",
		"nl": "Cousins",
		"url": "https://findagrave.com/memorial/182367259",
		"id": 182367259,
		"lng": -77.38648734,
		"lat": 37.53562415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 11,
		"dd": 1,
		"by": 1860,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "King",
		"nl": "Cousins",
		"url": "https://findagrave.com/memorial/182367292",
		"id": 182367292,
		"lng": -77.38648825,
		"lat": 37.53561459,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Leroy",
		"nl": "Cousins",
		"url": "https://findagrave.com/memorial/153896426",
		"id": 153896426,
		"lng": -77.3864756,
		"lat": 37.53744767,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 11,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Cousins",
		"url": "https://findagrave.com/memorial/144542880",
		"id": 144542880,
		"lng": -77.38652822,
		"lat": 37.53576964,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 12,
		"dd": "",
		"by": 1907,
		"bd": 1,
		"bm": 10,
		"nm": "S.",
		"nf": "Willie",
		"nl": "Cowens",
		"url": "https://findagrave.com/memorial/150493611",
		"id": 150493611,
		"lng": -77.38640918,
		"lat": 37.5360029,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 7,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Albert",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/149250655",
		"id": 149250655,
		"lng": -77.38697381,
		"lat": 37.53592528,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 18,
		"by": 1933,
		"bd": 2,
		"bm": 6,
		"nm": "",
		"nf": "Estelle",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/170814999",
		"id": 170814999,
		"lng": -77.38632079,
		"lat": 37.53669159,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 11,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hattie",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/184708256",
		"id": 184708256,
		"lng": -77.38654366,
		"lat": 37.53763277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/173470969",
		"id": 173470969,
		"lng": -77.38729916,
		"lat": 37.53712727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 12,
		"dd": 16,
		"by": 1866,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sully",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/152256452",
		"id": 152256452,
		"lng": -77.38650835,
		"lat": 37.53559345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 11,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Uriah",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/148748075",
		"id": 148748075,
		"lng": -77.38800639,
		"lat": 37.53719787,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 3,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "William",
		"nl": "Cox",
		"url": "https://findagrave.com/memorial/120610680",
		"id": 120610680,
		"lng": -77.38588749,
		"lat": 37.53665904,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 11,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Coy",
		"url": "https://findagrave.com/memorial/174706685",
		"id": 174706685,
		"lng": -77.38761546,
		"lat": 37.53690254,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 2,
		"dd": 8,
		"by": 1884,
		"bd": 2,
		"bm": 10,
		"nm": "H.",
		"nf": "William",
		"nl": "Coy",
		"url": "https://findagrave.com/memorial/155021589",
		"id": 155021589,
		"lng": -77.38669742,
		"lat": 37.53751714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 2,
		"dd": 17,
		"by": 1861,
		"bd": "",
		"bm": 4,
		"nm": "",
		"nf": "Kate",
		"nl": "Craddock",
		"url": "https://findagrave.com/memorial/125805568",
		"id": 125805568,
		"lng": -77.38595711,
		"lat": 37.53618971,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 8,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Craddock",
		"url": "https://findagrave.com/memorial/150946390",
		"id": 150946390,
		"lng": -77.38722602,
		"lat": 37.53629231,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 9,
		"dd": 9,
		"by": 1892,
		"bd": 28,
		"bm": 9,
		"nm": "Mae",
		"nf": "Lillie",
		"nl": "Craig",
		"url": "https://findagrave.com/memorial/185649300",
		"id": 185649300,
		"lng": -77.38751223,
		"lat": 37.53693712,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 26,
		"by": 1911,
		"bd": 25,
		"bm": 10,
		"nm": "",
		"nf": "Bernice",
		"nl": "Crawford",
		"url": "https://findagrave.com/memorial/173314365",
		"id": 173314365,
		"lng": -77.38706578,
		"lat": 37.53724873,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 20,
		"by": 1924,
		"bd": 15,
		"bm": 8,
		"nm": "McKinley",
		"nf": "John",
		"nl": "Crawford",
		"url": "https://findagrave.com/memorial/158942449",
		"id": 158942449,
		"lng": -77.38689418,
		"lat": 37.537441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Massie",
		"nl": "Crawford",
		"url": "https://findagrave.com/memorial/183254052",
		"id": 183254052,
		"lng": -77.38738176,
		"lat": 37.53704057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 7,
		"dd": 20,
		"by": 1886,
		"bd": 5,
		"bm": 2,
		"nm": "",
		"nf": "Edward",
		"nl": "Crawley",
		"url": "https://findagrave.com/memorial/179694191",
		"id": 179694191,
		"lng": -77.38799666,
		"lat": 37.5376375,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 7,
		"dd": 8,
		"by": 1889,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Frank",
		"nl": "Crawley",
		"url": "https://findagrave.com/memorial/144013899",
		"id": 144013899,
		"lng": -77.3873594,
		"lat": 37.53779696,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 1,
		"dd": 13,
		"by": 1888,
		"bd": 30,
		"bm": 6,
		"nm": "Roane",
		"nf": "Lillie",
		"nl": "Crawley",
		"url": "https://findagrave.com/memorial/174696206",
		"id": 174696206,
		"lng": -77.38753693,
		"lat": 37.53706067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 7,
		"dd": 5,
		"by": 1919,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Blanche",
		"nl": "Crittenton",
		"url": "https://findagrave.com/memorial/178412472",
		"id": 178412472,
		"lng": -77.3860308,
		"lat": 37.53640294,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 21,
		"by": 1922,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gladys",
		"nl": "Crittenton",
		"url": "https://findagrave.com/memorial/175822563",
		"id": 175822563,
		"lng": -77.3864095,
		"lat": 37.53672106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1981,
		"dm": 1,
		"dd": 7,
		"by": 1905,
		"bd": 7,
		"bm": 2,
		"nm": "",
		"nf": "Edna",
		"nl": "Cross",
		"url": "https://findagrave.com/memorial/142526030",
		"id": 142526030,
		"lng": -77.38560062,
		"lat": 37.5371889,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 4,
		"dd": 1,
		"by": 1904,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Bennie",
		"nl": "Crossen",
		"url": "https://findagrave.com/memorial/153864384",
		"id": 153864384,
		"lng": -77.386268,
		"lat": 37.53741964,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 25,
		"by": 1964,
		"bd": 28,
		"bm": 12,
		"nm": "Jean",
		"nf": "Doris",
		"nl": "Crowell",
		"url": "https://findagrave.com/memorial/155984794",
		"id": 155984794,
		"lng": -77.38603618,
		"lat": 37.53746727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 4,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Josephine",
		"nl": "Crumbley",
		"url": "https://findagrave.com/memorial/128632108",
		"id": 128632108,
		"lng": -77.38620261,
		"lat": 37.5366361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 9,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eliza",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/134359114",
		"id": 134359114,
		"lng": -77.38600114,
		"lat": 37.53608026,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 9,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ella",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/145084181",
		"id": 145084181,
		"lng": -77.38645824,
		"lat": 37.53537765,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 6,
		"dd": 26,
		"by": 1858,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Junius",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/149165849",
		"id": 149165849,
		"lng": -77.38645833,
		"lat": 37.53538465,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 4,
		"by": 1922,
		"bd": 21,
		"bm": 6,
		"nm": "Everett",
		"nf": "Lawrence",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/190867105",
		"id": 190867105,
		"lng": -77.38644886,
		"lat": 37.53735713,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 12,
		"dd": 26,
		"by": 1912,
		"bd": 17,
		"bm": 8,
		"nm": "",
		"nf": "Louise",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/175622317",
		"id": 175622317,
		"lng": -77.38679873,
		"lat": 37.53643753,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Percy",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/185647879",
		"id": 185647879,
		"lng": -77.38774957,
		"lat": 37.53705664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 12,
		"dd": 19,
		"by": 1896,
		"bd": 17,
		"bm": 5,
		"nm": "",
		"nf": "Sarah",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/173743441",
		"id": 173743441,
		"lng": -77.38733804,
		"lat": 37.53714474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 5,
		"dd": 9,
		"by": 1939,
		"bd": 3,
		"bm": 4,
		"nm": "V.",
		"nf": "Mildred",
		"nl": "Cubby",
		"url": "https://findagrave.com/memorial/142446667",
		"id": 142446667,
		"lng": -77.38567818,
		"lat": 37.53741609,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Coleman",
		"nf": "Arthur",
		"nl": "Culmer",
		"url": "https://findagrave.com/memorial/150348920",
		"id": 150348920,
		"lng": -77.38598462,
		"lat": 37.53636588,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 7,
		"dd": 9,
		"by": 1949,
		"bd": 5,
		"bm": 6,
		"nm": "Jean",
		"nf": "Bobbie",
		"nl": "Cumberbatch",
		"url": "https://findagrave.com/memorial/150493620",
		"id": 150493620,
		"lng": -77.38631989,
		"lat": 37.53601984,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 12,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Winston",
		"nl": "Cunningham",
		"url": "https://findagrave.com/memorial/146012155",
		"id": 146012155,
		"lng": -77.38656617,
		"lat": 37.53634637,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 7,
		"dd": 5,
		"by": 1881,
		"bd": 22,
		"bm": 6,
		"nm": "Stokes",
		"nf": "Florence",
		"nl": "Curtis",
		"url": "https://findagrave.com/memorial/177428901",
		"id": 177428901,
		"lng": -77.38744568,
		"lat": 37.53695842,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 15,
		"by": 1925,
		"bd": 4,
		"bm": 1,
		"nm": "Jane",
		"nf": "Mary",
		"nl": "Curtis",
		"url": "https://findagrave.com/memorial/158438093",
		"id": 158438093,
		"lng": -77.38771101,
		"lat": 37.53757045,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 7,
		"dd": 22,
		"by": 1852,
		"bd": "",
		"bm": 12,
		"nm": "",
		"nf": "Nancy",
		"nl": "Custalo",
		"url": "https://findagrave.com/memorial/143631857",
		"id": 143631857,
		"lng": -77.38619295,
		"lat": 37.53566019,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 9,
		"dd": 7,
		"by": 1845,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Custalo",
		"url": "https://findagrave.com/memorial/143631869",
		"id": 143631869,
		"lng": -77.38619286,
		"lat": 37.53566802,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 4,
		"dd": 17,
		"by": 1880,
		"bd": 3,
		"bm": 12,
		"nm": "",
		"nf": "Ruth",
		"nl": "D'antignac",
		"url": "https://findagrave.com/memorial/145084189",
		"id": 145084189,
		"lng": -77.38643165,
		"lat": 37.53552067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 24,
		"by": 1912,
		"bd": 25,
		"bm": 12,
		"nm": "B.",
		"nf": "Allen",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/125517852",
		"id": 125517852,
		"lng": -77.3857728,
		"lat": 37.53660099,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Betsy",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/184360143",
		"id": 184360143,
		"lng": -77.38780499,
		"lat": 37.53692677,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 12,
		"dd": 21,
		"by": 1910,
		"bd": 26,
		"bm": 5,
		"nm": "E.",
		"nf": "Blanche",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/122027276",
		"id": 122027276,
		"lng": -77.38578604,
		"lat": 37.53659522,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 11,
		"dd": 28,
		"by": 1894,
		"bd": 22,
		"bm": 11,
		"nm": "Oliver",
		"nf": "David",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/137968564",
		"id": 137968564,
		"lng": -77.3867386,
		"lat": 37.53700113,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frances",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/132764916",
		"id": 132764916,
		"lng": -77.38754038,
		"lat": 37.53661476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/162307276",
		"id": 162307276,
		"lng": -77.38660901,
		"lat": 37.53662919,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 1,
		"dd": 12,
		"by": 1893,
		"bd": 9,
		"bm": 2,
		"nm": "",
		"nf": "Minnie",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/184482565",
		"id": 184482565,
		"lng": -77.38730487,
		"lat": 37.53765175,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 7,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/188244937",
		"id": 188244937,
		"lng": -77.38796954,
		"lat": 37.53717543,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 12,
		"dd": 8,
		"by": 1912,
		"bd": 29,
		"bm": 6,
		"nm": "H.",
		"nf": "William",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/143201776",
		"id": 143201776,
		"lng": -77.38640588,
		"lat": 37.53573745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 9,
		"dd": 7,
		"by": 1921,
		"bd": 22,
		"bm": 5,
		"nm": "A.",
		"nf": "William",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/151265302",
		"id": 151265302,
		"lng": -77.38676632,
		"lat": 37.53752429,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 11,
		"dd": 8,
		"by": 1887,
		"bd": 15,
		"bm": 11,
		"nm": "",
		"nf": "William",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/144820122",
		"id": 144820122,
		"lng": -77.3864476,
		"lat": 37.53574973,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "John",
		"nl": "Dance",
		"url": "https://findagrave.com/memorial/146012160",
		"id": 146012160,
		"lng": -77.38662657,
		"lat": 37.53659228,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 2,
		"dd": 5,
		"by": 1877,
		"bd": 25,
		"bm": 5,
		"nm": "Wilbert",
		"nf": "Alpheus",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/111589836",
		"id": 111589836,
		"lng": -77.38610096,
		"lat": 37.5367509,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 6,
		"dd": 17,
		"by": 1885,
		"bd": 8,
		"bm": 4,
		"nm": "Ellis",
		"nf": "Bessie",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/111589839",
		"id": 111589839,
		"lng": -77.38609875,
		"lat": 37.53675592,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 22,
		"by": 1895,
		"bd": 18,
		"bm": 10,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/185390202",
		"id": 185390202,
		"lng": -77.38742531,
		"lat": 37.53764624,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 2,
		"dd": 2,
		"by": 1898,
		"bd": 10,
		"bm": 3,
		"nm": "B.",
		"nf": "Ethel",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/150493626",
		"id": 150493626,
		"lng": -77.3865722,
		"lat": 37.53592211,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 7,
		"dd": 8,
		"by": 1880,
		"bd": 4,
		"bm": 3,
		"nm": "Lee",
		"nf": "George",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/144105270",
		"id": 144105270,
		"lng": -77.38642681,
		"lat": 37.53753182,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 4,
		"dd": 6,
		"by": 1910,
		"bd": 6,
		"bm": 8,
		"nm": "Hazelwood",
		"nf": "Haywood",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/155984799",
		"id": 155984799,
		"lng": -77.38598812,
		"lat": 37.53688084,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 10,
		"dd": 20,
		"by": 1886,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "Katie",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/174783395",
		"id": 174783395,
		"lng": -77.38747891,
		"lat": 37.53715449,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 4,
		"dd": 8,
		"by": 1889,
		"bd": 10,
		"bm": 10,
		"nm": "D.",
		"nf": "Lillie",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/183697447",
		"id": 183697447,
		"lng": -77.38703537,
		"lat": 37.53694937,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 8,
		"dd": 25,
		"by": 1912,
		"bd": 8,
		"bm": 6,
		"nm": "",
		"nf": "Lillie",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/185305572",
		"id": 185305572,
		"lng": -77.38702074,
		"lat": 37.53758016,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": "",
		"dd": "",
		"by": 1914,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lorenzo",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/115720616",
		"id": 115720616,
		"lng": -77.38612113,
		"lat": 37.53676523,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1898,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matilda",
		"nl": "Dandridge",
		"url": "https://findagrave.com/memorial/126456396",
		"id": 126456396,
		"lng": -77.38651627,
		"lat": 37.53587667,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": 12,
		"bm": 2,
		"nm": "Fleming",
		"nf": "Carrie",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/158481175",
		"id": 158481175,
		"lng": -77.38678945,
		"lat": 37.53759883,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": "",
		"dd": "",
		"by": 1964,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/159411337",
		"id": 159411337,
		"lng": -77.38615973,
		"lat": 37.53745235,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Eugene",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/176570422",
		"id": 176570422,
		"lng": -77.38720303,
		"lat": 37.53756494,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 11,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Mack",
		"nf": "John",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/130967993",
		"id": 130967993,
		"lng": -77.38563312,
		"lat": 37.53724525,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 16,
		"by": 1883,
		"bd": 15,
		"bm": 3,
		"nm": "L.",
		"nf": "Maggie",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/130968010",
		"id": 130968010,
		"lng": -77.38562801,
		"lat": 37.53725466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 12,
		"dd": 13,
		"by": 1900,
		"bd": 3,
		"bm": 6,
		"nm": "",
		"nf": "Mary",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/167336921",
		"id": 167336921,
		"lng": -77.38686707,
		"lat": 37.53732829,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 7,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Patricia",
		"nl": "Daniel",
		"url": "https://findagrave.com/memorial/142448395",
		"id": 142448395,
		"lng": -77.38567772,
		"lat": 37.53742553,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 12,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/188298644",
		"id": 188298644,
		"lng": -77.38792835,
		"lat": 37.53712282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby girl",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/145638789",
		"id": 145638789,
		"lng": -77.386108,
		"lat": 37.53743086,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 5,
		"by": 1905,
		"bd": 24,
		"bm": 11,
		"nm": "L.",
		"nf": "Bessie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/187347884",
		"id": 187347884,
		"lng": -77.38726227,
		"lat": 37.53730059,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 11,
		"dd": 11,
		"by": 1879,
		"bd": 25,
		"bm": 9,
		"nm": "M.",
		"nf": "Bettie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/162643310",
		"id": 162643310,
		"lng": -77.3871634,
		"lat": 37.53707924,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 7,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Boss",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/174711234",
		"id": 174711234,
		"lng": -77.38761038,
		"lat": 37.53691006,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 1,
		"by": 1878,
		"bd": 20,
		"bm": 1,
		"nm": "",
		"nf": "Charles",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/115976009",
		"id": 115976009,
		"lng": -77.38616699,
		"lat": 37.53678157,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 22,
		"by": 1964,
		"bd": 19,
		"bm": 4,
		"nm": "",
		"nf": "Donell",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/169042639",
		"id": 169042639,
		"lng": -77.38616624,
		"lat": 37.53747021,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 4,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/174858483",
		"id": 174858483,
		"lng": -77.38743132,
		"lat": 37.53709233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/154294638",
		"id": 154294638,
		"lng": -77.3868844,
		"lat": 37.53544664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 7,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M. C. M.",
		"nf": "Fleming",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/187898175",
		"id": 187898175,
		"lng": -77.38798054,
		"lat": 37.53715654,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 29,
		"by": 1964,
		"bd": 8,
		"bm": 5,
		"nm": "",
		"nf": "Franklin",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/153379930",
		"id": 153379930,
		"lng": -77.38618522,
		"lat": 37.5374728,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 11,
		"by": 1920,
		"bd": 30,
		"bm": 9,
		"nm": "C.",
		"nf": "Gertrude",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/177762462",
		"id": 177762462,
		"lng": -77.38785706,
		"lat": 37.53739685,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 31,
		"by": 1918,
		"bd": 23,
		"bm": 12,
		"nm": "Jessie",
		"nf": "James",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/130378900",
		"id": 130378900,
		"lng": -77.38582197,
		"lat": 37.53636303,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 1,
		"dd": 6,
		"by": 1896,
		"bd": 26,
		"bm": 2,
		"nm": "A. M.",
		"nf": "John",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/159661372",
		"id": 159661372,
		"lng": -77.3868972,
		"lat": 37.5371202,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 8,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Julia",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/129208549",
		"id": 129208549,
		"lng": -77.3861741,
		"lat": 37.53679455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 10,
		"dd": 7,
		"by": 1968,
		"bd": 20,
		"bm": 7,
		"nm": "D.",
		"nf": "Lasandra",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/159661370",
		"id": 159661370,
		"lng": -77.38590507,
		"lat": 37.53740751,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 9,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Laura",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/169422611",
		"id": 169422611,
		"lng": -77.38766224,
		"lat": 37.53696169,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 9,
		"dd": 15,
		"by": 1881,
		"bd": "",
		"bm": 4,
		"nm": "C.",
		"nf": "Lucy",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/153375778",
		"id": 153375778,
		"lng": -77.38613451,
		"lat": 37.53574444,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 7,
		"dd": 23,
		"by": 1884,
		"bd": 14,
		"bm": 5,
		"nm": "J.",
		"nf": "Mabel",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/150786817",
		"id": 150786817,
		"lng": -77.38643486,
		"lat": 37.53551032,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 10,
		"by": 1930,
		"bd": 1,
		"bm": 10,
		"nm": "Roberta",
		"nf": "Marion",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/184094526",
		"id": 184094526,
		"lng": -77.38722017,
		"lat": 37.5374999,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 11,
		"dd": 4,
		"by": 1839,
		"bd": 5,
		"bm": 6,
		"nm": "",
		"nf": "Martha",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/123696598",
		"id": 123696598,
		"lng": -77.38618706,
		"lat": 37.53683365,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 4,
		"dd": 30,
		"by": 1885,
		"bd": 25,
		"bm": 4,
		"nm": "",
		"nf": "Minnie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/185647258",
		"id": 185647258,
		"lng": -77.38752691,
		"lat": 37.53697793,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nettie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/177760815",
		"id": 177760815,
		"lng": -77.38785079,
		"lat": 37.53736975,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 12,
		"by": 1896,
		"bd": 22,
		"bm": 3,
		"nm": "",
		"nf": "Rebecca",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/154509662",
		"id": 154509662,
		"lng": -77.38635414,
		"lat": 37.53746504,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 23,
		"by": 1905,
		"bd": 16,
		"bm": 9,
		"nm": "Henry",
		"nf": "Robert",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/155512337",
		"id": 155512337,
		"lng": -77.38761711,
		"lat": 37.53764824,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 8,
		"dd": 15,
		"by": 1899,
		"bd": 29,
		"bm": 6,
		"nm": "",
		"nf": "Rosa",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/155512345",
		"id": 155512345,
		"lng": -77.38752854,
		"lat": 37.53762887,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 10,
		"dd": 29,
		"by": 1876,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Sophia",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/159661371",
		"id": 159661371,
		"lng": -77.38690069,
		"lat": 37.53712157,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 2,
		"by": 1918,
		"bd": 20,
		"bm": 2,
		"nm": "Ambrose",
		"nf": "Thomas",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/187351664",
		"id": 187351664,
		"lng": -77.38727512,
		"lat": 37.53740126,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H",
		"nf": "Viola",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/170839581",
		"id": 170839581,
		"lng": -77.38653516,
		"lat": 37.53703808,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 14,
		"by": 1883,
		"bd": 12,
		"bm": 3,
		"nm": "T.",
		"nf": "Virginia",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/144013901",
		"id": 144013901,
		"lng": -77.38738723,
		"lat": 37.53769203,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 9,
		"dd": 2,
		"by": 1862,
		"bd": 8,
		"bm": 9,
		"nm": "H.",
		"nf": "William",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/146682150",
		"id": 146682150,
		"lng": -77.38617467,
		"lat": 37.53576551,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 12,
		"dd": 31,
		"by": 1909,
		"bd": 2,
		"bm": 7,
		"nm": "",
		"nf": "Willie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/175449704",
		"id": 175449704,
		"lng": -77.38748666,
		"lat": 37.53702002,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 11,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/144105277",
		"id": 144105277,
		"lng": -77.38592037,
		"lat": 37.53730408,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 7,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "George",
		"nl": "Dawson",
		"url": "https://findagrave.com/memorial/136304139",
		"id": 136304139,
		"lng": -77.38618588,
		"lat": 37.53635532,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 11,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Day",
		"url": "https://findagrave.com/memorial/151976238",
		"id": 151976238,
		"lng": -77.38553561,
		"lat": 37.53736529,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 10,
		"dd": 29,
		"by": 1889,
		"bd": 28,
		"bm": 1,
		"nm": "",
		"nf": "Sidney",
		"nl": "Dean",
		"url": "https://findagrave.com/memorial/141446349",
		"id": 141446349,
		"lng": -77.38728663,
		"lat": 37.53777046,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 7,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Pearl",
		"nl": "Deas",
		"url": "https://findagrave.com/memorial/120146981",
		"id": 120146981,
		"lng": -77.38599508,
		"lat": 37.53672937,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 10,
		"dd": 23,
		"by": 1910,
		"bd": 10,
		"bm": 3,
		"nm": "",
		"nf": "Arthur",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/159852034",
		"id": 159852034,
		"lng": -77.38741323,
		"lat": 37.53755679,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 10,
		"dd": 12,
		"by": 1902,
		"bd": 25,
		"bm": 8,
		"nm": "",
		"nf": "Joseph",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/158891057",
		"id": 158891057,
		"lng": -77.38740921,
		"lat": 37.53756648,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 11,
		"dd": 15,
		"by": 1924,
		"bd": 31,
		"bm": 1,
		"nm": "Agatha Williams",
		"nf": "Louise",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/183697455",
		"id": 183697455,
		"lng": -77.38723923,
		"lat": 37.53706317,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/811.502",
		"id": 207129734,
		"lng": -77.38659355,
		"lat": 37.53671056,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 3,
		"dd": 3,
		"by": 1875,
		"bd": 14,
		"bm": 10,
		"nm": "D.",
		"nf": "Samuel",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/174697075",
		"id": 174697075,
		"lng": -77.3874154,
		"lat": 37.5370205,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 1,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Samuel",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/146012163",
		"id": 146012163,
		"lng": -77.38660448,
		"lat": 37.53667865,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 1,
		"dd": 29,
		"by": 1854,
		"bd": 12,
		"bm": 10,
		"nm": "",
		"nf": "Abraham",
		"nl": "Dickens",
		"url": "https://findagrave.com/memorial/159760640",
		"id": 159760640,
		"lng": -77.3878496,
		"lat": 37.53782483,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 11,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Catherine",
		"nl": "Dickerson",
		"url": "https://findagrave.com/memorial/178249229",
		"id": 178249229,
		"lng": -77.38601904,
		"lat": 37.53645,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 11,
		"dd": 23,
		"by": 1888,
		"bd": 11,
		"bm": 4,
		"nm": "T.",
		"nf": "James",
		"nl": "Dickerson",
		"url": "https://findagrave.com/memorial/125518387",
		"id": 125518387,
		"lng": -77.385848,
		"lat": 37.53701305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 7,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Margaret",
		"nl": "Dickerson",
		"url": "https://findagrave.com/memorial/137430005",
		"id": 137430005,
		"lng": -77.38586652,
		"lat": 37.53701863,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 1,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Matthew",
		"nl": "Dickerson",
		"url": "https://findagrave.com/memorial/150836536",
		"id": 150836536,
		"lng": -77.38599019,
		"lat": 37.53646365,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 11,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Dickerson",
		"url": "https://findagrave.com/memorial/152529073",
		"id": 152529073,
		"lng": -77.38601742,
		"lat": 37.5364604,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 25,
		"by": 1962,
		"bd": 24,
		"bm": 10,
		"nm": "Portee",
		"nf": "Milton Lee",
		"nl": "Dix",
		"url": "https://findagrave.com/memorial/164110779",
		"id": 164110779,
		"lng": -77.38648713,
		"lat": 37.53707582,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 2,
		"dd": 27,
		"by": 1880,
		"bd": "",
		"bm": 11,
		"nm": "",
		"nf": "Carl",
		"nl": "Dixon",
		"url": "https://findagrave.com/memorial/117431888",
		"id": 117431888,
		"lng": -77.38547845,
		"lat": 37.5372979,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 9,
		"dd": 24,
		"by": 1912,
		"bd": 16,
		"bm": 7,
		"nm": "",
		"nf": "David",
		"nl": "Dixon",
		"url": "https://findagrave.com/memorial/163611734",
		"id": 163611734,
		"lng": -77.3875606,
		"lat": 37.5375854,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 1,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Edward",
		"nl": "Dixon",
		"url": "https://findagrave.com/memorial/175409066",
		"id": 175409066,
		"lng": -77.38742179,
		"lat": 37.53714664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 12,
		"dd": 13,
		"by": 1850,
		"bd": "",
		"bm": 7,
		"nm": "",
		"nf": "Otway",
		"nl": "Dixon",
		"url": "https://findagrave.com/memorial/144315624",
		"id": 144315624,
		"lng": -77.38661126,
		"lat": 37.53576682,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 4,
		"by": 1880,
		"bd": 19,
		"bm": 9,
		"nm": "Allen",
		"nf": "Walter",
		"nl": "Dixon",
		"url": "https://findagrave.com/memorial/146339053",
		"id": 146339053,
		"lng": -77.3854777,
		"lat": 37.53731902,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 12,
		"dd": 12,
		"by": 1927,
		"bd": 11,
		"bm": 6,
		"nm": "Ross",
		"nf": "Wilbur",
		"nl": "Dixon",
		"url": "https://findagrave.com/memorial/177970580",
		"id": 177970580,
		"lng": -77.38800269,
		"lat": 37.53743042,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 12,
		"dd": 25,
		"by": 1949,
		"bd": 7,
		"bm": 8,
		"nm": "",
		"nf": "Willie",
		"nl": "Dobson",
		"url": "https://findagrave.com/memorial/178412477",
		"id": 178412477,
		"lng": -77.38608454,
		"lat": 37.53629657,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 8,
		"dd": 26,
		"by": 1914,
		"bd": 17,
		"bm": 10,
		"nm": "D.",
		"nf": "John",
		"nl": "Dockery",
		"url": "https://findagrave.com/memorial/136304148",
		"id": 136304148,
		"lng": -77.38594741,
		"lat": 37.53701972,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 6,
		"dd": 10,
		"by": 1914,
		"bd": 6,
		"bm": 10,
		"nm": "",
		"nf": "Lessie",
		"nl": "Dockery",
		"url": "https://findagrave.com/memorial/173314374",
		"id": 173314374,
		"lng": -77.38701308,
		"lat": 37.53719745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 7,
		"dd": 17,
		"by": 1909,
		"bd": 3,
		"bm": 7,
		"nm": "Collonial",
		"nf": "Louis",
		"nl": "Dockery",
		"url": "https://findagrave.com/memorial/139146810",
		"id": 139146810,
		"lng": -77.38726968,
		"lat": 37.53720749,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 2,
		"dd": 12,
		"by": 1876,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Laura",
		"nl": "Donald",
		"url": "https://findagrave.com/memorial/161052004",
		"id": 161052004,
		"lng": -77.38711218,
		"lat": 37.537047,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 11,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Sarah",
		"nl": "Dorsey",
		"url": "https://findagrave.com/memorial/126456526",
		"id": 126456526,
		"lng": -77.38666148,
		"lat": 37.53585385,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Thelma",
		"nl": "Drew",
		"url": "https://findagrave.com/memorial/119240789",
		"id": 119240789,
		"lng": -77.38591552,
		"lat": 37.53679288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 23,
		"by": 1884,
		"bd": 17,
		"bm": 7,
		"nm": "",
		"nf": "Timothy",
		"nl": "Drinkwater",
		"url": "https://findagrave.com/memorial/153866424",
		"id": 153866424,
		"lng": -77.38622114,
		"lat": 37.5373548,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 9,
		"dd": 13,
		"by": 1903,
		"bd": 27,
		"bm": 11,
		"nm": "",
		"nf": "Edward",
		"nl": "Dudley",
		"url": "https://findagrave.com/memorial/185390204",
		"id": 185390204,
		"lng": -77.38760889,
		"lat": 37.53779534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Tazewell",
		"nl": "Dudley",
		"url": "https://findagrave.com/memorial/125806300",
		"id": 125806300,
		"lng": -77.38608521,
		"lat": 37.53595131,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 1,
		"dd": 1,
		"by": 1875,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Elnora",
		"nl": "Dungee",
		"url": "https://findagrave.com/memorial/125806315",
		"id": 125806315,
		"lng": -77.38579064,
		"lat": 37.53653006,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 12,
		"dd": 27,
		"by": 1870,
		"bd": "",
		"bm": 4,
		"nm": "A.",
		"nf": "Martha",
		"nl": "Dunn",
		"url": "https://findagrave.com/memorial/139146820",
		"id": 139146820,
		"lng": -77.38773167,
		"lat": 37.53690268,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Lowell",
		"nl": "Dupree",
		"url": "https://findagrave.com/memorial/144105280",
		"id": 144105280,
		"lng": -77.3858999,
		"lat": 37.53744636,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 12,
		"dd": 24,
		"by": 1914,
		"bd": 29,
		"bm": 1,
		"nm": "",
		"nf": "Samuel",
		"nl": "Earl",
		"url": "https://findagrave.com/memorial/184480111",
		"id": 184480111,
		"lng": -77.38730708,
		"lat": 37.53763282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Celia",
		"nl": "Earley",
		"url": "https://findagrave.com/memorial/144542886",
		"id": 144542886,
		"lng": -77.3865093,
		"lat": 37.53571072,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 5,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "O.",
		"nf": "James",
		"nl": "Early",
		"url": "https://findagrave.com/memorial/144542901",
		"id": 144542901,
		"lng": -77.38647715,
		"lat": 37.53571057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Easley",
		"url": "https://findagrave.com/memorial/176768251",
		"id": 176768251,
		"lng": -77.38776282,
		"lat": 37.53712627,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 6,
		"dd": 16,
		"by": 1921,
		"bd": 6,
		"bm": 4,
		"nm": "",
		"nf": "Howard",
		"nl": "Easley",
		"url": "https://findagrave.com/memorial/170723940",
		"id": 170723940,
		"lng": -77.38600892,
		"lat": 37.53628347,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 10,
		"dd": 28,
		"by": 1893,
		"bd": 30,
		"bm": 12,
		"nm": "Henry",
		"nf": "James",
		"nl": "Easley",
		"url": "https://findagrave.com/memorial/183194054",
		"id": 183194054,
		"lng": -77.38737611,
		"lat": 37.53706014,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 11,
		"dd": 11,
		"by": 1857,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "East",
		"url": "https://findagrave.com/memorial/155759128",
		"id": 155759128,
		"lng": -77.38589264,
		"lat": 37.53643936,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 8,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Irvin",
		"nl": "East",
		"url": "https://findagrave.com/memorial/155757768",
		"id": 155757768,
		"lng": -77.38589295,
		"lat": 37.53644761,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 13,
		"by": 1925,
		"bd": 12,
		"bm": 8,
		"nm": "L.",
		"nf": "Carroll",
		"nl": "Eddleton",
		"url": "https://findagrave.com/memorial/158891067",
		"id": 158891067,
		"lng": -77.38707445,
		"lat": 37.53768886,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 7,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Harrison",
		"nl": "Edmondson",
		"url": "https://findagrave.com/memorial/150786831",
		"id": 150786831,
		"lng": -77.38642352,
		"lat": 37.5355311,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alease",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/175401444",
		"id": 175401444,
		"lng": -77.38755594,
		"lat": 37.53694263,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 11,
		"dd": 1,
		"by": 1918,
		"bd": 14,
		"bm": 7,
		"nm": "V.",
		"nf": "Fannie",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/148285662",
		"id": 148285662,
		"lng": -77.38645999,
		"lat": 37.53543664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 6,
		"by": 1873,
		"bd": 5,
		"bm": 5,
		"nm": "",
		"nf": "Hattie",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/154294641",
		"id": 154294641,
		"lng": -77.38686012,
		"lat": 37.53555338,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 3,
		"dd": 27,
		"by": 1858,
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Lucy",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/113626444",
		"id": 113626444,
		"lng": -77.38582198,
		"lat": 37.5368281,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 8,
		"dd": 5,
		"by": 1910,
		"bd": 17,
		"bm": 11,
		"nm": "Bell",
		"nf": "Martin",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/180231848",
		"id": 180231848,
		"lng": -77.38723157,
		"lat": 37.53690493,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 29,
		"by": 1953,
		"bd": 31,
		"bm": 3,
		"nm": "Esterine",
		"nf": "Royall",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/173166589",
		"id": 173166589,
		"lng": -77.38699825,
		"lat": 37.53722945,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 11,
		"dd": 14,
		"by": 1888,
		"bd": 16,
		"bm": 6,
		"nm": "S.",
		"nf": "William",
		"nl": "Edwards",
		"url": "https://findagrave.com/memorial/127460977",
		"id": 127460977,
		"lng": -77.3858007,
		"lat": 37.53660122,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 7,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Caroline",
		"nl": "Eldridge",
		"url": "https://findagrave.com/memorial/184277132",
		"id": 184277132,
		"lng": -77.38758096,
		"lat": 37.53743251,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Ellett",
		"url": "https://findagrave.com/memorial/175614966",
		"id": 175614966,
		"lng": -77.38802703,
		"lat": 37.53718992,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 10,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Catherine",
		"nl": "Ellett",
		"url": "https://findagrave.com/memorial/134454186",
		"id": 134454186,
		"lng": -77.38568831,
		"lat": 37.53688701,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 23,
		"by": 1887,
		"bd": 10,
		"bm": 7,
		"nm": "",
		"nf": "Cabell",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/160933697",
		"id": 160933697,
		"lng": -77.38641646,
		"lat": 37.536786,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 10,
		"by": 1945,
		"bd": 26,
		"bm": 5,
		"nm": "",
		"nf": "Dawson",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/125806326",
		"id": 125806326,
		"lng": -77.38601926,
		"lat": 37.53742498,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 8,
		"dd": 12,
		"by": 1865,
		"bd": 13,
		"bm": 7,
		"nm": "",
		"nf": "James",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/144542922",
		"id": 144542922,
		"lng": -77.3865397,
		"lat": 37.5356719,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 11,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucinda",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/185763553",
		"id": 185763553,
		"lng": -77.38768296,
		"lat": 37.53692067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 3,
		"by": 1942,
		"bd": 19,
		"bm": 4,
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/155512360",
		"id": 155512360,
		"lng": -77.38654461,
		"lat": 37.5367659,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 17,
		"by": 1893,
		"bd": 26,
		"bm": 5,
		"nm": "H.",
		"nf": "Wirt",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/177545576",
		"id": 177545576,
		"lng": -77.38694052,
		"lat": 37.5354804,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 9,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Lucy",
		"nl": "Epps",
		"url": "https://findagrave.com/memorial/133716111",
		"id": 133716111,
		"lng": -77.38594107,
		"lat": 37.53613523,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 2,
		"dd": 11,
		"by": 1882,
		"bd": 3,
		"bm": 6,
		"nm": "",
		"nf": "Mathews",
		"nl": "Epps",
		"url": "https://findagrave.com/memorial/130426335",
		"id": 130426335,
		"lng": -77.3860724,
		"lat": 37.53586315,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 14,
		"by": 1844,
		"bd": "",
		"bm": 5,
		"nm": "",
		"nf": "Sarah",
		"nl": "Epps",
		"url": "https://findagrave.com/memorial/156187912",
		"id": 156187912,
		"lng": -77.38645527,
		"lat": 37.53540704,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 6,
		"dd": 12,
		"by": 1903,
		"bd": 19,
		"bm": 7,
		"nm": "",
		"nf": "Susie",
		"nl": "Epps",
		"url": "https://findagrave.com/memorial/122027340",
		"id": 122027340,
		"lng": -77.38594231,
		"lat": 37.53655484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 9,
		"dd": 17,
		"by": 1903,
		"bd": 17,
		"bm": 7,
		"nm": "Roosevelt",
		"nf": "Walter",
		"nl": "Epps",
		"url": "https://findagrave.com/memorial/122027352",
		"id": 122027352,
		"lng": -77.38594077,
		"lat": 37.53655834,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 8,
		"dd": 2,
		"by": 1892,
		"bd": 1,
		"bm": 11,
		"nm": "L. M.",
		"nf": "Alma",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/144820785",
		"id": 144820785,
		"lng": -77.38652804,
		"lat": 37.5356957,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 11,
		"dd": 18,
		"by": 1908,
		"bd": 25,
		"bm": 11,
		"nm": "W.",
		"nf": "Charles",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/173664285",
		"id": 173664285,
		"lng": -77.3872262,
		"lat": 37.53741349,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 4,
		"by": 1928,
		"bd": 21,
		"bm": 4,
		"nm": "W.",
		"nf": "Constance",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/129208551",
		"id": 129208551,
		"lng": -77.38635145,
		"lat": 37.5369953,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 1,
		"dd": 24,
		"by": 1965,
		"bd": 20,
		"bm": 8,
		"nm": "",
		"nf": "Diane",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/159411349",
		"id": 159411349,
		"lng": -77.38606252,
		"lat": 37.53747758,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 3,
		"dd": 25,
		"by": 1932,
		"bd": 13,
		"bm": 10,
		"nm": "",
		"nf": "Florence",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/127719218",
		"id": 127719218,
		"lng": -77.38608749,
		"lat": 37.53655631,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 7,
		"dd": 7,
		"by": 1899,
		"bd": 24,
		"bm": 10,
		"nm": "L.",
		"nf": "Hazel",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/120610682",
		"id": 120610682,
		"lng": -77.38721712,
		"lat": 37.53743033,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 12,
		"dd": 28,
		"by": 1891,
		"bd": 1,
		"bm": 1,
		"nm": "P.",
		"nf": "Ida",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/160053469",
		"id": 160053469,
		"lng": -77.38659387,
		"lat": 37.53747743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 9,
		"dd": 29,
		"by": 1877,
		"bd": 3,
		"bm": 4,
		"nm": "",
		"nf": "Jacob",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/185390213",
		"id": 185390213,
		"lng": -77.38754879,
		"lat": 37.53654671,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 12,
		"by": 1917,
		"bd": 29,
		"bm": 8,
		"nm": "",
		"nf": "Margie",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/123850448",
		"id": 123850448,
		"lng": -77.38602633,
		"lat": 37.53668066,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1899,
		"dm": 1,
		"dd": 23,
		"by": 1858,
		"bd": 22,
		"bm": 1,
		"nm": "Bruce",
		"nf": "Robert",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/145838350",
		"id": 145838350,
		"lng": -77.38652956,
		"lat": 37.53569772,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 11,
		"dd": 12,
		"by": 1858,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Evans",
		"url": "https://findagrave.com/memorial/119328003",
		"id": 119328003,
		"lng": -77.38552586,
		"lat": 37.53731097,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 12,
		"by": 1905,
		"bd": 8,
		"bm": 10,
		"nm": "Mae",
		"nf": "Annie",
		"nl": "Everett",
		"url": "https://findagrave.com/memorial/144315633",
		"id": 144315633,
		"lng": -77.38768229,
		"lat": 37.53765377,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 4,
		"dd": 22,
		"by": 1857,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Ewell",
		"url": "https://findagrave.com/memorial/154228740",
		"id": 154228740,
		"lng": -77.38666305,
		"lat": 37.53554944,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 16,
		"by": 1947,
		"bd": 11,
		"bm": 3,
		"nm": "Ann",
		"nf": "Barbra",
		"nl": "Faison",
		"url": "https://findagrave.com/memorial/173773133",
		"id": 173773133,
		"lng": -77.38733127,
		"lat": 37.53739818,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 31,
		"by": 1909,
		"bd": 12,
		"bm": 11,
		"nm": "Henry",
		"nf": "Wilbur",
		"nl": "Faison",
		"url": "https://findagrave.com/memorial/142221483",
		"id": 142221483,
		"lng": -77.38664272,
		"lat": 37.5371714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 7,
		"dd": 17,
		"by": 1908,
		"bd": 8,
		"bm": 8,
		"nm": "Lisvell",
		"nf": "Matt",
		"nl": "Farrar",
		"url": "https://findagrave.com/memorial/151265418",
		"id": 151265418,
		"lng": -77.38652068,
		"lat": 37.53676974,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 10,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Ulysses",
		"nl": "Farrow",
		"url": "https://findagrave.com/memorial/167182278",
		"id": 167182278,
		"lng": -77.3867652,
		"lat": 37.53682523,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 4,
		"dd": 3,
		"by": 1875,
		"bd": 2,
		"bm": 4,
		"nm": "Jackson",
		"nf": "Henry",
		"nl": "Faulk",
		"url": "https://findagrave.com/memorial/146682156",
		"id": 146682156,
		"lng": -77.38622281,
		"lat": 37.5358335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 6,
		"dd": 15,
		"by": 1861,
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Charles",
		"nl": "Fauntleroy",
		"url": "https://findagrave.com/memorial/151085424",
		"id": 151085424,
		"lng": -77.38673656,
		"lat": 37.53568102,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 29,
		"by": 1848,
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "John",
		"nl": "Fauntleroy",
		"url": "https://findagrave.com/memorial/150866183",
		"id": 150866183,
		"lng": -77.38672863,
		"lat": 37.53582708,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 10,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Felder",
		"url": "https://findagrave.com/memorial/177284422",
		"id": 177284422,
		"lng": -77.3873912,
		"lat": 37.53728471,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 8,
		"by": 1888,
		"bd": 3,
		"bm": 3,
		"nm": "D.",
		"nf": "Samuel",
		"nl": "Felder",
		"url": "https://findagrave.com/memorial/177280192",
		"id": 177280192,
		"lng": -77.38741685,
		"lat": 37.53728398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 8,
		"dd": 13,
		"by": 1889,
		"bd": 11,
		"bm": 11,
		"nm": "A.",
		"nf": "Louise",
		"nl": "Fells",
		"url": "https://findagrave.com/memorial/156119504",
		"id": 156119504,
		"lng": -77.38613456,
		"lat": 37.53695955,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 19,
		"by": 1887,
		"bd": 14,
		"bm": 1,
		"nm": "Philip",
		"nf": "William",
		"nl": "Fells",
		"url": "https://findagrave.com/memorial/156126310",
		"id": 156126310,
		"lng": -77.3860531,
		"lat": 37.53694458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 9,
		"by": 1905,
		"bd": 16,
		"bm": 5,
		"nm": "",
		"nf": "Bessie",
		"nl": "Feltz",
		"url": "https://findagrave.com/memorial/154509674",
		"id": 154509674,
		"lng": -77.38638853,
		"lat": 37.5374119,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Fenderson",
		"url": "https://findagrave.com/memorial/175469648",
		"id": 175469648,
		"lng": -77.38733099,
		"lat": 37.53701739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 8,
		"dd": 30,
		"by": 1899,
		"bd": 26,
		"bm": 12,
		"nm": "",
		"nf": "Guy",
		"nl": "Ferguson",
		"url": "https://findagrave.com/memorial/144105287",
		"id": 144105287,
		"lng": -77.38760125,
		"lat": 37.53759741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 10,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lewis",
		"nl": "Ferrell",
		"url": "https://findagrave.com/memorial/161097218",
		"id": 161097218,
		"lng": -77.38708965,
		"lat": 37.53704339,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 24,
		"by": 1925,
		"bd": 7,
		"bm": 3,
		"nm": "Juanita",
		"nf": "Mary",
		"nl": "Fessenton",
		"url": "https://findagrave.com/memorial/153946517",
		"id": 153946517,
		"lng": -77.38632911,
		"lat": 37.5374785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 2,
		"dd": 19,
		"by": 1974,
		"bd": 24,
		"bm": 1,
		"nm": "Rosaette",
		"nf": "Tonya",
		"nl": "Fields",
		"url": "https://findagrave.com/memorial/142526897",
		"id": 142526897,
		"lng": -77.38591255,
		"lat": 37.5373508,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Finney",
		"url": "https://findagrave.com/memorial/145325136",
		"id": 145325136,
		"lng": -77.385586,
		"lat": 37.53725614,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Fisher",
		"url": "https://findagrave.com/memorial/175449958",
		"id": 175449958,
		"lng": -77.38748925,
		"lat": 37.53699904,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 5,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Fisher",
		"url": "https://findagrave.com/memorial/164624182",
		"id": 164624182,
		"lng": -77.38645735,
		"lat": 37.53567207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Fitzgerald",
		"url": "https://findagrave.com/memorial/145084193",
		"id": 145084193,
		"lng": -77.38742566,
		"lat": 37.53782747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 4,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mattie",
		"nl": "Fitzgerald",
		"url": "https://findagrave.com/memorial/125408441",
		"id": 125408441,
		"lng": -77.38728676,
		"lat": 37.53694354,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 12,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Anna",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/173897359",
		"id": 173897359,
		"lng": -77.38762173,
		"lat": 37.5371732,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Eliza",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/188299223",
		"id": 188299223,
		"lng": -77.38791968,
		"lat": 37.53706984,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 5,
		"dd": 26,
		"by": 1895,
		"bd": 6,
		"bm": 9,
		"nm": "T.",
		"nf": "Estelle",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/152552926",
		"id": 152552926,
		"lng": -77.38659225,
		"lat": 37.53738469,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 10,
		"dd": 15,
		"by": 1910,
		"bd": 8,
		"bm": 8,
		"nm": "Lee",
		"nf": "Harold",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/151265587",
		"id": 151265587,
		"lng": -77.3870195,
		"lat": 37.53703325,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 7,
		"dd": 3,
		"by": 1933,
		"bd": 19,
		"bm": 6,
		"nm": "Ronald",
		"nf": "James",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/76587778",
		"id": 76587778,
		"lng": -77.3860925,
		"lat": 37.53702553,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 7,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/181427144",
		"id": 181427144,
		"lng": -77.38799484,
		"lat": 37.53775696,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 7,
		"dd": 10,
		"by": 1873,
		"bd": 16,
		"bm": 9,
		"nm": "R.",
		"nf": "Shedrick",
		"nl": "Fleming",
		"url": "https://findagrave.com/memorial/153162680",
		"id": 153162680,
		"lng": -77.386133,
		"lat": 37.53695389,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 2,
		"dd": 6,
		"by": 1910,
		"bd": 3,
		"bm": 3,
		"nm": "",
		"nf": "Johnnie",
		"nl": "Flood",
		"url": "https://findagrave.com/memorial/139424351",
		"id": 139424351,
		"lng": -77.38631813,
		"lat": 37.53635795,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 3,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Flood",
		"url": "https://findagrave.com/memorial/187351673",
		"id": 187351673,
		"lng": -77.38785804,
		"lat": 37.53709122,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 6,
		"dd": 24,
		"by": 1901,
		"bd": 5,
		"bm": 8,
		"nm": "",
		"nf": "Pearl",
		"nl": "Flowers",
		"url": "https://findagrave.com/memorial/180521722",
		"id": 180521722,
		"lng": -77.38809568,
		"lat": 37.53753137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Floyd",
		"url": "https://findagrave.com/memorial/155123737",
		"id": 155123737,
		"lng": -77.38668663,
		"lat": 37.53713597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 5,
		"dd": 17,
		"by": 1899,
		"bd": 15,
		"bm": 7,
		"nm": "",
		"nf": "Mack",
		"nl": "Fogle",
		"url": "https://findagrave.com/memorial/158676911",
		"id": 158676911,
		"lng": -77.3868794,
		"lat": 37.53747288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Alfred",
		"nl": "Folkes",
		"url": "https://findagrave.com/memorial/149439659",
		"id": 149439659,
		"lng": -77.38611653,
		"lat": 37.53589903,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 6,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Annie",
		"nl": "Folkes",
		"url": "https://findagrave.com/memorial/38425507",
		"id": 38425507,
		"lng": -77.3861288,
		"lat": 37.53574683,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 17,
		"by": 1901,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Marcia",
		"nl": "Forcey",
		"url": "https://findagrave.com/memorial/175882989",
		"id": 175882989,
		"lng": -77.38636976,
		"lat": 37.53673049,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Forcey",
		"url": "https://findagrave.com/memorial/187342818",
		"id": 187342818,
		"lng": -77.38775866,
		"lat": 37.53628097,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 10,
		"dd": 2,
		"by": 1865,
		"bd": "",
		"bm": 2,
		"nm": "Eliza",
		"nf": "Annie",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/138564996",
		"id": 138564996,
		"lng": -77.38644242,
		"lat": 37.53692178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bernard",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/134454192",
		"id": 134454192,
		"lng": -77.38647837,
		"lat": 37.53699644,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 2,
		"dd": 24,
		"by": 1862,
		"bd": "",
		"bm": 2,
		"nm": "",
		"nf": "Beverly",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/138565000",
		"id": 138565000,
		"lng": -77.38644528,
		"lat": 37.53691602,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 1,
		"dd": 10,
		"by": 1888,
		"bd": 2,
		"bm": 2,
		"nm": "Thomas",
		"nf": "Beverly",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/76587792",
		"id": 76587792,
		"lng": -77.38638416,
		"lat": 37.53700583,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 7,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Grimes",
		"nf": "Charles",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/117804400",
		"id": 117804400,
		"lng": -77.38665649,
		"lat": 37.53738408,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 20,
		"by": 1880,
		"bd": 3,
		"bm": 7,
		"nm": "M.",
		"nf": "Estelle",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/161053094",
		"id": 161053094,
		"lng": -77.38720177,
		"lat": 37.53707869,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 25,
		"by": 1904,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "Irene",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/142221487",
		"id": 142221487,
		"lng": -77.38665388,
		"lat": 37.53713178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 3,
		"dd": 13,
		"by": 1896,
		"bd": 14,
		"bm": 12,
		"nm": "Harold",
		"nf": "James",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/138565008",
		"id": 138565008,
		"lng": -77.38645092,
		"lat": 37.53690358,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 10,
		"dd": 7,
		"by": 1921,
		"bd": 29,
		"bm": 10,
		"nm": "Reginald",
		"nf": "James",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/146920646",
		"id": 146920646,
		"lng": -77.38639025,
		"lat": 37.53698965,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/161053145",
		"id": 161053145,
		"lng": -77.38721016,
		"lat": 37.53708508,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 10,
		"by": 1901,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Joseph",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/119391249",
		"id": 119391249,
		"lng": -77.38590594,
		"lat": 37.53660858,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 12,
		"dd": 28,
		"by": 1900,
		"bd": 10,
		"bm": 1,
		"nm": "",
		"nf": "Mary",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/145594999",
		"id": 145594999,
		"lng": -77.3863032,
		"lat": 37.53729983,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/119391281",
		"id": 119391281,
		"lng": -77.38590006,
		"lat": 37.53662293,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 2,
		"by": 1907,
		"bd": 17,
		"bm": 9,
		"nm": "",
		"nf": "Samuel",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/161947678",
		"id": 161947678,
		"lng": -77.38639086,
		"lat": 37.53712819,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 25,
		"by": 1923,
		"bd": 4,
		"bm": 7,
		"nm": "Henry",
		"nf": "William",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/172033331",
		"id": 172033331,
		"lng": -77.38735247,
		"lat": 37.53682755,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 3,
		"dd": 28,
		"by": 1881,
		"bd": 1,
		"bm": 9,
		"nm": "",
		"nf": "William",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/119391300",
		"id": 119391300,
		"lng": -77.38587018,
		"lat": 37.53662646,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 2,
		"dd": 15,
		"by": 1892,
		"bd": "",
		"bm": 5,
		"nm": "Oscar",
		"nf": "William",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/138565018",
		"id": 138565018,
		"lng": -77.38642419,
		"lat": 37.53690464,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 8,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eddie",
		"nl": "Foster",
		"url": "https://findagrave.com/memorial/186894216",
		"id": 186894216,
		"lng": -77.38752072,
		"lat": 37.53687419,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 16,
		"by": 1909,
		"bd": 17,
		"bm": 8,
		"nm": "",
		"nf": "Eva",
		"nl": "Foster",
		"url": "https://findagrave.com/memorial/144558508",
		"id": 144558508,
		"lng": -77.38749697,
		"lat": 37.53734563,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 13,
		"by": 1912,
		"bd": 18,
		"bm": 7,
		"nm": "",
		"nf": "George",
		"nl": "Foster",
		"url": "https://findagrave.com/memorial/172068399",
		"id": 172068399,
		"lng": -77.38692313,
		"lat": 37.53717126,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 4,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mitchell",
		"nl": "Fountain",
		"url": "https://findagrave.com/memorial/150035999",
		"id": 150035999,
		"lng": -77.38720295,
		"lat": 37.53547796,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1986,
		"dm": 11,
		"dd": 26,
		"by": 1903,
		"bd": 11,
		"bm": 6,
		"nm": "E.",
		"nf": "William",
		"nl": "Fountain",
		"url": "https://findagrave.com/memorial/38455978",
		"id": 38455978,
		"lng": -77.38578184,
		"lat": 37.53699647,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 5,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Anthony",
		"nl": "Fowlkes",
		"url": "https://findagrave.com/memorial/156045959",
		"id": 156045959,
		"lng": -77.38607774,
		"lat": 37.53589516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 8,
		"dd": 31,
		"by": 1924,
		"bd": 6,
		"bm": 12,
		"nm": "Elizabeth",
		"nf": "Alease",
		"nl": "Fox",
		"url": "https://findagrave.com/memorial/148648708",
		"id": 148648708,
		"lng": -77.38701246,
		"lat": 37.53697596,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 17,
		"by": 1878,
		"bd": 20,
		"bm": 1,
		"nm": "",
		"nf": "John",
		"nl": "Fox",
		"url": "https://findagrave.com/memorial/172043643",
		"id": 172043643,
		"lng": -77.38690938,
		"lat": 37.53724827,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alexander",
		"nl": "Franklin",
		"url": "https://findagrave.com/memorial/185493770",
		"id": 185493770,
		"lng": -77.38659403,
		"lat": 37.53594488,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Carrie",
		"nl": "Franklin",
		"url": "https://findagrave.com/memorial/76587804",
		"id": 76587804,
		"lng": -77.38547053,
		"lat": 37.53735102,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 24,
		"by": 1913,
		"bd": 17,
		"bm": 4,
		"nm": "D.",
		"nf": "Leroy",
		"nl": "Franklin",
		"url": "https://findagrave.com/memorial/169042949",
		"id": 169042949,
		"lng": -77.38616075,
		"lat": 37.53741279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 13,
		"by": 1894,
		"bd": 20,
		"bm": 4,
		"nm": "",
		"nf": "Frank",
		"nl": "Frasure",
		"url": "https://findagrave.com/memorial/141193901",
		"id": 141193901,
		"lng": -77.3862801,
		"lat": 37.53668509,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 12,
		"by": 1900,
		"bd": 19,
		"bm": 8,
		"nm": "",
		"nf": "Viola",
		"nl": "Frasure",
		"url": "https://findagrave.com/memorial/184094531",
		"id": 184094531,
		"lng": -77.38720488,
		"lat": 37.53757747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 9,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Fravier",
		"url": "https://findagrave.com/memorial/185564844",
		"id": 185564844,
		"lng": -77.3873161,
		"lat": 37.53685474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elnora",
		"nl": "Frazier",
		"url": "https://findagrave.com/memorial/155123917",
		"id": 155123917,
		"lng": -77.38666619,
		"lat": 37.53711345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 12,
		"dd": 26,
		"by": 1883,
		"bd": 4,
		"bm": 7,
		"nm": "E.",
		"nf": "Leroy",
		"nl": "Frazier",
		"url": "https://findagrave.com/memorial/119240867",
		"id": 119240867,
		"lng": -77.38584394,
		"lat": 37.5368527,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 8,
		"dd": 3,
		"by": 1932,
		"bd": 26,
		"bm": 1,
		"nm": "R.",
		"nf": "Dorothy",
		"nl": "Freeman",
		"url": "https://findagrave.com/memorial/171761581",
		"id": 171761581,
		"lng": -77.38695709,
		"lat": 37.53705827,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 24,
		"by": 1962,
		"bd": 14,
		"bm": 10,
		"nm": "F.",
		"nf": "Princella",
		"nl": "Freeman",
		"url": "https://findagrave.com/memorial/191503822",
		"id": 191503822,
		"lng": -77.38614808,
		"lat": 37.53751409,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 5,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Freeman",
		"url": "https://findagrave.com/memorial/186818136",
		"id": 186818136,
		"lng": -77.38723236,
		"lat": 37.53698769,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 5,
		"dd": 22,
		"by": 1901,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Louise",
		"nl": "French",
		"url": "https://findagrave.com/memorial/139146848",
		"id": 139146848,
		"lng": -77.38780075,
		"lat": 37.53696202,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 12,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "French",
		"url": "https://findagrave.com/memorial/166483161",
		"id": 166483161,
		"lng": -77.38726772,
		"lat": 37.5363109,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 2,
		"dd": 13,
		"by": 1931,
		"bd": 16,
		"bm": 4,
		"nm": "G.",
		"nf": "Julia",
		"nl": "Fuller",
		"url": "https://findagrave.com/memorial/153627702",
		"id": 153627702,
		"lng": -77.38630726,
		"lat": 37.53747015,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 22,
		"by": 1884,
		"bd": 17,
		"bm": 12,
		"nm": "",
		"nf": "Mutt",
		"nl": "Fuller",
		"url": "https://findagrave.com/memorial/158891074",
		"id": 158891074,
		"lng": -77.38711204,
		"lat": 37.53750554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 8,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nancy",
		"nl": "Fuller",
		"url": "https://findagrave.com/memorial/146012164",
		"id": 146012164,
		"lng": -77.38775299,
		"lat": 37.53668613,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Fuller",
		"url": "https://findagrave.com/memorial/146207059",
		"id": 146207059,
		"lng": -77.38587684,
		"lat": 37.53677522,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hermina",
		"nl": "Fulton",
		"url": "https://findagrave.com/memorial/145595007",
		"id": 145595007,
		"lng": -77.38587031,
		"lat": 37.53734345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 7,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Fulton",
		"url": "https://findagrave.com/memorial/145595012",
		"id": 145595012,
		"lng": -77.38587358,
		"lat": 37.53734448,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 15,
		"by": 1886,
		"bd": 7,
		"bm": 3,
		"nm": "",
		"nf": "Jane",
		"nl": "Gabbin",
		"url": "https://findagrave.com/memorial/144105299",
		"id": 144105299,
		"lng": -77.38588815,
		"lat": 37.53739333,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 9,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frank",
		"nl": "Gaddy",
		"url": "https://findagrave.com/memorial/176983670",
		"id": 176983670,
		"lng": -77.38749883,
		"lat": 37.53560601,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 4,
		"dd": 11,
		"by": 1871,
		"bd": 2,
		"bm": 3,
		"nm": "C.",
		"nf": "Mary",
		"nl": "Gaines",
		"url": "https://findagrave.com/memorial/176466887",
		"id": 176466887,
		"lng": -77.38717136,
		"lat": 37.5369388,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 7,
		"dd": 23,
		"by": 1879,
		"bd": 18,
		"bm": 12,
		"nm": "H. Allen",
		"nf": "William",
		"nl": "Gaines",
		"url": "https://findagrave.com/memorial/176466599",
		"id": 176466599,
		"lng": -77.38717175,
		"lat": 37.53694675,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 6,
		"dd": 19,
		"by": 1873,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Florence",
		"nl": "Gaines",
		"url": "https://findagrave.com/memorial/192637700",
		"id": 192637700,
		"lng": -77.38660003,
		"lat": 37.53736996,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 8,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Gardner",
		"url": "https://findagrave.com/memorial/151460478",
		"id": 151460478,
		"lng": -77.38800488,
		"lat": 37.53730351,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 12,
		"by": 1950,
		"bd": 27,
		"bm": 3,
		"nm": "E.",
		"nf": "Carneal",
		"nl": "Garlick",
		"url": "https://findagrave.com/memorial/176570431",
		"id": 176570431,
		"lng": -77.38722312,
		"lat": 37.53752839,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Edward",
		"nf": "Willie",
		"nl": "Garner",
		"url": "https://findagrave.com/memorial/144189279",
		"id": 144189279,
		"lng": -77.38749514,
		"lat": 37.53741592,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 5,
		"dd": 7,
		"by": 1881,
		"bd": 21,
		"bm": 11,
		"nm": "E.",
		"nf": "Archie",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/145084195",
		"id": 145084195,
		"lng": -77.38632636,
		"lat": 37.53730358,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 11,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Correlia",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/139146860",
		"id": 139146860,
		"lng": -77.38798197,
		"lat": 37.53700034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 5,
		"dd": 4,
		"by": 1858,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "James",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/115976029",
		"id": 115976029,
		"lng": -77.38570182,
		"lat": 37.53672178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 5,
		"dd": 10,
		"by": 1888,
		"bd": 26,
		"bm": 12,
		"nm": "F.",
		"nf": "James",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/117307716",
		"id": 117307716,
		"lng": -77.38571962,
		"lat": 37.53673848,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Josephine",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/176983375",
		"id": 176983375,
		"lng": -77.38748792,
		"lat": 37.53567164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 8,
		"by": 1897,
		"bd": 2,
		"bm": 1,
		"nm": "",
		"nf": "Lewis",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/117449099",
		"id": 117449099,
		"lng": -77.38573246,
		"lat": 37.53671632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 4,
		"dd": 3,
		"by": 1860,
		"bd": 5,
		"bm": 5,
		"nm": "",
		"nf": "Virginia",
		"nl": "Garnett",
		"url": "https://findagrave.com/memorial/117449105",
		"id": 117449105,
		"lng": -77.38572721,
		"lat": 37.53672705,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 4,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Russell",
		"nl": "Gates",
		"url": "https://findagrave.com/memorial/144370207",
		"id": 144370207,
		"lng": -77.38705004,
		"lat": 37.53780921,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 23,
		"by": 1892,
		"bd": 22,
		"bm": 8,
		"nm": "A.",
		"nf": "Florence",
		"nl": "Gatewood",
		"url": "https://findagrave.com/memorial/145638795",
		"id": 145638795,
		"lng": -77.38559228,
		"lat": 37.53722361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Gatewood",
		"url": "https://findagrave.com/memorial/161171365",
		"id": 161171365,
		"lng": -77.38702389,
		"lat": 37.53704767,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 2,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Gatewood",
		"url": "https://findagrave.com/memorial/169904896",
		"id": 169904896,
		"lng": -77.38682852,
		"lat": 37.53709348,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 9,
		"dd": 29,
		"by": 1960,
		"bd": 30,
		"bm": 6,
		"nm": "",
		"nf": "Ronnie",
		"nl": "Gay",
		"url": "https://findagrave.com/memorial/153625634",
		"id": 153625634,
		"lng": -77.38645577,
		"lat": 37.5376325,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 5,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Amanda",
		"nl": "Gayles",
		"url": "https://findagrave.com/memorial/120147040",
		"id": 120147040,
		"lng": -77.38599313,
		"lat": 37.53673764,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 4,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ezekiel",
		"nl": "Gayles",
		"url": "https://findagrave.com/memorial/188439060",
		"id": 188439060,
		"lng": -77.38800374,
		"lat": 37.53703539,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 6,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Josephine",
		"nl": "Gayles",
		"url": "https://findagrave.com/memorial/169425026",
		"id": 169425026,
		"lng": -77.38729796,
		"lat": 37.53674743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 4,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Evelyna",
		"nl": "Geiger",
		"url": "https://findagrave.com/memorial/176570439",
		"id": 176570439,
		"lng": -77.38692751,
		"lat": 37.5375213,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 9,
		"dd": 4,
		"by": 1897,
		"bd": "",
		"bm": "",
		"nm": "V.",
		"nf": "Ruth",
		"nl": "General",
		"url": "https://findagrave.com/memorial/137835705",
		"id": 137835705,
		"lng": -77.38625153,
		"lat": 37.53707881,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 25,
		"by": 1918,
		"bd": 5,
		"bm": 3,
		"nm": "G.",
		"nf": "Susie",
		"nl": "General",
		"url": "https://findagrave.com/memorial/143022066",
		"id": 143022066,
		"lng": -77.38605633,
		"lat": 37.53733002,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 12,
		"dd": "",
		"by": 1894,
		"bd": 13,
		"bm": 2,
		"nm": "W.",
		"nf": "Sylvester",
		"nl": "General",
		"url": "https://findagrave.com/memorial/137835760",
		"id": 137835760,
		"lng": -77.38625042,
		"lat": 37.5370811,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 16,
		"by": 1916,
		"bd": 21,
		"bm": 5,
		"nm": "T.",
		"nf": "Willie",
		"nl": "General",
		"url": "https://findagrave.com/memorial/128632132",
		"id": 128632132,
		"lng": -77.38621979,
		"lat": 37.5366222,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 12,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Claudie",
		"nl": "Gentry",
		"url": "https://findagrave.com/memorial/143696154",
		"id": 143696154,
		"lng": -77.38600565,
		"lat": 37.53606099,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 9,
		"dd": 25,
		"by": 1885,
		"bd": 9,
		"bm": 6,
		"nm": "",
		"nf": "Rosa",
		"nl": "Gerst",
		"url": "https://findagrave.com/memorial/141798909",
		"id": 141798909,
		"lng": -77.38670899,
		"lat": 37.53725441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 20,
		"by": 1939,
		"bd": 23,
		"bm": 11,
		"nm": "J.",
		"nf": "Albert",
		"nl": "Ghee",
		"url": "https://findagrave.com/memorial/144370216",
		"id": 144370216,
		"lng": -77.38606551,
		"lat": 37.53731722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 6,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bessie",
		"nl": "Gibbs",
		"url": "https://findagrave.com/memorial/150037935",
		"id": 150037935,
		"lng": -77.3862292,
		"lat": 37.53614389,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 12,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "James",
		"nl": "Gibbs",
		"url": "https://findagrave.com/memorial/143632565",
		"id": 143632565,
		"lng": -77.3861201,
		"lat": 37.53585064,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Daisy",
		"nl": "Gibson",
		"url": "https://findagrave.com/memorial/155514218",
		"id": 155514218,
		"lng": -77.38757899,
		"lat": 37.53769471,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Laura",
		"nl": "Giggetts",
		"url": "https://findagrave.com/memorial/137430011",
		"id": 137430011,
		"lng": -77.38594056,
		"lat": 37.53704109,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": "",
		"dd": "",
		"by": 1903,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Gilliam",
		"url": "https://findagrave.com/memorial/154039270",
		"id": 154039270,
		"lng": -77.38635726,
		"lat": 37.53712897,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 28,
		"by": 1899,
		"bd": 3,
		"bm": 2,
		"nm": "",
		"nf": "Amos",
		"nl": "Gladney",
		"url": "https://findagrave.com/memorial/144105308",
		"id": 144105308,
		"lng": -77.38736431,
		"lat": 37.53791335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 2,
		"dd": 12,
		"by": 1890,
		"bd": 19,
		"bm": 1,
		"nm": "J.",
		"nf": "Loving",
		"nl": "Glaspy",
		"url": "https://findagrave.com/memorial/155514228",
		"id": 155514228,
		"lng": -77.38757897,
		"lat": 37.5377762,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 2,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charlotte",
		"nl": "Glenn",
		"url": "https://findagrave.com/memorial/185739565",
		"id": 185739565,
		"lng": -77.38780184,
		"lat": 37.53712664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 23,
		"by": 1910,
		"bd": 1,
		"bm": 1,
		"nm": "",
		"nf": "Leroy",
		"nl": "Glenn",
		"url": "https://findagrave.com/memorial/137835763",
		"id": 137835763,
		"lng": -77.38630305,
		"lat": 37.53704031,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Godfrey",
		"url": "https://findagrave.com/memorial/127131707",
		"id": 127131707,
		"lng": -77.38610526,
		"lat": 37.53636561,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jasper",
		"nl": "Goforth",
		"url": "https://findagrave.com/memorial/177152036",
		"id": 177152036,
		"lng": -77.38792258,
		"lat": 37.53701233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 6,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Goings",
		"url": "https://findagrave.com/memorial/188267878",
		"id": 188267878,
		"lng": -77.38787804,
		"lat": 37.5371516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 25,
		"by": 1878,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Gideon",
		"nl": "Goldsberry",
		"url": "https://findagrave.com/memorial/175409420",
		"id": 175409420,
		"lng": -77.3874174,
		"lat": 37.53702981,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 6,
		"dd": 14,
		"by": "",
		"bd": 19,
		"bm": 4,
		"nm": "",
		"nf": "Louise",
		"nl": "Goldsberry",
		"url": "https://findagrave.com/memorial/175411173",
		"id": 175411173,
		"lng": -77.38763045,
		"lat": 37.53727034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 8,
		"dd": 7,
		"by": 1914,
		"bd": 1,
		"bm": 12,
		"nm": "Ann",
		"nf": "Cora",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/158942456",
		"id": 158942456,
		"lng": -77.38688944,
		"lat": 37.53747999,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 5,
		"dd": 4,
		"by": 1924,
		"bd": 20,
		"bm": 9,
		"nm": "L.",
		"nf": "Ernest",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/144105313",
		"id": 144105313,
		"lng": -77.38645008,
		"lat": 37.53755164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 10,
		"by": 1908,
		"bd": 28,
		"bm": 6,
		"nm": "O.",
		"nf": "Frederick",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/142448405",
		"id": 142448405,
		"lng": -77.38563597,
		"lat": 37.53738415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 5,
		"dd": 26,
		"by": 1872,
		"bd": 28,
		"bm": 6,
		"nm": "",
		"nf": "Lewis",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/176986415",
		"id": 176986415,
		"lng": -77.38797799,
		"lat": 37.53721126,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 9,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Steele Jones",
		"nf": "Lula",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/176720253",
		"id": 176720253,
		"lng": -77.38795768,
		"lat": 37.53730125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 4,
		"dd": 11,
		"by": 1904,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Oliver",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/142448408",
		"id": 142448408,
		"lng": -77.38565602,
		"lat": 37.53739428,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 1,
		"by": 1935,
		"bd": 21,
		"bm": 1,
		"nm": "Lee",
		"nf": "Robert",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/164021573",
		"id": 164021573,
		"lng": -77.38755592,
		"lat": 37.53735311,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/142448418",
		"id": 142448418,
		"lng": -77.3856166,
		"lat": 37.5373808,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 3,
		"by": 1965,
		"bd": 26,
		"bm": 1,
		"nm": "Tyrone",
		"nf": "Timothy",
		"nl": "Goode",
		"url": "https://findagrave.com/memorial/153100495",
		"id": 153100495,
		"lng": -77.38604419,
		"lat": 37.53748182,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Goodwin",
		"url": "https://findagrave.com/memorial/151104683",
		"id": 151104683,
		"lng": -77.3867537,
		"lat": 37.53545514,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": "",
		"dd": "",
		"by": 1886,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Salome",
		"nl": "Goodwyn",
		"url": "https://findagrave.com/memorial/141657452",
		"id": 141657452,
		"lng": -77.38666164,
		"lat": 37.53730562,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 13,
		"by": 1897,
		"bd": 4,
		"bm": 12,
		"nm": "",
		"nf": "Cubic",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/158891083",
		"id": 158891083,
		"lng": -77.38750407,
		"lat": 37.53758163,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 7,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Douglas",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/144558511",
		"id": 144558511,
		"lng": -77.38656777,
		"lat": 37.53570835,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 3,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/150037583",
		"id": 150037583,
		"lng": -77.38741291,
		"lat": 37.53659347,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 5,
		"by": 1919,
		"bd": "",
		"bm": 10,
		"nm": "Rosetta",
		"nf": "Mary",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/177284774",
		"id": 177284774,
		"lng": -77.38734573,
		"lat": 37.5372835,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 4,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Percy",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/185390231",
		"id": 185390231,
		"lng": -77.38739135,
		"lat": 37.53657707,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 11,
		"dd": 12,
		"by": 1939,
		"bd": 19,
		"bm": 10,
		"nm": "Mae",
		"nf": "Shirley",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/176713424",
		"id": 176713424,
		"lng": -77.38748322,
		"lat": 37.53707616,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 4,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennie",
		"nl": "Goss",
		"url": "https://findagrave.com/memorial/167269942",
		"id": 167269942,
		"lng": -77.38657732,
		"lat": 37.53741448,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 3,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Anna",
		"nl": "Gossett",
		"url": "https://findagrave.com/memorial/175585474",
		"id": 175585474,
		"lng": -77.38717305,
		"lat": 37.53700693,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Katie",
		"nl": "Graham",
		"url": "https://findagrave.com/memorial/154037716",
		"id": 154037716,
		"lng": -77.38652897,
		"lat": 37.53719211,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 6,
		"by": 1935,
		"bd": 2,
		"bm": 8,
		"nm": "L.",
		"nf": "Lynwood",
		"nl": "Graham",
		"url": "https://findagrave.com/memorial/156930841",
		"id": 156930841,
		"lng": -77.38644106,
		"lat": 37.5371134,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 3,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mattie",
		"nl": "Graham",
		"url": "https://findagrave.com/memorial/166382255",
		"id": 166382255,
		"lng": -77.3875046,
		"lat": 37.53672638,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 10,
		"dd": 29,
		"by": 1919,
		"bd": 13,
		"bm": 5,
		"nm": "",
		"nf": "Alice",
		"nl": "Gramby",
		"url": "https://findagrave.com/memorial/155514238",
		"id": 155514238,
		"lng": -77.38765528,
		"lat": 37.53754475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 29,
		"by": 1897,
		"bd": 19,
		"bm": 10,
		"nm": "",
		"nf": "Joseph",
		"nl": "Grammer",
		"url": "https://findagrave.com/memorial/177099244",
		"id": 177099244,
		"lng": -77.38777427,
		"lat": 37.53722263,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 8,
		"dd": 27,
		"by": 1893,
		"bd": 5,
		"bm": 3,
		"nm": "",
		"nf": "Erna",
		"nl": "Granderson",
		"url": "https://findagrave.com/memorial/146013313",
		"id": 146013313,
		"lng": -77.38656234,
		"lat": 37.53640121,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 7,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Christopher",
		"nl": "Grantham",
		"url": "https://findagrave.com/memorial/177565589",
		"id": 177565589,
		"lng": -77.38746965,
		"lat": 37.53549472,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 5,
		"dd": 19,
		"by": 1895,
		"bd": 3,
		"bm": 5,
		"nm": "",
		"nf": "Lillie",
		"nl": "Grandison",
		"url": "https://findagrave.com/memorial/154509715",
		"id": 154509715,
		"lng": -77.38682954,
		"lat": 37.53732714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 1,
		"dd": 29,
		"by": 1903,
		"bd": 23,
		"bm": 7,
		"nm": "",
		"nf": "Willie",
		"nl": "Grant",
		"url": "https://findagrave.com/memorial/117208876",
		"id": 117208876,
		"lng": -77.38560157,
		"lat": 37.53710139,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 7,
		"dd": 13,
		"by": 1880,
		"bd": 20,
		"bm": 3,
		"nm": "",
		"nf": "Henry",
		"nl": "Granton",
		"url": "https://findagrave.com/memorial/146920657",
		"id": 146920657,
		"lng": -77.38583885,
		"lat": 37.53677579,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 10,
		"dd": 23,
		"by": 1878,
		"bd": 30,
		"bm": 11,
		"nm": "",
		"nf": "Cora",
		"nl": "Graves",
		"url": "https://findagrave.com/memorial/151104689",
		"id": 151104689,
		"lng": -77.38670798,
		"lat": 37.53559073,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 2,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "George",
		"nl": "Graves",
		"url": "https://findagrave.com/memorial/127568669",
		"id": 127568669,
		"lng": -77.38772558,
		"lat": 37.53648788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 28,
		"by": 1891,
		"bd": 26,
		"bm": 9,
		"nm": "J.",
		"nf": "Julia",
		"nl": "Graves",
		"url": "https://findagrave.com/memorial/176770846",
		"id": 176770846,
		"lng": -77.3874633,
		"lat": 37.53725011,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 10,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Walter",
		"nl": "Graves",
		"url": "https://findagrave.com/memorial/135631946",
		"id": 135631946,
		"lng": -77.38599466,
		"lat": 37.53691022,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 5,
		"dd": 15,
		"by": 1879,
		"bd": 9,
		"bm": 8,
		"nm": "Henry",
		"nf": "William",
		"nl": "Graves",
		"url": "https://findagrave.com/memorial/167182283",
		"id": 167182283,
		"lng": -77.38659258,
		"lat": 37.53691168,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ella",
		"nl": "Gray",
		"url": "https://findagrave.com/memorial/145638801",
		"id": 145638801,
		"lng": -77.38583736,
		"lat": 37.53704681,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 2,
		"dd": 14,
		"by": 1863,
		"bd": "",
		"bm": 12,
		"nm": "",
		"nf": "Hattie",
		"nl": "Gray",
		"url": "https://findagrave.com/memorial/125820813",
		"id": 125820813,
		"lng": -77.38621371,
		"lat": 37.53589791,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 2,
		"dd": 3,
		"by": 1922,
		"bd": 22,
		"bm": 1,
		"nm": "",
		"nf": "Irma",
		"nl": "Gray",
		"url": "https://findagrave.com/memorial/160335425",
		"id": 160335425,
		"lng": -77.38609337,
		"lat": 37.53634692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 8,
		"dd": 30,
		"by": 1916,
		"bd": 10,
		"bm": 7,
		"nm": "Frank",
		"nf": "Purcell",
		"nl": "Gray",
		"url": "https://findagrave.com/memorial/129209843",
		"id": 129209843,
		"lng": -77.38624243,
		"lat": 37.53684581,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 6,
		"dd": 5,
		"by": 1860,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Randolph",
		"nl": "Gray",
		"url": "https://findagrave.com/memorial/125820808",
		"id": 125820808,
		"lng": -77.38620698,
		"lat": 37.53589921,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 7,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sheppard",
		"nl": "Gray",
		"url": "https://findagrave.com/memorial/188268351",
		"id": 188268351,
		"lng": -77.38787868,
		"lat": 37.53713524,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 27,
		"by": 1892,
		"bd": "",
		"bm": "",
		"nm": "I.",
		"nf": "Alenzia",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/144315639",
		"id": 144315639,
		"lng": -77.38752593,
		"lat": 37.53735762,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 15,
		"by": 1868,
		"bd": "",
		"bm": 5,
		"nm": "",
		"nf": "Archie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/154294645",
		"id": 154294645,
		"lng": -77.38699538,
		"lat": 37.53558145,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 7,
		"dd": 29,
		"by": 1894,
		"bd": 16,
		"bm": 2,
		"nm": "",
		"nf": "Ben",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/179193103",
		"id": 179193103,
		"lng": -77.3867019,
		"lat": 37.53764426,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 10,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/151108164",
		"id": 151108164,
		"lng": -77.38666366,
		"lat": 37.53549088,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 23,
		"by": 1872,
		"bd": "",
		"bm": 8,
		"nm": "",
		"nf": "Carrie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/121031150",
		"id": 121031150,
		"lng": -77.38590289,
		"lat": 37.53655457,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 9,
		"dd": 3,
		"by": 1868,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eliza",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/154515969",
		"id": 154515969,
		"lng": -77.38652211,
		"lat": 37.53561926,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 10,
		"by": 1880,
		"bd": 27,
		"bm": 2,
		"nm": "Beatrice",
		"nf": "Emma",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/138366538",
		"id": 138366538,
		"lng": -77.38680389,
		"lat": 37.53688437,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 7,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/169465043",
		"id": 169465043,
		"lng": -77.38766047,
		"lat": 37.53699687,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 1,
		"dd": 22,
		"by": 1868,
		"bd": 30,
		"bm": 10,
		"nm": "H.",
		"nf": "John",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/155514253",
		"id": 155514253,
		"lng": -77.38701567,
		"lat": 37.53554233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 11,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Lawson",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/127881078",
		"id": 127881078,
		"lng": -77.38604818,
		"lat": 37.53657167,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1991,
		"dm": 1,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Maggie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/128632158",
		"id": 128632158,
		"lng": -77.38613367,
		"lat": 37.5366394,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 3,
		"dd": 8,
		"by": 1903,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Mary",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/158525865",
		"id": 158525865,
		"lng": -77.38673914,
		"lat": 37.53769524,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 1,
		"dd": 20,
		"by": 1894,
		"bd": 12,
		"bm": 2,
		"nm": "V.",
		"nf": "Mattie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/151039623",
		"id": 151039623,
		"lng": -77.3869956,
		"lat": 37.53556747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virginia",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/171937820",
		"id": 171937820,
		"lng": -77.38697138,
		"lat": 37.53727038,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 12,
		"dd": 24,
		"by": 1942,
		"bd": 1,
		"bm": 3,
		"nm": "Clifton",
		"nf": "Walter",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/184319229",
		"id": 184319229,
		"lng": -77.38708009,
		"lat": 37.53760068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 11,
		"by": 1903,
		"bd": 2,
		"bm": 11,
		"nm": "Avis",
		"nf": "Evelyn",
		"nl": "Griffin",
		"url": "https://findagrave.com/memorial/117208905",
		"id": 117208905,
		"lng": -77.38556282,
		"lat": 37.5371159,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 7,
		"dd": 6,
		"by": 1875,
		"bd": 1,
		"bm": 9,
		"nm": "Valentine",
		"nf": "Joseph",
		"nl": "Griffin",
		"url": "https://findagrave.com/memorial/117208912",
		"id": 117208912,
		"lng": -77.38554084,
		"lat": 37.53709676,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 1,
		"dd": 30,
		"by": 1853,
		"bd": 9,
		"bm": 10,
		"nm": "R.",
		"nf": "Joshua",
		"nl": "Griffin",
		"url": "https://findagrave.com/memorial/150836254",
		"id": 150836254,
		"lng": -77.38629837,
		"lat": 37.5354715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 29,
		"by": 1935,
		"bd": 10,
		"bm": 8,
		"nm": "Sylvester",
		"nf": "Leon",
		"nl": "Griffin",
		"url": "https://findagrave.com/memorial/173773143",
		"id": 173773143,
		"lng": -77.38715239,
		"lat": 37.5373121,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1904,
		"dm": 4,
		"dd": 12,
		"by": 1854,
		"bd": "",
		"bm": 12,
		"nm": "A.",
		"nf": "Minerva",
		"nl": "Griffin",
		"url": "https://findagrave.com/memorial/148460578",
		"id": 148460578,
		"lng": -77.38632752,
		"lat": 37.53545767,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 5,
		"by": 1964,
		"bd": 2,
		"bm": 10,
		"nm": "Leon",
		"nf": "Roosevelt",
		"nl": "Griffin",
		"url": "https://findagrave.com/memorial/191503826",
		"id": 191503826,
		"lng": -77.38607781,
		"lat": 37.53747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 5,
		"dd": 5,
		"by": 1882,
		"bd": 28,
		"bm": 6,
		"nm": "Donnas",
		"nf": "Sie",
		"nl": "Griffis",
		"url": "https://findagrave.com/memorial/185715929",
		"id": 185715929,
		"lng": -77.38772937,
		"lat": 37.53738575,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 1,
		"dd": 17,
		"by": 1859,
		"bd": 9,
		"bm": 8,
		"nm": "Thomas",
		"nf": "Henry",
		"nl": "Grimes",
		"url": "https://findagrave.com/memorial/149251652",
		"id": 149251652,
		"lng": -77.38620481,
		"lat": 37.53606397,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 10,
		"dd": 5,
		"by": 1893,
		"bd": 31,
		"bm": 8,
		"nm": "T.",
		"nf": "Henry",
		"nl": "Grymes",
		"url": "https://findagrave.com/memorial/171101256",
		"id": 171101256,
		"lng": -77.38620745,
		"lat": 37.53604442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 14,
		"by": 1963,
		"bd": 10,
		"bm": 11,
		"nm": "",
		"nf": "Stephen",
		"nl": "Hagins",
		"url": "https://findagrave.com/memorial/159411360",
		"id": 159411360,
		"lng": -77.38615271,
		"lat": 37.53748474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 7,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fred",
		"nl": "Hall",
		"url": "https://findagrave.com/memorial/125518395",
		"id": 125518395,
		"lng": -77.38621613,
		"lat": 37.53685221,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 9,
		"by": 1909,
		"bd": 10,
		"bm": 11,
		"nm": "Dyous",
		"nf": "Minnie",
		"nl": "Hall",
		"url": "https://findagrave.com/memorial/183587440",
		"id": 183587440,
		"lng": -77.38695522,
		"lat": 37.5372392,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 17,
		"by": 1940,
		"bd": 10,
		"bm": 7,
		"nm": "",
		"nf": "Rosemarie",
		"nl": "Hall",
		"url": "https://findagrave.com/memorial/177284023",
		"id": 177284023,
		"lng": -77.38735403,
		"lat": 37.53725929,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Hamilton",
		"url": "https://findagrave.com/memorial/148450710",
		"id": 148450710,
		"lng": -77.38637767,
		"lat": 37.5357077,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 6,
		"dd": 28,
		"by": 1858,
		"bd": "",
		"bm": 1,
		"nm": "Jane",
		"nf": "Mary",
		"nl": "Hamilton",
		"url": "https://findagrave.com/memorial/150033720",
		"id": 150033720,
		"lng": -77.38627997,
		"lat": 37.53585103,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": "",
		"dd": "",
		"by": 1894,
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Tim",
		"nl": "Hamilton",
		"url": "https://findagrave.com/memorial/144315648",
		"id": 144315648,
		"lng": -77.38614294,
		"lat": 37.53726021,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 6,
		"dd": 22,
		"by": 1854,
		"bd": 25,
		"bm": 12,
		"nm": "Henry",
		"nf": "William",
		"nl": "Hamilton",
		"url": "https://findagrave.com/memorial/150033728",
		"id": 150033728,
		"lng": -77.38627826,
		"lat": 37.53585716,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 11,
		"dd": 4,
		"by": 1879,
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Walter",
		"nl": "Hamm",
		"url": "https://findagrave.com/memorial/185658247",
		"id": 185658247,
		"lng": -77.38782138,
		"lat": 37.53724237,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 6,
		"dd": 23,
		"by": 1873,
		"bd": 25,
		"bm": 10,
		"nm": "",
		"nf": "Susie",
		"nl": "Hammond",
		"url": "https://findagrave.com/memorial/185392422",
		"id": 185392422,
		"lng": -77.3874951,
		"lat": 37.53761249,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Rufus",
		"nf": "Thomas",
		"nl": "Hammond",
		"url": "https://findagrave.com/memorial/185377784",
		"id": 185377784,
		"lng": -77.38672325,
		"lat": 37.53761334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 5,
		"dd": 2,
		"by": 1897,
		"bd": 27,
		"bm": 8,
		"nm": "H.",
		"nf": "William",
		"nl": "Hammond",
		"url": "https://findagrave.com/memorial/163847049",
		"id": 163847049,
		"lng": -77.38755706,
		"lat": 37.53743631,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 7,
		"dd": 21,
		"by": 1907,
		"bd": 12,
		"bm": 4,
		"nm": "",
		"nf": "Virginia",
		"nl": "Hancock",
		"url": "https://findagrave.com/memorial/137430038",
		"id": 137430038,
		"lng": -77.38597584,
		"lat": 37.5370665,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "James",
		"nl": "Hardin",
		"url": "https://findagrave.com/memorial/144143005",
		"id": 144143005,
		"lng": -77.38595464,
		"lat": 37.5372959,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 5,
		"dd": 20,
		"by": 1912,
		"bd": 19,
		"bm": 1,
		"nm": "",
		"nf": "Blufort",
		"nl": "Hardy",
		"url": "https://findagrave.com/memorial/155515675",
		"id": 155515675,
		"lng": -77.38755294,
		"lat": 37.53747961,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 10,
		"by": 1916,
		"bd": 3,
		"bm": 12,
		"nm": "S.",
		"nf": "Charles",
		"nl": "Hargrove",
		"url": "https://findagrave.com/memorial/154037786",
		"id": 154037786,
		"lng": -77.38652614,
		"lat": 37.5372013,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 23,
		"by": 1898,
		"bd": 22,
		"bm": 11,
		"nm": "",
		"nf": "George",
		"nl": "Hargrove",
		"url": "https://findagrave.com/memorial/161180417",
		"id": 161180417,
		"lng": -77.38721794,
		"lat": 37.53716534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 19,
		"by": 1900,
		"bd": 11,
		"bm": 7,
		"nm": "",
		"nf": "James",
		"nl": "Hargrove",
		"url": "https://findagrave.com/memorial/139146877",
		"id": 139146877,
		"lng": -77.38785644,
		"lat": 37.53695809,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Hargrove",
		"url": "https://findagrave.com/memorial/145595967",
		"id": 145595967,
		"lng": -77.38588245,
		"lat": 37.53740055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 22,
		"by": 1877,
		"bd": 23,
		"bm": 11,
		"nm": "James",
		"nf": "Stephen",
		"nl": "Hargrove",
		"url": "https://findagrave.com/memorial/158679365",
		"id": 158679365,
		"lng": -77.38707979,
		"lat": 37.53747392,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 3,
		"by": 1915,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Lindsay",
		"nl": "Harkless",
		"url": "https://findagrave.com/memorial/141800929",
		"id": 141800929,
		"lng": -77.38655054,
		"lat": 37.53722056,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Ella",
		"nl": "Harper",
		"url": "https://findagrave.com/memorial/151108172",
		"id": 151108172,
		"lng": -77.38660053,
		"lat": 37.53545044,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 13,
		"by": 1967,
		"bd": 8,
		"bm": 12,
		"nm": "",
		"nf": "Eugenia",
		"nl": "Harper",
		"url": "https://findagrave.com/memorial/124564894",
		"id": 124564894,
		"lng": -77.3859238,
		"lat": 37.53744958,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 29,
		"by": 1901,
		"bd": "",
		"bm": "",
		"nm": "Archer",
		"nf": "Frank",
		"nl": "Harper",
		"url": "https://findagrave.com/memorial/138181480",
		"id": 138181480,
		"lng": -77.38638229,
		"lat": 37.53706617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 9,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "James",
		"nl": "Harper",
		"url": "https://findagrave.com/memorial/151108176",
		"id": 151108176,
		"lng": -77.38656515,
		"lat": 37.53545667,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 12,
		"dd": 21,
		"by": 1825,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Adaline",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/132641390",
		"id": 132641390,
		"lng": -77.38775524,
		"lat": 37.53651694,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Armistead",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/156119513",
		"id": 156119513,
		"lng": -77.38612163,
		"lat": 37.53695309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185392427",
		"id": 185392427,
		"lng": -77.3877793,
		"lat": 37.53655488,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 12,
		"dd": 1,
		"by": 1887,
		"bd": 3,
		"bm": 10,
		"nm": "L.",
		"nf": "Carrington",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/175585497",
		"id": 175585497,
		"lng": -77.3874193,
		"lat": 37.53627501,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 5,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Catherine",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/151108184",
		"id": 151108184,
		"lng": -77.38650926,
		"lat": 37.53543585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 20,
		"by": 1893,
		"bd": 1,
		"bm": 4,
		"nm": "",
		"nf": "Clinton",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/164024392",
		"id": 164024392,
		"lng": -77.38641507,
		"lat": 37.53710963,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 10,
		"dd": 26,
		"by": 1872,
		"bd": 15,
		"bm": 11,
		"nm": "",
		"nf": "David",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/113633256",
		"id": 113633256,
		"lng": -77.38588236,
		"lat": 37.53697788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/122027543",
		"id": 122027543,
		"lng": -77.38592501,
		"lat": 37.5364987,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 12,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emma",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/183587447",
		"id": 183587447,
		"lng": -77.38691609,
		"lat": 37.53694125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T",
		"nf": "Emma",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/170839568",
		"id": 170839568,
		"lng": -77.38650209,
		"lat": 37.53705668,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": "",
		"dd": "",
		"by": 1908,
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "George",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/129209851",
		"id": 129209851,
		"lng": -77.38602905,
		"lat": 37.53674407,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 13,
		"by": 1912,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Gertrude",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/172031021",
		"id": 172031021,
		"lng": -77.38663378,
		"lat": 37.53720043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 3,
		"by": 1901,
		"bd": 5,
		"bm": 3,
		"nm": "G.",
		"nf": "Gladys",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/136107558",
		"id": 136107558,
		"lng": -77.38564036,
		"lat": 37.53732534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 12,
		"dd": 13,
		"by": 1899,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gladyst",
		"nl": "Foster",
		"url": "https://findagrave.com/memorial/185392436",
		"id": 185392436,
		"lng": -77.38779385,
		"lat": 37.53646304,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 1,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/157969004",
		"id": 157969004,
		"lng": -77.38633886,
		"lat": 37.53571717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 1,
		"dd": 10,
		"by": 1919,
		"bd": 20,
		"bm": 10,
		"nm": "",
		"nf": "Herman",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/172296830",
		"id": 172296830,
		"lng": -77.38641702,
		"lat": 37.5353279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 6,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isabella",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/169483648",
		"id": 169483648,
		"lng": -77.38787616,
		"lat": 37.5370274,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 1,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isaiah",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/119240880",
		"id": 119240880,
		"lng": -77.38583466,
		"lat": 37.53687874,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 8,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/24865524",
		"id": 24865524,
		"lng": -77.38588098,
		"lat": 37.53648163,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 24,
		"by": 1941,
		"bd": 25,
		"bm": 2,
		"nm": "Ann",
		"nf": "Jean",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/168728638",
		"id": 168728638,
		"lng": -77.38635037,
		"lat": 37.53715606,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 1,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Julia",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/154264051",
		"id": 154264051,
		"lng": -77.38645854,
		"lat": 37.53557717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 8,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Leonard",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/129209861",
		"id": 129209861,
		"lng": -77.38588512,
		"lat": 37.53697071,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Lillie",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/169397253",
		"id": 169397253,
		"lng": -77.38632712,
		"lat": 37.53684152,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 2,
		"by": 1895,
		"bd": 16,
		"bm": 10,
		"nm": "",
		"nf": "Lottie",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/136304874",
		"id": 136304874,
		"lng": -77.38587394,
		"lat": 37.53707328,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucious",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/184048824",
		"id": 184048824,
		"lng": -77.38640521,
		"lat": 37.53668624,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 10,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Lucy",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/169397261",
		"id": 169397261,
		"lng": -77.38630223,
		"lat": 37.53683029,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 7,
		"dd": 8,
		"by": 1897,
		"bd": 26,
		"bm": 5,
		"nm": "",
		"nf": "Lula",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185377429",
		"id": 185377429,
		"lng": -77.3867381,
		"lat": 37.53759293,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 5,
		"dd": 4,
		"by": 1908,
		"bd": 28,
		"bm": 9,
		"nm": "",
		"nf": "Maria",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/157757353",
		"id": 157757353,
		"lng": -77.38571971,
		"lat": 37.53734716,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 1,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ellen",
		"nf": "Martha",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/151041067",
		"id": 151041067,
		"lng": -77.38625143,
		"lat": 37.53589327,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 8,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/181956325",
		"id": 181956325,
		"lng": -77.38777671,
		"lat": 37.53642309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 2,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Mary",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/184512317",
		"id": 184512317,
		"lng": -77.38766158,
		"lat": 37.53675879,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 13,
		"by": 1895,
		"bd": 18,
		"bm": 12,
		"nm": "",
		"nf": "Mary",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/184483920",
		"id": 184483920,
		"lng": -77.38733521,
		"lat": 37.53766813,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 10,
		"by": 1899,
		"bd": 23,
		"bm": 10,
		"nm": "Wellington",
		"nf": "Moses",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/136107567",
		"id": 136107567,
		"lng": -77.38565867,
		"lat": 37.53734194,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rebecca",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/128672339",
		"id": 128672339,
		"lng": -77.38612527,
		"lat": 37.53662598,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Richard",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/187354308",
		"id": 187354308,
		"lng": -77.38701281,
		"lat": 37.53660756,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 3,
		"dd": 13,
		"by": 1855,
		"bd": 10,
		"bm": 1,
		"nm": "",
		"nf": "Robert",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185392442",
		"id": 185392442,
		"lng": -77.38773458,
		"lat": 37.53651479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 12,
		"dd": 12,
		"by": 1874,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/171761593",
		"id": 171761593,
		"lng": -77.38720472,
		"lat": 37.53672445,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 6,
		"by": 1932,
		"bd": 4,
		"bm": 1,
		"nm": "",
		"nf": "Robert",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/173077979",
		"id": 173077979,
		"lng": -77.38705941,
		"lat": 37.53733123,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 6,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Robert",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/136304879",
		"id": 136304879,
		"lng": -77.38589839,
		"lat": 37.53704431,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 4,
		"dd": 7,
		"by": 1870,
		"bd": "",
		"bm": 10,
		"nm": "L.",
		"nf": "Rosa",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/125408451",
		"id": 125408451,
		"lng": -77.38778421,
		"lat": 37.53633956,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/169483298",
		"id": 169483298,
		"lng": -77.38766077,
		"lat": 37.53707397,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 1,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Alice",
		"nf": "Sarah",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/172081905",
		"id": 172081905,
		"lng": -77.38739178,
		"lat": 37.53667821,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 23,
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/164022533",
		"id": 164022533,
		"lng": -77.38654102,
		"lat": 37.53702476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": "",
		"dd": "",
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Susie",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/175421165",
		"id": 175421165,
		"lng": -77.38751899,
		"lat": 37.53711967,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 12,
		"dd": 23,
		"by": 1968,
		"bd": 10,
		"bm": 11,
		"nm": "L.",
		"nf": "Tammy",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/159663319",
		"id": 159663319,
		"lng": -77.38590352,
		"lat": 37.53741689,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 11,
		"dd": 3,
		"by": 1923,
		"bd": 7,
		"bm": 1,
		"nm": "J.",
		"nf": "Thelma",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185958406",
		"id": 185958406,
		"lng": -77.38638349,
		"lat": 37.53593313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 7,
		"dd": 30,
		"by": 1921,
		"bd": 5,
		"bm": 11,
		"nm": "",
		"nf": "Thomas",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/156453282",
		"id": 156453282,
		"lng": -77.3863813,
		"lat": 37.53577352,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 7,
		"dd": 17,
		"by": 1932,
		"bd": 5,
		"bm": 8,
		"nm": "",
		"nf": "Thomas",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/177286672",
		"id": 177286672,
		"lng": -77.38728972,
		"lat": 37.53725168,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 12,
		"dd": 26,
		"by": 1925,
		"bd": 25,
		"bm": 12,
		"nm": "Robert",
		"nf": "Thomas",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/123587189",
		"id": 123587189,
		"lng": -77.38601486,
		"lat": 37.53637475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 11,
		"dd": 11,
		"by": 1930,
		"bd": 4,
		"bm": 3,
		"nm": "A.",
		"nf": "Vernon",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/153511905",
		"id": 153511905,
		"lng": -77.38677611,
		"lat": 37.53734851,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Walter",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/138565033",
		"id": 138565033,
		"lng": -77.38627802,
		"lat": 37.5366092,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 8,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Washington",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/126652589",
		"id": 126652589,
		"lng": -77.38591169,
		"lat": 37.53648462,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 11,
		"dd": 24,
		"by": 1878,
		"bd": "",
		"bm": 7,
		"nm": "B.",
		"nf": "Wellington",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/150786876",
		"id": 150786876,
		"lng": -77.38652317,
		"lat": 37.53545106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 7,
		"dd": 30,
		"by": 1901,
		"bd": 9,
		"bm": 10,
		"nm": "",
		"nf": "Wilbur",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185648652",
		"id": 185648652,
		"lng": -77.38752984,
		"lat": 37.53695236,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 3,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "William",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/132641394",
		"id": 132641394,
		"lng": -77.3877434,
		"lat": 37.5365499,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185392455",
		"id": 185392455,
		"lng": -77.38778322,
		"lat": 37.5365485,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 9,
		"dd": 14,
		"by": 1905,
		"bd": 4,
		"bm": 8,
		"nm": "Thomas",
		"nf": "William",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/142448424",
		"id": 142448424,
		"lng": -77.38570174,
		"lat": 37.5373611,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 12,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/144143010",
		"id": 144143010,
		"lng": -77.38652648,
		"lat": 37.53760345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 8,
		"by": 1885,
		"bd": 4,
		"bm": 7,
		"nm": "Lee",
		"nf": "Willie",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/173844095",
		"id": 173844095,
		"lng": -77.387574,
		"lat": 37.5370745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 9,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alexander",
		"nl": "Harrison",
		"url": "https://findagrave.com/memorial/148867291",
		"id": 148867291,
		"lng": -77.38798702,
		"lat": 37.53706332,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": "",
		"dd": "",
		"by": 1900,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emmanuel",
		"nl": "Harrison",
		"url": "https://findagrave.com/memorial/173793283",
		"id": 173793283,
		"lng": -77.38712785,
		"lat": 37.53714945,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 11,
		"dd": 7,
		"by": 1915,
		"bd": 20,
		"bm": 6,
		"nm": "V.",
		"nf": "Rosetta",
		"nl": "Harrison",
		"url": "https://findagrave.com/memorial/159411378",
		"id": 159411378,
		"lng": -77.38636007,
		"lat": 37.53753367,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 10,
		"dd": 6,
		"by": 1899,
		"bd": 8,
		"bm": 5,
		"nm": "",
		"nf": "Annie",
		"nl": "Hartwell",
		"url": "https://findagrave.com/memorial/163950347",
		"id": 163950347,
		"lng": -77.38672009,
		"lat": 37.53688354,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 2,
		"dd": 27,
		"by": 1893,
		"bd": 13,
		"bm": 4,
		"nm": "",
		"nf": "Benjamin",
		"nl": "Hartwell",
		"url": "https://findagrave.com/memorial/161002450",
		"id": 161002450,
		"lng": -77.38712374,
		"lat": 37.53703231,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 6,
		"dd": 8,
		"by": 1862,
		"bd": "",
		"bm": 10,
		"nm": "",
		"nf": "Clem",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/143825857",
		"id": 143825857,
		"lng": -77.38674956,
		"lat": 37.5366807,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 5,
		"dd": 14,
		"by": 1953,
		"bd": 8,
		"bm": 12,
		"nm": "Edward",
		"nf": "Eugene",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/125518406",
		"id": 125518406,
		"lng": -77.38622053,
		"lat": 37.53683954,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 8,
		"dd": 9,
		"by": 1914,
		"bd": 16,
		"bm": 8,
		"nm": "Lee",
		"nf": "Harriet",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/161180422",
		"id": 161180422,
		"lng": -77.38721268,
		"lat": 37.537165,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 26,
		"by": 1888,
		"bd": 8,
		"bm": 6,
		"nm": "",
		"nf": "Henrietta",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/168145998",
		"id": 168145998,
		"lng": -77.38628256,
		"lat": 37.53717486,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 30,
		"by": 1904,
		"bd": 1,
		"bm": 2,
		"nm": "B.",
		"nf": "Julia",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/149354950",
		"id": 149354950,
		"lng": -77.38618292,
		"lat": 37.53599257,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 5,
		"dd": 29,
		"by": 1911,
		"bd": 17,
		"bm": 11,
		"nm": "Elsie",
		"nf": "Mary",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/147853159",
		"id": 147853159,
		"lng": -77.38630595,
		"lat": 37.53718002,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 18,
		"by": 1889,
		"bd": 18,
		"bm": 2,
		"nm": "",
		"nf": "Mazy",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/148285670",
		"id": 148285670,
		"lng": -77.38639029,
		"lat": 37.53725277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 10,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Patience",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/146013333",
		"id": 146013333,
		"lng": -77.38575189,
		"lat": 37.53669059,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 28,
		"by": 1915,
		"bd": 12,
		"bm": 8,
		"nm": "Clara",
		"nf": "Lois",
		"nl": "Haskins",
		"url": "https://findagrave.com/memorial/156929749",
		"id": 156929749,
		"lng": -77.38643832,
		"lat": 37.53713288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 3,
		"dd": 3,
		"by": 1893,
		"bd": 27,
		"bm": 9,
		"nm": "Lewis",
		"nf": "William",
		"nl": "Haskins",
		"url": "https://findagrave.com/memorial/156612117",
		"id": 156612117,
		"lng": -77.38643435,
		"lat": 37.53714313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nannie",
		"nl": "Haskins",
		"url": "https://findagrave.com/memorial/192423394",
		"id": 192423394,
		"lng": -77.38744333,
		"lat": 37.53716019,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 6,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Luther",
		"nl": "Hasty",
		"url": "https://findagrave.com/memorial/150981962",
		"id": 150981962,
		"lng": -77.38676685,
		"lat": 37.53552659,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 22,
		"by": 1883,
		"bd": 4,
		"bm": 7,
		"nm": "Lenton",
		"nf": "Marcellus",
		"nl": "Hatcher",
		"url": "https://findagrave.com/memorial/177750771",
		"id": 177750771,
		"lng": -77.38774509,
		"lat": 37.53744773,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 12,
		"dd": 29,
		"by": 1907,
		"bd": 13,
		"bm": 4,
		"nm": "Lee",
		"nf": "Rosa",
		"nl": "Hatcher",
		"url": "https://findagrave.com/memorial/125634266",
		"id": 125634266,
		"lng": -77.38681448,
		"lat": 37.53651884,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nebraska",
		"nl": "Hawkins",
		"url": "https://findagrave.com/memorial/175610407",
		"id": 175610407,
		"lng": -77.38771914,
		"lat": 37.53705192,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 11,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rebecca",
		"nl": "Hawthorne",
		"url": "https://findagrave.com/memorial/148285686",
		"id": 148285686,
		"lng": -77.38644453,
		"lat": 37.53723847,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 1,
		"dd": 7,
		"by": 1854,
		"bd": "",
		"bm": 5,
		"nm": "",
		"nf": "Arthur",
		"nl": "Hayes",
		"url": "https://findagrave.com/memorial/150035721",
		"id": 150035721,
		"lng": -77.38624285,
		"lat": 37.5355506,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 4,
		"by": 1882,
		"bd": 23,
		"bm": 5,
		"nm": "",
		"nf": "Edward",
		"nl": "Hayes",
		"url": "https://findagrave.com/memorial/135631960",
		"id": 135631960,
		"lng": -77.38568813,
		"lat": 37.53686863,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 3,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henrietta",
		"nl": "Hayes",
		"url": "https://findagrave.com/memorial/188466151",
		"id": 188466151,
		"lng": -77.38774748,
		"lat": 37.53685774,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 11,
		"dd": 11,
		"by": 1892,
		"bd": 20,
		"bm": 1,
		"nm": "",
		"nf": "Laura",
		"nl": "Hayes",
		"url": "https://findagrave.com/memorial/135631969",
		"id": 135631969,
		"lng": -77.38568601,
		"lat": 37.53687674,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 11,
		"by": 1884,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alfred",
		"nl": "Haywood",
		"url": "https://findagrave.com/memorial/159760652",
		"id": 159760652,
		"lng": -77.38641064,
		"lat": 37.53751482,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 11,
		"dd": 20,
		"by": 1911,
		"bd": 3,
		"bm": 1,
		"nm": "",
		"nf": "Ollie",
		"nl": "Hazell",
		"url": "https://findagrave.com/memorial/133448296",
		"id": 133448296,
		"lng": -77.38625594,
		"lat": 37.53695657,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Albert",
		"nf": "Prince",
		"nl": "Heath",
		"url": "https://findagrave.com/memorial/175822882",
		"id": 175822882,
		"lng": -77.38640712,
		"lat": 37.53673483,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 8,
		"dd": 23,
		"by": 1905,
		"bd": 11,
		"bm": 12,
		"nm": "E.",
		"nf": "Bernice",
		"nl": "Hedgeman",
		"url": "https://findagrave.com/memorial/148460413",
		"id": 148460413,
		"lng": -77.38627929,
		"lat": 37.53544882,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 7,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Blanch",
		"nf": "Lavinia",
		"nl": "Hedgeman",
		"url": "https://findagrave.com/memorial/182568993",
		"id": 182568993,
		"lng": -77.38627051,
		"lat": 37.53545649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 5,
		"dd": 8,
		"by": 1882,
		"bd": 14,
		"bm": 5,
		"nm": "Tony",
		"nf": "Alice",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/190229668",
		"id": 190229668,
		"lng": -77.38763725,
		"lat": 37.53723038,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 30,
		"by": 1967,
		"bd": 24,
		"bm": 8,
		"nm": "",
		"nf": "Brenda",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/142797041",
		"id": 142797041,
		"lng": -77.38604917,
		"lat": 37.53747636,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 7,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cora",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/180521726",
		"id": 180521726,
		"lng": -77.38800119,
		"lat": 37.53762931,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 12,
		"dd": 19,
		"by": 1866,
		"bd": 25,
		"bm": 11,
		"nm": "H.",
		"nf": "John",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/188064738",
		"id": 188064738,
		"lng": -77.38664469,
		"lat": 37.53558155,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "John",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/137430045",
		"id": 137430045,
		"lng": -77.38593901,
		"lat": 37.53712367,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 12,
		"by": 1893,
		"bd": 14,
		"bm": 2,
		"nm": "B.",
		"nf": "Joseph",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/140290798",
		"id": 140290798,
		"lng": -77.38594257,
		"lat": 37.5366611,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 8,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Joseph",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/166235133",
		"id": 166235133,
		"lng": -77.38590802,
		"lat": 37.53665162,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Lizzie",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/137430052",
		"id": 137430052,
		"lng": -77.3859452,
		"lat": 37.53711279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louvinia",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/154201278",
		"id": 154201278,
		"lng": -77.3862421,
		"lat": 37.53537812,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 5,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Samuel",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/139146891",
		"id": 139146891,
		"lng": -77.38614576,
		"lat": 37.53658091,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 25,
		"by": 1895,
		"bd": "",
		"bm": 4,
		"nm": "B.",
		"nf": "Walter",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/158679743",
		"id": 158679743,
		"lng": -77.38680328,
		"lat": 37.53742031,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 1,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Henley",
		"url": "https://findagrave.com/memorial/171956202",
		"id": 171956202,
		"lng": -77.38726844,
		"lat": 37.53672451,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 4,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charlotte",
		"nl": "Henry",
		"url": "https://findagrave.com/memorial/132641398",
		"id": 132641398,
		"lng": -77.38782431,
		"lat": 37.53640815,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 11,
		"dd": 28,
		"by": 1968,
		"bd": 9,
		"bm": 11,
		"nm": "Linwood",
		"nf": "Frederick",
		"nl": "Henry",
		"url": "https://findagrave.com/memorial/159663324",
		"id": 159663324,
		"lng": -77.38590643,
		"lat": 37.53741151,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 1,
		"dd": 28,
		"by": 1868,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "James",
		"nl": "Henry",
		"url": "https://findagrave.com/memorial/173461773",
		"id": 173461773,
		"lng": -77.38727156,
		"lat": 37.53712213,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maria",
		"nl": "Henry",
		"url": "https://findagrave.com/memorial/143201785",
		"id": 143201785,
		"lng": -77.38599251,
		"lat": 37.5373227,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 3,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "William",
		"nl": "Henry",
		"url": "https://findagrave.com/memorial/158922804",
		"id": 158922804,
		"lng": -77.3874965,
		"lat": 37.53759741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Henson",
		"url": "https://findagrave.com/memorial/141193915",
		"id": 141193915,
		"lng": -77.38627933,
		"lat": 37.53664764,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 10,
		"dd": 27,
		"by": 1944,
		"bd": 14,
		"bm": 1,
		"nm": "J.",
		"nf": "Bertha",
		"nl": "Herring",
		"url": "https://findagrave.com/memorial/136171644",
		"id": 136171644,
		"lng": -77.38575815,
		"lat": 37.53730781,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 9,
		"dd": 19,
		"by": 1889,
		"bd": 6,
		"bm": 8,
		"nm": "I",
		"nf": "Alice",
		"nl": "Hewin",
		"url": "https://findagrave.com/memorial/149168053",
		"id": 149168053,
		"lng": -77.38643254,
		"lat": 37.53540601,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 5,
		"dd": 2,
		"by": 1867,
		"bd": "",
		"bm": 7,
		"nm": "R.",
		"nf": "Alice",
		"nl": "Hewin",
		"url": "https://findagrave.com/memorial/143058146",
		"id": 143058146,
		"lng": -77.38644615,
		"lat": 37.53539339,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 1,
		"dd": 14,
		"by": 1887,
		"bd": 31,
		"bm": 8,
		"nm": "T.",
		"nf": "Beverly",
		"nl": "Hewin",
		"url": "https://findagrave.com/memorial/149168058",
		"id": 149168058,
		"lng": -77.38641785,
		"lat": 37.53539213,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 2,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Beverly",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/144143013",
		"id": 144143013,
		"lng": -77.38591285,
		"lat": 37.53741989,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 4,
		"dd": 27,
		"by": 1923,
		"bd": 28,
		"bm": 7,
		"nm": "L.",
		"nf": "Dorothy",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/135631975",
		"id": 135631975,
		"lng": -77.38610239,
		"lat": 37.5370548,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 3,
		"dd": 14,
		"by": 1870,
		"bd": 24,
		"bm": 11,
		"nm": "",
		"nf": "Kate",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/134474418",
		"id": 134474418,
		"lng": -77.3874955,
		"lat": 37.53655766,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 7,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Lucy",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/158450780",
		"id": 158450780,
		"lng": -77.38777221,
		"lat": 37.53724188,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 12,
		"dd": 11,
		"by": 1888,
		"bd": 11,
		"bm": 9,
		"nm": "E.",
		"nf": "Martha",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/166222833",
		"id": 166222833,
		"lng": -77.38709476,
		"lat": 37.53661986,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 6,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Richard",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/185392463",
		"id": 185392463,
		"lng": -77.38750111,
		"lat": 37.53658214,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/158450775",
		"id": 158450775,
		"lng": -77.38776533,
		"lat": 37.53723009,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 4,
		"dd": 13,
		"by": 1898,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bill",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/169823402",
		"id": 169823402,
		"lng": -77.38678407,
		"lat": 37.53711507,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 2,
		"by": 1894,
		"bd": 4,
		"bm": 2,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/127460986",
		"id": 127460986,
		"lng": -77.3859807,
		"lat": 37.53735009,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 6,
		"dd": 5,
		"by": 1891,
		"bd": 25,
		"bm": 5,
		"nm": "",
		"nf": "Ella",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/155322619",
		"id": 155322619,
		"lng": -77.38712156,
		"lat": 37.5371787,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 4,
		"dd": 7,
		"by": 1891,
		"bd": 4,
		"bm": 9,
		"nm": "Lee",
		"nf": "Matthew",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/155318977",
		"id": 155318977,
		"lng": -77.38711631,
		"lat": 37.53718776,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 3,
		"dd": 9,
		"by": 1907,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Pearl",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/147853170",
		"id": 147853170,
		"lng": -77.38601076,
		"lat": 37.53633199,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 15,
		"by": 1893,
		"bd": 14,
		"bm": 5,
		"nm": "J.",
		"nf": "Sarah",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/191380199",
		"id": 191380199,
		"lng": -77.38772911,
		"lat": 37.53794134,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 8,
		"dd": 28,
		"by": 1897,
		"bd": 18,
		"bm": 1,
		"nm": "C.",
		"nf": "Spencer",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/125634282",
		"id": 125634282,
		"lng": -77.38732818,
		"lat": 37.53743799,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 11,
		"dd": 19,
		"by": 1910,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Bertha",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/150493634",
		"id": 150493634,
		"lng": -77.38599442,
		"lat": 37.53632761,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": 20,
		"bm": 10,
		"nm": "Lee",
		"nf": "Fitzhugh",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/166397290",
		"id": 166397290,
		"lng": -77.38746525,
		"lat": 37.53670178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 4,
		"dd": 4,
		"by": 1919,
		"bd": 6,
		"bm": 7,
		"nm": "Cora",
		"nf": "Flocelia",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/158942474",
		"id": 158942474,
		"lng": -77.38746494,
		"lat": 37.53759441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 3,
		"by": 1915,
		"bd": 16,
		"bm": 10,
		"nm": "O. R.",
		"nf": "Gertrude",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/161563073",
		"id": 161563073,
		"lng": -77.38676434,
		"lat": 37.53743176,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 8,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jacob",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/177119120",
		"id": 177119120,
		"lng": -77.38797776,
		"lat": 37.53711543,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 30,
		"by": 1891,
		"bd": 11,
		"bm": 11,
		"nm": "R.",
		"nf": "John",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/146013338",
		"id": 146013338,
		"lng": -77.38656047,
		"lat": 37.53641271,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 5,
		"dd": 27,
		"by": 1916,
		"bd": 22,
		"bm": 5,
		"nm": "Irvin",
		"nf": "Joseph",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/158922809",
		"id": 158922809,
		"lng": -77.38746986,
		"lat": 37.53757805,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 11,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Junius",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/173166606",
		"id": 173166606,
		"lng": -77.38759098,
		"lat": 37.5372678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 5,
		"by": 1908,
		"bd": 3,
		"bm": 5,
		"nm": "",
		"nf": "Leonetta",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/167254347",
		"id": 167254347,
		"lng": -77.3868126,
		"lat": 37.53712917,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/172076699",
		"id": 172076699,
		"lng": -77.38695152,
		"lat": 37.53716568,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 9,
		"by": 1875,
		"bd": 3,
		"bm": 1,
		"nm": "",
		"nf": "Margaret",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/167272740",
		"id": 167272740,
		"lng": -77.38655871,
		"lat": 37.53741484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 5,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Frances",
		"nf": "Mary",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/166398563",
		"id": 166398563,
		"lng": -77.38750886,
		"lat": 37.53668707,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 8,
		"dd": 6,
		"by": 1909,
		"bd": 16,
		"bm": 1,
		"nm": "Sue",
		"nf": "Mary",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/125094175",
		"id": 125094175,
		"lng": -77.38604879,
		"lat": 37.53663245,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 3,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Millie",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/144558531",
		"id": 144558531,
		"lng": -77.38656887,
		"lat": 37.53570212,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 5,
		"by": 1884,
		"bd": 17,
		"bm": 10,
		"nm": "",
		"nf": "Moses",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/175449631",
		"id": 175449631,
		"lng": -77.38747637,
		"lat": 37.53729882,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1903,
		"dm": 8,
		"dd": 2,
		"by": 1840,
		"bd": 3,
		"bm": 9,
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/166396445",
		"id": 166396445,
		"lng": -77.38748104,
		"lat": 37.53671186,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 8,
		"by": 1946,
		"bd": 12,
		"bm": 11,
		"nm": "Leonard",
		"nf": "Reginald",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/158679638",
		"id": 158679638,
		"lng": -77.3868374,
		"lat": 37.53745111,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/173209743",
		"id": 173209743,
		"lng": -77.38744429,
		"lat": 37.536811,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 1,
		"by": 1906,
		"bd": 12,
		"bm": 1,
		"nm": "Edward Roosevelt",
		"nf": "Robert",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/167074274",
		"id": 167074274,
		"lng": -77.38682595,
		"lat": 37.53712081,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sallie",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/176134064",
		"id": 176134064,
		"lng": -77.38767146,
		"lat": 37.53716223,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 6,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Anderson",
		"nf": "William",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/161636481",
		"id": 161636481,
		"lng": -77.3868656,
		"lat": 37.5375069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 11,
		"by": 1871,
		"bd": 15,
		"bm": 11,
		"nm": "",
		"nf": "Willianna",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/169822163",
		"id": 169822163,
		"lng": -77.38677835,
		"lat": 37.53710612,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 15,
		"by": 1880,
		"bd": 27,
		"bm": 5,
		"nm": "",
		"nf": "Lucy",
		"nl": "Hilliard",
		"url": "https://findagrave.com/memorial/191436619",
		"id": 191436619,
		"lng": -77.38659754,
		"lat": 37.53717622,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 7,
		"dd": 10,
		"by": 1928,
		"bd": 13,
		"bm": 9,
		"nm": "Lee",
		"nf": "Sarah",
		"nl": "Hilliard",
		"url": "https://findagrave.com/memorial/173076610",
		"id": 173076610,
		"lng": -77.38704997,
		"lat": 37.5373478,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jesse",
		"nl": "Hilton",
		"url": "https://findagrave.com/memorial/159880557",
		"id": 159880557,
		"lng": -77.38792285,
		"lat": 37.53696925,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 6,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Minnie",
		"nl": "Hilton",
		"url": "https://findagrave.com/memorial/138565040",
		"id": 138565040,
		"lng": -77.3861755,
		"lat": 37.53662794,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Susie",
		"nl": "Hilton",
		"url": "https://findagrave.com/memorial/177152407",
		"id": 177152407,
		"lng": -77.3879283,
		"lat": 37.53702248,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 3,
		"dd": 6,
		"by": 1884,
		"bd": 28,
		"bm": 12,
		"nm": "",
		"nf": "Effie",
		"nl": "Hinton",
		"url": "https://findagrave.com/memorial/176570454",
		"id": 176570454,
		"lng": -77.38700192,
		"lat": 37.53748535,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 1,
		"dd": 29,
		"by": 1914,
		"bd": 24,
		"bm": 7,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Hinton",
		"url": "https://findagrave.com/memorial/158922811",
		"id": 158922811,
		"lng": -77.38747089,
		"lat": 37.5375732,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 25,
		"by": 1908,
		"bd": 26,
		"bm": 12,
		"nm": "Alexander",
		"nf": "Walter",
		"nl": "Hinton",
		"url": "https://findagrave.com/memorial/192390609",
		"id": 192390609,
		"lng": -77.38766199,
		"lat": 37.53745513,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 5,
		"by": 1910,
		"bd": 19,
		"bm": 8,
		"nm": "",
		"nf": "Manson",
		"nl": "Hobbs",
		"url": "https://findagrave.com/memorial/144820792",
		"id": 144820792,
		"lng": -77.38556112,
		"lat": 37.53728475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 3,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Barlow",
		"nl": "Hobson",
		"url": "https://findagrave.com/memorial/182349905",
		"id": 182349905,
		"lng": -77.38639418,
		"lat": 37.53562286,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 6,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "John",
		"nl": "Hobson",
		"url": "https://findagrave.com/memorial/150037864",
		"id": 150037864,
		"lng": -77.38739578,
		"lat": 37.53667106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 3,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Mary",
		"nl": "Hodge",
		"url": "https://findagrave.com/memorial/182546686",
		"id": 182546686,
		"lng": -77.38754205,
		"lat": 37.53668961,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 13,
		"by": 1910,
		"bd": 13,
		"bm": 1,
		"nm": "David",
		"nf": "Abraham",
		"nl": "Hodges",
		"url": "https://findagrave.com/memorial/159411394",
		"id": 159411394,
		"lng": -77.38632807,
		"lat": 37.53674133,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 9,
		"dd": 3,
		"by": 1900,
		"bd": 17,
		"bm": 7,
		"nm": "",
		"nf": "John",
		"nl": "Hodges",
		"url": "https://findagrave.com/memorial/169397273",
		"id": 169397273,
		"lng": -77.38652051,
		"lat": 37.53681318,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 19,
		"by": 1909,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Martha",
		"nl": "Hodges",
		"url": "https://findagrave.com/memorial/161171380",
		"id": 161171380,
		"lng": -77.38653443,
		"lat": 37.53703351,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emma",
		"nl": "Holland",
		"url": "https://findagrave.com/memorial/176059055",
		"id": 176059055,
		"lng": -77.38746454,
		"lat": 37.53699037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 28,
		"by": 1967,
		"bd": 16,
		"bm": 10,
		"nm": "",
		"nf": "Yolana",
		"nl": "Holland",
		"url": "https://findagrave.com/memorial/152794725",
		"id": 152794725,
		"lng": -77.38595043,
		"lat": 37.53746544,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 3,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby boy",
		"nl": "Holliday",
		"url": "https://findagrave.com/memorial/142448446",
		"id": 142448446,
		"lng": -77.38729632,
		"lat": 37.5379062,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 7,
		"dd": 1,
		"by": 1907,
		"bd": 23,
		"bm": 6,
		"nm": "C.",
		"nf": "Myrteen",
		"nl": "Holliday",
		"url": "https://findagrave.com/memorial/137430067",
		"id": 137430067,
		"lng": -77.3859538,
		"lat": 37.53711962,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Charles",
		"nl": "Holloway",
		"url": "https://findagrave.com/memorial/125312945",
		"id": 125312945,
		"lng": -77.38592822,
		"lat": 37.53689718,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 1,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Georgiana",
		"nl": "Holloway",
		"url": "https://findagrave.com/memorial/125312961",
		"id": 125312961,
		"lng": -77.38592628,
		"lat": 37.5369043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 2,
		"dd": 11,
		"by": 1903,
		"bd": 7,
		"bm": 1,
		"nm": "M.",
		"nf": "Strawdia",
		"nl": "Holman",
		"url": "https://findagrave.com/memorial/161171406",
		"id": 161171406,
		"lng": -77.38726638,
		"lat": 37.53710037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1895,
		"dm": 7,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "E.",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/128012860",
		"id": 128012860,
		"lng": -77.38621138,
		"lat": 37.53635668,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": "",
		"dd": "",
		"by": 1877,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emmett",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/143632575",
		"id": 143632575,
		"lng": -77.38601901,
		"lat": 37.53599552,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 3,
		"dd": 21,
		"by": 1913,
		"bd": 11,
		"bm": 1,
		"nm": "Emily",
		"nf": "Helen",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/174622142",
		"id": 174622142,
		"lng": -77.38689024,
		"lat": 37.53645466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 8,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Henry",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/178249242",
		"id": 178249242,
		"lng": -77.38682678,
		"lat": 37.53541817,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 11,
		"dd": 18,
		"by": 1910,
		"bd": 28,
		"bm": 10,
		"nm": "Edward",
		"nf": "James",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/130968028",
		"id": 130968028,
		"lng": -77.38567934,
		"lat": 37.53718703,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 12,
		"dd": 13,
		"by": 1881,
		"bd": 14,
		"bm": 4,
		"nm": "",
		"nf": "John",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/166568172",
		"id": 166568172,
		"lng": -77.38803454,
		"lat": 37.53766479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 9,
		"dd": 15,
		"by": 1889,
		"bd": 14,
		"bm": 10,
		"nm": "C.",
		"nf": "Junius",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/144370332",
		"id": 144370332,
		"lng": -77.38749788,
		"lat": 37.53778075,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 11,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Mamie",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/155782740",
		"id": 155782740,
		"lng": -77.38723485,
		"lat": 37.53560015,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 9,
		"dd": 12,
		"by": 1904,
		"bd": 20,
		"bm": 7,
		"nm": "Louisa",
		"nf": "Marie",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/127719224",
		"id": 127719224,
		"lng": -77.38783647,
		"lat": 37.53639148,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 10,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Myrtle",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/128012889",
		"id": 128012889,
		"lng": -77.38621187,
		"lat": 37.53635672,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 7,
		"dd": 9,
		"by": 1884,
		"bd": 12,
		"bm": 2,
		"nm": "Henry",
		"nf": "Owen",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/147323477",
		"id": 147323477,
		"lng": -77.38757033,
		"lat": 37.53745137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 7,
		"dd": 10,
		"by": 1862,
		"bd": "",
		"bm": 5,
		"nm": "Henry",
		"nf": "Patrick",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/127994553",
		"id": 127994553,
		"lng": -77.38621211,
		"lat": 37.53635674,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 9,
		"by": 1872,
		"bd": 24,
		"bm": 8,
		"nm": "",
		"nf": "Rosa",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/130692450",
		"id": 130692450,
		"lng": -77.3856758,
		"lat": 37.53719387,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 6,
		"dd": 16,
		"by": 1869,
		"bd": 7,
		"bm": 3,
		"nm": "Cooper",
		"nf": "Sallie",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/128012920",
		"id": 128012920,
		"lng": -77.38621351,
		"lat": 37.53635678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 9,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/128012874",
		"id": 128012874,
		"lng": -77.38621162,
		"lat": 37.5363567,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": "",
		"dd": "",
		"by": 1852,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Susan",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/143632569",
		"id": 143632569,
		"lng": -77.38601702,
		"lat": 37.53599505,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 6,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/161052876",
		"id": 161052876,
		"lng": -77.38706227,
		"lat": 37.53702389,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 5,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/130692467",
		"id": 130692467,
		"lng": -77.38568203,
		"lat": 37.53717822,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Willie",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/155123310",
		"id": 155123310,
		"lng": -77.38656332,
		"lat": 37.5371962,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 4,
		"dd": 8,
		"by": 1913,
		"bd": 17,
		"bm": 9,
		"nm": "",
		"nf": "Wydell",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/151312617",
		"id": 151312617,
		"lng": -77.38697211,
		"lat": 37.53738332,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 7,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Essex",
		"nl": "Holtz",
		"url": "https://findagrave.com/memorial/136304889",
		"id": 136304889,
		"lng": -77.38635807,
		"lat": 37.53634641,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Lucy",
		"nl": "Holtz",
		"url": "https://findagrave.com/memorial/136304911",
		"id": 136304911,
		"lng": -77.3863596,
		"lat": 37.53634574,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 8,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Holtz",
		"url": "https://findagrave.com/memorial/136304899",
		"id": 136304899,
		"lng": -77.38635792,
		"lat": 37.5363475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 11,
		"dd": 8,
		"by": 1863,
		"bd": 8,
		"bm": 4,
		"nm": "",
		"nf": "Sylvia",
		"nl": "Hood",
		"url": "https://findagrave.com/memorial/153100504",
		"id": 153100504,
		"lng": -77.38672849,
		"lat": 37.53546415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 1,
		"dd": 13,
		"by": 1869,
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Albert",
		"nl": "Hooper",
		"url": "https://findagrave.com/memorial/155515682",
		"id": 155515682,
		"lng": -77.3862961,
		"lat": 37.53600439,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 9,
		"dd": 13,
		"by": 1872,
		"bd": 12,
		"bm": 11,
		"nm": "H.",
		"nf": "Charles",
		"nl": "Hooper",
		"url": "https://findagrave.com/memorial/179090999",
		"id": 179090999,
		"lng": -77.38596964,
		"lat": 37.53644028,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Hooper",
		"url": "https://findagrave.com/memorial/155515691",
		"id": 155515691,
		"lng": -77.38626369,
		"lat": 37.53600364,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Hopkins",
		"url": "https://findagrave.com/memorial/187354314",
		"id": 187354314,
		"lng": -77.38741625,
		"lat": 37.53736473,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 5,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Henry",
		"nl": "Hopkins",
		"url": "https://findagrave.com/memorial/146682158",
		"id": 146682158,
		"lng": -77.38616906,
		"lat": 37.535762,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 18,
		"by": 1899,
		"bd": "",
		"bm": 9,
		"nm": "",
		"nf": "Landon",
		"nl": "Hopkins",
		"url": "https://findagrave.com/memorial/177545577",
		"id": 177545577,
		"lng": -77.38705582,
		"lat": 37.53776419,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 12,
		"by": 1964,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matthew",
		"nl": "Hopkins",
		"url": "https://findagrave.com/memorial/191417550",
		"id": 191417550,
		"lng": -77.38620583,
		"lat": 37.53749144,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 22,
		"by": 1898,
		"bd": 15,
		"bm": 2,
		"nm": "",
		"nf": "Nolia",
		"nl": "Hopkins",
		"url": "#REF!",
		"id": 162203614,
		"lng": -77.38784183,
		"lat": 37.53699016,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 1,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Hopkins",
		"url": "https://findagrave.com/memorial/125518422",
		"id": 125518422,
		"lng": -77.38646684,
		"lat": 37.53638947,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 4,
		"dd": 11,
		"by": 1899,
		"bd": 20,
		"bm": 3,
		"nm": "Louise",
		"nf": "Marian",
		"nl": "Hopper",
		"url": "https://findagrave.com/memorial/145838355",
		"id": 145838355,
		"lng": -77.38663404,
		"lat": 37.53578513,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Hopper",
		"url": "https://findagrave.com/memorial/146339080",
		"id": 146339080,
		"lng": -77.38663255,
		"lat": 37.53579442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 6,
		"dd": 15,
		"by": 1920,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Ralph",
		"nl": "House",
		"url": "https://findagrave.com/memorial/127995644",
		"id": 127995644,
		"lng": -77.38621278,
		"lat": 37.53635676,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 5,
		"dd": 7,
		"by": 1894,
		"bd": "",
		"bm": 6,
		"nm": "B.",
		"nf": "Verna",
		"nl": "House",
		"url": "https://findagrave.com/memorial/127995635",
		"id": 127995635,
		"lng": -77.38621325,
		"lat": 37.53635677,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ellen",
		"nl": "Houston",
		"url": "https://findagrave.com/memorial/176765627",
		"id": 176765627,
		"lng": -77.3877127,
		"lat": 37.53716578,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 8,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "George",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/182626171",
		"id": 182626171,
		"lng": -77.38637506,
		"lat": 37.53574438,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 9,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/148518230",
		"id": 148518230,
		"lng": -77.38688342,
		"lat": 37.53542788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 5,
		"dd": 11,
		"by": 1882,
		"bd": 24,
		"bm": 10,
		"nm": "",
		"nf": "Georgia",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/187354318",
		"id": 187354318,
		"lng": -77.38687068,
		"lat": 37.53747975,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 1,
		"dd": 24,
		"by": 1883,
		"bd": 2,
		"bm": 11,
		"nm": "Winston",
		"nf": "Isaiah",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/135631980",
		"id": 135631980,
		"lng": -77.3860861,
		"lat": 37.53704428,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 8,
		"dd": 6,
		"by": 1864,
		"bd": 9,
		"bm": 5,
		"nm": "Elizabeth",
		"nf": "Pollie",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/143201852",
		"id": 143201852,
		"lng": -77.38640533,
		"lat": 37.53574039,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Silas",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/141194062",
		"id": 141194062,
		"lng": -77.38646028,
		"lat": 37.53660554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 17,
		"by": 1897,
		"bd": 6,
		"bm": 3,
		"nm": "",
		"nf": "Florence",
		"nl": "Howerton",
		"url": "https://findagrave.com/memorial/151108196",
		"id": 151108196,
		"lng": -77.38666108,
		"lat": 37.53549949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 7,
		"dd": 20,
		"by": 1904,
		"bd": 2,
		"bm": 6,
		"nm": "Clarence",
		"nf": "Frederick",
		"nl": "Howerton",
		"url": "https://findagrave.com/memorial/152005269",
		"id": 152005269,
		"lng": -77.3858049,
		"lat": 37.53716664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 3,
		"by": 1901,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Howerton",
		"url": "https://findagrave.com/memorial/142797047",
		"id": 142797047,
		"lng": -77.38605546,
		"lat": 37.53735116,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 12,
		"dd": 1,
		"by": 1913,
		"bd": 29,
		"bm": 7,
		"nm": "",
		"nf": "Clarence",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/151265651",
		"id": 151265651,
		"lng": -77.38752924,
		"lat": 37.5378006,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 10,
		"dd": 28,
		"by": 1909,
		"bd": 26,
		"bm": 5,
		"nm": "",
		"nf": "James",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/150677868",
		"id": 150677868,
		"lng": -77.38644742,
		"lat": 37.53533267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 3,
		"dd": 29,
		"by": 1905,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Julia",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/158922813",
		"id": 158922813,
		"lng": -77.38777767,
		"lat": 37.53769322,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lindell",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/145638802",
		"id": 145638802,
		"lng": -77.38595744,
		"lat": 37.53745151,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 4,
		"by": 1886,
		"bd": 9,
		"bm": 1,
		"nm": "",
		"nf": "Minnie",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/167182288",
		"id": 167182288,
		"lng": -77.38673943,
		"lat": 37.53678615,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 10,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Phillip",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/184319387",
		"id": 184319387,
		"lng": -77.38717894,
		"lat": 37.5376287,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 12,
		"dd": 9,
		"by": 1882,
		"bd": "",
		"bm": "",
		"nm": "Christian",
		"nf": "Virginia",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/171145798",
		"id": 171145798,
		"lng": -77.38704899,
		"lat": 37.53758848,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 5,
		"dd": 7,
		"by": 1908,
		"bd": 2,
		"bm": 6,
		"nm": "Henry",
		"nf": "James",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/155769342",
		"id": 155769342,
		"lng": -77.3872562,
		"lat": 37.53551727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 3,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "John",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/166116750",
		"id": 166116750,
		"lng": -77.38703309,
		"lat": 37.53677233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 12,
		"dd": 20,
		"by": 1897,
		"bd": 2,
		"bm": 2,
		"nm": "McKinley",
		"nf": "Mack",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/125518489",
		"id": 125518489,
		"lng": -77.38563305,
		"lat": 37.53728916,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 6,
		"dd": 6,
		"by": 1869,
		"bd": "",
		"bm": 6,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/151108209",
		"id": 151108209,
		"lng": -77.38656674,
		"lat": 37.53543448,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 7,
		"by": 1914,
		"bd": 3,
		"bm": 8,
		"nm": "",
		"nf": "Sandy",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/125820817",
		"id": 125820817,
		"lng": -77.38601719,
		"lat": 37.5374114,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 4,
		"dd": 19,
		"by": 1937,
		"bd": 1,
		"bm": 7,
		"nm": "May",
		"nf": "Trula",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/138366545",
		"id": 138366545,
		"lng": -77.38679026,
		"lat": 37.53702428,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 8,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Walter",
		"nl": "Hudson",
		"url": "https://findagrave.com/memorial/151108216",
		"id": 151108216,
		"lng": -77.38656671,
		"lat": 37.53542479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 11,
		"dd": 30,
		"by": 1875,
		"bd": 11,
		"bm": 5,
		"nm": "Henry",
		"nf": "James",
		"nl": "Huggins",
		"url": "https://findagrave.com/memorial/157164962",
		"id": 157164962,
		"lng": -77.38648783,
		"lat": 37.53583372,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 19,
		"by": 1882,
		"bd": 22,
		"bm": 2,
		"nm": "B.",
		"nf": "Laura",
		"nl": "Huggins",
		"url": "https://findagrave.com/memorial/157964800",
		"id": 157964800,
		"lng": -77.38632842,
		"lat": 37.53581014,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 5,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Hunt",
		"url": "https://findagrave.com/memorial/166355510",
		"id": 166355510,
		"lng": -77.38751555,
		"lat": 37.53688918,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 4,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Hunt",
		"url": "https://findagrave.com/memorial/171763329",
		"id": 171763329,
		"lng": -77.38715831,
		"lat": 37.53675738,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 3,
		"dd": 28,
		"by": 1942,
		"bd": 5,
		"bm": 7,
		"nm": "Robert",
		"nf": "Wirt",
		"nl": "Hunt",
		"url": "https://findagrave.com/memorial/6071627",
		"id": 6071627,
		"lng": -77.38586018,
		"lat": 37.53655076,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 6,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Homer",
		"nl": "Huntley",
		"url": "https://findagrave.com/memorial/140290809",
		"id": 140290809,
		"lng": -77.38604045,
		"lat": 37.5363971,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 1,
		"dd": 28,
		"by": 1887,
		"bd": 18,
		"bm": 1,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Hurdle",
		"url": "https://findagrave.com/memorial/117208920",
		"id": 117208920,
		"lng": -77.38560449,
		"lat": 37.53710201,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 31,
		"by": 1933,
		"bd": 5,
		"bm": 11,
		"nm": "Beatrice",
		"nf": "Vivian",
		"nl": "Hutcheson",
		"url": "https://findagrave.com/memorial/173793332",
		"id": 173793332,
		"lng": -77.38711524,
		"lat": 37.53727236,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 1,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Regina",
		"nl": "Hutchinson",
		"url": "https://findagrave.com/memorial/119240891",
		"id": 119240891,
		"lng": -77.38583599,
		"lat": 37.53687315,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 6,
		"by": 1904,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Lucy",
		"nl": "Ingram",
		"url": "https://findagrave.com/memorial/156119514",
		"id": 156119514,
		"lng": -77.38642189,
		"lat": 37.53722813,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 5,
		"dd": 17,
		"by": 1856,
		"bd": "",
		"bm": 4,
		"nm": "A.",
		"nf": "Ella",
		"nl": "Isham",
		"url": "https://findagrave.com/memorial/150788960",
		"id": 150788960,
		"lng": -77.38632808,
		"lat": 37.53562069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 1,
		"dd": 12,
		"by": 1820,
		"bd": 4,
		"bm": 7,
		"nm": "Ann",
		"nf": "Virginia",
		"nl": "Isham",
		"url": "https://findagrave.com/memorial/150788970",
		"id": 150788970,
		"lng": -77.38632642,
		"lat": 37.53562937,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 8,
		"dd": 5,
		"by": 1845,
		"bd": "",
		"bm": 5,
		"nm": "H.",
		"nf": "William",
		"nl": "Isham",
		"url": "https://findagrave.com/memorial/150788981",
		"id": 150788981,
		"lng": -77.38631374,
		"lat": 37.53562017,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 1,
		"dd": 6,
		"by": 1876,
		"bd": 30,
		"bm": 1,
		"nm": "H.",
		"nf": "William",
		"nl": "Isham",
		"url": "https://findagrave.com/memorial/150788990",
		"id": 150788990,
		"lng": -77.38631138,
		"lat": 37.53562781,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 10,
		"dd": 30,
		"by": 1889,
		"bd": 9,
		"bm": 11,
		"nm": "",
		"nf": "Alberta",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/113626462",
		"id": 113626462,
		"lng": -77.3877837,
		"lat": 37.53709479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 11,
		"dd": 15,
		"by": 1899,
		"bd": "",
		"bm": 5,
		"nm": "V.",
		"nf": "Andrew",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/129209867",
		"id": 129209867,
		"lng": -77.38608511,
		"lat": 37.53680405,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 4,
		"dd": 21,
		"by": 1887,
		"bd": 25,
		"bm": 12,
		"nm": "Rase",
		"nf": "Asbury",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/138567072",
		"id": 138567072,
		"lng": -77.38645383,
		"lat": 37.53689807,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 2,
		"dd": 1,
		"by": 1969,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "baby boy",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/179854702",
		"id": 179854702,
		"lng": -77.38589359,
		"lat": 37.53744267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 12,
		"dd": 16,
		"by": 1841,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Benjamin",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/154222275",
		"id": 154222275,
		"lng": -77.38657069,
		"lat": 37.5355814,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 11,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bernard",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/111589845",
		"id": 111589845,
		"lng": -77.38732867,
		"lat": 37.53754528,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 7,
		"dd": 2,
		"by": 1930,
		"bd": 24,
		"bm": 7,
		"nm": "Asbury",
		"nf": "Clifton",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/130538938",
		"id": 130538938,
		"lng": -77.38640522,
		"lat": 37.53701354,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 10,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cora",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/140290940",
		"id": 140290940,
		"lng": -77.38661454,
		"lat": 37.53556272,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 11,
		"dd": 15,
		"by": 1922,
		"bd": 17,
		"bm": 2,
		"nm": "James",
		"nf": "David",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/189776221",
		"id": 189776221,
		"lng": -77.38712473,
		"lat": 37.53754792,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Donald",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/144143017",
		"id": 144143017,
		"lng": -77.38611867,
		"lat": 37.53741764,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eddie",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/159880460",
		"id": 159880460,
		"lng": -77.38781366,
		"lat": 37.53702276,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 9,
		"dd": 7,
		"by": 1903,
		"bd": 14,
		"bm": 3,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/158924491",
		"id": 158924491,
		"lng": -77.3865957,
		"lat": 37.53757495,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1863,
		"bd": "",
		"bm": 9,
		"nm": "",
		"nf": "Flora",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/149168063",
		"id": 149168063,
		"lng": -77.38629181,
		"lat": 37.53541847,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 23,
		"by": 1896,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Floyd",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/151266445",
		"id": 151266445,
		"lng": -77.38715571,
		"lat": 37.53764422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 9,
		"by": 1875,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Georgianna",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/174858865",
		"id": 174858865,
		"lng": -77.38743184,
		"lat": 37.53705735,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 6,
		"dd": 14,
		"by": 1916,
		"bd": 15,
		"bm": 5,
		"nm": "Beatrice",
		"nf": "Gladys",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/184094538",
		"id": 184094538,
		"lng": -77.38732339,
		"lat": 37.53757069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": "",
		"dd": "",
		"by": 1902,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hallie",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/138567085",
		"id": 138567085,
		"lng": -77.38626606,
		"lat": 37.53659015,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 8,
		"dd": 24,
		"by": 1901,
		"bd": 22,
		"bm": 6,
		"nm": "",
		"nf": "Horace",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/142449367",
		"id": 142449367,
		"lng": -77.38745002,
		"lat": 37.53790318,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 3,
		"dd": 17,
		"by": 1903,
		"bd": 1,
		"bm": 1,
		"nm": "B.",
		"nf": "Ida",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/113750917",
		"id": 113750917,
		"lng": -77.38614947,
		"lat": 37.53691004,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 10,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Belle",
		"nf": "Ida",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/160639667",
		"id": 160639667,
		"lng": -77.38604127,
		"lat": 37.5368157,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 3,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "James",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/122786308",
		"id": 122786308,
		"lng": -77.38571223,
		"lat": 37.53698756,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 12,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jeanette",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/140290958",
		"id": 140290958,
		"lng": -77.38661519,
		"lat": 37.53557084,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 5,
		"dd": 1,
		"by": 1891,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennie",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/184693849",
		"id": 184693849,
		"lng": -77.38639703,
		"lat": 37.53754553,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 15,
		"by": 1910,
		"bd": 12,
		"bm": 10,
		"nm": "Lee",
		"nf": "John",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/176769430",
		"id": 176769430,
		"lng": -77.38748467,
		"lat": 37.53726496,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 10,
		"dd": 23,
		"by": 1895,
		"bd": 16,
		"bm": 11,
		"nm": "Ann",
		"nf": "Julia",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/191417556",
		"id": 191417556,
		"lng": -77.386409,
		"lat": 37.53747381,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 4,
		"dd": 3,
		"by": 1930,
		"bd": 25,
		"bm": 10,
		"nm": "",
		"nf": "Julia",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/38456036",
		"id": 38456036,
		"lng": -77.38577242,
		"lat": 37.53697218,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 5,
		"dd": 8,
		"by": 1900,
		"bd": 24,
		"bm": 9,
		"nm": "",
		"nf": "Kate",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/130538951",
		"id": 130538951,
		"lng": -77.38639318,
		"lat": 37.53697847,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 14,
		"by": 1897,
		"bd": 10,
		"bm": 6,
		"nm": "",
		"nf": "Leanna",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/134378279",
		"id": 134378279,
		"lng": -77.3864,
		"lat": 37.53736082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 2,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lee",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/127569715",
		"id": 127569715,
		"lng": -77.38577424,
		"lat": 37.53707913,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 11,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Malinda",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/187881417",
		"id": 187881417,
		"lng": -77.38761485,
		"lat": 37.53699305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 1,
		"dd": 25,
		"by": 1854,
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Maria",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/154222161",
		"id": 154222161,
		"lng": -77.3865719,
		"lat": 37.53555043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 5,
		"dd": 1,
		"by": 1875,
		"bd": 5,
		"bm": 5,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/176134498",
		"id": 176134498,
		"lng": -77.387647,
		"lat": 37.5371545,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Mary",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/145085195",
		"id": 145085195,
		"lng": -77.38761095,
		"lat": 37.53721565,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/151459721",
		"id": 151459721,
		"lng": -77.38804971,
		"lat": 37.53731936,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Mary",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/161636482",
		"id": 161636482,
		"lng": -77.38650298,
		"lat": 37.53657605,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 1,
		"by": 1912,
		"bd": "",
		"bm": "",
		"nm": "Esther",
		"nf": "Mary",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/125520647",
		"id": 125520647,
		"lng": -77.38625498,
		"lat": 37.53677506,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 4,
		"dd": 29,
		"by": 1910,
		"bd": 4,
		"bm": 6,
		"nm": "T.",
		"nf": "Melvin",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/125583724",
		"id": 125583724,
		"lng": -77.38624934,
		"lat": 37.53678701,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/170838903",
		"id": 170838903,
		"lng": -77.38644032,
		"lat": 37.53719596,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 2,
		"dd": 23,
		"by": 1867,
		"bd": 18,
		"bm": 8,
		"nm": "",
		"nf": "Nelson",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/156126599",
		"id": 156126599,
		"lng": -77.38614147,
		"lat": 37.53693571,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 2,
		"dd": 28,
		"by": 1916,
		"bd": 28,
		"bm": 1,
		"nm": "",
		"nf": "Nicholas",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/153512662",
		"id": 153512662,
		"lng": -77.38668296,
		"lat": 37.53719783,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 10,
		"dd": 4,
		"by": 1919,
		"bd": 9,
		"bm": 5,
		"nm": "",
		"nf": "Oscar",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/188244328",
		"id": 188244328,
		"lng": -77.38805292,
		"lat": 37.5373943,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 29,
		"by": 1912,
		"bd": 17,
		"bm": 6,
		"nm": "",
		"nf": "Pearl",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/168128975",
		"id": 168128975,
		"lng": -77.38690851,
		"lat": 37.53725911,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 2,
		"by": 1891,
		"bd": 18,
		"bm": 2,
		"nm": "",
		"nf": "Rebecca",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/148285699",
		"id": 148285699,
		"lng": -77.38640142,
		"lat": 37.53720326,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1850,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Richard",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/149168068",
		"id": 149168068,
		"lng": -77.38628923,
		"lat": 37.53542546,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 4,
		"dd": 4,
		"by": 1920,
		"bd": 28,
		"bm": 5,
		"nm": "Lee",
		"nf": "Rosa",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/84788791",
		"id": 84788791,
		"lng": -77.38773621,
		"lat": 37.537423,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 9,
		"dd": 1,
		"by": 1961,
		"bd": 9,
		"bm": 7,
		"nm": "W.",
		"nf": "Vernon",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/161636483",
		"id": 161636483,
		"lng": -77.38602476,
		"lat": 37.53631506,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 4,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Vinia",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/130693438",
		"id": 130693438,
		"lng": -77.38577921,
		"lat": 37.53707049,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 8,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/175402532",
		"id": 175402532,
		"lng": -77.38743116,
		"lat": 37.53706886,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 10,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Van",
		"nf": "William",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/140290947",
		"id": 140290947,
		"lng": -77.3866148,
		"lat": 37.53556683,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 26,
		"by": 1906,
		"bd": 6,
		"bm": 11,
		"nm": "H.",
		"nf": "William",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/143825862",
		"id": 143825862,
		"lng": -77.3860393,
		"lat": 37.53730791,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/175401624",
		"id": 175401624,
		"lng": -77.38756957,
		"lat": 37.53693457,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 2,
		"dd": 2,
		"by": 1922,
		"bd": 27,
		"bm": 11,
		"nm": "Mae",
		"nf": "Willie",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/160277977",
		"id": 160277977,
		"lng": -77.38608269,
		"lat": 37.53636305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 11,
		"dd": 19,
		"by": 1888,
		"bd": 1,
		"bm": 4,
		"nm": "",
		"nf": "Wilson",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/145596013",
		"id": 145596013,
		"lng": -77.38630538,
		"lat": 37.53734785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 26,
		"by": 1921,
		"bd": 28,
		"bm": 5,
		"nm": "",
		"nf": "Trust",
		"nl": "Jacobs",
		"url": "https://findagrave.com/memorial/155517942",
		"id": 155517942,
		"lng": -77.38765589,
		"lat": 37.537454,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 9,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Eddie",
		"nl": "James",
		"url": "https://findagrave.com/memorial/145085208",
		"id": 145085208,
		"lng": -77.38782323,
		"lat": 37.5372641,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 30,
		"by": 1963,
		"bd": 22,
		"bm": 8,
		"nm": "Bouvia",
		"nf": "Faye",
		"nl": "James",
		"url": "https://findagrave.com/memorial/151940959",
		"id": 151940959,
		"lng": -77.38598392,
		"lat": 37.53748226,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 16,
		"by": 1926,
		"bd": 9,
		"bm": 10,
		"nm": "Lorraine",
		"nf": "Gladys",
		"nl": "James",
		"url": "https://findagrave.com/memorial/125820823",
		"id": 125820823,
		"lng": -77.3862498,
		"lat": 37.53735033,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 16,
		"by": 1900,
		"bd": 24,
		"bm": 7,
		"nm": "Kearney",
		"nf": "Helen",
		"nl": "James",
		"url": "https://findagrave.com/memorial/152794731",
		"id": 152794731,
		"lng": -77.38657852,
		"lat": 37.53735686,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 3,
		"dd": 28,
		"by": 1889,
		"bd": 1,
		"bm": 12,
		"nm": "",
		"nf": "Lucy",
		"nl": "James",
		"url": "https://findagrave.com/memorial/144143019",
		"id": 144143019,
		"lng": -77.38656743,
		"lat": 37.53760652,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 9,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mahaley",
		"nl": "James",
		"url": "https://findagrave.com/memorial/155517954",
		"id": 155517954,
		"lng": -77.38702545,
		"lat": 37.53599269,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maria",
		"nl": "James",
		"url": "https://findagrave.com/memorial/141194075",
		"id": 141194075,
		"lng": -77.38627278,
		"lat": 37.53666503,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 15,
		"by": 1888,
		"bd": 7,
		"bm": 6,
		"nm": "",
		"nf": "Matilda",
		"nl": "James",
		"url": "https://findagrave.com/memorial/177020045",
		"id": 177020045,
		"lng": -77.38793677,
		"lat": 37.53726636,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 1,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maud",
		"nl": "James",
		"url": "https://findagrave.com/memorial/125408480",
		"id": 125408480,
		"lng": -77.38778585,
		"lat": 37.53651619,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 18,
		"by": 1894,
		"bd": 4,
		"bm": 7,
		"nm": "",
		"nf": "Richard",
		"nl": "James",
		"url": "https://findagrave.com/memorial/186818085",
		"id": 186818085,
		"lng": -77.3871282,
		"lat": 37.5369082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 23,
		"by": 1882,
		"bd": 27,
		"bm": 12,
		"nm": "",
		"nf": "Virginia",
		"nl": "James",
		"url": "https://findagrave.com/memorial/117449108",
		"id": 117449108,
		"lng": -77.38786882,
		"lat": 37.53721171,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 7,
		"dd": 5,
		"by": 1858,
		"bd": 4,
		"bm": 3,
		"nm": "Madison",
		"nf": "James",
		"nl": "Jasper",
		"url": "https://findagrave.com/memorial/38427941",
		"id": 38427941,
		"lng": -77.38592873,
		"lat": 37.53643189,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 2,
		"dd": 1,
		"by": 1891,
		"bd": 17,
		"bm": 8,
		"nm": "Manning",
		"nf": "Joseph",
		"nl": "Jasper",
		"url": "https://findagrave.com/memorial/38455502",
		"id": 38455502,
		"lng": -77.38575181,
		"lat": 37.53695091,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 27,
		"by": 1889,
		"bd": 22,
		"bm": 12,
		"nm": "S.",
		"nf": "Lelia",
		"nl": "Jasper",
		"url": "https://findagrave.com/memorial/38455332",
		"id": 38455332,
		"lng": -77.38575511,
		"lat": 37.53694197,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": 4,
		"dd": 30,
		"by": 1897,
		"bd": 2,
		"bm": 7,
		"nm": "H.",
		"nf": "Earsell",
		"nl": "Jeffers",
		"url": "https://findagrave.com/memorial/126456538",
		"id": 126456538,
		"lng": -77.38580441,
		"lat": 37.53649178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 3,
		"dd": 13,
		"by": 1903,
		"bd": 25,
		"bm": 2,
		"nm": "Ruth",
		"nf": "Eliza",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/126586610",
		"id": 126586610,
		"lng": -77.387781,
		"lat": 37.53782597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 11,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/144143021",
		"id": 144143021,
		"lng": -77.38592722,
		"lat": 37.53728528,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 9,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "John",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/185715188",
		"id": 185715188,
		"lng": -77.38801127,
		"lat": 37.53699516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 8,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Marie",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/174859738",
		"id": 174859738,
		"lng": -77.38747258,
		"lat": 37.53707104,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 2,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/174657542",
		"id": 174657542,
		"lng": -77.38763047,
		"lat": 37.53711571,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 16,
		"by": 1889,
		"bd": 1,
		"bm": 7,
		"nm": "",
		"nf": "Nancy",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/176247076",
		"id": 176247076,
		"lng": -77.38763382,
		"lat": 37.53734632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 12,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nancy",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/150493643",
		"id": 150493643,
		"lng": -77.38638672,
		"lat": 37.53602564,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 24,
		"by": 1900,
		"bd": 1,
		"bm": 3,
		"nm": "O.",
		"nf": "Rufus",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/153512666",
		"id": 153512666,
		"lng": -77.38663031,
		"lat": 37.5372101,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 3,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Watt",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/188566984",
		"id": 188566984,
		"lng": -77.38674258,
		"lat": 37.53657872,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/117209001",
		"id": 117209001,
		"lng": -77.38583584,
		"lat": 37.53672267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Winfree",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/181956331",
		"id": 181956331,
		"lng": -77.38628014,
		"lat": 37.53569995,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1984,
		"dm": 7,
		"dd": 10,
		"by": 1914,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Jeffiers",
		"url": "https://findagrave.com/memorial/122794799",
		"id": 122794799,
		"lng": -77.38590076,
		"lat": 37.53694836,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 6,
		"dd": 1,
		"by": 1891,
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Charlie",
		"nl": "Jeffries",
		"url": "https://findagrave.com/memorial/146013345",
		"id": 146013345,
		"lng": -77.38659195,
		"lat": 37.5367,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 9,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hattie",
		"nl": "Jeffries",
		"url": "https://findagrave.com/memorial/185378279",
		"id": 185378279,
		"lng": -77.38649302,
		"lat": 37.53760806,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Jeffries",
		"url": "https://findagrave.com/memorial/176468244",
		"id": 176468244,
		"lng": -77.38733783,
		"lat": 37.53705726,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Viola",
		"nl": "Jeffries",
		"url": "https://findagrave.com/memorial/142449470",
		"id": 142449470,
		"lng": -77.38744732,
		"lat": 37.53787848,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 2,
		"dd": 28,
		"by": 1900,
		"bd": 6,
		"bm": 3,
		"nm": "",
		"nf": "Edna",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/177500645",
		"id": 177500645,
		"lng": -77.38794283,
		"lat": 37.53731295,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/159603611",
		"id": 159603611,
		"lng": -77.38715266,
		"lat": 37.53748082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 11,
		"dd": 25,
		"by": 1866,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Kate",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/113750928",
		"id": 113750928,
		"lng": -77.38569033,
		"lat": 37.53683854,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 8,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/134359185",
		"id": 134359185,
		"lng": -77.38596381,
		"lat": 37.53615847,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 5,
		"dd": 19,
		"by": 1892,
		"bd": "",
		"bm": 9,
		"nm": "Nathaniel",
		"nf": "Magnus",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/113750936",
		"id": 113750936,
		"lng": -77.3856867,
		"lat": 37.5368465,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 8,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Major",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/131428507",
		"id": 131428507,
		"lng": -77.3856963,
		"lat": 37.53682346,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 2,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A. E.",
		"nf": "Sallie",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/154515401",
		"id": 154515401,
		"lng": -77.38662967,
		"lat": 37.53563858,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 24,
		"by": 1894,
		"bd": 27,
		"bm": 1,
		"nm": "Arthur Corbin",
		"nf": "John",
		"nl": "Jernigan",
		"url": "https://findagrave.com/memorial/152531974",
		"id": 152531974,
		"lng": -77.38586594,
		"lat": 37.53642125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 21,
		"by": 1964,
		"bd": 9,
		"bm": 7,
		"nm": "Lynn",
		"nf": "Vickie",
		"nl": "Jeter",
		"url": "https://findagrave.com/memorial/170815001",
		"id": 170815001,
		"lng": -77.38630076,
		"lat": 37.53680469,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 9,
		"dd": 3,
		"by": 1895,
		"bd": 7,
		"bm": 9,
		"nm": "",
		"nf": "Adelle",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/162642078",
		"id": 162642078,
		"lng": -77.3867575,
		"lat": 37.5370844,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 4,
		"dd": 11,
		"by": 1939,
		"bd": 22,
		"bm": 5,
		"nm": "",
		"nf": "Adelle",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/162164386",
		"id": 162164386,
		"lng": -77.38612275,
		"lat": 37.53629108,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 4,
		"by": 1921,
		"bd": 21,
		"bm": 10,
		"nm": "",
		"nf": "Albert",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/185739192",
		"id": 185739192,
		"lng": -77.38752218,
		"lat": 37.53737844,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 9,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Alexander",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/136173071",
		"id": 136173071,
		"lng": -77.38641651,
		"lat": 37.53643085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Alyce",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/125520655",
		"id": 125520655,
		"lng": -77.38588223,
		"lat": 37.53702047,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 5,
		"dd": 9,
		"by": 1933,
		"bd": 8,
		"bm": 5,
		"nm": "",
		"nf": "Annanias",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/160941306",
		"id": 160941306,
		"lng": -77.38689127,
		"lat": 37.53700731,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 1,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/148747970",
		"id": 148747970,
		"lng": -77.38801534,
		"lat": 37.53712711,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 9,
		"dd": 9,
		"by": 1925,
		"bd": 6,
		"bm": 7,
		"nm": "M.",
		"nf": "Bessie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/153512671",
		"id": 153512671,
		"lng": -77.38680865,
		"lat": 37.53731451,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 6,
		"by": 1917,
		"bd": 27,
		"bm": 9,
		"nm": "",
		"nf": "Betsy",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/172687171",
		"id": 172687171,
		"lng": -77.38728712,
		"lat": 37.53731936,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 11,
		"dd": 6,
		"by": 1893,
		"bd": 12,
		"bm": 8,
		"nm": "Antionette",
		"nf": "Bettie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/155517956",
		"id": 155517956,
		"lng": -77.38634677,
		"lat": 37.53638398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 9,
		"by": 1887,
		"bd": 10,
		"bm": 4,
		"nm": "",
		"nf": "Betty",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/142221493",
		"id": 142221493,
		"lng": -77.3866477,
		"lat": 37.53715376,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 1,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Catherine",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/155292257",
		"id": 155292257,
		"lng": -77.38660718,
		"lat": 37.53568036,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 2,
		"dd": 17,
		"by": 1893,
		"bd": "",
		"bm": 12,
		"nm": "",
		"nf": "Clarance",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/163950338",
		"id": 163950338,
		"lng": -77.38681416,
		"lat": 37.5367359,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 3,
		"dd": 14,
		"by": 1931,
		"bd": 18,
		"bm": 3,
		"nm": "",
		"nf": "Clarence",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/128400032",
		"id": 128400032,
		"lng": -77.38562742,
		"lat": 37.53704426,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Colindus",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/127483499",
		"id": 127483499,
		"lng": -77.38593841,
		"lat": 37.53731198,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 3,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Collins",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/176768898",
		"id": 176768898,
		"lng": -77.38769693,
		"lat": 37.53687453,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Edwin",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/124564899",
		"id": 124564899,
		"lng": -77.38587574,
		"lat": 37.53746293,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 5,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eliza",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/149201568",
		"id": 149201568,
		"lng": -77.38625596,
		"lat": 37.53544115,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 12,
		"dd": 20,
		"by": 1906,
		"bd": 26,
		"bm": 11,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/158678134",
		"id": 158678134,
		"lng": -77.38668486,
		"lat": 37.53758345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/146013350",
		"id": 146013350,
		"lng": -77.38650581,
		"lat": 37.53663419,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 2,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/120147052",
		"id": 120147052,
		"lng": -77.3859814,
		"lat": 37.5367546,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 3,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/128400018",
		"id": 128400018,
		"lng": -77.38568959,
		"lat": 37.53699682,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 4,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elmira",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/113750945",
		"id": 113750945,
		"lng": -77.38569734,
		"lat": 37.53683788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 10,
		"dd": 27,
		"by": 1898,
		"bd": 17,
		"bm": 7,
		"nm": "",
		"nf": "Emma",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/138366551",
		"id": 138366551,
		"lng": -77.38623257,
		"lat": 37.5367351,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 11,
		"dd": 12,
		"by": 1942,
		"bd": 17,
		"bm": 2,
		"nm": "",
		"nf": "Evelyn",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/148285720",
		"id": 148285720,
		"lng": -77.38646355,
		"lat": 37.53725812,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 11,
		"dd": 6,
		"by": 1920,
		"bd": 25,
		"bm": 4,
		"nm": "J.",
		"nf": "Evelyn",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/136304921",
		"id": 136304921,
		"lng": -77.38618819,
		"lat": 37.53634788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 5,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ewell",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/140623857",
		"id": 140623857,
		"lng": -77.38683179,
		"lat": 37.53545403,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 12,
		"dd": 10,
		"by": 1898,
		"bd": 10,
		"bm": 11,
		"nm": "1944nton",
		"nf": "Fleming",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/175328114",
		"id": 175328114,
		"lng": -77.38740581,
		"lat": 37.53708991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 3,
		"dd": 30,
		"by": 1908,
		"bd": 27,
		"bm": 7,
		"nm": "",
		"nf": "Florence",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/152006128",
		"id": 152006128,
		"lng": -77.38581602,
		"lat": 37.53722116,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 10,
		"dd": 14,
		"by": 1920,
		"bd": 25,
		"bm": 3,
		"nm": "",
		"nf": "Florence",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/192019526",
		"id": 192019526,
		"lng": -77.38781234,
		"lat": 37.53744652,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 3,
		"by": 1892,
		"bd": 7,
		"bm": 8,
		"nm": "W.",
		"nf": "Fred",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/141194091",
		"id": 141194091,
		"lng": -77.3863687,
		"lat": 37.53666659,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Geneva",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/158679293",
		"id": 158679293,
		"lng": -77.38695547,
		"lat": 37.53743516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 5,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Geneva",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/155477294",
		"id": 155477294,
		"lng": -77.38731097,
		"lat": 37.53551938,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": "",
		"dd": "",
		"by": 1914,
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "George",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/144315666",
		"id": 144315666,
		"lng": -77.38641835,
		"lat": 37.5353029,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Georgia",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/175609734",
		"id": 175609734,
		"lng": -77.3876349,
		"lat": 37.53709433,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 12,
		"dd": 14,
		"by": 1858,
		"bd": 22,
		"bm": 2,
		"nm": "L.",
		"nf": "Hannah",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/136107589",
		"id": 136107589,
		"lng": -77.38613595,
		"lat": 37.53692099,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Helen",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/166382775",
		"id": 166382775,
		"lng": -77.3874795,
		"lat": 37.53672161,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "James",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/177354181",
		"id": 177354181,
		"lng": -77.38634052,
		"lat": 37.5374685,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 11,
		"by": 1884,
		"bd": 22,
		"bm": 5,
		"nm": "",
		"nf": "James",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/175421244",
		"id": 175421244,
		"lng": -77.38739998,
		"lat": 37.53724082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 11,
		"dd": 24,
		"by": 1892,
		"bd": 24,
		"bm": 10,
		"nm": "Edward",
		"nf": "James",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/125634287",
		"id": 125634287,
		"lng": -77.38621973,
		"lat": 37.53676116,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 7,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/139424383",
		"id": 139424383,
		"lng": -77.38714106,
		"lat": 37.53546241,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 4,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Joseph",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/125408496",
		"id": 125408496,
		"lng": -77.38708842,
		"lat": 37.5362555,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Josephine",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/167467393",
		"id": 167467393,
		"lng": -77.38785469,
		"lat": 37.53726085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1882,
		"dm": 1,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Josephine",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/125520670",
		"id": 125520670,
		"lng": -77.38642964,
		"lat": 37.53643927,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 8,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ellen",
		"nf": "Lena",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/161052809",
		"id": 161052809,
		"lng": -77.38716574,
		"lat": 37.5370137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 23,
		"by": 1932,
		"bd": 8,
		"bm": 7,
		"nm": "B.",
		"nf": "Lenora",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/123850460",
		"id": 123850460,
		"lng": -77.38597475,
		"lat": 37.53668393,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 11,
		"by": 1886,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Linwood",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/154296434",
		"id": 154296434,
		"lng": -77.38710443,
		"lat": 37.53547785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 10,
		"by": 1903,
		"bd": 3,
		"bm": 3,
		"nm": "Elizabeth",
		"nf": "Louise",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/167325683",
		"id": 167325683,
		"lng": -77.38689818,
		"lat": 37.53729082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucinda",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/187354563",
		"id": 187354563,
		"lng": -77.38782631,
		"lat": 37.53708905,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 6,
		"dd": 24,
		"by": 1890,
		"bd": 11,
		"bm": 12,
		"nm": "",
		"nf": "Lucy",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/158734643",
		"id": 158734643,
		"lng": -77.38703517,
		"lat": 37.53752961,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 6,
		"dd": 28,
		"by": 1857,
		"bd": 10,
		"bm": 4,
		"nm": "Catherine",
		"nf": "Lucy",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/154296445",
		"id": 154296445,
		"lng": -77.38648084,
		"lat": 37.53552452,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1900,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Margaret",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/155517966",
		"id": 155517966,
		"lng": -77.386616,
		"lat": 37.53558036,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 7,
		"dd": 23,
		"by": 1900,
		"bd": 17,
		"bm": 4,
		"nm": "O.",
		"nf": "Maria",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/183697461",
		"id": 183697461,
		"lng": -77.38713967,
		"lat": 37.53695861,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Marvella",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/157309889",
		"id": 157309889,
		"lng": -77.38642862,
		"lat": 37.53704769,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 11,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/145638850",
		"id": 145638850,
		"lng": -77.38783772,
		"lat": 37.5372368,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 5,
		"dd": 14,
		"by": 1871,
		"bd": 20,
		"bm": 7,
		"nm": "F.",
		"nf": "Mary",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/125408514",
		"id": 125408514,
		"lng": -77.38721971,
		"lat": 37.5362771,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 11,
		"by": 1891,
		"bd": 18,
		"bm": 1,
		"nm": "Spencer",
		"nf": "Mary",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/158678309",
		"id": 158678309,
		"lng": -77.38686499,
		"lat": 37.53766766,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 12,
		"dd": 6,
		"by": 1884,
		"bd": 6,
		"bm": 1,
		"nm": "Louise",
		"nf": "Mary",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/154296452",
		"id": 154296452,
		"lng": -77.38680719,
		"lat": 37.53547446,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Mary",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/174622145",
		"id": 174622145,
		"lng": -77.38586431,
		"lat": 37.53643042,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 11,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Minnie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/182115890",
		"id": 182115890,
		"lng": -77.38661858,
		"lat": 37.53741526,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 9,
		"dd": 25,
		"by": 1885,
		"bd": 10,
		"bm": 4,
		"nm": "E.",
		"nf": "Missouria",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/169397284",
		"id": 169397284,
		"lng": -77.38651878,
		"lat": 37.53682298,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 2,
		"dd": 4,
		"by": 1939,
		"bd": "",
		"bm": "",
		"nm": "Watson",
		"nf": "Nannie Anne",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/173107347",
		"id": 173107347,
		"lng": -77.38700848,
		"lat": 37.53737196,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Neal",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/145638851",
		"id": 145638851,
		"lng": -77.38590519,
		"lat": 37.53744288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 5,
		"dd": 11,
		"by": 1927,
		"bd": 11,
		"bm": 11,
		"nm": "",
		"nf": "Otto",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/176570459",
		"id": 176570459,
		"lng": -77.38701901,
		"lat": 37.53746614,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 1,
		"dd": 22,
		"by": 1918,
		"bd": 11,
		"bm": 7,
		"nm": "E.",
		"nf": "Percy",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/153100511",
		"id": 153100511,
		"lng": -77.38657329,
		"lat": 37.53737124,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Rachel",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/144013906",
		"id": 144013906,
		"lng": -77.38721557,
		"lat": 37.53763025,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 3,
		"dd": 21,
		"by": 1924,
		"bd": 4,
		"bm": 5,
		"nm": "E.",
		"nf": "Richard",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/141658033",
		"id": 141658033,
		"lng": -77.38664212,
		"lat": 37.53726646,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/176097673",
		"id": 176097673,
		"lng": -77.38726263,
		"lat": 37.53687661,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 18,
		"by": 1907,
		"bd": 11,
		"bm": 4,
		"nm": "A.",
		"nf": "Robert",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/169121717",
		"id": 169121717,
		"lng": -77.38635986,
		"lat": 37.53740465,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 17,
		"by": 1922,
		"bd": 26,
		"bm": 10,
		"nm": "",
		"nf": "Rosa",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/173314382",
		"id": 173314382,
		"lng": -77.38710914,
		"lat": 37.53730952,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 12,
		"dd": 29,
		"by": 1903,
		"bd": 13,
		"bm": 2,
		"nm": "A.",
		"nf": "Ruby",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/167325969",
		"id": 167325969,
		"lng": -77.3868217,
		"lat": 37.53722301,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/170951406",
		"id": 170951406,
		"lng": -77.38607534,
		"lat": 37.53618077,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 7,
		"dd": 30,
		"by": 1923,
		"bd": 31,
		"bm": 7,
		"nm": "",
		"nf": "Susie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/133351410",
		"id": 133351410,
		"lng": -77.38757946,
		"lat": 37.53737627,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "O.",
		"nf": "Sydney",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/155289177",
		"id": 155289177,
		"lng": -77.3866355,
		"lat": 37.53565131,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 5,
		"by": 1886,
		"bd": 3,
		"bm": 4,
		"nm": "Everette",
		"nf": "Thomas",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/178089641",
		"id": 178089641,
		"lng": -77.38779575,
		"lat": 37.53754064,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Thomas",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/161052759",
		"id": 161052759,
		"lng": -77.38716518,
		"lat": 37.53702491,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 2,
		"by": "",
		"bd": 7,
		"bm": 4,
		"nm": "",
		"nf": "Thomas",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/143201864",
		"id": 143201864,
		"lng": -77.38599113,
		"lat": 37.53739727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Thomas",
		"nf": "William",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/183872295",
		"id": 183872295,
		"lng": -77.38732171,
		"lat": 37.536982,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 6,
		"dd": 5,
		"by": 1897,
		"bd": 4,
		"bm": 12,
		"nm": "H.",
		"nf": "William",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/138567105",
		"id": 138567105,
		"lng": -77.38622867,
		"lat": 37.53674206,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 1,
		"dd": 1,
		"by": 1840,
		"bd": 14,
		"bm": 5,
		"nm": "I.",
		"nf": "William",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/136107579",
		"id": 136107579,
		"lng": -77.38613762,
		"lat": 37.53691745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 2,
		"dd": 26,
		"by": 1928,
		"bd": 3,
		"bm": 2,
		"nm": "I.",
		"nf": "William",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/136107602",
		"id": 136107602,
		"lng": -77.38613451,
		"lat": 37.53692419,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 2,
		"dd": 7,
		"by": 1905,
		"bd": 12,
		"bm": 2,
		"nm": "M.",
		"nf": "Wortha",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/157897056",
		"id": 157897056,
		"lng": -77.38674221,
		"lat": 37.53751877,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 1,
		"dd": 25,
		"by": 1843,
		"bd": "",
		"bm": 7,
		"nm": "",
		"nf": "Alexander",
		"nl": "Jonathan",
		"url": "https://findagrave.com/memorial/139424431",
		"id": 139424431,
		"lng": -77.38670702,
		"lat": 37.53659837,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 5,
		"dd": 26,
		"by": 1915,
		"bd": 9,
		"bm": 7,
		"nm": "",
		"nf": "Alexander",
		"nl": "Jonathan",
		"url": "https://findagrave.com/memorial/146013359",
		"id": 146013359,
		"lng": -77.38667156,
		"lat": 37.53662029,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 9,
		"dd": 15,
		"by": 1872,
		"bd": "",
		"bm": 5,
		"nm": "G.",
		"nf": "Cora",
		"nl": "Jonathan",
		"url": "https://findagrave.com/memorial/145838602",
		"id": 145838602,
		"lng": -77.38670199,
		"lat": 37.53577989,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 2,
		"dd": 5,
		"by": 1861,
		"bd": 7,
		"bm": 11,
		"nm": "F.",
		"nf": "Hezekiah",
		"nl": "Jonathan",
		"url": "https://findagrave.com/memorial/145838711",
		"id": 145838711,
		"lng": -77.38671706,
		"lat": 37.53578677,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 7,
		"by": 1913,
		"bd": 13,
		"bm": 7,
		"nm": "Arthur",
		"nf": "Ovel",
		"nl": "Jonathan",
		"url": "https://findagrave.com/memorial/144188806",
		"id": 144188806,
		"lng": -77.38750785,
		"lat": 37.5374329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 30,
		"by": 1896,
		"bd": 18,
		"bm": 8,
		"nm": "Fulton",
		"nf": "Stanley",
		"nl": "Jonathan",
		"url": "https://findagrave.com/memorial/145838608",
		"id": 145838608,
		"lng": -77.38675228,
		"lat": 37.53575714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1994,
		"dm": 10,
		"dd": 31,
		"by": 1900,
		"bd": 1,
		"bm": 5,
		"nm": "",
		"nf": "Alexander",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/123696706",
		"id": 123696706,
		"lng": -77.38636857,
		"lat": 37.5370398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 1,
		"by": 1895,
		"bd": 23,
		"bm": 8,
		"nm": "",
		"nf": "Alice",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/142464315",
		"id": 142464315,
		"lng": -77.38586875,
		"lat": 37.53728559,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 8,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Anna",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/139424472",
		"id": 139424472,
		"lng": -77.38789633,
		"lat": 37.53706704,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 9,
		"dd": 10,
		"by": 1895,
		"bd": 5,
		"bm": 6,
		"nm": "Walter",
		"nf": "Arthur",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/151108246",
		"id": 151108246,
		"lng": -77.38665449,
		"lat": 37.53552657,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 9,
		"dd": 29,
		"by": 1863,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Asa",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/140290823",
		"id": 140290823,
		"lng": -77.38664609,
		"lat": 37.53550662,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 9,
		"dd": 9,
		"by": 1898,
		"bd": 4,
		"bm": 7,
		"nm": "F.",
		"nf": "Benjamin",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/150078592",
		"id": 150078592,
		"lng": -77.38681696,
		"lat": 37.53707475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 28,
		"by": 1923,
		"bd": 9,
		"bm": 2,
		"nm": "Lee",
		"nf": "Bernard",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/136107614",
		"id": 136107614,
		"lng": -77.38610519,
		"lat": 37.53693982,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1903,
		"dm": 1,
		"dd": 13,
		"by": 1879,
		"bd": 25,
		"bm": 6,
		"nm": "",
		"nf": "Bettie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/131428520",
		"id": 131428520,
		"lng": -77.38755994,
		"lat": 37.53653541,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Camilla",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/154277695",
		"id": 154277695,
		"lng": -77.3864822,
		"lat": 37.53551105,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 4,
		"dd": 20,
		"by": 1901,
		"bd": 19,
		"bm": 9,
		"nm": "T.",
		"nf": "Carlton",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/160433739",
		"id": 160433739,
		"lng": -77.38617208,
		"lat": 37.53637683,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 6,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Caroline",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/130538958",
		"id": 130538958,
		"lng": -77.38651134,
		"lat": 37.53692735,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 3,
		"dd": 20,
		"by": 1914,
		"bd": 15,
		"bm": 11,
		"nm": "",
		"nf": "Carrie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/65522321",
		"id": 65522321,
		"lng": -77.38592843,
		"lat": 37.53656065,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 19,
		"by": 1933,
		"bd": 1,
		"bm": 2,
		"nm": "Jordan",
		"nf": "Charles",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/111589849",
		"id": 111589849,
		"lng": -77.38732484,
		"lat": 37.53752533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 11,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Joe",
		"nf": "Charles",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/178412485",
		"id": 178412485,
		"lng": -77.38603521,
		"lat": 37.53627629,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 27,
		"by": 1884,
		"bd": 12,
		"bm": 12,
		"nm": "",
		"nf": "Charley",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/129211442",
		"id": 129211442,
		"lng": -77.38603122,
		"lat": 37.53670888,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 6,
		"dd": 10,
		"by": 1912,
		"bd": 16,
		"bm": 12,
		"nm": "Belle",
		"nf": "Cora",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/123696618",
		"id": 123696618,
		"lng": -77.38634429,
		"lat": 37.53703143,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Cornelia",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/146013368",
		"id": 146013368,
		"lng": -77.38773178,
		"lat": 37.53668415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 5,
		"dd": 31,
		"by": 1888,
		"bd": 6,
		"bm": 9,
		"nm": "",
		"nf": "Cyrus",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/154514984",
		"id": 154514984,
		"lng": -77.38644061,
		"lat": 37.53565058,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 5,
		"dd": 28,
		"by": 1910,
		"bd": 10,
		"bm": 5,
		"nm": "Winston",
		"nf": "David",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/144315674",
		"id": 144315674,
		"lng": -77.38625195,
		"lat": 37.5352887,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Douglas",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/138567111",
		"id": 138567111,
		"lng": -77.38636673,
		"lat": 37.53659197,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 1,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Agnes",
		"nf": "Elizabeth",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/151944040",
		"id": 151944040,
		"lng": -77.38665918,
		"lat": 37.53573637,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Etta",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/179574638",
		"id": 179574638,
		"lng": -77.38794363,
		"lat": 37.53774531,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 3,
		"dd": 9,
		"by": 1918,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Evelyn",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/125312983",
		"id": 125312983,
		"lng": -77.38591764,
		"lat": 37.53687174,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 25,
		"by": 1940,
		"bd": 19,
		"bm": 5,
		"nm": "R.",
		"nf": "Franklin",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/123696711",
		"id": 123696711,
		"lng": -77.38637371,
		"lat": 37.53702691,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 18,
		"by": 1907,
		"bd": 8,
		"bm": 11,
		"nm": "Bertha",
		"nf": "Geneva",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/185658251",
		"id": 185658251,
		"lng": -77.38610516,
		"lat": 37.53734292,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 1,
		"dd": 21,
		"by": 1937,
		"bd": 15,
		"bm": 4,
		"nm": "Ottis",
		"nf": "George",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/128400039",
		"id": 128400039,
		"lng": -77.3858963,
		"lat": 37.53689934,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 15,
		"by": 1950,
		"bd": 29,
		"bm": 1,
		"nm": "Nelson",
		"nf": "Glenn",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/141800936",
		"id": 141800936,
		"lng": -77.38657822,
		"lat": 37.5372374,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Henry",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/135631986",
		"id": 135631986,
		"lng": -77.38607724,
		"lat": 37.53706322,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 9,
		"by": 1965,
		"bd": 5,
		"bm": 12,
		"nm": "Desalle",
		"nf": "Huron",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/164205395",
		"id": 164205395,
		"lng": -77.38556273,
		"lat": 37.537295,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 14,
		"by": 1875,
		"bd": 2,
		"bm": 5,
		"nm": "",
		"nf": "Isaiah",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/138567127",
		"id": 138567127,
		"lng": -77.38648685,
		"lat": 37.53691484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 5,
		"dd": 13,
		"by": 1924,
		"bd": 3,
		"bm": 9,
		"nm": "",
		"nf": "James",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/177214504",
		"id": 177214504,
		"lng": -77.38732579,
		"lat": 37.53674678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Edward",
		"nf": "James",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/151943567",
		"id": 151943567,
		"lng": -77.38665944,
		"lat": 37.53572881,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jessie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/170839552",
		"id": 170839552,
		"lng": -77.38648595,
		"lat": 37.53708949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 11,
		"dd": 5,
		"by": 1905,
		"bd": 18,
		"bm": 12,
		"nm": "",
		"nf": "Joe",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/117449109",
		"id": 117449109,
		"lng": -77.38709395,
		"lat": 37.53715069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": "",
		"dd": "",
		"by": 1907,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joe",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/147853387",
		"id": 147853387,
		"lng": -77.38705052,
		"lat": 37.53714099,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 30,
		"by": 1892,
		"bd": 21,
		"bm": 3,
		"nm": "H.",
		"nf": "John",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/114466963",
		"id": 114466963,
		"lng": -77.38629643,
		"lat": 37.53688616,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 5,
		"dd": 27,
		"by": 1904,
		"bd": 28,
		"bm": 7,
		"nm": "H.",
		"nf": "John",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/178412488",
		"id": 178412488,
		"lng": -77.38606357,
		"lat": 37.53629053,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 3,
		"dd": 16,
		"by": 1915,
		"bd": 1,
		"bm": 3,
		"nm": "Edward",
		"nf": "Joseph",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/65522125",
		"id": 65522125,
		"lng": -77.38593402,
		"lat": 37.53655083,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": "",
		"dd": "",
		"by": 1966,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/145838715",
		"id": 145838715,
		"lng": -77.38593711,
		"lat": 37.53743985,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 8,
		"dd": 6,
		"by": 1900,
		"bd": 1,
		"bm": 3,
		"nm": "",
		"nf": "Josephine",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/166327350",
		"id": 166327350,
		"lng": -77.38700062,
		"lat": 37.53664402,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kate",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/159880465",
		"id": 159880465,
		"lng": -77.38781577,
		"lat": 37.53703178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 11,
		"dd": 20,
		"by": 1863,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Lawson",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/142526934",
		"id": 142526934,
		"lng": -77.38650561,
		"lat": 37.53538924,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Leslie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/175614661",
		"id": 175614661,
		"lng": -77.3874832,
		"lat": 37.53571034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 4,
		"dd": 11,
		"by": 1883,
		"bd": 23,
		"bm": 10,
		"nm": "P.",
		"nf": "Lucy",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/147853404",
		"id": 147853404,
		"lng": -77.38704837,
		"lat": 37.5371494,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 11,
		"dd": 7,
		"by": 1916,
		"bd": 8,
		"bm": 1,
		"nm": "",
		"nf": "Luella",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/161636486",
		"id": 161636486,
		"lng": -77.38800252,
		"lat": 37.53737484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 2,
		"dd": 6,
		"by": 1882,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Magnolia",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/144188891",
		"id": 144188891,
		"lng": -77.38731971,
		"lat": 37.53745984,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 10,
		"dd": 23,
		"by": 1896,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Martha",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/164026272",
		"id": 164026272,
		"lng": -77.38762911,
		"lat": 37.53731123,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 30,
		"by": 1874,
		"bd": 16,
		"bm": 8,
		"nm": "A.",
		"nf": "Martha",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/142464326",
		"id": 142464326,
		"lng": -77.38588095,
		"lat": 37.53728808,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 9,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/176240017",
		"id": 176240017,
		"lng": -77.3872682,
		"lat": 37.53702312,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 8,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Mary",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/166330812",
		"id": 166330812,
		"lng": -77.38700992,
		"lat": 37.53664614,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 3,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Mary",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/168837061",
		"id": 168837061,
		"lng": -77.38667889,
		"lat": 37.5369365,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1984,
		"dm": 12,
		"dd": 3,
		"by": 1895,
		"bd": 6,
		"bm": 10,
		"nm": "Louise",
		"nf": "Mary",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/120610687",
		"id": 120610687,
		"lng": -77.38584915,
		"lat": 37.53657783,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 23,
		"by": 1903,
		"bd": 4,
		"bm": 12,
		"nm": "Lillian",
		"nf": "Mary",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/142464403",
		"id": 142464403,
		"lng": -77.38588732,
		"lat": 37.53728913,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 11,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "V.",
		"nf": "Mattie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/121796876",
		"id": 121796876,
		"lng": -77.38583996,
		"lat": 37.53653502,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 2,
		"dd": 13,
		"by": 1920,
		"bd": 15,
		"bm": 1,
		"nm": "",
		"nf": "Nannie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/159859035",
		"id": 159859035,
		"lng": -77.38802699,
		"lat": 37.5374629,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 9,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Patsey",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/166327409",
		"id": 166327409,
		"lng": -77.38700544,
		"lat": 37.53664518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 14,
		"by": 1907,
		"bd": 7,
		"bm": 8,
		"nm": "",
		"nf": "Pearl",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/177468850",
		"id": 177468850,
		"lng": -77.38753666,
		"lat": 37.53732474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 3,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Pinkie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/154512041",
		"id": 154512041,
		"lng": -77.38642751,
		"lat": 37.53567486,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Primus",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/130538964",
		"id": 130538964,
		"lng": -77.38651053,
		"lat": 37.53693662,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rachel",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/207174222",
		"id": 207174222,
		"lng": -77.38631079,
		"lat": 37.53573589,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 7,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rebecca",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/140290827",
		"id": 140290827,
		"lng": -77.38664389,
		"lat": 37.53550633,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 7,
		"dd": 5,
		"by": 1850,
		"bd": "",
		"bm": 12,
		"nm": "M.",
		"nf": "Rebecca",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/150792655",
		"id": 150792655,
		"lng": -77.38621798,
		"lat": 37.53562106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rebecca",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/160277979",
		"id": 160277979,
		"lng": -77.3861316,
		"lat": 37.53639772,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 7,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/174698024",
		"id": 174698024,
		"lng": -77.38758824,
		"lat": 37.53705364,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 9,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "James",
		"nf": "Robert",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/156126613",
		"id": 156126613,
		"lng": -77.38612496,
		"lat": 37.53694359,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 1,
		"dd": 6,
		"by": 1896,
		"bd": 6,
		"bm": 8,
		"nm": "Robinson",
		"nf": "Sallie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/144143025",
		"id": 144143025,
		"lng": -77.38619339,
		"lat": 37.5373204,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 1,
		"dd": 13,
		"by": 1888,
		"bd": 21,
		"bm": 8,
		"nm": "Lee",
		"nf": "Sallie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/136107621",
		"id": 136107621,
		"lng": -77.38610233,
		"lat": 37.53694736,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 12,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Samuel",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/171697340",
		"id": 171697340,
		"lng": -77.3862273,
		"lat": 37.53589804,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 11,
		"dd": 10,
		"by": 1878,
		"bd": 8,
		"bm": 12,
		"nm": "Wyatt",
		"nf": "Thomas",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/155517984",
		"id": 155517984,
		"lng": -77.3873167,
		"lat": 37.53747035,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 1,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/166327211",
		"id": 166327211,
		"lng": -77.38701476,
		"lat": 37.53664687,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 9,
		"by": 1870,
		"bd": 12,
		"bm": 3,
		"nm": "Lorenzo",
		"nf": "Thomas",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/142464409",
		"id": 142464409,
		"lng": -77.38589246,
		"lat": 37.53729068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 10,
		"dd": 20,
		"by": 1914,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Victoria",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/177123348",
		"id": 177123348,
		"lng": -77.3867004,
		"lat": 37.53688809,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 2,
		"dd": 14,
		"by": 1895,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virginia",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/145085212",
		"id": 145085212,
		"lng": -77.38791737,
		"lat": 37.53740458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 2,
		"dd": 5,
		"by": 1888,
		"bd": 30,
		"bm": 5,
		"nm": "",
		"nf": "Walter",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/153512681",
		"id": 153512681,
		"lng": -77.38666639,
		"lat": 37.53720144,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 11,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Walter",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/126772094",
		"id": 126772094,
		"lng": -77.38584763,
		"lat": 37.53651288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 20,
		"by": 1959,
		"bd": 26,
		"bm": 4,
		"nm": "L.",
		"nf": "Wayne",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/128672355",
		"id": 128672355,
		"lng": -77.38623333,
		"lat": 37.53664642,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 16,
		"by": 1877,
		"bd": 25,
		"bm": 7,
		"nm": "Allen",
		"nf": "William",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/123119728",
		"id": 123119728,
		"lng": -77.38719921,
		"lat": 37.53751442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 10,
		"dd": 9,
		"by": 1881,
		"bd": 13,
		"bm": 11,
		"nm": "",
		"nf": "William",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/166358216",
		"id": 166358216,
		"lng": -77.38704707,
		"lat": 37.53687229,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 4,
		"dd": 10,
		"by": 1843,
		"bd": "",
		"bm": 12,
		"nm": "Howard",
		"nf": "William",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/150677872",
		"id": 150677872,
		"lng": -77.38621001,
		"lat": 37.53562531,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 7,
		"dd": 23,
		"by": 1918,
		"bd": 18,
		"bm": 12,
		"nm": "Robert",
		"nf": "Wirt",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/121628052",
		"id": 121628052,
		"lng": -77.38582644,
		"lat": 37.53653994,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 3,
		"dd": 21,
		"by": 1885,
		"bd": 10,
		"bm": 10,
		"nm": "Robert",
		"nf": "Wirt",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/121628036",
		"id": 121628036,
		"lng": -77.38581352,
		"lat": 37.53656867,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 11,
		"by": 1884,
		"bd": 21,
		"bm": 12,
		"nm": "C.",
		"nf": "Albert",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/38456254",
		"id": 38456254,
		"lng": -77.38552538,
		"lat": 37.53715884,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 5,
		"dd": 21,
		"by": 1911,
		"bd": 5,
		"bm": 10,
		"nm": "",
		"nf": "Alice",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/153512976",
		"id": 153512976,
		"lng": -77.38672167,
		"lat": 37.53731208,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 1,
		"dd": 5,
		"by": 1914,
		"bd": 28,
		"bm": 3,
		"nm": "",
		"nf": "Clarence",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/167324570",
		"id": 167324570,
		"lng": -77.38684949,
		"lat": 37.53728593,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 7,
		"dd": 27,
		"by": 1860,
		"bd": 23,
		"bm": 12,
		"nm": "",
		"nf": "Fannie",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/144820802",
		"id": 144820802,
		"lng": -77.38554466,
		"lat": 37.53716455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 18,
		"by": 1892,
		"bd": 2,
		"bm": 2,
		"nm": "",
		"nf": "Hester",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/167324168",
		"id": 167324168,
		"lng": -77.38687774,
		"lat": 37.53728502,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 5,
		"dd": 15,
		"by": 1912,
		"bd": 26,
		"bm": 2,
		"nm": "Edward",
		"nf": "James",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/167324948",
		"id": 167324948,
		"lng": -77.38687571,
		"lat": 37.53729089,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 11,
		"dd": 2,
		"by": 1915,
		"bd": 18,
		"bm": 4,
		"nm": "R. B.",
		"nf": "Katherleen",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/145085220",
		"id": 145085220,
		"lng": -77.38619065,
		"lat": 37.53732835,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 4,
		"dd": 29,
		"by": 1893,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Lilia",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/153512987",
		"id": 153512987,
		"lng": -77.38672083,
		"lat": 37.53731687,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 8,
		"dd": 16,
		"by": 1903,
		"bd": 15,
		"bm": 8,
		"nm": "Roosevelt",
		"nf": "Ralph",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/144820813",
		"id": 144820813,
		"lng": -77.38553919,
		"lat": 37.53718313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 7,
		"dd": 30,
		"by": 1892,
		"bd": 6,
		"bm": 7,
		"nm": "",
		"nf": "Rogers",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/177969282",
		"id": 177969282,
		"lng": -77.38801515,
		"lat": 37.53754636,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 3,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/158679165",
		"id": 158679165,
		"lng": -77.38692102,
		"lat": 37.53742452,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 30,
		"by": 1890,
		"bd": 28,
		"bm": 5,
		"nm": "Reed",
		"nf": "Sylvanus",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/153512993",
		"id": 153512993,
		"lng": -77.38672274,
		"lat": 37.5373067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virginia",
		"nl": "Jordan",
		"url": "https://findagrave.com/memorial/186817876",
		"id": 186817876,
		"lng": -77.38738196,
		"lat": 37.53771484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 6,
		"dd": 5,
		"by": 1886,
		"bd": 14,
		"bm": 2,
		"nm": "",
		"nf": "Alexander",
		"nl": "Jordon",
		"url": "https://findagrave.com/memorial/142464414",
		"id": 142464414,
		"lng": -77.38560432,
		"lat": 37.53734179,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 9,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Parthenia",
		"nl": "Joyner",
		"url": "https://findagrave.com/memorial/154296516",
		"id": 154296516,
		"lng": -77.38693007,
		"lat": 37.53544159,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 11,
		"dd": 6,
		"by": 1885,
		"bd": 27,
		"bm": 9,
		"nm": "",
		"nf": "Florence",
		"nl": "Judkins",
		"url": "https://findagrave.com/memorial/125820828",
		"id": 125820828,
		"lng": -77.38625932,
		"lat": 37.535763,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 2,
		"by": 1908,
		"bd": 7,
		"bm": 3,
		"nm": "",
		"nf": "Lennie",
		"nl": "Keel",
		"url": "https://findagrave.com/memorial/141658048",
		"id": 141658048,
		"lng": -77.38666701,
		"lat": 37.53728528,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1986,
		"dm": 7,
		"dd": 15,
		"by": 1910,
		"bd": 2,
		"bm": 10,
		"nm": "",
		"nf": "Ruth",
		"nl": "Keel",
		"url": "https://findagrave.com/memorial/141800945",
		"id": 141800945,
		"lng": -77.38667205,
		"lat": 37.53727582,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 14,
		"by": 1948,
		"bd": 27,
		"bm": 7,
		"nm": "Edward",
		"nf": "Richard",
		"nl": "Keels",
		"url": "https://findagrave.com/memorial/173156234",
		"id": 173156234,
		"lng": -77.38698708,
		"lat": 37.53730432,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 11,
		"dd": 23,
		"by": 1889,
		"bd": 8,
		"bm": 12,
		"nm": "",
		"nf": "Jessie",
		"nl": "Kelly",
		"url": "https://findagrave.com/memorial/130378933",
		"id": 130378933,
		"lng": -77.38597288,
		"lat": 37.5367789,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Rebecca",
		"nf": "Ann",
		"nl": "Kemp",
		"url": "https://findagrave.com/memorial/170118952",
		"id": 170118952,
		"lng": -77.38602152,
		"lat": 37.53605197,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 3,
		"dd": 17,
		"by": 1888,
		"bd": 25,
		"bm": 8,
		"nm": "Burgess",
		"nf": "C.",
		"nl": "Kemp",
		"url": "https://findagrave.com/memorial/143865722",
		"id": 143865722,
		"lng": -77.38599497,
		"lat": 37.53608545,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 8,
		"dd": 17,
		"by": 1887,
		"bd": 3,
		"bm": 6,
		"nm": "P.",
		"nf": "Hattie",
		"nl": "Kemp",
		"url": "https://findagrave.com/memorial/156285970",
		"id": 156285970,
		"lng": -77.38606107,
		"lat": 37.5360653,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 5,
		"dd": 22,
		"by": 1890,
		"bd": 31,
		"bm": 7,
		"nm": "",
		"nf": "Minnie",
		"nl": "Kemp",
		"url": "https://findagrave.com/memorial/142526955",
		"id": 142526955,
		"lng": -77.38646772,
		"lat": 37.53538708,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 6,
		"dd": 2,
		"by": 1893,
		"bd": 19,
		"bm": 4,
		"nm": "Allen",
		"nf": "Sidney",
		"nl": "Kemp",
		"url": "https://findagrave.com/memorial/170119393",
		"id": 170119393,
		"lng": -77.3860265,
		"lat": 37.53605329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 5,
		"dd": 25,
		"by": 1912,
		"bd": 30,
		"bm": 12,
		"nm": "E.",
		"nf": "Louise",
		"nl": "Kendrick",
		"url": "https://findagrave.com/memorial/125312997",
		"id": 125312997,
		"lng": -77.38590069,
		"lat": 37.53695824,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 3,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Kenney",
		"url": "https://findagrave.com/memorial/155529323",
		"id": 155529323,
		"lng": -77.38732629,
		"lat": 37.53554215,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 6,
		"dd": 17,
		"by": 1877,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Kenney",
		"url": "https://findagrave.com/memorial/155529325",
		"id": 155529325,
		"lng": -77.38732488,
		"lat": 37.53552822,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 4,
		"dd": 20,
		"by": 1888,
		"bd": 9,
		"bm": 2,
		"nm": "",
		"nf": "Artelia",
		"nl": "Kenny",
		"url": "https://findagrave.com/memorial/187587286",
		"id": 187587286,
		"lng": -77.387723,
		"lat": 37.53704145,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 6,
		"by": 1901,
		"bd": 14,
		"bm": 9,
		"nm": "Brown Ings",
		"nf": "Leonia",
		"nl": "Ketter",
		"url": "https://findagrave.com/memorial/154509725",
		"id": 154509725,
		"lng": -77.38639502,
		"lat": 37.53739856,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Belle",
		"nl": "Kimbrough",
		"url": "https://findagrave.com/memorial/185392968",
		"id": 185392968,
		"lng": -77.38735083,
		"lat": 37.53770393,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 4,
		"dd": 22,
		"by": 1917,
		"bd": 4,
		"bm": 5,
		"nm": "Virginia",
		"nf": "Ruth",
		"nl": "Kinder",
		"url": "https://findagrave.com/memorial/161179727",
		"id": 161179727,
		"lng": -77.38608136,
		"lat": 37.53631625,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 24,
		"by": 1905,
		"bd": 3,
		"bm": 3,
		"nm": "",
		"nf": "David",
		"nl": "King",
		"url": "https://findagrave.com/memorial/150637819",
		"id": 150637819,
		"lng": -77.38651681,
		"lat": 37.53724581,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "King",
		"url": "https://findagrave.com/memorial/168728876",
		"id": 168728876,
		"lng": -77.38637433,
		"lat": 37.53713511,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 4,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Overton",
		"nf": "Ralph",
		"nl": "King",
		"url": "https://findagrave.com/memorial/144558533",
		"id": 144558533,
		"lng": -77.38651015,
		"lat": 37.53567048,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 8,
		"by": 1901,
		"bd": 19,
		"bm": 8,
		"nm": "L.",
		"nf": "Rosa",
		"nl": "King",
		"url": "https://findagrave.com/memorial/141194103",
		"id": 141194103,
		"lng": -77.3863931,
		"lat": 37.53663409,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 9,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "King",
		"url": "https://findagrave.com/memorial/146013372",
		"id": 146013372,
		"lng": -77.38773093,
		"lat": 37.53674319,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 8,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "King",
		"url": "https://findagrave.com/memorial/173806185",
		"id": 173806185,
		"lng": -77.3874564,
		"lat": 37.53709247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 1,
		"dd": 21,
		"by": 1874,
		"bd": 15,
		"bm": 10,
		"nm": "",
		"nf": "Taylor",
		"nl": "King",
		"url": "https://findagrave.com/memorial/134359193",
		"id": 134359193,
		"lng": -77.3876185,
		"lat": 37.53659149,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 3,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Giles",
		"nl": "Kinney",
		"url": "https://findagrave.com/memorial/176983576",
		"id": 176983576,
		"lng": -77.38748592,
		"lat": 37.5355374,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 11,
		"dd": 27,
		"by": 1930,
		"bd": 31,
		"bm": 1,
		"nm": "Troy",
		"nf": "Levan",
		"nl": "Kirven",
		"url": "https://findagrave.com/memorial/159885809",
		"id": 159885809,
		"lng": -77.38802144,
		"lat": 37.53739551,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 2,
		"dd": 8,
		"by": 1890,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Annie",
		"nl": "Kittrell",
		"url": "https://findagrave.com/memorial/159973279",
		"id": 159973279,
		"lng": -77.386444,
		"lat": 37.53745776,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 1,
		"dd": 24,
		"by": 1938,
		"bd": 5,
		"bm": 7,
		"nm": "S",
		"nf": "Preston",
		"nl": "Kittrell",
		"url": "https://findagrave.com/memorial/190318871",
		"id": 190318871,
		"lng": -77.38666353,
		"lat": 37.53730584,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 17,
		"by": 1915,
		"bd": 18,
		"bm": 11,
		"nm": "Robert",
		"nf": "Elmore",
		"nl": "Knight",
		"url": "https://findagrave.com/memorial/76604953",
		"id": 76604953,
		"lng": -77.3861271,
		"lat": 37.53672309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1990,
		"dm": 6,
		"dd": 7,
		"by": 1929,
		"bd": 5,
		"bm": 1,
		"nm": "F.",
		"nf": "George",
		"nl": "Knight",
		"url": "https://findagrave.com/memorial/76604961",
		"id": 76604961,
		"lng": -77.3861072,
		"lat": 37.53670732,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 11,
		"dd": 5,
		"by": 1887,
		"bd": 11,
		"bm": 5,
		"nm": "R.",
		"nf": "George",
		"nl": "Knight",
		"url": "https://findagrave.com/memorial/76604969",
		"id": 76604969,
		"lng": -77.38609216,
		"lat": 37.5367401,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1986,
		"dm": 8,
		"dd": 30,
		"by": 1895,
		"bd": 15,
		"bm": 8,
		"nm": "B.",
		"nf": "Mary",
		"nl": "Knight",
		"url": "https://findagrave.com/memorial/76604982",
		"id": 76604982,
		"lng": -77.3860964,
		"lat": 37.53673231,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 1,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Knight",
		"url": "https://findagrave.com/memorial/127131714",
		"id": 127131714,
		"lng": -77.38607095,
		"lat": 37.53638445,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": "",
		"dd": "",
		"by": 1917,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Earl",
		"nl": "Lancaster",
		"url": "https://findagrave.com/memorial/118206431",
		"id": 118206431,
		"lng": -77.38584378,
		"lat": 37.53671192,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 6,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Lancaster",
		"url": "https://findagrave.com/memorial/118206473",
		"id": 118206473,
		"lng": -77.38586491,
		"lat": 37.53669764,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "N",
		"nf": "Mattie",
		"nl": "Laney",
		"url": "https://findagrave.com/memorial/170839546",
		"id": 170839546,
		"lng": -77.38652437,
		"lat": 37.53711153,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 12,
		"dd": 12,
		"by": 1880,
		"bd": 13,
		"bm": 3,
		"nm": "Montgomery",
		"nf": "Benjamin",
		"nl": "Langhorn",
		"url": "https://findagrave.com/memorial/149355154",
		"id": 149355154,
		"lng": -77.38618265,
		"lat": 37.53597092,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 8,
		"dd": 3,
		"by": 1855,
		"bd": 3,
		"bm": 5,
		"nm": "S.",
		"nf": "Walter",
		"nl": "Langhorn",
		"url": "https://findagrave.com/memorial/122786317",
		"id": 122786317,
		"lng": -77.38589267,
		"lat": 37.53646127,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 7,
		"dd": 1,
		"by": 1857,
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Cornelius",
		"nl": "Langhorne",
		"url": "https://findagrave.com/memorial/125820905",
		"id": 125820905,
		"lng": -77.38620257,
		"lat": 37.53597348,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 8,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Martha",
		"nl": "Langhorne",
		"url": "https://findagrave.com/memorial/125820911",
		"id": 125820911,
		"lng": -77.38619936,
		"lat": 37.53597274,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 7,
		"dd": 24,
		"by": 1921,
		"bd": 20,
		"bm": 8,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Langon",
		"url": "https://findagrave.com/memorial/187354576",
		"id": 187354576,
		"lng": -77.38725314,
		"lat": 37.53725255,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Angie",
		"nl": "Law",
		"url": "https://findagrave.com/memorial/175843484",
		"id": 175843484,
		"lng": -77.38771299,
		"lat": 37.53713107,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 7,
		"dd": 25,
		"by": 1889,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Elliott",
		"nl": "Lawrence",
		"url": "https://findagrave.com/memorial/184278331",
		"id": 184278331,
		"lng": -77.38702318,
		"lat": 37.53757073,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 3,
		"dd": 10,
		"by": 1917,
		"bd": 4,
		"bm": 7,
		"nm": "",
		"nf": "Raymond",
		"nl": "Lawrence",
		"url": "https://findagrave.com/memorial/155529327",
		"id": 155529327,
		"lng": -77.38753407,
		"lat": 37.5376257,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 27,
		"by": 1938,
		"bd": 5,
		"bm": 4,
		"nm": "E.",
		"nf": "Ernest",
		"nl": "Lawson",
		"url": "https://findagrave.com/memorial/170815131",
		"id": 170815131,
		"lng": -77.38628849,
		"lat": 37.53676131,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 23,
		"by": 1871,
		"bd": 1,
		"bm": 1,
		"nm": "",
		"nf": "Martha",
		"nl": "Lawson",
		"url": "https://findagrave.com/memorial/184094545",
		"id": 184094545,
		"lng": -77.38708727,
		"lat": 37.53753281,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 1,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Mary",
		"nl": "Lawson",
		"url": "https://findagrave.com/memorial/146343903",
		"id": 146343903,
		"lng": -77.38635522,
		"lat": 37.53576714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 12,
		"dd": 25,
		"by": 1874,
		"bd": 27,
		"bm": 4,
		"nm": "V.",
		"nf": "Queen",
		"nl": "Lawson",
		"url": "https://findagrave.com/memorial/141446419",
		"id": 141446419,
		"lng": -77.38736377,
		"lat": 37.53760202,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 2,
		"by": 1909,
		"bd": 10,
		"bm": 7,
		"nm": "Hampton",
		"nf": "Wade",
		"nl": "Le Grand",
		"url": "https://findagrave.com/memorial/158463640",
		"id": 158463640,
		"lng": -77.38677395,
		"lat": 37.53760147,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Albert",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/125313009",
		"id": 125313009,
		"lng": -77.38555926,
		"lat": 37.5371939,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Staunton",
		"nf": "Alberta",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/160934046",
		"id": 160934046,
		"lng": -77.3866984,
		"lat": 37.53673983,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 11,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Catherine",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/139424710",
		"id": 139424710,
		"lng": -77.38680216,
		"lat": 37.53686216,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Celeste",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/166116779",
		"id": 166116779,
		"lng": -77.38760059,
		"lat": 37.53678284,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 2,
		"dd": 12,
		"by": 1899,
		"bd": 4,
		"bm": 10,
		"nm": "Leslie",
		"nf": "Charles",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/155529330",
		"id": 155529330,
		"lng": -77.38740856,
		"lat": 37.53748382,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 12,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/170815005",
		"id": 170815005,
		"lng": -77.38620265,
		"lat": 37.5355865,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 12,
		"dd": 22,
		"by": 1882,
		"bd": 22,
		"bm": 9,
		"nm": "",
		"nf": "Effie",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/130693691",
		"id": 130693691,
		"lng": -77.38564586,
		"lat": 37.53695079,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 3,
		"dd": 20,
		"by": 1875,
		"bd": 10,
		"bm": 7,
		"nm": "Jane",
		"nf": "Elsie",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/173481988",
		"id": 173481988,
		"lng": -77.387558,
		"lat": 37.53710183,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 11,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Major",
		"nf": "Emanuel",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/185645591",
		"id": 185645591,
		"lng": -77.38777532,
		"lat": 37.53707068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "John",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/177226658",
		"id": 177226658,
		"lng": -77.38756598,
		"lat": 37.53678603,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 30,
		"by": 1894,
		"bd": 25,
		"bm": 5,
		"nm": "Francis",
		"nf": "John",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/173077010",
		"id": 173077010,
		"lng": -77.38702866,
		"lat": 37.53732965,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 12,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lelie",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/145638852",
		"id": 145638852,
		"lng": -77.38556275,
		"lat": 37.53718139,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 19,
		"by": 1915,
		"bd": 15,
		"bm": 5,
		"nm": "",
		"nf": "Mamie",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/148285740",
		"id": 148285740,
		"lng": -77.38637482,
		"lat": 37.53717311,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Percy",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/144820821",
		"id": 144820821,
		"lng": -77.3855347,
		"lat": 37.53723418,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 7,
		"by": 1889,
		"bd": 26,
		"bm": 10,
		"nm": "E.",
		"nf": "Robert",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/175408957",
		"id": 175408957,
		"lng": -77.38736106,
		"lat": 37.53724689,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 1,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sweeter",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/181956334",
		"id": 181956334,
		"lng": -77.38774495,
		"lat": 37.536425,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 12,
		"by": 1921,
		"bd": 8,
		"bm": 6,
		"nm": "",
		"nf": "Clarence",
		"nl": "Leeper",
		"url": "https://findagrave.com/memorial/141194116",
		"id": 141194116,
		"lng": -77.38637308,
		"lat": 37.53678099,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 4,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sadie",
		"nl": "Leeper",
		"url": "https://findagrave.com/memorial/188245142",
		"id": 188245142,
		"lng": -77.38804372,
		"lat": 37.53733926,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 15,
		"by": 1900,
		"bd": 17,
		"bm": 12,
		"nm": "Coward",
		"nf": "Lucille",
		"nl": "Leftenant",
		"url": "https://findagrave.com/memorial/158678985",
		"id": 158678985,
		"lng": -77.38707537,
		"lat": 37.53747329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 6,
		"dd": 26,
		"by": 1895,
		"bd": 2,
		"bm": 7,
		"nm": "Fred",
		"nf": "Thaddeus",
		"nl": "Leftenant",
		"url": "https://findagrave.com/memorial/158678825",
		"id": 158678825,
		"lng": -77.38707241,
		"lat": 37.53748106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Milledge",
		"nl": "Leggs",
		"url": "https://findagrave.com/memorial/160934052",
		"id": 160934052,
		"lng": -77.38673785,
		"lat": 37.53674534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 4,
		"dd": 30,
		"by": 1869,
		"bd": 12,
		"bm": 2,
		"nm": "Alice",
		"nf": "Mary",
		"nl": "Lemas",
		"url": "https://findagrave.com/memorial/154201513",
		"id": 154201513,
		"lng": -77.3872493,
		"lat": 37.53546347,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 1,
		"dd": 5,
		"by": 1889,
		"bd": 15,
		"bm": 6,
		"nm": "Philex",
		"nf": "Albert",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/145838755",
		"id": 145838755,
		"lng": -77.38655857,
		"lat": 37.53567536,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 18,
		"by": 1919,
		"bd": 25,
		"bm": 12,
		"nm": "Mae",
		"nf": "Annie",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/159762336",
		"id": 159762336,
		"lng": -77.38642401,
		"lat": 37.53750908,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 5,
		"dd": 16,
		"by": 1918,
		"bd": 7,
		"bm": 9,
		"nm": "H.",
		"nf": "Charles",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/145325148",
		"id": 145325148,
		"lng": -77.38593616,
		"lat": 37.53629213,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 7,
		"dd": 11,
		"by": 1902,
		"bd": 1,
		"bm": 6,
		"nm": "",
		"nf": "Dora",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/150637825",
		"id": 150637825,
		"lng": -77.38633635,
		"lat": 37.53600471,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 3,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Grant",
		"nf": "Harvey",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/155027259",
		"id": 155027259,
		"lng": -77.38650379,
		"lat": 37.53566305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 11,
		"dd": 7,
		"by": 1890,
		"bd": 23,
		"bm": 2,
		"nm": "",
		"nf": "Hettie",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/128672366",
		"id": 128672366,
		"lng": -77.38742417,
		"lat": 37.53750145,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 13,
		"by": 1962,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Janet",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/159414581",
		"id": 159414581,
		"lng": -77.38617464,
		"lat": 37.53752302,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/159886270",
		"id": 159886270,
		"lng": -77.38791123,
		"lat": 37.53765436,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 12,
		"by": 1862,
		"bd": 27,
		"bm": 9,
		"nm": "Oliver",
		"nf": "John",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/149561058",
		"id": 149561058,
		"lng": -77.38626024,
		"lat": 37.53597245,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 1,
		"dd": 1,
		"by": 1917,
		"bd": 18,
		"bm": 9,
		"nm": "A.",
		"nf": "John",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/144143918",
		"id": 144143918,
		"lng": -77.38623094,
		"lat": 37.53741611,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 11,
		"dd": 29,
		"by": 1885,
		"bd": 25,
		"bm": 5,
		"nm": "Edward",
		"nf": "John",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/125313042",
		"id": 125313042,
		"lng": -77.38590221,
		"lat": 37.53687834,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 8,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kate",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/141446446",
		"id": 141446446,
		"lng": -77.38737265,
		"lat": 37.53778991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 2,
		"dd": 14,
		"by": 1870,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kate",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/149561068",
		"id": 149561068,
		"lng": -77.38625948,
		"lat": 37.53597934,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 8,
		"dd": 9,
		"by": 1893,
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Leroy",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/166383668",
		"id": 166383668,
		"lng": -77.38760846,
		"lat": 37.5367084,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 4,
		"dd": 15,
		"by": 1891,
		"bd": 3,
		"bm": 11,
		"nm": "",
		"nf": "Lettie",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/155529333",
		"id": 155529333,
		"lng": -77.3875335,
		"lat": 37.53748672,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 10,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luvenia",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/125820926",
		"id": 125820926,
		"lng": -77.38626191,
		"lat": 37.53596201,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 7,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/151049343",
		"id": 151049343,
		"lng": -77.38707931,
		"lat": 37.53559621,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 5,
		"by": 1948,
		"bd": 12,
		"bm": 11,
		"nm": "Alice",
		"nf": "Mary",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/139424718",
		"id": 139424718,
		"lng": -77.38673172,
		"lat": 37.53680189,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Nathaniel",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/150038034",
		"id": 150038034,
		"lng": -77.38691299,
		"lat": 37.5357404,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": "",
		"dd": "",
		"by": 1912,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rebecca",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/145085226",
		"id": 145085226,
		"lng": -77.38741761,
		"lat": 37.53788643,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1904,
		"dm": 4,
		"dd": 17,
		"by": 1891,
		"bd": 1,
		"bm": 7,
		"nm": "S.",
		"nf": "Robert",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/125408674",
		"id": 125408674,
		"lng": -77.38760391,
		"lat": 37.53673091,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 8,
		"dd": 23,
		"by": 1963,
		"bd": 21,
		"bm": 8,
		"nm": "Ronnell",
		"nf": "Ronald",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/159414599",
		"id": 159414599,
		"lng": -77.38609575,
		"lat": 37.53748785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 23,
		"by": 1909,
		"bd": 2,
		"bm": 11,
		"nm": "",
		"nf": "Rosetta",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/152794735",
		"id": 152794735,
		"lng": -77.38590633,
		"lat": 37.53745587,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 12,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ryland",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/146682163",
		"id": 146682163,
		"lng": -77.38622417,
		"lat": 37.53586047,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 12,
		"dd": 29,
		"by": 1870,
		"bd": 17,
		"bm": 5,
		"nm": "L.",
		"nf": "Samuel",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/157165343",
		"id": 157165343,
		"lng": -77.38646816,
		"lat": 37.53587492,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Sarah",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/146682164",
		"id": 146682164,
		"lng": -77.38622381,
		"lat": 37.53586386,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 11,
		"dd": 26,
		"by": 1903,
		"bd": 6,
		"bm": 7,
		"nm": "",
		"nf": "Siles",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/160048193",
		"id": 160048193,
		"lng": -77.38647127,
		"lat": 37.5374806,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 8,
		"by": 1870,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Tom",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/141194127",
		"id": 141194127,
		"lng": -77.38633191,
		"lat": 37.53673017,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 8,
		"dd": 7,
		"by": 1953,
		"bd": 6,
		"bm": 8,
		"nm": "",
		"nf": "Walter",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/175820492",
		"id": 175820492,
		"lng": -77.38643935,
		"lat": 37.53676734,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 10,
		"dd": 27,
		"by": 1918,
		"bd": 16,
		"bm": 10,
		"nm": "",
		"nf": "Welton",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/187354583",
		"id": 187354583,
		"lng": -77.38743319,
		"lat": 37.53749037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 7,
		"dd": 16,
		"by": 1905,
		"bd": 12,
		"bm": 12,
		"nm": "",
		"nf": "Elliott",
		"nl": "Libron",
		"url": "https://findagrave.com/memorial/133137510",
		"id": 133137510,
		"lng": -77.3869788,
		"lat": 37.53706357,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 10,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frances",
		"nl": "Liggons",
		"url": "https://findagrave.com/memorial/155529341",
		"id": 155529341,
		"lng": -77.38701701,
		"lat": 37.53640998,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 4,
		"dd": 6,
		"by": 1919,
		"bd": 30,
		"bm": 8,
		"nm": "",
		"nf": "James",
		"nl": "Liggon",
		"url": "https://findagrave.com/memorial/183587462",
		"id": 183587462,
		"lng": -77.38664346,
		"lat": 37.53709604,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 11,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jesse",
		"nl": "Light",
		"url": "https://findagrave.com/memorial/123587202",
		"id": 123587202,
		"lng": -77.38578518,
		"lat": 37.5369087,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 11,
		"by": 1907,
		"bd": 25,
		"bm": 11,
		"nm": "Bernard",
		"nf": "George",
		"nl": "Lindsay",
		"url": "https://findagrave.com/memorial/152527314",
		"id": 152527314,
		"lng": -77.38583583,
		"lat": 37.53722722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 7,
		"dd": 5,
		"by": 1883,
		"bd": 16,
		"bm": 10,
		"nm": "Henry",
		"nf": "William",
		"nl": "Lindsay",
		"url": "https://findagrave.com/memorial/142468273",
		"id": 142468273,
		"lng": -77.38581257,
		"lat": 37.53723348,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 10,
		"dd": 14,
		"by": 1817,
		"bd": "",
		"bm": 9,
		"nm": "",
		"nf": "Caroline",
		"nl": "Lindsey",
		"url": "https://findagrave.com/memorial/151945883",
		"id": 151945883,
		"lng": -77.38661337,
		"lat": 37.53572923,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clarence",
		"nl": "Linson",
		"url": "https://findagrave.com/memorial/186818175",
		"id": 186818175,
		"lng": -77.38758979,
		"lat": 37.53708953,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 15,
		"by": 1920,
		"bd": 21,
		"bm": 1,
		"nm": "James",
		"nf": "Robert",
		"nl": "Lipscombe",
		"url": "https://findagrave.com/memorial/156929080",
		"id": 156929080,
		"lng": -77.38642621,
		"lat": 37.53715305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 1,
		"dd": 18,
		"by": 1904,
		"bd": 25,
		"bm": 10,
		"nm": "Jo",
		"nf": "Artie",
		"nl": "Lloyd",
		"url": "https://findagrave.com/memorial/143865729",
		"id": 143865729,
		"lng": -77.38596171,
		"lat": 37.53723021,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 6,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Lloyd",
		"url": "https://findagrave.com/memorial/176529368",
		"id": 176529368,
		"lng": -77.38801455,
		"lat": 37.53761883,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Lloyd",
		"url": "https://findagrave.com/memorial/144143928",
		"id": 144143928,
		"lng": -77.38595623,
		"lat": 37.53723987,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 12,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Locket",
		"url": "https://findagrave.com/memorial/188298789",
		"id": 188298789,
		"lng": -77.38794865,
		"lat": 37.53708652,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 12,
		"dd": 17,
		"by": 1904,
		"bd": 28,
		"bm": 10,
		"nm": "",
		"nf": "Edward",
		"nl": "Lockett",
		"url": "https://findagrave.com/memorial/138567137",
		"id": 138567137,
		"lng": -77.38650882,
		"lat": 37.53690928,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 10,
		"by": 1900,
		"bd": 4,
		"bm": 7,
		"nm": "",
		"nf": "William",
		"nl": "Lockhart",
		"url": "https://findagrave.com/memorial/178249246",
		"id": 178249246,
		"lng": -77.38759952,
		"lat": 37.53744395,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Lofton",
		"url": "https://findagrave.com/memorial/175585502",
		"id": 175585502,
		"lng": -77.38722261,
		"lat": 37.53654949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 1,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nellie",
		"nl": "Lofton",
		"url": "https://findagrave.com/memorial/175585515",
		"id": 175585515,
		"lng": -77.38698857,
		"lat": 37.53624852,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Logan",
		"url": "https://findagrave.com/memorial/145638853",
		"id": 145638853,
		"lng": -77.38632529,
		"lat": 37.53739023,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 12,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Lewis",
		"nl": "Lomax",
		"url": "https://findagrave.com/memorial/158626752",
		"id": 158626752,
		"lng": -77.38668121,
		"lat": 37.53570351,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 6,
		"dd": 1,
		"by": 1882,
		"bd": 31,
		"bm": 3,
		"nm": "",
		"nf": "Mary",
		"nl": "Lomax",
		"url": "https://findagrave.com/memorial/158924508",
		"id": 158924508,
		"lng": -77.38753339,
		"lat": 37.53757836,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 8,
		"dd": 5,
		"by": 1888,
		"bd": 7,
		"bm": 7,
		"nm": "H.",
		"nf": "Millard",
		"nl": "Lomax",
		"url": "https://findagrave.com/memorial/158924509",
		"id": 158924509,
		"lng": -77.38753697,
		"lat": 37.53757904,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 8,
		"dd": 18,
		"by": 1931,
		"bd": 17,
		"bm": 1,
		"nm": "",
		"nf": "Arlene",
		"nl": "Long",
		"url": "https://findagrave.com/memorial/181401042",
		"id": 181401042,
		"lng": -77.38623566,
		"lat": 37.53681037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 8,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Love",
		"url": "https://findagrave.com/memorial/114399874",
		"id": 114399874,
		"lng": -77.38571646,
		"lat": 37.53680456,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 4,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "William",
		"nl": "Loving",
		"url": "https://findagrave.com/memorial/171769798",
		"id": 171769798,
		"lng": -77.38720752,
		"lat": 37.53666997,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 11,
		"by": 1875,
		"bd": 1,
		"bm": 2,
		"nm": "",
		"nf": "Lillie",
		"nl": "Lovings",
		"url": "https://findagrave.com/memorial/149439667",
		"id": 149439667,
		"lng": -77.38617718,
		"lat": 37.5360055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 29,
		"by": 1902,
		"bd": 7,
		"bm": 3,
		"nm": "A.",
		"nf": "Leslie",
		"nl": "Lucas",
		"url": "https://findagrave.com/memorial/144143931",
		"id": 144143931,
		"lng": -77.38647925,
		"lat": 37.53743586,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 16,
		"by": 1889,
		"bd": 27,
		"bm": 11,
		"nm": "",
		"nf": "Martha",
		"nl": "Lucas",
		"url": "https://findagrave.com/memorial/179570202",
		"id": 179570202,
		"lng": -77.38794149,
		"lat": 37.53775442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 8,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matthew",
		"nl": "Lucas",
		"url": "https://findagrave.com/memorial/151108236",
		"id": 151108236,
		"lng": -77.3867193,
		"lat": 37.53565316,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 18,
		"by": 1906,
		"bd": 2,
		"bm": 2,
		"nm": "",
		"nf": "Fannie",
		"nl": "Lucky",
		"url": "https://findagrave.com/memorial/184477064",
		"id": 184477064,
		"lng": -77.38794512,
		"lat": 37.53697402,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 3,
		"dd": 9,
		"by": 1918,
		"bd": 6,
		"bm": 12,
		"nm": "Izear",
		"nf": "James",
		"nl": "Lyons",
		"url": "https://findagrave.com/memorial/150349046",
		"id": 150349046,
		"lng": -77.38571183,
		"lat": 37.53712464,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 21,
		"by": 1922,
		"bd": 5,
		"bm": 9,
		"nm": "",
		"nf": "Rosa",
		"nl": "Lyons",
		"url": "https://findagrave.com/memorial/154228754",
		"id": 154228754,
		"lng": -77.38634358,
		"lat": 37.53742563,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1984,
		"dm": 3,
		"dd": 3,
		"by": 1901,
		"bd": 4,
		"bm": 10,
		"nm": "",
		"nf": "Annie",
		"nl": "Mack",
		"url": "https://findagrave.com/memorial/153512997",
		"id": 153512997,
		"lng": -77.38670494,
		"lat": 37.53722455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 12,
		"by": 1885,
		"bd": 7,
		"bm": 6,
		"nm": "",
		"nf": "Bonnie",
		"nl": "Mack",
		"url": "https://findagrave.com/memorial/187366457",
		"id": 187366457,
		"lng": -77.38727343,
		"lat": 37.53728082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 10,
		"dd": 17,
		"by": 1899,
		"bd": 22,
		"bm": 1,
		"nm": "",
		"nf": "Flegg",
		"nl": "Mack",
		"url": "https://findagrave.com/memorial/141924953",
		"id": 141924953,
		"lng": -77.38670503,
		"lat": 37.53721331,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 1,
		"dd": 31,
		"by": 1904,
		"bd": 15,
		"bm": 5,
		"nm": "",
		"nf": "Livingston",
		"nl": "Mack",
		"url": "https://findagrave.com/memorial/160335435",
		"id": 160335435,
		"lng": -77.38608672,
		"lat": 37.53633252,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 14,
		"by": 1885,
		"bd": 30,
		"bm": 8,
		"nm": "",
		"nf": "Mollie",
		"nl": "Majors",
		"url": "https://findagrave.com/memorial/146019955",
		"id": 146019955,
		"lng": -77.38673795,
		"lat": 37.5357494,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 12,
		"dd": 14,
		"by": 1861,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Henry",
		"nl": "Mallory",
		"url": "https://findagrave.com/memorial/113626488",
		"id": 113626488,
		"lng": -77.38642901,
		"lat": 37.5365137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 3,
		"dd": 1,
		"by": 1897,
		"bd": 31,
		"bm": 1,
		"nm": "",
		"nf": "Henry",
		"nl": "Mallory",
		"url": "https://findagrave.com/memorial/138926465",
		"id": 138926465,
		"lng": -77.38642175,
		"lat": 37.53652992,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 11,
		"dd": 20,
		"by": 1898,
		"bd": 15,
		"bm": 6,
		"nm": "Bell",
		"nf": "Lula",
		"nl": "Mallory",
		"url": "https://findagrave.com/memorial/127881088",
		"id": 127881088,
		"lng": -77.38638273,
		"lat": 37.53652182,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 3,
		"dd": 14,
		"by": 1875,
		"bd": "",
		"bm": 4,
		"nm": "",
		"nf": "Lula",
		"nl": "Mallory",
		"url": "https://findagrave.com/memorial/127881085",
		"id": 127881085,
		"lng": -77.38638752,
		"lat": 37.53650345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 11,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Adolphus",
		"nl": "Malone",
		"url": "https://findagrave.com/memorial/135631994",
		"id": 135631994,
		"lng": -77.38609959,
		"lat": 37.53708016,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 4,
		"dd": 27,
		"by": 1925,
		"bd": 15,
		"bm": 6,
		"nm": "Alvin",
		"nf": "James",
		"nl": "Malone",
		"url": "https://findagrave.com/memorial/152794739",
		"id": 152794739,
		"lng": -77.38699264,
		"lat": 37.53744555,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "N.",
		"nf": "Charles",
		"nl": "Mangum",
		"url": "https://findagrave.com/memorial/153899323",
		"id": 153899323,
		"lng": -77.38653303,
		"lat": 37.53739475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 7,
		"dd": 6,
		"by": 1877,
		"bd": 15,
		"bm": 12,
		"nm": "Hiram",
		"nf": "James",
		"nl": "Mann",
		"url": "https://findagrave.com/memorial/156126621",
		"id": 156126621,
		"lng": -77.38599492,
		"lat": 37.53703389,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 8,
		"dd": 16,
		"by": 1918,
		"bd": 6,
		"bm": 6,
		"nm": "",
		"nf": "Roosevelt",
		"nl": "Manning",
		"url": "https://findagrave.com/memorial/154199631",
		"id": 154199631,
		"lng": -77.38633539,
		"lat": 37.53525876,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 8,
		"dd": 4,
		"by": 1880,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Lewis",
		"nl": "Manson",
		"url": "https://findagrave.com/memorial/157622958",
		"id": 157622958,
		"lng": -77.38674188,
		"lat": 37.53744845,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Roberta",
		"nl": "Manson",
		"url": "https://findagrave.com/memorial/175328218",
		"id": 175328218,
		"lng": -77.38741551,
		"lat": 37.53703942,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luvenia",
		"nl": "Marks",
		"url": "https://findagrave.com/memorial/147853440",
		"id": 147853440,
		"lng": -77.38636767,
		"lat": 37.53719237,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frank",
		"nl": "Marshall",
		"url": "https://findagrave.com/memorial/177153442",
		"id": 177153442,
		"lng": -77.38794907,
		"lat": 37.53704447,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 1,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hezekiah",
		"nl": "Marshall",
		"url": "https://findagrave.com/memorial/149696161",
		"id": 149696161,
		"lng": -77.38687089,
		"lat": 37.53669915,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Marshalle",
		"url": "https://findagrave.com/memorial/177768011",
		"id": 177768011,
		"lng": -77.38782925,
		"lat": 37.53758909,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Martin",
		"url": "https://findagrave.com/memorial/173793337",
		"id": 173793337,
		"lng": -77.38723555,
		"lat": 37.53728548,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 11,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/170100400",
		"id": 170100400,
		"lng": -77.38744241,
		"lat": 37.53679105,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 11,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Della",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/188104576",
		"id": 188104576,
		"lng": -77.38568655,
		"lat": 37.53694037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 7,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/155734904",
		"id": 155734904,
		"lng": -77.38726375,
		"lat": 37.53549294,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kirk",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/151459499",
		"id": 151459499,
		"lng": -77.38804708,
		"lat": 37.53730737,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 9,
		"dd": 3,
		"by": 1868,
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Walter",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/155735363",
		"id": 155735363,
		"lng": -77.38726036,
		"lat": 37.53550903,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "William",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/155731348",
		"id": 155731348,
		"lng": -77.38726544,
		"lat": 37.53549854,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 1,
		"dd": 15,
		"by": 1850,
		"bd": 1,
		"bm": 1,
		"nm": "A.",
		"nf": "William",
		"nl": "Mason",
		"url": "https://findagrave.com/memorial/172034068",
		"id": 172034068,
		"lng": -77.38717143,
		"lat": 37.53666325,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 6,
		"dd": 30,
		"by": 1907,
		"bd": 1,
		"bm": 11,
		"nm": "L.",
		"nf": "Lillian",
		"nl": "Massenberg",
		"url": "https://findagrave.com/memorial/170567287",
		"id": 170567287,
		"lng": -77.38596575,
		"lat": 37.53627048,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 2,
		"by": 1904,
		"bd": 25,
		"bm": 4,
		"nm": "John",
		"nf": "Renes",
		"nl": "Massey",
		"url": "https://findagrave.com/memorial/145085234",
		"id": 145085234,
		"lng": -77.38615505,
		"lat": 37.53732199,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 9,
		"dd": 20,
		"by": 1873,
		"bd": 9,
		"bm": 10,
		"nm": "",
		"nf": "Rosa",
		"nl": "Massey",
		"url": "https://findagrave.com/memorial/125408689",
		"id": 125408689,
		"lng": -77.38781084,
		"lat": 37.53641966,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 1,
		"dd": 16,
		"by": 1922,
		"bd": 23,
		"bm": 7,
		"nm": "H.",
		"nf": "Thomas",
		"nl": "Massie",
		"url": "https://findagrave.com/memorial/161179741",
		"id": 161179741,
		"lng": -77.38608557,
		"lat": 37.53631527,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 2,
		"dd": 5,
		"by": 1886,
		"bd": 16,
		"bm": 1,
		"nm": "",
		"nf": "Edward",
		"nl": "Mathews",
		"url": "https://findagrave.com/memorial/160981229",
		"id": 160981229,
		"lng": -77.38692157,
		"lat": 37.53699011,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 2,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Laura",
		"nl": "Matthew",
		"url": "https://findagrave.com/memorial/187366462",
		"id": 187366462,
		"lng": -77.38779436,
		"lat": 37.53711981,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 8,
		"dd": 11,
		"by": 1884,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Malachi",
		"nl": "Matthews",
		"url": "https://findagrave.com/memorial/155781968",
		"id": 155781968,
		"lng": -77.38722667,
		"lat": 37.53563706,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 10,
		"dd": 12,
		"by": 1887,
		"bd": 22,
		"bm": 1,
		"nm": "",
		"nf": "William",
		"nl": "Mayes",
		"url": "https://findagrave.com/memorial/130426346",
		"id": 130426346,
		"lng": -77.38579281,
		"lat": 37.53692911,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 13,
		"by": 1893,
		"bd": 27,
		"bm": 9,
		"nm": "",
		"nf": "Winston",
		"nl": "Maynard",
		"url": "https://findagrave.com/memorial/172041083",
		"id": 172041083,
		"lng": -77.38691682,
		"lat": 37.53723871,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 19,
		"by": 1892,
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Carrie",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/142221500",
		"id": 142221500,
		"lng": -77.38740556,
		"lat": 37.53793066,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Edward",
		"nf": "James",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/153410145",
		"id": 153410145,
		"lng": -77.38576951,
		"lat": 37.53685371,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 11,
		"dd": 25,
		"by": 1870,
		"bd": 4,
		"bm": 7,
		"nm": "R.",
		"nf": "Thaddeus",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/149201617",
		"id": 149201617,
		"lng": -77.3860182,
		"lat": 37.53608778,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 8,
		"dd": 23,
		"by": 1904,
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Ulrich",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/144820832",
		"id": 144820832,
		"lng": -77.38692937,
		"lat": 37.53666283,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 11,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Whitsell",
		"nf": "Willie",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/175449457",
		"id": 175449457,
		"lng": -77.38747229,
		"lat": 37.53702769,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Carrie",
		"nl": "McCain",
		"url": "https://findagrave.com/memorial/160277986",
		"id": 160277986,
		"lng": -77.3860444,
		"lat": 37.5363664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 10,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "McCall",
		"url": "https://findagrave.com/memorial/176228191",
		"id": 176228191,
		"lng": -77.3862803,
		"lat": 37.53752198,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 29,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "McCall",
		"url": "https://findagrave.com/memorial/161180424",
		"id": 161180424,
		"lng": -77.38720034,
		"lat": 37.53718016,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "McCargo",
		"url": "https://findagrave.com/memorial/173844919",
		"id": 173844919,
		"lng": -77.38757393,
		"lat": 37.53710879,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 12,
		"dd": 9,
		"by": 1867,
		"bd": 12,
		"bm": 6,
		"nm": "C.",
		"nf": "E.",
		"nl": "McCarmack",
		"url": "https://findagrave.com/memorial/138926508",
		"id": 138926508,
		"lng": -77.38633613,
		"lat": 37.53656543,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": "",
		"dd": "",
		"by": 1900,
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Mildred",
		"nl": "McClair",
		"url": "https://findagrave.com/memorial/188810629",
		"id": 188810629,
		"lng": -77.3880096,
		"lat": 37.53705465,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 5,
		"dd": 10,
		"by": 1925,
		"bd": 20,
		"bm": 2,
		"nm": "Roosevelt",
		"nf": "Theodore",
		"nl": "McClure",
		"url": "https://findagrave.com/memorial/130378945",
		"id": 130378945,
		"lng": -77.38659518,
		"lat": 37.53692789,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 11,
		"dd": 14,
		"by": 1916,
		"bd": 9,
		"bm": 4,
		"nm": "",
		"nf": "Laborn",
		"nl": "McCoy",
		"url": "https://findagrave.com/memorial/120726073",
		"id": 120726073,
		"lng": -77.38566633,
		"lat": 37.53689988,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Graves",
		"nf": "Bettie",
		"nl": "McCraw",
		"url": "https://findagrave.com/memorial/185151335",
		"id": 185151335,
		"lng": -77.38773094,
		"lat": 37.53650171,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 6,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Richard",
		"nl": "McCraw",
		"url": "https://findagrave.com/memorial/185151350",
		"id": 185151350,
		"lng": -77.3877333,
		"lat": 37.5364772,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Carrie",
		"nl": "McCullough",
		"url": "https://findagrave.com/memorial/157314046",
		"id": 157314046,
		"lng": -77.38663402,
		"lat": 37.53686372,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 17,
		"by": 1904,
		"bd": 17,
		"bm": 2,
		"nm": "",
		"nf": "James",
		"nl": "McDaniel",
		"url": "https://findagrave.com/memorial/144143936",
		"id": 144143936,
		"lng": -77.38625536,
		"lat": 37.53739726,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 11,
		"by": 1951,
		"bd": 8,
		"bm": 3,
		"nm": "",
		"nf": "James",
		"nl": "McDaniel",
		"url": "https://findagrave.com/memorial/142797051",
		"id": 142797051,
		"lng": -77.38604474,
		"lat": 37.53735988,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 5,
		"dd": 24,
		"by": 1919,
		"bd": 2,
		"bm": 5,
		"nm": "Elizabeth",
		"nf": "Mabel",
		"nl": "McDaniel",
		"url": "https://findagrave.com/memorial/172999604",
		"id": 172999604,
		"lng": -77.38697027,
		"lat": 37.53732588,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 14,
		"by": 1887,
		"bd": 21,
		"bm": 12,
		"nm": "",
		"nf": "Novella",
		"nl": "Mcginnis",
		"url": "https://findagrave.com/memorial/173793352",
		"id": 173793352,
		"lng": -77.3869619,
		"lat": 37.53729388,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 30,
		"by": 1954,
		"bd": 1,
		"bm": 5,
		"nm": "",
		"nf": "Manuel",
		"nl": "McGowan",
		"url": "https://findagrave.com/memorial/152412745",
		"id": 152412745,
		"lng": -77.38697393,
		"lat": 37.53737717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 9,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Thomas",
		"nl": "McGriff",
		"url": "https://findagrave.com/memorial/154509451",
		"id": 154509451,
		"lng": -77.38648071,
		"lat": 37.53570649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Fannie",
		"nl": "McKee",
		"url": "https://findagrave.com/memorial/145167328",
		"id": 145167328,
		"lng": -77.38629926,
		"lat": 37.53710234,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 10,
		"dd": 18,
		"by": 1879,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Esther",
		"nl": "McLane",
		"url": "https://findagrave.com/memorial/144370353",
		"id": 144370353,
		"lng": -77.38734846,
		"lat": 37.53784146,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 11,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "McLane",
		"url": "https://findagrave.com/memorial/155814937",
		"id": 155814937,
		"lng": -77.38747627,
		"lat": 37.53695129,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 25,
		"by": 1922,
		"bd": 5,
		"bm": 4,
		"nm": "Mae",
		"nf": "Cora",
		"nl": "McLaughlin",
		"url": "https://findagrave.com/memorial/184483109",
		"id": 184483109,
		"lng": -77.38718045,
		"lat": 37.53759478,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 6,
		"dd": 28,
		"by": 1931,
		"bd": 17,
		"bm": 11,
		"nm": "Delores Everett",
		"nf": "Lillian",
		"nl": "McLean",
		"url": "https://findagrave.com/memorial/125634297",
		"id": 125634297,
		"lng": -77.38612074,
		"lat": 37.5370708,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jannie",
		"nl": "McMillian",
		"url": "https://findagrave.com/memorial/189488573",
		"id": 189488573,
		"lng": -77.38789372,
		"lat": 37.53769156,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 12,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "McNair",
		"url": "https://findagrave.com/memorial/144370363",
		"id": 144370363,
		"lng": -77.38732543,
		"lat": 37.53781102,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Walter",
		"nl": "McNeir",
		"url": "https://findagrave.com/memorial/167182293",
		"id": 167182293,
		"lng": -77.38677756,
		"lat": 37.53682261,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "N.",
		"nf": "James",
		"nl": "McPherson",
		"url": "https://findagrave.com/memorial/139146901",
		"id": 139146901,
		"lng": -77.38785752,
		"lat": 37.53698466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 1,
		"dd": 27,
		"by": 1916,
		"bd": 27,
		"bm": 12,
		"nm": "Isabelle",
		"nf": "Nannie",
		"nl": "McPherson",
		"url": "https://findagrave.com/memorial/175328233",
		"id": 175328233,
		"lng": -77.3874014,
		"lat": 37.53704581,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 6,
		"dd": 12,
		"by": 1879,
		"bd": "",
		"bm": "",
		"nm": "Arthur",
		"nf": "Fred",
		"nl": "McRae",
		"url": "https://findagrave.com/memorial/155531201",
		"id": 155531201,
		"lng": -77.38752634,
		"lat": 37.53772724,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 22,
		"by": 1884,
		"bd": 25,
		"bm": 11,
		"nm": "G.",
		"nf": "Onie",
		"nl": "McRae",
		"url": "https://findagrave.com/memorial/161179745",
		"id": 161179745,
		"lng": -77.38653348,
		"lat": 37.53708179,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 10,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rufus",
		"nl": "McTeer",
		"url": "https://findagrave.com/memorial/135741641",
		"id": 135741641,
		"lng": -77.38599008,
		"lat": 37.53686315,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 1,
		"dd": 11,
		"by": 1916,
		"bd": 5,
		"bm": 1,
		"nm": "",
		"nf": "Juanita",
		"nl": "Meadows",
		"url": "https://findagrave.com/memorial/143632582",
		"id": 143632582,
		"lng": -77.38610709,
		"lat": 37.53573863,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 9,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Meadows",
		"url": "https://findagrave.com/memorial/187826465",
		"id": 187826465,
		"lng": -77.38794486,
		"lat": 37.53715741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 7,
		"dd": 31,
		"by": 1898,
		"bd": 4,
		"bm": 1,
		"nm": "",
		"nf": "Albert",
		"nl": "Mealy",
		"url": "https://findagrave.com/memorial/156480507",
		"id": 156480507,
		"lng": -77.38677515,
		"lat": 37.53585188,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 8,
		"dd": 5,
		"by": 1884,
		"bd": 2,
		"bm": 2,
		"nm": "",
		"nf": "Abraham",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/161000150",
		"id": 161000150,
		"lng": -77.38710073,
		"lat": 37.53699974,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 4,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/175421100",
		"id": 175421100,
		"lng": -77.38764894,
		"lat": 37.5371783,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 20,
		"by": 1889,
		"bd": 8,
		"bm": 6,
		"nm": "",
		"nf": "Armetter",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/160941090",
		"id": 160941090,
		"lng": -77.38710571,
		"lat": 37.53699017,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 11,
		"dd": 3,
		"by": 1903,
		"bd": 7,
		"bm": 11,
		"nm": "",
		"nf": "Leroy",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/161000414",
		"id": 161000414,
		"lng": -77.38709743,
		"lat": 37.53701072,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 7,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/167182302",
		"id": 167182302,
		"lng": -77.38656024,
		"lat": 37.53685057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 8,
		"by": 1949,
		"bd": 11,
		"bm": 12,
		"nm": "Garland",
		"nf": "William",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/192392034",
		"id": 192392034,
		"lng": -77.38741142,
		"lat": 37.53742063,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 2,
		"dd": 25,
		"by": 1924,
		"bd": 26,
		"bm": 7,
		"nm": "",
		"nf": "Amanda",
		"nl": "Meredith",
		"url": "https://findagrave.com/memorial/129211451",
		"id": 129211451,
		"lng": -77.38618518,
		"lat": 37.53676554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": "",
		"dd": "",
		"by": 1922,
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Edward",
		"nl": "Meredith",
		"url": "https://findagrave.com/memorial/144315689",
		"id": 144315689,
		"lng": -77.38617481,
		"lat": 37.5367632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1993,
		"dm": 1,
		"dd": 31,
		"by": 1905,
		"bd": 8,
		"bm": 6,
		"nm": "",
		"nf": "Grace",
		"nl": "Meredith",
		"url": "https://findagrave.com/memorial/148648726",
		"id": 148648726,
		"lng": -77.38616098,
		"lat": 37.5367917,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 10,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hezekiah",
		"nl": "Meredith",
		"url": "https://findagrave.com/memorial/141658079",
		"id": 141658079,
		"lng": -77.38606463,
		"lat": 37.53716274,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 3,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Meredith",
		"url": "https://findagrave.com/memorial/146772746",
		"id": 146772746,
		"lng": -77.38614579,
		"lat": 37.53578877,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 6,
		"by": 1857,
		"bd": 23,
		"bm": 2,
		"nm": "W.",
		"nf": "George",
		"nl": "Middleton",
		"url": "https://findagrave.com/memorial/169429852",
		"id": 169429852,
		"lng": -77.38769356,
		"lat": 37.53696426,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 18,
		"by": 1909,
		"bd": 11,
		"bm": 10,
		"nm": "",
		"nf": "Hazel",
		"nl": "Miles",
		"url": "https://findagrave.com/memorial/158450783",
		"id": 158450783,
		"lng": -77.38586928,
		"lat": 37.53741744,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 5,
		"by": 1945,
		"bd": 26,
		"bm": 6,
		"nm": "Anthony",
		"nf": "John",
		"nl": "Miles",
		"url": "https://findagrave.com/memorial/185715952",
		"id": 185715952,
		"lng": -77.38732892,
		"lat": 37.5374086,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 1,
		"by": 1906,
		"bd": 4,
		"bm": 8,
		"nm": "Cornelius",
		"nf": "Leslie",
		"nl": "Miles",
		"url": "https://findagrave.com/memorial/185717314",
		"id": 185717314,
		"lng": -77.38755323,
		"lat": 37.53772856,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Miles",
		"url": "https://findagrave.com/memorial/139146911",
		"id": 139146911,
		"lng": -77.38598301,
		"lat": 37.53657298,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 11,
		"dd": 23,
		"by": 1879,
		"bd": 10,
		"bm": 5,
		"nm": "Ann",
		"nf": "Mary",
		"nl": "Miles",
		"url": "https://findagrave.com/memorial/122027569",
		"id": 122027569,
		"lng": -77.38774764,
		"lat": 37.53694278,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 30,
		"by": 1865,
		"bd": 9,
		"bm": 3,
		"nm": "",
		"nf": "Peter",
		"nl": "Miles",
		"url": "https://findagrave.com/memorial/122027604",
		"id": 122027604,
		"lng": -77.38598345,
		"lat": 37.53657214,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 8,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/155757775",
		"id": 155757775,
		"lng": -77.38720054,
		"lat": 37.53563857,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 7,
		"dd": 29,
		"by": 1913,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Blanche",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/173071358",
		"id": 173071358,
		"lng": -77.38696251,
		"lat": 37.53734174,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 4,
		"dd": 5,
		"by": 1900,
		"bd": 5,
		"bm": 9,
		"nm": "E.",
		"nf": "Earl",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/144188900",
		"id": 144188900,
		"lng": -77.38727193,
		"lat": 37.53762236,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 5,
		"dd": 4,
		"by": 1890,
		"bd": 16,
		"bm": 6,
		"nm": "A.",
		"nf": "Elizabeth",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/140290919",
		"id": 140290919,
		"lng": -77.38616846,
		"lat": 37.53661207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 18,
		"by": 1895,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Elnora",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/155531210",
		"id": 155531210,
		"lng": -77.38647363,
		"lat": 37.53680961,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 9,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Hall",
		"nf": "Emmett",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/145344819",
		"id": 145344819,
		"lng": -77.38581452,
		"lat": 37.53704938,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 7,
		"dd": 10,
		"by": 1875,
		"bd": 17,
		"bm": 8,
		"nm": "Bartlett",
		"nf": "Leeanna",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/183195338",
		"id": 183195338,
		"lng": -77.38731155,
		"lat": 37.53707746,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louisa",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/157242637",
		"id": 157242637,
		"lng": -77.38668628,
		"lat": 37.53581373,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H",
		"nf": "Mary",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/144370459",
		"id": 144370459,
		"lng": -77.38613768,
		"lat": 37.53738436,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Mary",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/159663329",
		"id": 159663329,
		"lng": -77.38591587,
		"lat": 37.53741432,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 9,
		"dd": 1,
		"by": 1874,
		"bd": 1,
		"bm": 7,
		"nm": "E.",
		"nf": "William",
		"nl": "Miller",
		"url": "https://findagrave.com/memorial/155760652",
		"id": 155760652,
		"lng": -77.3875721,
		"lat": 37.53701653,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 10,
		"dd": 10,
		"by": 1917,
		"bd": 1,
		"bm": 4,
		"nm": "",
		"nf": "Mary",
		"nl": "Mills",
		"url": "https://findagrave.com/memorial/173314388",
		"id": 173314388,
		"lng": -77.38699984,
		"lat": 37.53712081,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 9,
		"dd": 26,
		"by": 1963,
		"bd": 16,
		"bm": 7,
		"nm": "R.",
		"nf": "John",
		"nl": "Milton",
		"url": "https://findagrave.com/memorial/159414605",
		"id": 159414605,
		"lng": -77.38608632,
		"lat": 37.53746889,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 9,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby boy",
		"nl": "Minn",
		"url": "https://findagrave.com/memorial/144143940",
		"id": 144143940,
		"lng": -77.38588194,
		"lat": 37.53738771,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 5,
		"dd": 19,
		"by": 1895,
		"bd": 4,
		"bm": 7,
		"nm": "",
		"nf": "Joseph",
		"nl": "Minor",
		"url": "https://findagrave.com/memorial/145344914",
		"id": 145344914,
		"lng": -77.38556221,
		"lat": 37.53730556,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 9,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louise",
		"nl": "Minor",
		"url": "https://findagrave.com/memorial/142468283",
		"id": 142468283,
		"lng": -77.38739546,
		"lat": 37.53783311,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Minor",
		"url": "https://findagrave.com/memorial/146019963",
		"id": 146019963,
		"lng": -77.38648514,
		"lat": 37.53664811,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 8,
		"by": 1905,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Marjorie",
		"nl": "Minor",
		"url": "https://findagrave.com/memorial/146386369",
		"id": 146386369,
		"lng": -77.38633636,
		"lat": 37.5371743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ally",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/173847870",
		"id": 173847870,
		"lng": -77.38737462,
		"lat": 37.53715441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 28,
		"by": 1898,
		"bd": 10,
		"bm": 4,
		"nm": "",
		"nf": "James",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/184276788",
		"id": 184276788,
		"lng": -77.38763154,
		"lat": 37.53741746,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 7,
		"dd": 29,
		"by": 1870,
		"bd": 29,
		"bm": 5,
		"nm": "M.",
		"nf": "Kate",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/127569722",
		"id": 127569722,
		"lng": -77.38620197,
		"lat": 37.53640422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 8,
		"dd": 17,
		"by": 1900,
		"bd": 14,
		"bm": 2,
		"nm": "",
		"nf": "Louise",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/185357159",
		"id": 185357159,
		"lng": -77.3873748,
		"lat": 37.53680822,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 17,
		"by": 1917,
		"bd": 23,
		"bm": 5,
		"nm": "Robinson",
		"nf": "Mary",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/144143943",
		"id": 144143943,
		"lng": -77.38619681,
		"lat": 37.53731124,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 9,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mercia",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/125408697",
		"id": 125408697,
		"lng": -77.38769418,
		"lat": 37.53664958,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 9,
		"dd": 3,
		"by": 1889,
		"bd": 31,
		"bm": 3,
		"nm": "P.",
		"nf": "Rosa",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/143632588",
		"id": 143632588,
		"lng": -77.38606702,
		"lat": 37.53599719,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 19,
		"by": 1888,
		"bd": 24,
		"bm": 1,
		"nm": "H.",
		"nf": "Thomas",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/143696157",
		"id": 143696157,
		"lng": -77.38603221,
		"lat": 37.53601043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 11,
		"dd": 13,
		"by": 1856,
		"bd": 26,
		"bm": 2,
		"nm": "A.",
		"nf": "William",
		"nl": "Mitchell",
		"url": "https://findagrave.com/memorial/127131723",
		"id": 127131723,
		"lng": -77.38620367,
		"lat": 37.53640621,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 6,
		"dd": 27,
		"by": 1940,
		"bd": 2,
		"bm": 3,
		"nm": "E.",
		"nf": "Charles",
		"nl": "Mixon",
		"url": "https://findagrave.com/memorial/185958415",
		"id": 185958415,
		"lng": -77.38636146,
		"lat": 37.53593431,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 11,
		"dd": 10,
		"by": 1897,
		"bd": 31,
		"bm": 5,
		"nm": "C.",
		"nf": "Arthur",
		"nl": "Monday",
		"url": "https://findagrave.com/memorial/151266857",
		"id": 151266857,
		"lng": -77.38700012,
		"lat": 37.53693676,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 10,
		"by": 1892,
		"bd": 2,
		"bm": 8,
		"nm": "",
		"nf": "Herbert",
		"nl": "Monroe",
		"url": "https://findagrave.com/memorial/182320457",
		"id": 182320457,
		"lng": -77.38675735,
		"lat": 37.53771569,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 12,
		"dd": 28,
		"by": 1884,
		"bd": 30,
		"bm": 11,
		"nm": "William",
		"nf": "Robert",
		"nl": "Monteeth",
		"url": "https://findagrave.com/memorial/125820934",
		"id": 125820934,
		"lng": -77.3859325,
		"lat": 37.53732167,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 5,
		"dd": 27,
		"by": 1890,
		"bd": 28,
		"bm": 12,
		"nm": "",
		"nf": "Arthur",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/141446487",
		"id": 141446487,
		"lng": -77.38724012,
		"lat": 37.53769944,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Celia",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/186921406",
		"id": 186921406,
		"lng": -77.3873641,
		"lat": 37.53692519,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Clarence",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/155123812",
		"id": 155123812,
		"lng": -77.38666084,
		"lat": 37.53712101,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 12,
		"dd": 6,
		"by": 1924,
		"bd": 22,
		"bm": 4,
		"nm": "",
		"nf": "Clifton",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/157314396",
		"id": 157314396,
		"lng": -77.38670693,
		"lat": 37.53691134,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 25,
		"by": 1963,
		"bd": 28,
		"bm": 12,
		"nm": "",
		"nf": "Kelvin",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/144558536",
		"id": 144558536,
		"lng": -77.38616049,
		"lat": 37.53743727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 3,
		"by": 1907,
		"bd": 5,
		"bm": 10,
		"nm": "L.",
		"nf": "Lloyd",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/182115900",
		"id": 182115900,
		"lng": -77.38692176,
		"lat": 37.53754933,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 4,
		"by": 1895,
		"bd": 11,
		"bm": 8,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/145596017",
		"id": 145596017,
		"lng": -77.38617867,
		"lat": 37.5374306,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mattie",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/177617285",
		"id": 177617285,
		"lng": -77.38655394,
		"lat": 37.53743503,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 1,
		"by": 1906,
		"bd": 31,
		"bm": 5,
		"nm": "",
		"nf": "Mozelle",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/177285391",
		"id": 177285391,
		"lng": -77.38720658,
		"lat": 37.53734869,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 11,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/175409028",
		"id": 175409028,
		"lng": -77.38760462,
		"lat": 37.53719243,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 2,
		"dd": 15,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sallie",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/137430824",
		"id": 137430824,
		"lng": -77.38595724,
		"lat": 37.53710966,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 12,
		"dd": 8,
		"by": 1904,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Frank",
		"nl": "Moran",
		"url": "https://findagrave.com/memorial/153513004",
		"id": 153513004,
		"lng": -77.38679392,
		"lat": 37.53726313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1981,
		"dm": 4,
		"dd": 27,
		"by": 1906,
		"bd": 12,
		"bm": 11,
		"nm": "",
		"nf": "Loretta",
		"nl": "Moran",
		"url": "https://findagrave.com/memorial/153513014",
		"id": 153513014,
		"lng": -77.38679206,
		"lat": 37.53726729,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 3,
		"dd": 7,
		"by": 1926,
		"bd": 18,
		"bm": 7,
		"nm": "C.",
		"nf": "Ruby",
		"nl": "Moran",
		"url": "https://findagrave.com/memorial/171769813",
		"id": 171769813,
		"lng": -77.38681571,
		"lat": 37.53726794,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 10,
		"dd": 16,
		"by": 1904,
		"bd": 12,
		"bm": 3,
		"nm": "S.",
		"nf": "Nellie",
		"nl": "Mordecai",
		"url": "https://findagrave.com/memorial/140624981",
		"id": 140624981,
		"lng": -77.38798799,
		"lat": 37.53756827,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 11,
		"dd": 16,
		"by": 1899,
		"bd": 28,
		"bm": 2,
		"nm": "Wallace",
		"nf": "Paul",
		"nl": "Mordecai",
		"url": "https://findagrave.com/memorial/125634436",
		"id": 125634436,
		"lng": -77.3879975,
		"lat": 37.53755206,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eliza",
		"nl": "Morgan",
		"url": "https://findagrave.com/memorial/173515352",
		"id": 173515352,
		"lng": -77.38745479,
		"lat": 37.53712529,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 11,
		"dd": 14,
		"by": 1889,
		"bd": 18,
		"bm": 9,
		"nm": "",
		"nf": "Eva",
		"nl": "Morgan",
		"url": "https://findagrave.com/memorial/162642856",
		"id": 162642856,
		"lng": -77.38716499,
		"lat": 37.53707313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 11,
		"dd": 14,
		"by": 1878,
		"bd": 8,
		"bm": 5,
		"nm": "J.",
		"nf": "Mamie",
		"nl": "Morgan",
		"url": "https://findagrave.com/memorial/154296522",
		"id": 154296522,
		"lng": -77.38704404,
		"lat": 37.53551195,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 9,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby boy",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/163925086",
		"id": 163925086,
		"lng": -77.38671445,
		"lat": 37.53681732,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 4,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emma",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/119328039",
		"id": 119328039,
		"lng": -77.3854978,
		"lat": 37.53735719,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 6,
		"dd": 14,
		"by": 1849,
		"bd": "",
		"bm": 8,
		"nm": "H.",
		"nf": "George",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/132641404",
		"id": 132641404,
		"lng": -77.38778866,
		"lat": 37.53632194,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 11,
		"dd": 20,
		"by": 1851,
		"bd": "",
		"bm": 5,
		"nm": "Ann",
		"nf": "Julia",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/132641407",
		"id": 132641407,
		"lng": -77.38778619,
		"lat": 37.53633057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 9,
		"dd": 28,
		"by": 1888,
		"bd": 6,
		"bm": 7,
		"nm": "Belle",
		"nf": "Juliet",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/134474433",
		"id": 134474433,
		"lng": -77.38748208,
		"lat": 37.53652773,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 11,
		"dd": 6,
		"by": 1874,
		"bd": 15,
		"bm": 2,
		"nm": "D.",
		"nf": "Mabel",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/127569729",
		"id": 127569729,
		"lng": -77.38779109,
		"lat": 37.53631507,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 10,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/134474442",
		"id": 134474442,
		"lng": -77.38749347,
		"lat": 37.53651972,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/141194136",
		"id": 141194136,
		"lng": -77.38628259,
		"lat": 37.53666388,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 23,
		"by": 1886,
		"bd": 19,
		"bm": 10,
		"nm": "",
		"nf": "Mildred",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/173793356",
		"id": 173793356,
		"lng": -77.38717139,
		"lat": 37.53718419,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 6,
		"dd": 20,
		"by": 1895,
		"bd": 3,
		"bm": 11,
		"nm": "",
		"nf": "Priscilla",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/155989124",
		"id": 155989124,
		"lng": -77.38695516,
		"lat": 37.53554116,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1904,
		"dm": 1,
		"dd": 10,
		"by": 1878,
		"bd": 12,
		"bm": 8,
		"nm": "G.",
		"nf": "Sumner",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/132764929",
		"id": 132764929,
		"lng": -77.38777792,
		"lat": 37.5363499,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 8,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Walter",
		"nl": "Morris",
		"url": "https://findagrave.com/memorial/177545580",
		"id": 177545580,
		"lng": -77.38695583,
		"lat": 37.53553537,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 1,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucinda",
		"nl": "Morrison",
		"url": "https://findagrave.com/memorial/181401052",
		"id": 181401052,
		"lng": -77.38802982,
		"lat": 37.53768598,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 26,
		"by": 1953,
		"bd": 29,
		"bm": 11,
		"nm": "",
		"nf": "Daniel",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/155270316",
		"id": 155270316,
		"lng": -77.38703789,
		"lat": 37.53783573,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 9,
		"dd": 1,
		"by": 1904,
		"bd": 5,
		"bm": 5,
		"nm": "",
		"nf": "Estelle",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/185658256",
		"id": 185658256,
		"lng": -77.38723342,
		"lat": 37.53775597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 10,
		"dd": 11,
		"by": 1916,
		"bd": 27,
		"bm": 3,
		"nm": "Leroy",
		"nf": "Horace",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/183863701",
		"id": 183863701,
		"lng": -77.38738488,
		"lat": 37.5369789,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 6,
		"by": 1894,
		"bd": 3,
		"bm": 4,
		"nm": "Agnes",
		"nf": "Mary",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/163925087",
		"id": 163925087,
		"lng": -77.38682697,
		"lat": 37.53682874,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Patricia",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/153381658",
		"id": 153381658,
		"lng": -77.3861195,
		"lat": 37.53745937,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 1,
		"dd": 8,
		"by": 1891,
		"bd": 31,
		"bm": 5,
		"nm": "",
		"nf": "Shadrack",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/161096787",
		"id": 161096787,
		"lng": -77.38715068,
		"lat": 37.53709447,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 5,
		"dd": 30,
		"by": 1881,
		"bd": 9,
		"bm": 6,
		"nm": "",
		"nf": "Tinker",
		"nl": "Morton",
		"url": "https://findagrave.com/memorial/163951039",
		"id": 163951039,
		"lng": -77.38755845,
		"lat": 37.5374681,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 12,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mamie",
		"nl": "Mosby",
		"url": "https://findagrave.com/memorial/156480514",
		"id": 156480514,
		"lng": -77.38629959,
		"lat": 37.53588115,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 2,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nancy",
		"nl": "Mosby",
		"url": "https://findagrave.com/memorial/156632733",
		"id": 156632733,
		"lng": -77.38778929,
		"lat": 37.53718226,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 1,
		"dd": 18,
		"by": 1934,
		"bd": 4,
		"bm": 6,
		"nm": "",
		"nf": "Robert",
		"nl": "Mosby",
		"url": "https://findagrave.com/memorial/152369058",
		"id": 152369058,
		"lng": -77.38647411,
		"lat": 37.5373854,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 9,
		"dd": 25,
		"by": 1963,
		"bd": 20,
		"bm": 9,
		"nm": "",
		"nf": "baby girl",
		"nl": "Moses",
		"url": "https://findagrave.com/memorial/191503847",
		"id": 191503847,
		"lng": -77.38606893,
		"lat": 37.53749837,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 12,
		"dd": 24,
		"by": 1897,
		"bd": 10,
		"bm": 3,
		"nm": "",
		"nf": "Robert",
		"nl": "Moses",
		"url": "https://findagrave.com/memorial/181401058",
		"id": 181401058,
		"lng": -77.38800435,
		"lat": 37.5374366,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Marie",
		"nl": "Mosley",
		"url": "https://findagrave.com/memorial/141194177",
		"id": 141194177,
		"lng": -77.38626285,
		"lat": 37.53669247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 4,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Albert",
		"nl": "Moss",
		"url": "https://findagrave.com/memorial/185154030",
		"id": 185154030,
		"lng": -77.38696137,
		"lat": 37.53767785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 4,
		"by": 1931,
		"bd": 1,
		"bm": 8,
		"nm": "Evelyn",
		"nf": "Mable",
		"nl": "Moss",
		"url": "https://findagrave.com/memorial/177279588",
		"id": 177279588,
		"lng": -77.38751606,
		"lat": 37.5372898,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 20,
		"by": 1896,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Will",
		"nl": "Moss",
		"url": "https://findagrave.com/memorial/154037219",
		"id": 154037219,
		"lng": -77.38646199,
		"lat": 37.53715324,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 2,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Motley",
		"url": "https://findagrave.com/memorial/151461410",
		"id": 151461410,
		"lng": -77.38811193,
		"lat": 37.53739568,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jack",
		"nl": "Motley",
		"url": "https://findagrave.com/memorial/120726113",
		"id": 120726113,
		"lng": -77.38579672,
		"lat": 37.53691162,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 2,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nannie",
		"nl": "Motley",
		"url": "https://findagrave.com/memorial/120726132",
		"id": 120726132,
		"lng": -77.38577221,
		"lat": 37.53692156,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 4,
		"dd": 5,
		"by": 1873,
		"bd": 17,
		"bm": 5,
		"nm": "C.",
		"nf": "Atticus",
		"nl": "Moyler",
		"url": "https://findagrave.com/memorial/174616597",
		"id": 174616597,
		"lng": -77.38745455,
		"lat": 37.53701435,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 12,
		"dd": 12,
		"by": 1873,
		"bd": 9,
		"bm": 4,
		"nm": "E.",
		"nf": "Sarah",
		"nl": "Moyler",
		"url": "https://findagrave.com/memorial/174616583",
		"id": 174616583,
		"lng": -77.38745251,
		"lat": 37.53702203,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Mozell",
		"url": "https://findagrave.com/memorial/173314399",
		"id": 173314399,
		"lng": -77.38700654,
		"lat": 37.53718422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 7,
		"dd": 8,
		"by": 1877,
		"bd": "",
		"bm": 10,
		"nm": "Estelle",
		"nf": "Eva",
		"nl": "Mundin",
		"url": "https://findagrave.com/memorial/127881091",
		"id": 127881091,
		"lng": -77.38644044,
		"lat": 37.53654305,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 30,
		"by": 1879,
		"bd": 24,
		"bm": 6,
		"nm": "Goode",
		"nf": "Lillie",
		"nl": "Mundin",
		"url": "https://findagrave.com/memorial/157757359",
		"id": 157757359,
		"lng": -77.38561761,
		"lat": 37.53736421,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Murphy",
		"url": "https://findagrave.com/memorial/187601082",
		"id": 187601082,
		"lng": -77.38756878,
		"lat": 37.5368166,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nancy",
		"nl": "Murray",
		"url": "https://findagrave.com/memorial/145596006",
		"id": 145596006,
		"lng": -77.38608573,
		"lat": 37.53738437,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 30,
		"by": 1906,
		"bd": 19,
		"bm": 8,
		"nm": "",
		"nf": "Mayme",
		"nl": "Myers",
		"url": "https://findagrave.com/memorial/127483522",
		"id": 127483522,
		"lng": -77.3858422,
		"lat": 37.53652542,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 9,
		"dd": 7,
		"by": 1913,
		"bd": 13,
		"bm": 10,
		"nm": "Harold",
		"nf": "Walter",
		"nl": "Myers",
		"url": "https://findagrave.com/memorial/149439672",
		"id": 149439672,
		"lng": -77.38648322,
		"lat": 37.53547352,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 3,
		"dd": 15,
		"by": 1893,
		"bd": 3,
		"bm": 4,
		"nm": "Alexander",
		"nf": "Junius",
		"nl": "Nash",
		"url": "https://findagrave.com/memorial/132641409",
		"id": 132641409,
		"lng": -77.38573848,
		"lat": 37.53728587,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 4,
		"by": 1874,
		"bd": 15,
		"bm": 8,
		"nm": "Ann",
		"nf": "Sallie",
		"nl": "Nash",
		"url": "https://findagrave.com/memorial/132641415",
		"id": 132641415,
		"lng": -77.38574319,
		"lat": 37.53727692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 12,
		"dd": 4,
		"by": 1886,
		"bd": 20,
		"bm": 7,
		"nm": "G.",
		"nf": "Estelle",
		"nl": "Neal",
		"url": "https://findagrave.com/memorial/144370595",
		"id": 144370595,
		"lng": -77.38611038,
		"lat": 37.53731986,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 22,
		"by": 1882,
		"bd": 3,
		"bm": 4,
		"nm": "",
		"nf": "Joshua",
		"nl": "Neal",
		"url": "https://findagrave.com/memorial/169478114",
		"id": 169478114,
		"lng": -77.3877485,
		"lat": 37.53710763,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 7,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Neale",
		"url": "https://findagrave.com/memorial/154296533",
		"id": 154296533,
		"lng": -77.38706425,
		"lat": 37.53547902,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 2,
		"dd": 12,
		"by": 1909,
		"bd": 29,
		"bm": 5,
		"nm": "C.",
		"nf": "Beatrice",
		"nl": "Nelson",
		"url": "https://findagrave.com/memorial/142526963",
		"id": 142526963,
		"lng": -77.38594233,
		"lat": 37.53736739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 1,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lizzie",
		"nl": "Nelson",
		"url": "https://findagrave.com/memorial/173481228",
		"id": 173481228,
		"lng": -77.3873419,
		"lat": 37.53710563,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Nelson",
		"url": "https://findagrave.com/memorial/175616247",
		"id": 175616247,
		"lng": -77.38802391,
		"lat": 37.5372012,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 1,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Nelson",
		"url": "https://findagrave.com/memorial/126772051",
		"id": 126772051,
		"lng": -77.38776928,
		"lat": 37.53719975,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 7,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Vesta",
		"nl": "Nelson",
		"url": "https://findagrave.com/memorial/185741796",
		"id": 185741796,
		"lng": -77.38776392,
		"lat": 37.53697106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Willie",
		"nl": "Nelson",
		"url": "https://findagrave.com/memorial/147853444",
		"id": 147853444,
		"lng": -77.38635299,
		"lat": 37.53713786,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 9,
		"dd": "",
		"by": 1954,
		"bd": 10,
		"bm": 5,
		"nm": "Leon",
		"nf": "Albert",
		"nl": "Nero",
		"url": "https://findagrave.com/memorial/180686578",
		"id": 180686578,
		"lng": -77.38620188,
		"lat": 37.53544991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 7,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Wayne",
		"nl": "Nero",
		"url": "https://findagrave.com/memorial/142526977",
		"id": 142526977,
		"lng": -77.38585136,
		"lat": 37.5374608,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 9,
		"dd": 27,
		"by": 1880,
		"bd": 16,
		"bm": 6,
		"nm": "",
		"nf": "James",
		"nl": "Newsome",
		"url": "https://findagrave.com/memorial/182088432",
		"id": 182088432,
		"lng": -77.38664507,
		"lat": 37.537647,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "William",
		"nl": "Newton",
		"url": "https://findagrave.com/memorial/145344921",
		"id": 145344921,
		"lng": -77.38555214,
		"lat": 37.53733739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 2,
		"dd": 25,
		"by": 1929,
		"bd": 16,
		"bm": 5,
		"nm": "Elizabeth",
		"nf": "Gloria",
		"nl": "Nichols",
		"url": "https://findagrave.com/memorial/153627892",
		"id": 153627892,
		"lng": -77.38668641,
		"lat": 37.53742695,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 3,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Beula",
		"nl": "Noble",
		"url": "https://findagrave.com/memorial/151888670",
		"id": 151888670,
		"lng": -77.38662765,
		"lat": 37.53572652,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 9,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Noble",
		"url": "https://findagrave.com/memorial/185647527",
		"id": 185647527,
		"lng": -77.38749406,
		"lat": 37.53690387,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1867,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Ellen",
		"nl": "Norris",
		"url": "https://findagrave.com/memorial/150792681",
		"id": 150792681,
		"lng": -77.38643795,
		"lat": 37.53558484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Martha",
		"nl": "Nunnally",
		"url": "https://findagrave.com/memorial/130538968",
		"id": 130538968,
		"lng": -77.38638764,
		"lat": 37.53690279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 6,
		"by": 1901,
		"bd": 12,
		"bm": 2,
		"nm": "",
		"nf": "Lurie",
		"nl": "Ogburn",
		"url": "https://findagrave.com/memorial/172999368",
		"id": 172999368,
		"lng": -77.38702055,
		"lat": 37.53729635,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1872,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Catherine",
		"nl": "Oliver",
		"url": "https://findagrave.com/memorial/125837279",
		"id": 125837279,
		"lng": -77.38783797,
		"lat": 37.53627519,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1870,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "John",
		"nl": "Oliver",
		"url": "https://findagrave.com/memorial/125837266",
		"id": 125837266,
		"lng": -77.3878383,
		"lat": 37.53627393,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 1,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lynell",
		"nl": "Oliver",
		"url": "https://findagrave.com/memorial/144013907",
		"id": 144013907,
		"lng": -77.38740749,
		"lat": 37.53766219,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1840,
		"bd": "",
		"bm": 5,
		"nm": "Jane",
		"nf": "Mary",
		"nl": "Oliver",
		"url": "https://findagrave.com/memorial/125837246",
		"id": 125837246,
		"lng": -77.38783863,
		"lat": 37.53627266,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 23,
		"by": 1926,
		"bd": 9,
		"bm": 6,
		"nm": "",
		"nf": "Saunders",
		"nl": "Oliver",
		"url": "https://findagrave.com/memorial/155733899",
		"id": 155733899,
		"lng": -77.38641037,
		"lat": 37.53708404,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 4,
		"dd": 21,
		"by": 1879,
		"bd": 20,
		"bm": 6,
		"nm": "Thomas",
		"nf": "James",
		"nl": "Onley",
		"url": "https://findagrave.com/memorial/160940652",
		"id": 160940652,
		"lng": -77.38691021,
		"lat": 37.53697652,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 21,
		"by": 1891,
		"bd": 23,
		"bm": 10,
		"nm": "",
		"nf": "Matilda",
		"nl": "Onley",
		"url": "https://findagrave.com/memorial/154509740",
		"id": 154509740,
		"lng": -77.38636281,
		"lat": 37.537363,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 27,
		"by": 1890,
		"bd": 30,
		"bm": 11,
		"nm": "B.",
		"nf": "Fannie",
		"nl": "Osborne",
		"url": "https://findagrave.com/memorial/117804405",
		"id": 117804405,
		"lng": -77.38570276,
		"lat": 37.53712867,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 4,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "John",
		"nl": "Osborne",
		"url": "https://findagrave.com/memorial/169429985",
		"id": 169429985,
		"lng": -77.38772545,
		"lat": 37.53709078,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Jesse",
		"nl": "Outlaw",
		"url": "https://findagrave.com/memorial/138181482",
		"id": 138181482,
		"lng": -77.38623259,
		"lat": 37.53711561,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 4,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Terri",
		"nl": "Overby",
		"url": "https://findagrave.com/memorial/144143948",
		"id": 144143948,
		"lng": -77.38614045,
		"lat": 37.53726705,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 19,
		"by": 1967,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "Joseph",
		"nl": "Overton",
		"url": "https://findagrave.com/memorial/142468833",
		"id": 142468833,
		"lng": -77.38593935,
		"lat": 37.53743253,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": "",
		"dd": "",
		"by": 1936,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Owens",
		"url": "https://findagrave.com/memorial/185958418",
		"id": 185958418,
		"lng": -77.38637364,
		"lat": 37.53597609,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 9,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jasper",
		"nl": "Owens",
		"url": "https://findagrave.com/memorial/188269170",
		"id": 188269170,
		"lng": -77.38789238,
		"lat": 37.53721535,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 3,
		"by": 1910,
		"bd": 10,
		"bm": 8,
		"nm": "Jake",
		"nf": "Raymond",
		"nl": "Owens",
		"url": "https://findagrave.com/memorial/177469033",
		"id": 177469033,
		"lng": -77.38761451,
		"lat": 37.53749296,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 9,
		"dd": 3,
		"by": 1890,
		"bd": 23,
		"bm": 8,
		"nm": "",
		"nf": "David",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/136306512",
		"id": 136306512,
		"lng": -77.38602618,
		"lat": 37.53699112,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 12,
		"dd": 17,
		"by": 1859,
		"bd": 28,
		"bm": 8,
		"nm": "",
		"nf": "David",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/136306506",
		"id": 136306506,
		"lng": -77.38602136,
		"lat": 37.53699773,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 6,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Edgar",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/151460736",
		"id": 151460736,
		"lng": -77.38801723,
		"lat": 37.53730465,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 8,
		"dd": 29,
		"by": 1865,
		"bd": 14,
		"bm": 3,
		"nm": "",
		"nf": "Florence",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/136306518",
		"id": 136306518,
		"lng": -77.38601696,
		"lat": 37.53700471,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 4,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Harriet",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/154296540",
		"id": 154296540,
		"lng": -77.38710384,
		"lat": 37.5354826,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 1,
		"dd": 18,
		"by": 1852,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Jeremiah",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/76605000",
		"id": 76605000,
		"lng": -77.38546118,
		"lat": 37.53732697,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 2,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "John",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/150035858",
		"id": 150035858,
		"lng": -77.38641645,
		"lat": 37.535674,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 10,
		"dd": 9,
		"by": 1898,
		"bd": 31,
		"bm": 8,
		"nm": "R.",
		"nf": "Josephine",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/136306527",
		"id": 136306527,
		"lng": -77.38596247,
		"lat": 37.53698914,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 1,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Lawson",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/144316145",
		"id": 144316145,
		"lng": -77.38710378,
		"lat": 37.53547299,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 5,
		"dd": 4,
		"by": 1877,
		"bd": 11,
		"bm": 8,
		"nm": "Oliver",
		"nf": "Thomas",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/142470557",
		"id": 142470557,
		"lng": -77.3855042,
		"lat": 37.53730434,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 27,
		"by": 1917,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Vernetta",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/173314405",
		"id": 173314405,
		"lng": -77.38710073,
		"lat": 37.53733028,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/177026470",
		"id": 177026470,
		"lng": -77.38801009,
		"lat": 37.53722719,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 3,
		"dd": 25,
		"by": 1888,
		"bd": 22,
		"bm": 2,
		"nm": "A.",
		"nf": "William",
		"nl": "Page",
		"url": "https://findagrave.com/memorial/125520683",
		"id": 125520683,
		"lng": -77.3859651,
		"lat": 37.53697602,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 10,
		"dd": 19,
		"by": 1926,
		"bd": 6,
		"bm": 1,
		"nm": "",
		"nf": "Leo",
		"nl": "Pair",
		"url": "https://findagrave.com/memorial/142531401",
		"id": 142531401,
		"lng": -77.38647257,
		"lat": 37.53531904,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 6,
		"dd": 13,
		"by": 1889,
		"bd": "",
		"bm": 10,
		"nm": "",
		"nf": "Henrietta",
		"nl": "Parham",
		"url": "https://findagrave.com/memorial/130538976",
		"id": 130538976,
		"lng": -77.38639355,
		"lat": 37.53688699,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 8,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "William",
		"nf": "James",
		"nl": "Parham",
		"url": "https://findagrave.com/memorial/155290614",
		"id": 155290614,
		"lng": -77.38662146,
		"lat": 37.53559875,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 12,
		"dd": 2,
		"by": 1865,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "John",
		"nl": "Parham",
		"url": "https://findagrave.com/memorial/130538981",
		"id": 130538981,
		"lng": -77.3863974,
		"lat": 37.53687921,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 6,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Parham",
		"url": "https://findagrave.com/memorial/130538988",
		"id": 130538988,
		"lng": -77.38639131,
		"lat": 37.53689525,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 26,
		"by": 1898,
		"bd": 21,
		"bm": 12,
		"nm": "P.",
		"nf": "Mozell",
		"nl": "Parham",
		"url": "https://findagrave.com/memorial/144188906",
		"id": 144188906,
		"lng": -77.38620984,
		"lat": 37.53734459,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Parham",
		"url": "https://findagrave.com/memorial/187366463",
		"id": 187366463,
		"lng": -77.38805304,
		"lat": 37.53769213,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Andrew",
		"nl": "Parker",
		"url": "https://findagrave.com/memorial/140624997",
		"id": 140624997,
		"lng": -77.3868336,
		"lat": 37.53544022,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 11,
		"dd": 28,
		"by": 1845,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Andrew",
		"nl": "Parker",
		"url": "https://findagrave.com/memorial/152167172",
		"id": 152167172,
		"lng": -77.38616607,
		"lat": 37.53554005,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 2,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Julia",
		"nl": "Parker",
		"url": "https://findagrave.com/memorial/127131741",
		"id": 127131741,
		"lng": -77.38629105,
		"lat": 37.53641313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 9,
		"dd": 18,
		"by": 1915,
		"bd": 8,
		"bm": 2,
		"nm": "",
		"nf": "Louis",
		"nl": "Parker",
		"url": "https://findagrave.com/memorial/151267122",
		"id": 151267122,
		"lng": -77.38680402,
		"lat": 37.53724991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louis",
		"nl": "Parker",
		"url": "https://findagrave.com/memorial/137835768",
		"id": 137835768,
		"lng": -77.38625895,
		"lat": 37.53705357,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 8,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Parker",
		"url": "https://findagrave.com/memorial/152167332",
		"id": 152167332,
		"lng": -77.38616834,
		"lat": 37.53553201,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 4,
		"dd": 21,
		"by": 1893,
		"bd": 16,
		"bm": 3,
		"nm": "",
		"nf": "Lucy",
		"nl": "Paschall",
		"url": "https://findagrave.com/memorial/143998004",
		"id": 143998004,
		"lng": -77.38726184,
		"lat": 37.53766474,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 8,
		"dd": 24,
		"by": 1923,
		"bd": 26,
		"bm": 2,
		"nm": "Virginia",
		"nf": "Beatrice",
		"nl": "Patron",
		"url": "https://findagrave.com/memorial/147853464",
		"id": 147853464,
		"lng": -77.38698756,
		"lat": 37.53712291,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 22,
		"by": 1906,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Carrie",
		"nl": "Patterson",
		"url": "https://findagrave.com/memorial/161180316",
		"id": 161180316,
		"lng": -77.38644129,
		"lat": 37.53701741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 31,
		"by": 1878,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Eliza",
		"nl": "Patterson",
		"url": "https://findagrave.com/memorial/191703588",
		"id": 191703588,
		"lng": -77.38648332,
		"lat": 37.5374095,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 5,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Emma",
		"nl": "Patterson",
		"url": "https://findagrave.com/memorial/185151361",
		"id": 185151361,
		"lng": -77.38776419,
		"lat": 37.53661928,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 6,
		"dd": 30,
		"by": 1813,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Patterson",
		"url": "https://findagrave.com/memorial/183512383",
		"id": 183512383,
		"lng": -77.38622528,
		"lat": 37.53541561,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 13,
		"by": 1900,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Nannie",
		"nl": "Patterson",
		"url": "https://findagrave.com/memorial/137968575",
		"id": 137968575,
		"lng": -77.386679,
		"lat": 37.53707165,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 8,
		"by": 1884,
		"bd": 5,
		"bm": 3,
		"nm": "",
		"nf": "Rufus",
		"nl": "Patton",
		"url": "https://findagrave.com/memorial/161179887",
		"id": 161179887,
		"lng": -77.3865306,
		"lat": 37.53707062,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 19,
		"by": 1907,
		"bd": 21,
		"bm": 6,
		"nm": "C.",
		"nf": "Andrew",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/128672377",
		"id": 128672377,
		"lng": -77.3856927,
		"lat": 37.53715034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 12,
		"dd": 12,
		"by": 1860,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edmonia",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/145085238",
		"id": 145085238,
		"lng": -77.38572621,
		"lat": 37.53741085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 12,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Ella",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/146341607",
		"id": 146341607,
		"lng": -77.38664243,
		"lat": 37.53583741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 11,
		"dd": 15,
		"by": 1870,
		"bd": 21,
		"bm": 3,
		"nm": "",
		"nf": "Henrietta",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/128672390",
		"id": 128672390,
		"lng": -77.38569861,
		"lat": 37.5371361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Harrison",
		"nf": "Julian",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/142469222",
		"id": 142469222,
		"lng": -77.38572837,
		"lat": 37.53740264,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 22,
		"by": 1899,
		"bd": 17,
		"bm": 12,
		"nm": "Harold",
		"nf": "Louis",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/113633577",
		"id": 113633577,
		"lng": -77.38567271,
		"lat": 37.53714371,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 2,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Matthews",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/173897839",
		"id": 173897839,
		"lng": -77.38758616,
		"lat": 37.53718666,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 7,
		"dd": 10,
		"by": 1922,
		"bd": 28,
		"bm": 8,
		"nm": "",
		"nf": "Purcell",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/155270318",
		"id": 155270318,
		"lng": -77.3871448,
		"lat": 37.53775387,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 6,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "V.",
		"nf": "Rosa",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/136107642",
		"id": 136107642,
		"lng": -77.38563761,
		"lat": 37.53734661,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 5,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sophie",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/174884434",
		"id": 174884434,
		"lng": -77.38748379,
		"lat": 37.53714434,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 4,
		"dd": 23,
		"by": 1913,
		"bd": 15,
		"bm": 8,
		"nm": "H.",
		"nf": "William",
		"nl": "Payne",
		"url": "https://findagrave.com/memorial/127569736",
		"id": 127569736,
		"lng": -77.38575351,
		"lat": 37.53701636,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 3,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Upton",
		"nl": "Peace",
		"url": "https://findagrave.com/memorial/177192677",
		"id": 177192677,
		"lng": -77.3878642,
		"lat": 37.53708106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 8,
		"dd": 28,
		"by": 1870,
		"bd": 6,
		"bm": 1,
		"nm": "F.",
		"nf": "Mary",
		"nl": "Peeples",
		"url": "https://findagrave.com/memorial/157219263",
		"id": 157219263,
		"lng": -77.38655245,
		"lat": 37.53584218,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 10,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Dora",
		"nl": "Pegram",
		"url": "https://findagrave.com/memorial/155731903",
		"id": 155731903,
		"lng": -77.38727441,
		"lat": 37.53563502,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 10,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Pemberton",
		"url": "https://findagrave.com/memorial/169479024",
		"id": 169479024,
		"lng": -77.38774342,
		"lat": 37.53710593,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 8,
		"dd": 27,
		"by": 1954,
		"bd": 27,
		"bm": 8,
		"nm": "",
		"nf": "Richard",
		"nl": "Penn",
		"url": "https://findagrave.com/memorial/158450803",
		"id": 158450803,
		"lng": -77.3859203,
		"lat": 37.53734456,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 9,
		"by": 1902,
		"bd": 4,
		"bm": 2,
		"nm": "Bell",
		"nf": "Annie",
		"nl": "Perkins",
		"url": "https://findagrave.com/memorial/176939586",
		"id": 176939586,
		"lng": -77.38707622,
		"lat": 37.53752118,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 18,
		"by": 1886,
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Elizabeth",
		"nl": "Perkins",
		"url": "https://findagrave.com/memorial/176711948",
		"id": 176711948,
		"lng": -77.38766928,
		"lat": 37.53730378,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 5,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clara",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/122793371",
		"id": 122793371,
		"lng": -77.38590363,
		"lat": 37.53650313,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 5,
		"dd": 1,
		"by": 1896,
		"bd": 10,
		"bm": 4,
		"nm": "",
		"nf": "Henrietta",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/155021669",
		"id": 155021669,
		"lng": -77.38666585,
		"lat": 37.53746639,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 4,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/168954471",
		"id": 168954471,
		"lng": -77.38562172,
		"lat": 37.53698892,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 9,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Bell",
		"nf": "Ida",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/168954493",
		"id": 168954493,
		"lng": -77.3856252,
		"lat": 37.53698034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 12,
		"by": 1899,
		"bd": 15,
		"bm": 12,
		"nm": "R.",
		"nf": "John",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/131428533",
		"id": 131428533,
		"lng": -77.38604079,
		"lat": 37.5358425,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 10,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/131428525",
		"id": 131428525,
		"lng": -77.38603206,
		"lat": 37.53583799,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 1,
		"dd": 9,
		"by": 1903,
		"bd": 7,
		"bm": 5,
		"nm": "",
		"nf": "Latimus",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/147853490",
		"id": 147853490,
		"lng": -77.38699956,
		"lat": 37.53707508,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "N.",
		"nf": "Maggie",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/138570864",
		"id": 138570864,
		"lng": -77.38633358,
		"lat": 37.53658651,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 12,
		"by": 1913,
		"bd": 21,
		"bm": 3,
		"nm": "",
		"nf": "Mary",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/155531221",
		"id": 155531221,
		"lng": -77.38769938,
		"lat": 37.53770085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 9,
		"dd": 12,
		"by": 1878,
		"bd": 30,
		"bm": 5,
		"nm": "",
		"nf": "Mary",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/131428537",
		"id": 131428537,
		"lng": -77.38603644,
		"lat": 37.53583101,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 1,
		"dd": 21,
		"by": 1913,
		"bd": 27,
		"bm": 8,
		"nm": "Geneva",
		"nf": "Rubbie",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/134359200",
		"id": 134359200,
		"lng": -77.38757368,
		"lat": 37.53659314,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 8,
		"dd": 17,
		"by": 1902,
		"bd": 16,
		"bm": 2,
		"nm": "",
		"nf": "Sallie",
		"nl": "Perry",
		"url": "https://findagrave.com/memorial/183697482",
		"id": 183697482,
		"lng": -77.38697931,
		"lat": 37.53700602,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 1,
		"dd": 18,
		"by": 1896,
		"bd": 1,
		"bm": 6,
		"nm": "",
		"nf": "Maggie",
		"nl": "Petterson",
		"url": "https://findagrave.com/memorial/161179871",
		"id": 161179871,
		"lng": -77.38608571,
		"lat": 37.53632587,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 9,
		"dd": 29,
		"by": 1876,
		"bd": 30,
		"bm": 3,
		"nm": "",
		"nf": "Victoria",
		"nl": "Petterson",
		"url": "https://findagrave.com/memorial/128452612",
		"id": 128452612,
		"lng": -77.38565633,
		"lat": 37.53700846,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 14,
		"by": 1927,
		"bd": 9,
		"bm": 4,
		"nm": "E.",
		"nf": "Elsie",
		"nl": "Pettus",
		"url": "https://findagrave.com/memorial/177768015",
		"id": 177768015,
		"lng": -77.38659393,
		"lat": 37.53708693,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 8,
		"by": 1895,
		"bd": 25,
		"bm": 8,
		"nm": "",
		"nf": "James",
		"nl": "Pettus",
		"url": "https://findagrave.com/memorial/145344929",
		"id": 145344929,
		"lng": -77.38597932,
		"lat": 37.53693906,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 11,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Phoeby",
		"nl": "Pettus",
		"url": "https://findagrave.com/memorial/136306535",
		"id": 136306535,
		"lng": -77.38618462,
		"lat": 37.53636061,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "James",
		"nl": "Peyton",
		"url": "https://findagrave.com/memorial/144188916",
		"id": 144188916,
		"lng": -77.38604189,
		"lat": 37.53727637,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 4,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "John",
		"nl": "Peyton",
		"url": "https://findagrave.com/memorial/173925965",
		"id": 173925965,
		"lng": -77.38758905,
		"lat": 37.53714343,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Bettie",
		"nl": "Phillips",
		"url": "https://findagrave.com/memorial/127719227",
		"id": 127719227,
		"lng": -77.38605965,
		"lat": 37.53657695,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 7,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "James",
		"nl": "Pickens",
		"url": "https://findagrave.com/memorial/166049021",
		"id": 166049021,
		"lng": -77.38647334,
		"lat": 37.53665956,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 7,
		"dd": 9,
		"by": 1878,
		"bd": 15,
		"bm": 8,
		"nm": "",
		"nf": "Nancy",
		"nl": "Pickett",
		"url": "https://findagrave.com/memorial/187826207",
		"id": 187826207,
		"lng": -77.38794739,
		"lat": 37.53715044,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 23,
		"by": 1964,
		"bd": 23,
		"bm": 2,
		"nm": "",
		"nf": "baby girl",
		"nl": "Pierce",
		"url": "https://findagrave.com/memorial/159414634",
		"id": 159414634,
		"lng": -77.38617308,
		"lat": 37.53748647,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 4,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louise",
		"nl": "Pierce",
		"url": "https://findagrave.com/memorial/138181530",
		"id": 138181530,
		"lng": -77.38683728,
		"lat": 37.53690583,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bertha",
		"nl": "Pierson",
		"url": "https://findagrave.com/memorial/154038602",
		"id": 154038602,
		"lng": -77.38639631,
		"lat": 37.53717791,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 5,
		"dd": 27,
		"by": 1884,
		"bd": 15,
		"bm": 4,
		"nm": "E. White",
		"nf": "Sarah",
		"nl": "Piett",
		"url": "https://findagrave.com/memorial/171769826",
		"id": 171769826,
		"lng": -77.38709014,
		"lat": 37.53671132,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 12,
		"dd": 22,
		"by": 1892,
		"bd": 13,
		"bm": 7,
		"nm": "L. Sullivan",
		"nf": "John",
		"nl": "Pitchford",
		"url": "https://findagrave.com/memorial/152794740",
		"id": 152794740,
		"lng": -77.38698561,
		"lat": 37.53745618,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 12,
		"dd": 3,
		"by": 1914,
		"bd": 6,
		"bm": 1,
		"nm": "",
		"nf": "Walter",
		"nl": "Pitchford",
		"url": "https://findagrave.com/memorial/144370611",
		"id": 144370611,
		"lng": -77.38723697,
		"lat": 37.5377934,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Redick",
		"nl": "Pittman",
		"url": "https://findagrave.com/memorial/177286105",
		"id": 177286105,
		"lng": -77.38733875,
		"lat": 37.53729334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 2,
		"dd": 14,
		"by": 1879,
		"bd": 15,
		"bm": 4,
		"nm": "C.",
		"nf": "Walker",
		"nl": "Pleasant",
		"url": "https://findagrave.com/memorial/111589851",
		"id": 111589851,
		"lng": -77.38732328,
		"lat": 37.53753569,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Rebecca",
		"nf": "Alice",
		"nl": "Pleasants",
		"url": "https://findagrave.com/memorial/170604703",
		"id": 170604703,
		"lng": -77.38685448,
		"lat": 37.53690143,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 10,
		"dd": 13,
		"by": 1974,
		"bd": 12,
		"bm": 10,
		"nm": "Nicole",
		"nf": "Shannon",
		"nl": "Pleasants",
		"url": "https://findagrave.com/memorial/76605009",
		"id": 76605009,
		"lng": -77.38613845,
		"lat": 37.53672632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 7,
		"dd": 10,
		"by": 1887,
		"bd": 6,
		"bm": 6,
		"nm": "Bernard",
		"nf": "Nelson",
		"nl": "Plummer",
		"url": "https://findagrave.com/memorial/158733716",
		"id": 158733716,
		"lng": -77.38713051,
		"lat": 37.53748662,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 12,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Virginia",
		"nl": "Plummer",
		"url": "https://findagrave.com/memorial/189076333",
		"id": 189076333,
		"lng": -77.38608437,
		"lat": 37.53616378,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 29,
		"by": 1966,
		"bd": 17,
		"bm": 9,
		"nm": "Eric",
		"nf": "Morris",
		"nl": "Poag",
		"url": "https://findagrave.com/memorial/144189013",
		"id": 144189013,
		"lng": -77.38597049,
		"lat": 37.53745748,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 8,
		"dd": 25,
		"by": "",
		"bd": 26,
		"bm": 8,
		"nm": "",
		"nf": "Brady",
		"nl": "Poe",
		"url": "https://findagrave.com/memorial/163942732",
		"id": 163942732,
		"lng": -77.38760808,
		"lat": 37.53741919,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 7,
		"dd": 6,
		"by": 1859,
		"bd": 9,
		"bm": 8,
		"nm": "E.",
		"nf": "Fannie",
		"nl": "Poindexter",
		"url": "https://findagrave.com/memorial/150920523",
		"id": 150920523,
		"lng": -77.38618898,
		"lat": 37.53558475,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Poindexter",
		"url": "https://findagrave.com/memorial/148747858",
		"id": 148747858,
		"lng": -77.38785926,
		"lat": 37.53711373,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 11,
		"dd": 15,
		"by": 1859,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Bettie",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/143632593",
		"id": 143632593,
		"lng": -77.38602801,
		"lat": 37.536014,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charley",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/188269543",
		"id": 188269543,
		"lng": -77.38795762,
		"lat": 37.53707807,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 10,
		"dd": 23,
		"by": 1925,
		"bd": 2,
		"bm": 5,
		"nm": "E.",
		"nf": "Grayce",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/38457079",
		"id": 38457079,
		"lng": -77.38570851,
		"lat": 37.53705745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 22,
		"by": 1915,
		"bd": 25,
		"bm": 10,
		"nm": "Johnson",
		"nf": "Jack",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/158433253",
		"id": 158433253,
		"lng": -77.3867511,
		"lat": 37.53767706,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 2,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nelson",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/148517520",
		"id": 148517520,
		"lng": -77.38681564,
		"lat": 37.53577965,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 5,
		"by": 1959,
		"bd": 3,
		"bm": 9,
		"nm": "Marie",
		"nf": "Rosa",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/138570870",
		"id": 138570870,
		"lng": -77.38622544,
		"lat": 37.53660584,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 12,
		"dd": 26,
		"by": 1841,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/143696146",
		"id": 143696146,
		"lng": -77.38601299,
		"lat": 37.53603633,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 3,
		"by": 1894,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Cora",
		"nl": "Poole",
		"url": "https://findagrave.com/memorial/173068595",
		"id": 173068595,
		"lng": -77.38706536,
		"lat": 37.53732047,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 5,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ike",
		"nl": "Poole",
		"url": "https://findagrave.com/memorial/147853504",
		"id": 147853504,
		"lng": -77.38595378,
		"lat": 37.53636002,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "John",
		"nl": "Pope",
		"url": "https://findagrave.com/memorial/143632600",
		"id": 143632600,
		"lng": -77.38603939,
		"lat": 37.53600464,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 10,
		"dd": 31,
		"by": 1922,
		"bd": 22,
		"bm": 8,
		"nm": "L.",
		"nf": "Edward",
		"nl": "Porter",
		"url": "https://findagrave.com/memorial/138570881",
		"id": 138570881,
		"lng": -77.38624034,
		"lat": 37.53680226,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Janie",
		"nl": "Porter",
		"url": "https://findagrave.com/memorial/176720263",
		"id": 176720263,
		"lng": -77.38701492,
		"lat": 37.53747498,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 6,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Powell",
		"url": "https://findagrave.com/memorial/125634447",
		"id": 125634447,
		"lng": -77.38578389,
		"lat": 37.53665581,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 2,
		"by": 1909,
		"bd": 23,
		"bm": 3,
		"nm": "",
		"nf": "Douglas",
		"nl": "Powell",
		"url": "https://findagrave.com/memorial/148648734",
		"id": 148648734,
		"lng": -77.38600584,
		"lat": 37.53738186,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 6,
		"dd": 4,
		"by": 1870,
		"bd": 15,
		"bm": 2,
		"nm": "",
		"nf": "Harriett",
		"nl": "Powell",
		"url": "https://findagrave.com/memorial/113626512",
		"id": 113626512,
		"lng": -77.38797841,
		"lat": 37.53719787,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 4,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Powell",
		"url": "https://findagrave.com/memorial/175421305",
		"id": 175421305,
		"lng": -77.38750666,
		"lat": 37.53714035,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 3,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "William",
		"nl": "Powell",
		"url": "https://findagrave.com/memorial/151461706",
		"id": 151461706,
		"lng": -77.38816264,
		"lat": 37.53738762,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 10,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Powell",
		"url": "https://findagrave.com/memorial/184767568",
		"id": 184767568,
		"lng": -77.38767667,
		"lat": 37.53694202,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 11,
		"by": 1964,
		"bd": 27,
		"bm": 7,
		"nm": "Dominic",
		"nf": "Kelvin",
		"nl": "Prentiss",
		"url": "https://findagrave.com/memorial/153868177",
		"id": 153868177,
		"lng": -77.38618276,
		"lat": 37.53745362,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 27,
		"by": 1925,
		"bd": 5,
		"bm": 2,
		"nm": "",
		"nf": "Walter",
		"nl": "Prentiss",
		"url": "https://findagrave.com/memorial/191379205",
		"id": 191379205,
		"lng": -77.38645692,
		"lat": 37.53722575,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 10,
		"dd": 1,
		"by": 1903,
		"bd": 2,
		"bm": 2,
		"nm": "",
		"nf": "Walter",
		"nl": "Prentiss",
		"url": "https://findagrave.com/memorial/144013908",
		"id": 144013908,
		"lng": -77.38742947,
		"lat": 37.53760755,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eva",
		"nl": "Preston",
		"url": "https://findagrave.com/memorial/144821911",
		"id": 144821911,
		"lng": -77.38547992,
		"lat": 37.53732809,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1883,
		"dm": 1,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Abram",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/144316209",
		"id": 144316209,
		"lng": -77.3870911,
		"lat": 37.53547557,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 8,
		"dd": 5,
		"by": 1900,
		"bd": 4,
		"bm": 4,
		"nm": "",
		"nf": "Aurelia",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/151111976",
		"id": 151111976,
		"lng": -77.38650553,
		"lat": 37.53550537,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 10,
		"dd": 5,
		"by": 1925,
		"bd": 26,
		"bm": 7,
		"nm": "E.",
		"nf": "Geraldine",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/151111983",
		"id": 151111983,
		"lng": -77.38660381,
		"lat": 37.53542872,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1897,
		"dm": 9,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lydia",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/144316219",
		"id": 144316219,
		"lng": -77.38709198,
		"lat": 37.53547285,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lynwood",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/117449113",
		"id": 117449113,
		"lng": -77.38720366,
		"lat": 37.53712745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 8,
		"dd": 29,
		"by": 1895,
		"bd": 14,
		"bm": 5,
		"nm": "Abner",
		"nf": "Maurice",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/127483533",
		"id": 127483533,
		"lng": -77.38618537,
		"lat": 37.53699521,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 7,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nannie",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/158466956",
		"id": 158466956,
		"lng": -77.38689894,
		"lat": 37.53764273,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 11,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Patsie",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/146343908",
		"id": 146343908,
		"lng": -77.38631596,
		"lat": 37.53575764,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 12,
		"dd": 3,
		"by": 1898,
		"bd": 5,
		"bm": 10,
		"nm": "V.",
		"nf": "Pearl",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/127483586",
		"id": 127483586,
		"lng": -77.38618977,
		"lat": 37.53698779,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Horace",
		"nf": "Ralph",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/122793511",
		"id": 122793511,
		"lng": -77.38572862,
		"lat": 37.53699235,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 5,
		"dd": 3,
		"by": 1910,
		"bd": 10,
		"bm": 8,
		"nm": "E.",
		"nf": "Roger",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/172031031",
		"id": 172031031,
		"lng": -77.38700942,
		"lat": 37.53744771,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Bogle",
		"nf": "Sarah",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/184448923",
		"id": 184448923,
		"lng": -77.38737367,
		"lat": 37.53783624,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": "",
		"dd": "",
		"by": 1868,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Walter",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/138181533",
		"id": 138181533,
		"lng": -77.3862734,
		"lat": 37.53710717,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 4,
		"dd": 13,
		"by": 1897,
		"bd": 5,
		"bm": 8,
		"nm": "Samuel",
		"nf": "Wilson",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/174622146",
		"id": 174622146,
		"lng": -77.38581336,
		"lat": 37.53663518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Willie",
		"nl": "Pridgen",
		"url": "https://findagrave.com/memorial/141194239",
		"id": 141194239,
		"lng": -77.38640774,
		"lat": 37.53667627,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 10,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "James",
		"nl": "Pryor",
		"url": "https://findagrave.com/memorial/155531231",
		"id": 155531231,
		"lng": -77.38660452,
		"lat": 37.53561278,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 27,
		"by": 1932,
		"bd": 8,
		"bm": 6,
		"nm": "Emanuel",
		"nf": "Charles",
		"nl": "Pulley",
		"url": "https://findagrave.com/memorial/158676608",
		"id": 158676608,
		"lng": -77.3868368,
		"lat": 37.53750395,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 12,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Pulliam",
		"url": "https://findagrave.com/memorial/167373224",
		"id": 167373224,
		"lng": -77.38777769,
		"lat": 37.5370597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 7,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Pulliam",
		"url": "https://findagrave.com/memorial/187744295",
		"id": 187744295,
		"lng": -77.3877338,
		"lat": 37.53695362,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 4,
		"dd": 27,
		"by": 1895,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Pulliam",
		"url": "https://findagrave.com/memorial/151267213",
		"id": 151267213,
		"lng": -77.38747413,
		"lat": 37.53686067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 12,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cornelius",
		"nl": "Puryear",
		"url": "https://findagrave.com/memorial/145596028",
		"id": 145596028,
		"lng": -77.38690623,
		"lat": 37.53668583,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 5,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Puryear",
		"url": "https://findagrave.com/memorial/143865733",
		"id": 143865733,
		"lng": -77.38676343,
		"lat": 37.53664787,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 4,
		"dd": 7,
		"by": 1889,
		"bd": 19,
		"bm": 1,
		"nm": "Emma",
		"nf": "Kate",
		"nl": "Puryear",
		"url": "https://findagrave.com/memorial/158335474",
		"id": 158335474,
		"lng": -77.38613767,
		"lat": 37.53662007,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 2,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Anderson",
		"nl": "Quarles",
		"url": "https://findagrave.com/memorial/120147054",
		"id": 120147054,
		"lng": -77.38597794,
		"lat": 37.53674641,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 4,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Catherine",
		"nl": "Quarles",
		"url": "https://findagrave.com/memorial/120147064",
		"id": 120147064,
		"lng": -77.38597842,
		"lat": 37.53673707,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 2,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Frank",
		"nl": "Quarles",
		"url": "https://findagrave.com/memorial/189075393",
		"id": 189075393,
		"lng": -77.38617016,
		"lat": 37.53612918,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 3,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hester",
		"nl": "Quarles",
		"url": "https://findagrave.com/memorial/128672402",
		"id": 128672402,
		"lng": -77.38606003,
		"lat": 37.53663624,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 13,
		"by": 1876,
		"bd": 30,
		"bm": 4,
		"nm": "Henry",
		"nf": "James",
		"nl": "Quarles",
		"url": "https://findagrave.com/memorial/125094188",
		"id": 125094188,
		"lng": -77.3860439,
		"lat": 37.53663163,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 4,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Lizzie",
		"nl": "Radford",
		"url": "https://findagrave.com/memorial/125643880",
		"id": 125643880,
		"lng": -77.38725319,
		"lat": 37.53668567,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 6,
		"dd": 12,
		"by": 1907,
		"bd": 12,
		"bm": 9,
		"nm": "E.",
		"nf": "Blanche",
		"nl": "Ragland",
		"url": "https://findagrave.com/memorial/150033733",
		"id": 150033733,
		"lng": -77.38649426,
		"lat": 37.53726523,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 10,
		"by": 1895,
		"bd": 17,
		"bm": 5,
		"nm": "",
		"nf": "Isabella",
		"nl": "Ragland",
		"url": "https://findagrave.com/memorial/161179874",
		"id": 161179874,
		"lng": -77.38649628,
		"lat": 37.53706986,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 29,
		"by": 1905,
		"bd": 22,
		"bm": 6,
		"nm": "L.",
		"nf": "Russell",
		"nl": "Ragland",
		"url": "https://findagrave.com/memorial/150033740",
		"id": 150033740,
		"lng": -77.38649186,
		"lat": 37.5372645,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 7,
		"dd": 30,
		"by": 1918,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Ophelia",
		"nl": "Ramsey",
		"url": "https://findagrave.com/memorial/154040610",
		"id": 154040610,
		"lng": -77.38654377,
		"lat": 37.53756654,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 5,
		"dd": 29,
		"by": 1896,
		"bd": 26,
		"bm": 11,
		"nm": "James",
		"nf": "Royal",
		"nl": "Randall",
		"url": "https://findagrave.com/memorial/126652595",
		"id": 126652595,
		"lng": -77.38588656,
		"lat": 37.5365634,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 10,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Absolom",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/150677875",
		"id": 150677875,
		"lng": -77.38642347,
		"lat": 37.53549833,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 9,
		"dd": 22,
		"by": 1899,
		"bd": 7,
		"bm": 7,
		"nm": "L.",
		"nf": "Arthur",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/159416140",
		"id": 159416140,
		"lng": -77.3863501,
		"lat": 37.53751466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 9,
		"dd": 18,
		"by": 1920,
		"bd": 6,
		"bm": 5,
		"nm": "Edward",
		"nf": "Carlton",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/167072664",
		"id": 167072664,
		"lng": -77.38684301,
		"lat": 37.53714892,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 9,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Carrie",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/142106232",
		"id": 142106232,
		"lng": -77.38586104,
		"lat": 37.53736977,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1900,
		"dm": 4,
		"dd": 9,
		"by": 1866,
		"bd": 14,
		"bm": 6,
		"nm": "",
		"nf": "Eddie",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/138926519",
		"id": 138926519,
		"lng": -77.38635128,
		"lat": 37.53656926,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 11,
		"dd": 9,
		"by": 1896,
		"bd": 1,
		"bm": 1,
		"nm": "G.",
		"nf": "Hamlet",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/137332649",
		"id": 137332649,
		"lng": -77.38601984,
		"lat": 37.53696507,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 12,
		"dd": 20,
		"by": 1866,
		"bd": 1,
		"bm": 1,
		"nm": "",
		"nf": "Henry",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/142106234",
		"id": 142106234,
		"lng": -77.38585282,
		"lat": 37.53738266,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 3,
		"dd": 29,
		"by": 1892,
		"bd": 4,
		"bm": 2,
		"nm": "Cooper",
		"nf": "Hezekiah",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/143058187",
		"id": 143058187,
		"lng": -77.38639799,
		"lat": 37.53546601,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 7,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louise",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/150677877",
		"id": 150677877,
		"lng": -77.38640613,
		"lat": 37.53549455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 2,
		"dd": 17,
		"by": 1890,
		"bd": 4,
		"bm": 9,
		"nm": "Louise",
		"nf": "Maria",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/138570893",
		"id": 138570893,
		"lng": -77.38635323,
		"lat": 37.53656043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 8,
		"dd": 17,
		"by": 1908,
		"bd": 5,
		"bm": 6,
		"nm": "L.",
		"nf": "Pearl",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/143058197",
		"id": 143058197,
		"lng": -77.38641233,
		"lat": 37.53549694,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 7,
		"dd": 10,
		"by": 1882,
		"bd": 5,
		"bm": 4,
		"nm": "",
		"nf": "Silas",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/159762344",
		"id": 159762344,
		"lng": -77.38805344,
		"lat": 37.53778726,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 6,
		"dd": 7,
		"by": 1914,
		"bd": 19,
		"bm": 6,
		"nm": "D.",
		"nf": "Verlene",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/128452621",
		"id": 128452621,
		"lng": -77.38564445,
		"lat": 37.53701692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 3,
		"dd": 25,
		"by": 1881,
		"bd": 28,
		"bm": 10,
		"nm": "Ruth",
		"nf": "Vivian",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/155021677",
		"id": 155021677,
		"lng": -77.38650576,
		"lat": 37.5375732,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 9,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Walter",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/143058205",
		"id": 143058205,
		"lng": -77.38642245,
		"lat": 37.53548142,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 6,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Arthur",
		"nl": "Ransom",
		"url": "https://findagrave.com/memorial/176769019",
		"id": 176769019,
		"lng": -77.38774391,
		"lat": 37.53701968,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 1,
		"dd": 7,
		"by": 1903,
		"bd": 30,
		"bm": 3,
		"nm": "L.",
		"nf": "Clarence",
		"nl": "Ransom",
		"url": "https://findagrave.com/memorial/160037510",
		"id": 160037510,
		"lng": -77.3865665,
		"lat": 37.53747216,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 26,
		"by": 1903,
		"bd": 21,
		"bm": 8,
		"nm": "L.",
		"nf": "Maria",
		"nl": "Ransom",
		"url": "https://findagrave.com/memorial/129211487",
		"id": 129211487,
		"lng": -77.38595861,
		"lat": 37.53674099,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 3,
		"dd": 16,
		"by": 1926,
		"bd": 31,
		"bm": 12,
		"nm": "",
		"nf": "Ruth",
		"nl": "Ray",
		"url": "https://findagrave.com/memorial/158924517",
		"id": 158924517,
		"lng": -77.38685647,
		"lat": 37.53740855,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 1,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Reaves",
		"url": "https://findagrave.com/memorial/166075723",
		"id": 166075723,
		"lng": -77.38569313,
		"lat": 37.53689645,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 6,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lula",
		"nl": "Reaves",
		"url": "https://findagrave.com/memorial/115720697",
		"id": 115720697,
		"lng": -77.38571851,
		"lat": 37.53690779,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 4,
		"dd": 29,
		"by": 1891,
		"bd": 15,
		"bm": 11,
		"nm": "H.",
		"nf": "W.",
		"nl": "Reddick",
		"url": "https://findagrave.com/memorial/187366758",
		"id": 187366758,
		"lng": -77.3879611,
		"lat": 37.53723589,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 11,
		"by": 1898,
		"bd": 25,
		"bm": 8,
		"nm": "",
		"nf": "Arthur",
		"nl": "Reed",
		"url": "https://findagrave.com/memorial/187366761",
		"id": 187366761,
		"lng": -77.38597685,
		"lat": 37.53742007,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 6,
		"dd": 29,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Reed",
		"url": "https://findagrave.com/memorial/175610636",
		"id": 175610636,
		"lng": -77.38765606,
		"lat": 37.53701505,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 1,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Reed",
		"url": "https://findagrave.com/memorial/153100525",
		"id": 153100525,
		"lng": -77.3867076,
		"lat": 37.53583043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Eunice",
		"nl": "Reese",
		"url": "https://findagrave.com/memorial/144189029",
		"id": 144189029,
		"lng": -77.38593337,
		"lat": 37.53727215,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 2,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jessie",
		"nl": "Reynolds",
		"url": "https://findagrave.com/memorial/173512839",
		"id": 173512839,
		"lng": -77.38749348,
		"lat": 37.5370985,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 1,
		"dd": 2,
		"by": 1891,
		"bd": 30,
		"bm": 11,
		"nm": "",
		"nf": "Lillie",
		"nl": "Reynolds",
		"url": "https://findagrave.com/memorial/174859476",
		"id": 174859476,
		"lng": -77.38749584,
		"lat": 37.53708686,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 8,
		"dd": 23,
		"by": 1843,
		"bd": 28,
		"bm": 3,
		"nm": "J.",
		"nf": "Sarah",
		"nl": "Richards",
		"url": "https://findagrave.com/memorial/130695428",
		"id": 130695428,
		"lng": -77.38689296,
		"lat": 37.53541839,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 7,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/139146925",
		"id": 139146925,
		"lng": -77.38780326,
		"lat": 37.53695485,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 12,
		"dd": 23,
		"by": 1889,
		"bd": 11,
		"bm": 10,
		"nm": "",
		"nf": "John",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/171769836",
		"id": 171769836,
		"lng": -77.38719554,
		"lat": 37.53674525,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 3,
		"dd": 31,
		"by": 1881,
		"bd": 16,
		"bm": 4,
		"nm": "F.",
		"nf": "Mary",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/160048630",
		"id": 160048630,
		"lng": -77.38650897,
		"lat": 37.5375644,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 7,
		"dd": 5,
		"by": 1890,
		"bd": 9,
		"bm": 3,
		"nm": "Esther",
		"nf": "Queen",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/154512676",
		"id": 154512676,
		"lng": -77.38642988,
		"lat": 37.53566696,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sylvia",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/159416149",
		"id": 159416149,
		"lng": -77.38611931,
		"lat": 37.53748117,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 13,
		"by": 1895,
		"bd": 28,
		"bm": 3,
		"nm": "",
		"nf": "William",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/185658494",
		"id": 185658494,
		"lng": -77.38744263,
		"lat": 37.53739107,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 11,
		"dd": 3,
		"by": 1921,
		"bd": 1,
		"bm": 8,
		"nm": "L.",
		"nf": "William",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/171769847",
		"id": 171769847,
		"lng": -77.38675781,
		"lat": 37.53733324,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 9,
		"dd": 8,
		"by": 1877,
		"bd": 2,
		"bm": 9,
		"nm": "",
		"nf": "David",
		"nl": "Riley",
		"url": "https://findagrave.com/memorial/154393444",
		"id": 154393444,
		"lng": -77.38621292,
		"lat": 37.53603839,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 3,
		"dd": 27,
		"by": 1863,
		"bd": "",
		"bm": 9,
		"nm": "",
		"nf": "Peter",
		"nl": "Riley",
		"url": "https://findagrave.com/memorial/132764945",
		"id": 132764945,
		"lng": -77.38783649,
		"lat": 37.53637585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 6,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Arnie",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/146019975",
		"id": 146019975,
		"lng": -77.38656444,
		"lat": 37.53663054,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 1,
		"by": 1868,
		"bd": 18,
		"bm": 2,
		"nm": "",
		"nf": "Bessie",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/117804449",
		"id": 117804449,
		"lng": -77.38594926,
		"lat": 37.53719774,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 6,
		"dd": 26,
		"by": 1887,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Christine",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/133137521",
		"id": 133137521,
		"lng": -77.38705387,
		"lat": 37.5370284,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 12,
		"dd": 4,
		"by": 1887,
		"bd": 18,
		"bm": 8,
		"nm": "E.",
		"nf": "Freddie",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/175595371",
		"id": 175595371,
		"lng": -77.38644719,
		"lat": 37.53531113,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 11,
		"dd": 19,
		"by": 1838,
		"bd": 18,
		"bm": 2,
		"nm": "Washington",
		"nf": "George",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/131428513",
		"id": 131428513,
		"lng": -77.38756011,
		"lat": 37.53653411,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 8,
		"dd": 1,
		"by": 1885,
		"bd": 8,
		"bm": 2,
		"nm": "Wallace",
		"nf": "George",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/133137532",
		"id": 133137532,
		"lng": -77.38704951,
		"lat": 37.53703731,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jeanette",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/144189040",
		"id": 144189040,
		"lng": -77.38591239,
		"lat": 37.53731533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 20,
		"by": 1864,
		"bd": 26,
		"bm": 8,
		"nm": "H.",
		"nf": "John",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/143865748",
		"id": 143865748,
		"lng": -77.3860708,
		"lat": 37.53598975,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 4,
		"dd": 13,
		"by": 1869,
		"bd": 23,
		"bm": 11,
		"nm": "Elizabeth",
		"nf": "Mary",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/143635840",
		"id": 143635840,
		"lng": -77.38607484,
		"lat": 37.53597927,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 1,
		"dd": 23,
		"by": 1896,
		"bd": 30,
		"bm": 6,
		"nm": "Elizabeth",
		"nf": "Mary",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/156286037",
		"id": 156286037,
		"lng": -77.38587273,
		"lat": 37.5370388,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1902,
		"dm": 1,
		"dd": 6,
		"by": 1835,
		"bd": 6,
		"bm": 9,
		"nm": "",
		"nf": "Matilda",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/146019988",
		"id": 146019988,
		"lng": -77.38636962,
		"lat": 37.53650573,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 3,
		"dd": 29,
		"by": 1889,
		"bd": 12,
		"bm": 4,
		"nm": "",
		"nf": "Spencer",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/117804446",
		"id": 117804446,
		"lng": -77.38595087,
		"lat": 37.53719367,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 5,
		"dd": 28,
		"by": 1909,
		"bd": 7,
		"bm": 4,
		"nm": "",
		"nf": "Virginia",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/155531238",
		"id": 155531238,
		"lng": -77.3876771,
		"lat": 37.53770739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 3,
		"dd": 31,
		"by": 1913,
		"bd": 14,
		"bm": 6,
		"nm": "Lee",
		"nf": "Russell",
		"nl": "Robbs",
		"url": "https://findagrave.com/memorial/176247927",
		"id": 176247927,
		"lng": -77.38771677,
		"lat": 37.53742873,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Roberts",
		"url": "https://findagrave.com/memorial/146019996",
		"id": 146019996,
		"lng": -77.38771915,
		"lat": 37.53672416,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Dora",
		"nl": "Robertson",
		"url": "https://findagrave.com/memorial/177898224",
		"id": 177898224,
		"lng": -77.38756911,
		"lat": 37.53730999,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 11,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lawrence",
		"nl": "Robertson",
		"url": "https://findagrave.com/memorial/144189167",
		"id": 144189167,
		"lng": -77.38590124,
		"lat": 37.53742656,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 7,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/117804450",
		"id": 117804450,
		"lng": -77.38546573,
		"lat": 37.53733739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 12,
		"dd": 24,
		"by": 1921,
		"bd": 13,
		"bm": 8,
		"nm": "Eloise",
		"nf": "Alma",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/156480524",
		"id": 156480524,
		"lng": -77.38573506,
		"lat": 37.53707867,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Armistead",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/126772103",
		"id": 126772103,
		"lng": -77.38782036,
		"lat": 37.53704295,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 7,
		"dd": 16,
		"by": 1897,
		"bd": 15,
		"bm": 10,
		"nm": "",
		"nf": "Arthur",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/150637828",
		"id": 150637828,
		"lng": -77.38637421,
		"lat": 37.53593329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 10,
		"dd": 27,
		"by": 1914,
		"bd": 2,
		"bm": 5,
		"nm": "",
		"nf": "Bessie",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/114399879",
		"id": 114399879,
		"lng": -77.38574059,
		"lat": 37.53681945,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 8,
		"dd": 9,
		"by": 1854,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Catherine",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/156656248",
		"id": 156656248,
		"lng": -77.3869832,
		"lat": 37.53554503,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 9,
		"dd": 22,
		"by": 1904,
		"bd": 26,
		"bm": 5,
		"nm": "J.",
		"nf": "Charles",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/168837068",
		"id": 168837068,
		"lng": -77.3865056,
		"lat": 37.53687745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 3,
		"dd": 12,
		"by": 1907,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Cornelius",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/175585521",
		"id": 175585521,
		"lng": -77.38704297,
		"lat": 37.53697232,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Crenshaw",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/125313084",
		"id": 125313084,
		"lng": -77.38800645,
		"lat": 37.53726818,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 6,
		"dd": 20,
		"by": 1911,
		"bd": 15,
		"bm": 4,
		"nm": "",
		"nf": "Ellerson",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/161636492",
		"id": 161636492,
		"lng": -77.3865617,
		"lat": 37.53665303,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 1,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emanuel",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/113626527",
		"id": 113626527,
		"lng": -77.38646247,
		"lat": 37.53658789,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 1,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eva",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/167465645",
		"id": 167465645,
		"lng": -77.38784425,
		"lat": 37.53727171,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 9,
		"dd": 12,
		"by": 1915,
		"bd": 17,
		"bm": 7,
		"nm": "J.",
		"nf": "Frederick",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/128675446",
		"id": 128675446,
		"lng": -77.38614298,
		"lat": 37.53661115,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 11,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/76605051",
		"id": 76605051,
		"lng": -77.38546336,
		"lat": 37.53734692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 12,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gertrude",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/130426364",
		"id": 130426364,
		"lng": -77.38607981,
		"lat": 37.53585238,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1983,
		"dm": 2,
		"dd": 26,
		"by": 1895,
		"bd": 22,
		"bm": 6,
		"nm": "Ann",
		"nf": "Grace",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/158335471",
		"id": 158335471,
		"lng": -77.38613933,
		"lat": 37.53661723,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 7,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Henry",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/175611552",
		"id": 175611552,
		"lng": -77.38767049,
		"lat": 37.5370649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 2,
		"dd": 3,
		"by": 1911,
		"bd": 24,
		"bm": 10,
		"nm": "W.",
		"nf": "Irvin",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/126456553",
		"id": 126456553,
		"lng": -77.38635052,
		"lat": 37.53600402,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/181156845",
		"id": 181156845,
		"lng": -77.38817101,
		"lat": 37.5375152,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 24,
		"by": 1894,
		"bd": 10,
		"bm": 9,
		"nm": "",
		"nf": "James",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/177762251",
		"id": 177762251,
		"lng": -77.38789898,
		"lat": 37.53746117,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 4,
		"dd": 23,
		"by": 1896,
		"bd": 21,
		"bm": 10,
		"nm": "Edward",
		"nf": "James",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/151267641",
		"id": 151267641,
		"lng": -77.386903,
		"lat": 37.53699571,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 26,
		"by": 1898,
		"bd": 1,
		"bm": 4,
		"nm": "",
		"nf": "Janie",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/173664292",
		"id": 173664292,
		"lng": -77.3870716,
		"lat": 37.53731218,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 1,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/158945986",
		"id": 158945986,
		"lng": -77.38693735,
		"lat": 37.53745619,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 9,
		"dd": 2,
		"by": 1891,
		"bd": 26,
		"bm": 12,
		"nm": "Luke",
		"nf": "John",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/150349823",
		"id": 150349823,
		"lng": -77.38652815,
		"lat": 37.53733523,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 4,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/151461546",
		"id": 151461546,
		"lng": -77.38815918,
		"lat": 37.5373957,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 4,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Justine",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/122793576",
		"id": 122793576,
		"lng": -77.38567329,
		"lat": 37.53699003,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 7,
		"dd": 3,
		"by": 1888,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Leanna",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/150349054",
		"id": 150349054,
		"lng": -77.38650431,
		"lat": 37.5373398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 2,
		"dd": 19,
		"by": 1934,
		"bd": 28,
		"bm": 11,
		"nm": "Thomas",
		"nf": "Lemuel",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/176767940",
		"id": 176767940,
		"lng": -77.38767274,
		"lat": 37.53687297,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 7,
		"by": 1890,
		"bd": 31,
		"bm": 7,
		"nm": "",
		"nf": "Leslie",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/173920533",
		"id": 173920533,
		"lng": -77.38713131,
		"lat": 37.53733916,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 30,
		"by": 1893,
		"bd": 14,
		"bm": 4,
		"nm": "",
		"nf": "Louis",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/125643956",
		"id": 125643956,
		"lng": -77.38576961,
		"lat": 37.5366203,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louise",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/141194255",
		"id": 141194255,
		"lng": -77.38644075,
		"lat": 37.53660257,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 1,
		"by": 1887,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "Lucy",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/187366765",
		"id": 187366765,
		"lng": -77.38762266,
		"lat": 37.53737617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 6,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maria",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/188438585",
		"id": 188438585,
		"lng": -77.38789608,
		"lat": 37.53701346,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 9,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/186818146",
		"id": 186818146,
		"lng": -77.38735959,
		"lat": 37.53708585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 10,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/151112006",
		"id": 151112006,
		"lng": -77.38680758,
		"lat": 37.53575979,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 12,
		"dd": 14,
		"by": 1908,
		"bd": 7,
		"bm": 7,
		"nm": "J.",
		"nf": "Mary",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/190047985",
		"id": 190047985,
		"lng": -77.38596553,
		"lat": 37.53632799,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 12,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/76605090",
		"id": 76605090,
		"lng": -77.38547371,
		"lat": 37.5373452,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 2,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Mattie",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/145838765",
		"id": 145838765,
		"lng": -77.3867074,
		"lat": 37.53577037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 1,
		"dd": 11,
		"by": 1891,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Nannie",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/128675455",
		"id": 128675455,
		"lng": -77.3860684,
		"lat": 37.53663833,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Page",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/177617289",
		"id": 177617289,
		"lng": -77.38698226,
		"lat": 37.53553775,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 1,
		"dd": 18,
		"by": 1907,
		"bd": 8,
		"bm": 4,
		"nm": "Henry",
		"nf": "Patrick",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/179570304",
		"id": 179570304,
		"lng": -77.3879292,
		"lat": 37.53765618,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 4,
		"by": 1918,
		"bd": 29,
		"bm": 3,
		"nm": "Esther",
		"nf": "Queen",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/148285773",
		"id": 148285773,
		"lng": -77.38643855,
		"lat": 37.53725213,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 6,
		"by": 1909,
		"bd": 6,
		"bm": 4,
		"nm": "Andrew",
		"nf": "Samuel",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/191417559",
		"id": 191417559,
		"lng": -77.38641119,
		"lat": 37.53743579,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 1,
		"dd": 27,
		"by": 1845,
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Sandy",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/151884949",
		"id": 151884949,
		"lng": -77.3867138,
		"lat": 37.5357584,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/188438924",
		"id": 188438924,
		"lng": -77.38794823,
		"lat": 37.53703209,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 5,
		"dd": 10,
		"by": 1925,
		"bd": 27,
		"bm": 2,
		"nm": "C.",
		"nf": "Walter",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/151942716",
		"id": 151942716,
		"lng": -77.38580608,
		"lat": 37.53721752,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/175421012",
		"id": 175421012,
		"lng": -77.38761808,
		"lat": 37.53716035,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/152794743",
		"id": 152794743,
		"lng": -77.38600175,
		"lat": 37.53745525,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 30,
		"by": 1913,
		"bd": 17,
		"bm": 12,
		"nm": "H",
		"nf": "Lacie",
		"nl": "Rogers",
		"url": "https://findagrave.com/memorial/143866092",
		"id": 143866092,
		"lng": -77.38604394,
		"lat": 37.53729632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 11,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Thomas",
		"nl": "Rogers",
		"url": "https://findagrave.com/memorial/161947672",
		"id": 161947672,
		"lng": -77.38582403,
		"lat": 37.53658479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Watson",
		"nl": "Rollison",
		"url": "https://findagrave.com/memorial/187744063",
		"id": 187744063,
		"lng": -77.38785248,
		"lat": 37.53694171,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 9,
		"dd": 2,
		"by": 1885,
		"bd": 5,
		"bm": 7,
		"nm": "Henry",
		"nf": "James",
		"nl": "Roots",
		"url": "https://findagrave.com/memorial/174597877",
		"id": 174597877,
		"lng": -77.38749343,
		"lat": 37.53717449,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 9,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Patsie",
		"nl": "Roots",
		"url": "https://findagrave.com/memorial/174783256",
		"id": 174783256,
		"lng": -77.38753807,
		"lat": 37.53700914,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 4,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rebecca",
		"nl": "Roots",
		"url": "https://findagrave.com/memorial/174112659",
		"id": 174112659,
		"lng": -77.38750114,
		"lat": 37.53715536,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 7,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eva",
		"nl": "Rose",
		"url": "https://findagrave.com/memorial/187898056",
		"id": 187898056,
		"lng": -77.38797673,
		"lat": 37.53716818,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 5,
		"dd": 16,
		"by": 1898,
		"bd": 14,
		"bm": 9,
		"nm": "G.",
		"nf": "Minnie",
		"nl": "Rose",
		"url": "https://findagrave.com/memorial/185658495",
		"id": 185658495,
		"lng": -77.38743698,
		"lat": 37.53768317,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 21,
		"by": 1894,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Otelia",
		"nl": "Rose",
		"url": "https://findagrave.com/memorial/138570905",
		"id": 138570905,
		"lng": -77.38628948,
		"lat": 37.53659736,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 13,
		"by": 1894,
		"bd": 4,
		"bm": 6,
		"nm": "",
		"nf": "William",
		"nl": "Rose",
		"url": "https://findagrave.com/memorial/144013918",
		"id": 144013918,
		"lng": -77.3872129,
		"lat": 37.53764247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Atelia",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/152318042",
		"id": 152318042,
		"lng": -77.386858,
		"lat": 37.53576204,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 9,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clara",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/184398967",
		"id": 184398967,
		"lng": -77.38785953,
		"lat": 37.53693594,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cornelious",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/207135161",
		"id": 207135161,
		"lng": -77.38625149,
		"lat": 37.53535526,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 9,
		"by": 1962,
		"bd": 8,
		"bm": 10,
		"nm": "Vonzell",
		"nf": "Felipe",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/159416168",
		"id": 159416168,
		"lng": -77.38615816,
		"lat": 37.53750928,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Carpenter",
		"nf": "Mattie",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/174710152",
		"id": 174710152,
		"lng": -77.38755193,
		"lat": 37.53699811,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 1,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pearl",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/183194584",
		"id": 183194584,
		"lng": -77.38717517,
		"lat": 37.53702926,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 8,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Philip",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/183718560",
		"id": 183718560,
		"lng": -77.38699129,
		"lat": 37.53700685,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 8,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rolley",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/179535043",
		"id": 179535043,
		"lng": -77.38796575,
		"lat": 37.53765307,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 8,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Elizabeth",
		"nf": "Sarah",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/148285788",
		"id": 148285788,
		"lng": -77.38624484,
		"lat": 37.53533626,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 5,
		"dd": 4,
		"by": 1938,
		"bd": 27,
		"bm": 2,
		"nm": "Y.",
		"nf": "Dorothy",
		"nl": "Rowe",
		"url": "https://findagrave.com/memorial/160335453",
		"id": 160335453,
		"lng": -77.38611549,
		"lat": 37.53634528,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 1,
		"dd": 1,
		"by": 1929,
		"bd": 28,
		"bm": 10,
		"nm": "",
		"nf": "Fannie",
		"nl": "Royster",
		"url": "https://findagrave.com/memorial/145596030",
		"id": 145596030,
		"lng": -77.38621077,
		"lat": 37.5373868,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 30,
		"by": 1965,
		"bd": 11,
		"bm": 5,
		"nm": "Ann",
		"nf": "Mary",
		"nl": "Royster",
		"url": "https://findagrave.com/memorial/142106240",
		"id": 142106240,
		"lng": -77.38596538,
		"lat": 37.53743904,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 8,
		"dd": 1,
		"by": 1900,
		"bd": 9,
		"bm": 4,
		"nm": "Lee",
		"nf": "Milton",
		"nl": "Royster",
		"url": "https://findagrave.com/memorial/156215163",
		"id": 156215163,
		"lng": -77.38685798,
		"lat": 37.53543129,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Milton",
		"nl": "Royster",
		"url": "https://findagrave.com/memorial/151449325",
		"id": 151449325,
		"lng": -77.38686447,
		"lat": 37.53541574,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 28,
		"by": 1900,
		"bd": 29,
		"bm": 10,
		"nm": "",
		"nf": "Pearl",
		"nl": "Rucker",
		"url": "https://findagrave.com/memorial/187366771",
		"id": 187366771,
		"lng": -77.38712576,
		"lat": 37.53689353,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 5,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frazier",
		"nl": "Ruffin",
		"url": "https://findagrave.com/memorial/176055817",
		"id": 176055817,
		"lng": -77.38734483,
		"lat": 37.53704303,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 6,
		"dd": 17,
		"by": 1891,
		"bd": "",
		"bm": 4,
		"nm": "Ann",
		"nf": "Sallie",
		"nl": "Ruffin",
		"url": "https://findagrave.com/memorial/120147071",
		"id": 120147071,
		"lng": -77.38598357,
		"lat": 37.53674858,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 18,
		"by": 1962,
		"bd": 18,
		"bm": 10,
		"nm": "",
		"nf": "Ernestine",
		"nl": "Russell",
		"url": "https://findagrave.com/memorial/169041076",
		"id": 169041076,
		"lng": -77.3861343,
		"lat": 37.53749592,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 9,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ella",
		"nl": "Russell",
		"url": "https://findagrave.com/memorial/174694011",
		"id": 174694011,
		"lng": -77.38680126,
		"lat": 37.53769082,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 12,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Russell",
		"url": "https://findagrave.com/memorial/149201622",
		"id": 149201622,
		"lng": -77.38616764,
		"lat": 37.53608125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 4,
		"dd": 25,
		"by": 1891,
		"bd": 10,
		"bm": 8,
		"nm": "",
		"nf": "Armstead",
		"nl": "Rustin",
		"url": "https://findagrave.com/memorial/138366556",
		"id": 138366556,
		"lng": -77.38663166,
		"lat": 37.53696533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 7,
		"dd": 13,
		"by": 1925,
		"bd": 3,
		"bm": 3,
		"nm": "",
		"nf": "Maria",
		"nl": "Rustin",
		"url": "https://findagrave.com/memorial/169281489",
		"id": 169281489,
		"lng": -77.38654984,
		"lat": 37.53683499,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 6,
		"dd": 30,
		"by": 1891,
		"bd": 8,
		"bm": 8,
		"nm": "",
		"nf": "Vearylant",
		"nl": "Rustin",
		"url": "https://findagrave.com/memorial/174599396",
		"id": 174599396,
		"lng": -77.38717936,
		"lat": 37.5369697,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 7,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Martha",
		"nl": "Sales",
		"url": "https://findagrave.com/memorial/175402352",
		"id": 175402352,
		"lng": -77.38753516,
		"lat": 37.53696456,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 4,
		"dd": 14,
		"by": 1908,
		"bd": 6,
		"bm": 11,
		"nm": "",
		"nf": "Maggie",
		"nl": "Sampson",
		"url": "https://findagrave.com/memorial/128675475",
		"id": 128675475,
		"lng": -77.38619831,
		"lat": 37.53664371,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 9,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Leroy",
		"nl": "Samuels",
		"url": "https://findagrave.com/memorial/149202699",
		"id": 149202699,
		"lng": -77.38629525,
		"lat": 37.53548007,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 25,
		"by": 1918,
		"bd": 16,
		"bm": 3,
		"nm": "",
		"nf": "Margaret",
		"nl": "Sanford",
		"url": "https://findagrave.com/memorial/191503854",
		"id": 191503854,
		"lng": -77.38646494,
		"lat": 37.53741211,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": 4,
		"dd": 30,
		"by": 1894,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jack",
		"nl": "Santos",
		"url": "https://findagrave.com/memorial/141800964",
		"id": 141800964,
		"lng": -77.38666154,
		"lat": 37.53729468,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 12,
		"dd": 19,
		"by": 1908,
		"bd": 1,
		"bm": 7,
		"nm": "Maria",
		"nf": "Sallie",
		"nl": "Santos",
		"url": "https://findagrave.com/memorial/141701282",
		"id": 141701282,
		"lng": -77.38668339,
		"lat": 37.53731403,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1988,
		"dm": "",
		"dd": "",
		"by": 1912,
		"bd": "",
		"bm": "",
		"nm": "Ernestine",
		"nf": "Alice",
		"nl": "Satterwhite",
		"url": "https://findagrave.com/memorial/122027614",
		"id": 122027614,
		"lng": -77.38602224,
		"lat": 37.53661986,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 6,
		"dd": 30,
		"by": 1887,
		"bd": 24,
		"bm": 4,
		"nm": "",
		"nf": "Clotelle",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/182608061",
		"id": 182608061,
		"lng": -77.38628108,
		"lat": 37.5354613,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 12,
		"dd": 29,
		"by": 1937,
		"bd": 8,
		"bm": 8,
		"nm": "Lil",
		"nf": "Hannah",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/156187918",
		"id": 156187918,
		"lng": -77.38639522,
		"lat": 37.5353067,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 9,
		"dd": 11,
		"by": 1855,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/130426370",
		"id": 130426370,
		"lng": -77.38608383,
		"lat": 37.53584244,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 3,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lelia",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/174796572",
		"id": 174796572,
		"lng": -77.38764274,
		"lat": 37.5369204,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 12,
		"dd": 3,
		"by": 1902,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pearl",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/127569742",
		"id": 127569742,
		"lng": -77.38610469,
		"lat": 37.53708106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 7,
		"by": 1900,
		"bd": 12,
		"bm": 4,
		"nm": "",
		"nf": "Martha",
		"nl": "Sayles",
		"url": "https://findagrave.com/memorial/155021683",
		"id": 155021683,
		"lng": -77.38688097,
		"lat": 37.53734845,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 6,
		"dd": 13,
		"by": 1894,
		"bd": "",
		"bm": 2,
		"nm": "",
		"nf": "Percy",
		"nl": "Sayles",
		"url": "https://findagrave.com/memorial/155021695",
		"id": 155021695,
		"lng": -77.38687807,
		"lat": 37.53735592,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 11,
		"dd": 17,
		"by": 1882,
		"bd": 29,
		"bm": 10,
		"nm": "P.",
		"nf": "Adalena",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/132642689",
		"id": 132642689,
		"lng": -77.38774921,
		"lat": 37.53653861,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/143191589",
		"id": 143191589,
		"lng": -77.38636614,
		"lat": 37.53566835,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 9,
		"dd": 5,
		"by": 1864,
		"bd": "",
		"bm": 10,
		"nm": "",
		"nf": "Alpheus",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/125643969",
		"id": 125643969,
		"lng": -77.38554856,
		"lat": 37.5371342,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 3,
		"dd": 7,
		"by": 1883,
		"bd": 19,
		"bm": 12,
		"nm": "J.",
		"nf": "Andrew",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/127881103",
		"id": 127881103,
		"lng": -77.38628046,
		"lat": 37.53635851,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 5,
		"dd": 20,
		"by": 1890,
		"bd": 11,
		"bm": 3,
		"nm": "F.",
		"nf": "Arthur",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/127881109",
		"id": 127881109,
		"lng": -77.38628226,
		"lat": 37.53636813,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Bedford",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/143191584",
		"id": 143191584,
		"lng": -77.38636872,
		"lat": 37.53566863,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 23,
		"by": 1894,
		"bd": 10,
		"bm": 11,
		"nm": "C.",
		"nf": "Bertha",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/76605146",
		"id": 76605146,
		"lng": -77.38610905,
		"lat": 37.53700661,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 5,
		"dd": 27,
		"by": 1900,
		"bd": 15,
		"bm": 9,
		"nm": "Booker",
		"nf": "Charles",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/158945994",
		"id": 158945994,
		"lng": -77.3868997,
		"lat": 37.53750481,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 11,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Charles",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/134474453",
		"id": 134474453,
		"lng": -77.38611528,
		"lat": 37.53699179,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 6,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elsie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/121796893",
		"id": 121796893,
		"lng": -77.38578641,
		"lat": 37.53654221,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 10,
		"dd": 8,
		"by": 1893,
		"bd": 6,
		"bm": 8,
		"nm": "",
		"nf": "Eugenia",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/147853894",
		"id": 147853894,
		"lng": -77.38602868,
		"lat": 37.53629425,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 6,
		"dd": 29,
		"by": 1876,
		"bd": 3,
		"bm": 6,
		"nm": "",
		"nf": "Everlina",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/185658500",
		"id": 185658500,
		"lng": -77.38725134,
		"lat": 37.53772579,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 1,
		"dd": 19,
		"by": 1884,
		"bd": 17,
		"bm": 6,
		"nm": "B.",
		"nf": "Fannie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/132642749",
		"id": 132642749,
		"lng": -77.38775131,
		"lat": 37.53653021,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Fannie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/156613217",
		"id": 156613217,
		"lng": -77.3863927,
		"lat": 37.53711959,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 7,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Irene",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/125313091",
		"id": 125313091,
		"lng": -77.38593401,
		"lat": 37.53685348,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 6,
		"dd": 3,
		"by": 1874,
		"bd": 5,
		"bm": 1,
		"nm": "Emmett",
		"nf": "James",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/143191743",
		"id": 143191743,
		"lng": -77.38636571,
		"lat": 37.53567107,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 12,
		"dd": 4,
		"by": 1858,
		"bd": "",
		"bm": 3,
		"nm": "Wesley P.",
		"nf": "John",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/132642759",
		"id": 132642759,
		"lng": -77.38772269,
		"lat": 37.53654347,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "John",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/143191735",
		"id": 143191735,
		"lng": -77.38636839,
		"lat": 37.53567125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 6,
		"by": 1891,
		"bd": 3,
		"bm": 9,
		"nm": "Mitchell",
		"nf": "John",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/143192310",
		"id": 143192310,
		"lng": -77.38602847,
		"lat": 37.53732341,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "John",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/114466968",
		"id": 114466968,
		"lng": -77.38593031,
		"lat": 37.53686472,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 10,
		"dd": 10,
		"by": 1891,
		"bd": 11,
		"bm": 9,
		"nm": "",
		"nf": "Joseph",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/172198018",
		"id": 172198018,
		"lng": -77.3864258,
		"lat": 37.53533403,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 3,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Josephine",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/143191604",
		"id": 143191604,
		"lng": -77.38636358,
		"lat": 37.53567933,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 3,
		"dd": 19,
		"by": 1859,
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Julia",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/139424729",
		"id": 139424729,
		"lng": -77.38629625,
		"lat": 37.53637804,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 22,
		"by": 1914,
		"bd": 24,
		"bm": 6,
		"nm": "",
		"nf": "Katheleen",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/177325999",
		"id": 177325999,
		"lng": -77.38750771,
		"lat": 37.53731306,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 26,
		"by": 1913,
		"bd": 6,
		"bm": 2,
		"nm": "",
		"nf": "Leaonza",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/176939600",
		"id": 176939600,
		"lng": -77.38697358,
		"lat": 37.53753645,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 2,
		"dd": 25,
		"by": 1895,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Lenard",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/183718565",
		"id": 183718565,
		"lng": -77.38699827,
		"lat": 37.53682879,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 9,
		"dd": 30,
		"by": 1876,
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Lucie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/144821921",
		"id": 144821921,
		"lng": -77.3855573,
		"lat": 37.53715447,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 6,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luther",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/136306541",
		"id": 136306541,
		"lng": -77.38629516,
		"lat": 37.53634335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maggie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/187368543",
		"id": 187368543,
		"lng": -77.38732542,
		"lat": 37.53732644,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 1,
		"dd": 18,
		"by": 1861,
		"bd": "",
		"bm": 5,
		"nm": "",
		"nf": "Rosanna",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/132642764",
		"id": 132642764,
		"lng": -77.38772521,
		"lat": 37.53653516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Sadie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/155782478",
		"id": 155782478,
		"lng": -77.38724025,
		"lat": 37.53558498,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 9,
		"dd": 28,
		"by": 1888,
		"bd": 5,
		"bm": 10,
		"nm": "W.",
		"nf": "Samuel",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/127881119",
		"id": 127881119,
		"lng": -77.3862816,
		"lat": 37.53634833,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 8,
		"by": 1870,
		"bd": 18,
		"bm": 3,
		"nm": "",
		"nf": "Susie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/176277199",
		"id": 176277199,
		"lng": -77.3877853,
		"lat": 37.5373829,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 10,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/125843832",
		"id": 125843832,
		"lng": -77.38636643,
		"lat": 37.5358896,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 9,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sally",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/192423887",
		"id": 192423887,
		"lng": -77.38741527,
		"lat": 37.53716395,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gertrude",
		"nl": "Sears",
		"url": "https://findagrave.com/memorial/174712618",
		"id": 174712618,
		"lng": -77.38659378,
		"lat": 37.53709516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L",
		"nf": "Carlton",
		"nl": "Seay",
		"url": "https://findagrave.com/memorial/149353188",
		"id": 149353188,
		"lng": -77.38663376,
		"lat": 37.5371906,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 12,
		"dd": 13,
		"by": 1844,
		"bd": 14,
		"bm": 2,
		"nm": "M.",
		"nf": "Hannah",
		"nl": "Selden",
		"url": "https://findagrave.com/memorial/138570922",
		"id": 138570922,
		"lng": -77.38635702,
		"lat": 37.53655049,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rachel",
		"nl": "Selden",
		"url": "https://findagrave.com/memorial/138570933",
		"id": 138570933,
		"lng": -77.38635766,
		"lat": 37.53654154,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 12,
		"dd": 13,
		"by": 1850,
		"bd": "",
		"bm": 2,
		"nm": "S.",
		"nf": "William",
		"nl": "Selden",
		"url": "https://findagrave.com/memorial/138570948",
		"id": 138570948,
		"lng": -77.38632834,
		"lat": 37.53653661,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Sexton",
		"url": "https://findagrave.com/memorial/144013922",
		"id": 144013922,
		"lng": -77.38604807,
		"lat": 37.5372614,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 3,
		"dd": 1,
		"by": 1916,
		"bd": 14,
		"bm": 8,
		"nm": "C.",
		"nf": "Alvin",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/152369063",
		"id": 152369063,
		"lng": -77.38649758,
		"lat": 37.53739412,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 28,
		"by": 1966,
		"bd": 2,
		"bm": 8,
		"nm": "",
		"nf": "Andrew",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/142106261",
		"id": 142106261,
		"lng": -77.38594514,
		"lat": 37.53744736,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 30,
		"by": 1880,
		"bd": 8,
		"bm": 4,
		"nm": "",
		"nf": "Kenneth",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/168940043",
		"id": 168940043,
		"lng": -77.38598338,
		"lat": 37.537341,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 2,
		"dd": 20,
		"by": 1897,
		"bd": 21,
		"bm": 6,
		"nm": "L.",
		"nf": "Maria",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/144226110",
		"id": 144226110,
		"lng": -77.38649618,
		"lat": 37.53740422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 9,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ellen",
		"nf": "Mary",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/139146939",
		"id": 139146939,
		"lng": -77.38628884,
		"lat": 37.53653423,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 8,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Edward",
		"nf": "Thomas",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/139146947",
		"id": 139146947,
		"lng": -77.38628225,
		"lat": 37.53654864,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 6,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virginia",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/141446518",
		"id": 141446518,
		"lng": -77.38703229,
		"lat": 37.53745379,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 4,
		"dd": 26,
		"by": 1888,
		"bd": 18,
		"bm": 3,
		"nm": "",
		"nf": "Virginia",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/143866253",
		"id": 143866253,
		"lng": -77.38678898,
		"lat": 37.53668718,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 6,
		"dd": 11,
		"by": 1898,
		"bd": 2,
		"bm": 2,
		"nm": "",
		"nf": "Izetta",
		"nl": "Shelton",
		"url": "https://findagrave.com/memorial/192387018",
		"id": 192387018,
		"lng": -77.38630907,
		"lat": 37.53527374,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1854,
		"bd": 25,
		"bm": 12,
		"nm": "T.",
		"nf": "L.",
		"nl": "Shepard",
		"url": "https://findagrave.com/memorial/150792692",
		"id": 150792692,
		"lng": -77.38619457,
		"lat": 37.53565428,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Cora",
		"nl": "Sherman",
		"url": "https://findagrave.com/memorial/137430832",
		"id": 137430832,
		"lng": -77.38597126,
		"lat": 37.53709701,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Willie",
		"nl": "Sherman",
		"url": "https://findagrave.com/memorial/137430845",
		"id": 137430845,
		"lng": -77.38597342,
		"lat": 37.53709049,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 9,
		"by": 1920,
		"bd": 20,
		"bm": 8,
		"nm": "",
		"nf": "Lossie",
		"nl": "Sherod",
		"url": "https://findagrave.com/memorial/191503858",
		"id": 191503858,
		"lng": -77.38626867,
		"lat": 37.53736721,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 14,
		"by": 1905,
		"bd": 30,
		"bm": 12,
		"nm": "",
		"nf": "Josephine",
		"nl": "Simmons",
		"url": "https://findagrave.com/memorial/183718574",
		"id": 183718574,
		"lng": -77.38636963,
		"lat": 37.53669044,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 7,
		"dd": 5,
		"by": 1874,
		"bd": 15,
		"bm": 11,
		"nm": "",
		"nf": "Eddie",
		"nl": "Simms",
		"url": "https://findagrave.com/memorial/125843846",
		"id": 125843846,
		"lng": -77.3860946,
		"lat": 37.53684047,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 12,
		"dd": 22,
		"by": 1865,
		"bd": 26,
		"bm": 12,
		"nm": "",
		"nf": "Ella",
		"nl": "Simms",
		"url": "https://findagrave.com/memorial/136173084",
		"id": 136173084,
		"lng": -77.38622161,
		"lat": 37.53647515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 28,
		"by": 1917,
		"bd": 20,
		"bm": 10,
		"nm": "Ella",
		"nf": "Mary",
		"nl": "Simms",
		"url": "https://findagrave.com/memorial/187368549",
		"id": 187368549,
		"lng": -77.38726296,
		"lat": 37.53729016,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 29,
		"by": 1962,
		"bd": 3,
		"bm": 7,
		"nm": "",
		"nf": "Sharon",
		"nl": "Simms",
		"url": "https://findagrave.com/memorial/176205280",
		"id": 176205280,
		"lng": -77.38619741,
		"lat": 37.53752318,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 2,
		"dd": 10,
		"by": 1897,
		"bd": 26,
		"bm": 6,
		"nm": "Lee",
		"nf": "Herbert",
		"nl": "Simpson",
		"url": "https://findagrave.com/memorial/185658502",
		"id": 185658502,
		"lng": -77.38725582,
		"lat": 37.5376087,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 6,
		"dd": 29,
		"by": 1927,
		"bd": 12,
		"bm": 4,
		"nm": "Grant",
		"nf": "Ulysses",
		"nl": "Simpson",
		"url": "https://findagrave.com/memorial/166049761",
		"id": 166049761,
		"lng": -77.38657772,
		"lat": 37.53678586,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 5,
		"by": "",
		"bd": 1,
		"bm": 11,
		"nm": "",
		"nf": "Maria",
		"nl": "Sims",
		"url": "https://findagrave.com/memorial/163611606",
		"id": 163611606,
		"lng": -77.38764516,
		"lat": 37.53764234,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 19,
		"by": 1877,
		"bd": 18,
		"bm": 2,
		"nm": "",
		"nf": "Julia",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/149202705",
		"id": 149202705,
		"lng": -77.3863339,
		"lat": 37.53543506,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1983,
		"dm": 2,
		"dd": 22,
		"by": 1896,
		"bd": 26,
		"bm": 7,
		"nm": "",
		"nf": "Julia",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/125843857",
		"id": 125843857,
		"lng": -77.38573321,
		"lat": 37.53730342,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 10,
		"dd": 7,
		"by": 1837,
		"bd": 16,
		"bm": 8,
		"nm": "",
		"nf": "Margaret",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/149202731",
		"id": 149202731,
		"lng": -77.38632135,
		"lat": 37.53541658,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 3,
		"dd": 8,
		"by": 1872,
		"bd": 16,
		"bm": 1,
		"nm": "S.",
		"nf": "Meschach",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/149202723",
		"id": 149202723,
		"lng": -77.38632353,
		"lat": 37.53541698,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 10,
		"dd": 28,
		"by": 1921,
		"bd": 26,
		"bm": 3,
		"nm": "",
		"nf": "Pearl",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/138012346",
		"id": 138012346,
		"lng": -77.38668047,
		"lat": 37.53706555,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 12,
		"dd": 2,
		"by": 1873,
		"bd": 14,
		"bm": 2,
		"nm": "V.",
		"nf": "Susie",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/149202771",
		"id": 149202771,
		"lng": -77.38632187,
		"lat": 37.53541494,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 1,
		"dd": 8,
		"by": 1868,
		"bd": 14,
		"bm": 10,
		"nm": "Grant",
		"nf": "William",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/149202762",
		"id": 149202762,
		"lng": -77.38632406,
		"lat": 37.53541534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 4,
		"dd": 4,
		"by": 1883,
		"bd": 21,
		"bm": 10,
		"nm": "",
		"nf": "Edward",
		"nl": "Sizer",
		"url": "https://findagrave.com/memorial/119328053",
		"id": 119328053,
		"lng": -77.38551718,
		"lat": 37.5372936,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 10,
		"by": 1914,
		"bd": 28,
		"bm": 9,
		"nm": "",
		"nf": "Roberta",
		"nl": "Skinner",
		"url": "https://findagrave.com/memorial/177285943",
		"id": 177285943,
		"lng": -77.38737008,
		"lat": 37.53730691,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 10,
		"by": 1900,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Slade",
		"url": "https://findagrave.com/memorial/171780414",
		"id": 171780414,
		"lng": -77.38698918,
		"lat": 37.53717938,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Julia",
		"nl": "Slade",
		"url": "https://findagrave.com/memorial/170839590",
		"id": 170839590,
		"lng": -77.38643506,
		"lat": 37.53703064,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 10,
		"dd": 23,
		"by": 1913,
		"bd": 17,
		"bm": 4,
		"nm": "",
		"nf": "Alberta",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/157646057",
		"id": 157646057,
		"lng": -77.38662209,
		"lat": 37.53739563,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 5,
		"by": 1900,
		"bd": 27,
		"bm": 12,
		"nm": "T.",
		"nf": "Andrew",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/169397393",
		"id": 169397393,
		"lng": -77.38653116,
		"lat": 37.53679135,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 8,
		"by": 1915,
		"bd": 30,
		"bm": 4,
		"nm": "H.",
		"nf": "Arthur",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/174857774",
		"id": 174857774,
		"lng": -77.38723175,
		"lat": 37.53736561,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby boy",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/159762363",
		"id": 159762363,
		"lng": -77.38629081,
		"lat": 37.53757239,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 7,
		"dd": 19,
		"by": 1883,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Belle",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/129211495",
		"id": 129211495,
		"lng": -77.38559648,
		"lat": 37.53710733,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 10,
		"dd": 20,
		"by": 1895,
		"bd": 25,
		"bm": 6,
		"nm": "",
		"nf": "Bessie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/176467943",
		"id": 176467943,
		"lng": -77.38714843,
		"lat": 37.53692084,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 5,
		"dd": 20,
		"by": 1884,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Carrie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/128452629",
		"id": 128452629,
		"lng": -77.38561614,
		"lat": 37.53698966,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 6,
		"dd": 23,
		"by": 1901,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/151049026",
		"id": 151049026,
		"lng": -77.38645045,
		"lat": 37.53569533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 8,
		"dd": 28,
		"by": 1949,
		"bd": 21,
		"bm": 5,
		"nm": "Elmore",
		"nf": "Charles",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/185392992",
		"id": 185392992,
		"lng": -77.38595733,
		"lat": 37.53627425,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 9,
		"dd": 9,
		"by": 1850,
		"bd": 6,
		"bm": 9,
		"nm": "E.",
		"nf": "Charles",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/132642773",
		"id": 132642773,
		"lng": -77.38784914,
		"lat": 37.53632146,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": 9,
		"dd": 28,
		"by": 1901,
		"bd": 17,
		"bm": 3,
		"nm": "",
		"nf": "Charlotte",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/141701290",
		"id": 141701290,
		"lng": -77.38662194,
		"lat": 37.53729361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1982,
		"dm": 11,
		"dd": 17,
		"by": 1885,
		"bd": 3,
		"bm": 7,
		"nm": "",
		"nf": "Chassie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/138572940",
		"id": 138572940,
		"lng": -77.38625176,
		"lat": 37.53669576,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 12,
		"dd": 31,
		"by": 1906,
		"bd": 23,
		"bm": 11,
		"nm": "L.",
		"nf": "Clarence",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/142469229",
		"id": 142469229,
		"lng": -77.38729005,
		"lat": 37.53784084,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 10,
		"dd": 11,
		"by": 1917,
		"bd": "",
		"bm": "",
		"nm": "Richard",
		"nf": "Cleo",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/142531408",
		"id": 142531408,
		"lng": -77.38648263,
		"lat": 37.5353387,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 1,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clifton",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/158678498",
		"id": 158678498,
		"lng": -77.38671594,
		"lat": 37.53757308,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 3,
		"by": 1897,
		"bd": 15,
		"bm": 2,
		"nm": "",
		"nf": "Doc",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/170839563",
		"id": 170839563,
		"lng": -77.38656474,
		"lat": 37.5370723,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 6,
		"dd": 26,
		"by": 1927,
		"bd": 27,
		"bm": 12,
		"nm": "Ann",
		"nf": "Dorothy",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/173166614",
		"id": 173166614,
		"lng": -77.3870841,
		"lat": 37.5368387,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 4,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Earnest",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/138572956",
		"id": 138572956,
		"lng": -77.38619754,
		"lat": 37.53671491,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 6,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "V.",
		"nf": "Ella",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/128675482",
		"id": 128675482,
		"lng": -77.3861365,
		"lat": 37.53665806,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 27,
		"by": 1909,
		"bd": 3,
		"bm": 2,
		"nm": "",
		"nf": "Ethel",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/174698190",
		"id": 174698190,
		"lng": -77.3875332,
		"lat": 37.53701714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 5,
		"by": 1913,
		"bd": 18,
		"bm": 5,
		"nm": "F.",
		"nf": "Etta",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/157165936",
		"id": 157165936,
		"lng": -77.38648349,
		"lat": 37.53586005,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 1,
		"dd": 31,
		"by": 1899,
		"bd": 25,
		"bm": 5,
		"nm": "",
		"nf": "Eva",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/149696118",
		"id": 149696118,
		"lng": -77.38694478,
		"lat": 37.53660497,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Evelyn",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/111589854",
		"id": 111589854,
		"lng": -77.387311,
		"lat": 37.53755306,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 8,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "George",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/155539550",
		"id": 155539550,
		"lng": -77.38677205,
		"lat": 37.53590902,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 1,
		"dd": 22,
		"by": 1887,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/175585524",
		"id": 175585524,
		"lng": -77.38664548,
		"lat": 37.5353865,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 8,
		"dd": 19,
		"by": 1945,
		"bd": 21,
		"bm": 10,
		"nm": "Edward",
		"nf": "George",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/157623692",
		"id": 157623692,
		"lng": -77.38674865,
		"lat": 37.53746505,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 1,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Margaret",
		"nf": "Gertrude",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/128452633",
		"id": 128452633,
		"lng": -77.38561385,
		"lat": 37.53700373,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Helen",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/146207081",
		"id": 146207081,
		"lng": -77.38659088,
		"lat": 37.53664634,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 24,
		"by": 1906,
		"bd": 7,
		"bm": 3,
		"nm": "C.",
		"nf": "Henry",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/128675495",
		"id": 128675495,
		"lng": -77.38614045,
		"lat": 37.53665307,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Irene",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/141801148",
		"id": 141801148,
		"lng": -77.38659878,
		"lat": 37.53726933,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 8,
		"by": 1902,
		"bd": 25,
		"bm": 3,
		"nm": "",
		"nf": "Isaac",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/111589857",
		"id": 111589857,
		"lng": -77.38659708,
		"lat": 37.53728929,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 8,
		"dd": 3,
		"by": 1901,
		"bd": 25,
		"bm": 12,
		"nm": "Tenson",
		"nf": "Ivrie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/158924529",
		"id": 158924529,
		"lng": -77.38659605,
		"lat": 37.53758788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 10,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jackson",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/187744368",
		"id": 187744368,
		"lng": -77.38770811,
		"lat": 37.53694275,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 12,
		"dd": 29,
		"by": 1867,
		"bd": 18,
		"bm": 6,
		"nm": "C.",
		"nf": "James",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/150920532",
		"id": 150920532,
		"lng": -77.38632347,
		"lat": 37.5355821,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 11,
		"dd": 2,
		"by": 1938,
		"bd": 21,
		"bm": 8,
		"nm": "",
		"nf": "Jene",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/176097675",
		"id": 176097675,
		"lng": -77.38734186,
		"lat": 37.53690302,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "John",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/188590736",
		"id": 188590736,
		"lng": -77.38615282,
		"lat": 37.53562518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "John",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/178152992",
		"id": 178152992,
		"lng": -77.38775329,
		"lat": 37.53717746,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 2,
		"dd": 12,
		"by": 1891,
		"bd": 29,
		"bm": 3,
		"nm": "F.",
		"nf": "Joseph",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/161051897",
		"id": 161051897,
		"lng": -77.3871141,
		"lat": 37.53705797,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 28,
		"by": 1899,
		"bd": 16,
		"bm": 9,
		"nm": "",
		"nf": "Joseph",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/138572968",
		"id": 138572968,
		"lng": -77.38624461,
		"lat": 37.53671521,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 2,
		"dd": 28,
		"by": 1895,
		"bd": 10,
		"bm": 9,
		"nm": "",
		"nf": "Josephine",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/128675505",
		"id": 128675505,
		"lng": -77.38613325,
		"lat": 37.53666366,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 16,
		"by": 1888,
		"bd": 18,
		"bm": 5,
		"nm": "Edward",
		"nf": "Julius",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/151267777",
		"id": 151267777,
		"lng": -77.38700153,
		"lat": 37.53546898,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 11,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Junius",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/181956340",
		"id": 181956340,
		"lng": -77.38774428,
		"lat": 37.53645635,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Leroy",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/148285797",
		"id": 148285797,
		"lng": -77.38638969,
		"lat": 37.53721205,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 14,
		"by": 1893,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Lillie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/154303989",
		"id": 154303989,
		"lng": -77.38701752,
		"lat": 37.53543204,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 7,
		"dd": 28,
		"by": 1895,
		"bd": 26,
		"bm": 10,
		"nm": "H",
		"nf": "Linwood",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/156354482",
		"id": 156354482,
		"lng": -77.38646989,
		"lat": 37.53593234,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 11,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lizzie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/158532807",
		"id": 158532807,
		"lng": -77.38685226,
		"lat": 37.53765825,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Madeline",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/187368553",
		"id": 187368553,
		"lng": -77.38764045,
		"lat": 37.53782397,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/185541031",
		"id": 185541031,
		"lng": -77.38785912,
		"lat": 37.53710191,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "O.",
		"nf": "Mary",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/166816466",
		"id": 166816466,
		"lng": -77.38811577,
		"lat": 37.53749977,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mattie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/173918724",
		"id": 173918724,
		"lng": -77.38756504,
		"lat": 37.53711768,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 9,
		"dd": 17,
		"by": 1896,
		"bd": 27,
		"bm": 5,
		"nm": "W.",
		"nf": "Monroe",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/149696123",
		"id": 149696123,
		"lng": -77.38694811,
		"lat": 37.53659734,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 6,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nancy",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/188268780",
		"id": 188268780,
		"lng": -77.38788086,
		"lat": 37.53711295,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 2,
		"dd": 7,
		"by": 1918,
		"bd": 25,
		"bm": 5,
		"nm": "E.",
		"nf": "Olivia",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/171780420",
		"id": 171780420,
		"lng": -77.38677107,
		"lat": 37.53685204,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1985,
		"dm": 10,
		"dd": 26,
		"by": 1909,
		"bd": 26,
		"bm": 9,
		"nm": "",
		"nf": "Rebecca",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/127992091",
		"id": 127992091,
		"lng": -77.38611647,
		"lat": 37.53665818,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 7,
		"by": 1953,
		"bd": 22,
		"bm": 8,
		"nm": "LeRoy",
		"nf": "Richard",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/166049597",
		"id": 166049597,
		"lng": -77.38646201,
		"lat": 37.53675128,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 9,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/176228666",
		"id": 176228666,
		"lng": -77.38631415,
		"lat": 37.53753285,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 10,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Francis",
		"nf": "Rosa",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/155539560",
		"id": 155539560,
		"lng": -77.38694524,
		"lat": 37.53546309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 2,
		"dd": 24,
		"by": 1882,
		"bd": "",
		"bm": 10,
		"nm": "R.",
		"nf": "Rosa",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/116948333",
		"id": 116948333,
		"lng": -77.38576263,
		"lat": 37.53673928,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 9,
		"dd": 20,
		"by": 1885,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "Sallie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/155021704",
		"id": 155021704,
		"lng": -77.38654261,
		"lat": 37.53754541,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": "",
		"dd": "",
		"by": 1834,
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Sallie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/130426380",
		"id": 130426380,
		"lng": -77.38607363,
		"lat": 37.53582772,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/150881885",
		"id": 150881885,
		"lng": -77.38652902,
		"lat": 37.53587147,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 31,
		"by": 1900,
		"bd": 17,
		"bm": 3,
		"nm": "L.",
		"nf": "Sandy",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/182089965",
		"id": 182089965,
		"lng": -77.38663785,
		"lat": 37.53767949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 3,
		"dd": 5,
		"by": 1912,
		"bd": 5,
		"bm": 6,
		"nm": "Q.",
		"nf": "Susie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/141701296",
		"id": 141701296,
		"lng": -77.38684773,
		"lat": 37.53740595,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 5,
		"dd": 7,
		"by": 1875,
		"bd": 9,
		"bm": 5,
		"nm": "A.",
		"nf": "Susie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/148459830",
		"id": 148459830,
		"lng": -77.38632278,
		"lat": 37.53558894,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 6,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/142469235",
		"id": 142469235,
		"lng": -77.38675193,
		"lat": 37.53665433,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 12,
		"dd": 12,
		"by": 1912,
		"bd": 23,
		"bm": 2,
		"nm": "",
		"nf": "Vester",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/139424764",
		"id": 139424764,
		"lng": -77.38784093,
		"lat": 37.53721754,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 5,
		"dd": 24,
		"by": 1863,
		"bd": 22,
		"bm": 2,
		"nm": "A.",
		"nf": "Virginia",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/143635980",
		"id": 143635980,
		"lng": -77.38617458,
		"lat": 37.53562597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 12,
		"by": 1905,
		"bd": 17,
		"bm": 6,
		"nm": "Lee",
		"nf": "Virginia",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/125843873",
		"id": 125843873,
		"lng": -77.38601027,
		"lat": 37.53743361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 1,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "William",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/155964249",
		"id": 155964249,
		"lng": -77.38710809,
		"lat": 37.53561123,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 7,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "William",
		"nl": "Southall",
		"url": "https://findagrave.com/memorial/166513762",
		"id": 166513762,
		"lng": -77.38781307,
		"lat": 37.53716045,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 3,
		"by": 1898,
		"bd": 25,
		"bm": 7,
		"nm": "",
		"nf": "Herbert",
		"nl": "Spain",
		"url": "https://findagrave.com/memorial/173793361",
		"id": 173793361,
		"lng": -77.38708095,
		"lat": 37.53718844,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 7,
		"dd": 28,
		"by": 1869,
		"bd": 14,
		"bm": 2,
		"nm": "",
		"nf": "Solomon",
		"nl": "Sparks",
		"url": "https://findagrave.com/memorial/157307813",
		"id": 157307813,
		"lng": -77.38667916,
		"lat": 37.53583164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 2,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Bertha",
		"nl": "Spencer",
		"url": "https://findagrave.com/memorial/142106262",
		"id": 142106262,
		"lng": -77.38608123,
		"lat": 37.53742232,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 15,
		"by": 1888,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alberta",
		"nl": "Spiller",
		"url": "https://findagrave.com/memorial/151445531",
		"id": 151445531,
		"lng": -77.38681075,
		"lat": 37.53540985,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 1,
		"dd": 2,
		"by": 1879,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Spiller",
		"url": "https://findagrave.com/memorial/151445990",
		"id": 151445990,
		"lng": -77.3868088,
		"lat": 37.53541658,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Irene",
		"nl": "Squire",
		"url": "https://findagrave.com/memorial/163904087",
		"id": 163904087,
		"lng": -77.38692066,
		"lat": 37.53678559,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 4,
		"dd": 14,
		"by": 1938,
		"bd": 27,
		"bm": 11,
		"nm": "Yvonne",
		"nf": "Marie",
		"nl": "Stamps",
		"url": "https://findagrave.com/memorial/185646128",
		"id": 185646128,
		"lng": -77.38747775,
		"lat": 37.53691712,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 9,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Ella",
		"nl": "Stanton",
		"url": "https://findagrave.com/memorial/132641419",
		"id": 132641419,
		"lng": -77.38782302,
		"lat": 37.53632422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sidney",
		"nl": "Stanton",
		"url": "https://findagrave.com/memorial/171780423",
		"id": 171780423,
		"lng": -77.38784596,
		"lat": 37.53633068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 9,
		"dd": 18,
		"by": 1908,
		"bd": 31,
		"bm": 7,
		"nm": "May",
		"nf": "Pearly",
		"nl": "Starkes",
		"url": "https://findagrave.com/memorial/175837977",
		"id": 175837977,
		"lng": -77.38772672,
		"lat": 37.53713495,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 12,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Harriet",
		"nl": "Steadman",
		"url": "https://findagrave.com/memorial/146020046",
		"id": 146020046,
		"lng": -77.38656456,
		"lat": 37.53636017,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 11,
		"dd": 5,
		"by": 1920,
		"bd": 30,
		"bm": 9,
		"nm": "Lee",
		"nf": "Robert",
		"nl": "Steele",
		"url": "https://findagrave.com/memorial/178412492",
		"id": 178412492,
		"lng": -77.38602442,
		"lat": 37.53625262,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 10,
		"dd": 9,
		"by": 1886,
		"bd": 8,
		"bm": 3,
		"nm": "Webster",
		"nf": "Daniel",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/115720742",
		"id": 115720742,
		"lng": -77.38601488,
		"lat": 37.53713956,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 11,
		"dd": 9,
		"by": 1909,
		"bd": 10,
		"bm": 9,
		"nm": "Webster",
		"nf": "Daniel",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/115720801",
		"id": 115720801,
		"lng": -77.38603771,
		"lat": 37.53714094,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/169713741",
		"id": 169713741,
		"lng": -77.38670471,
		"lat": 37.53694714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 17,
		"by": 1914,
		"bd": 25,
		"bm": 3,
		"nm": "",
		"nf": "Helen",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/175450155",
		"id": 175450155,
		"lng": -77.38751345,
		"lat": 37.53698678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 10,
		"dd": 19,
		"by": 1888,
		"bd": 22,
		"bm": 4,
		"nm": "F.",
		"nf": "Letitia",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/115720893",
		"id": 115720893,
		"lng": -77.38601136,
		"lat": 37.53714964,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 2,
		"dd": 5,
		"by": 1908,
		"bd": "",
		"bm": 6,
		"nm": "E.",
		"nf": "Raymond",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/127569751",
		"id": 127569751,
		"lng": -77.38603577,
		"lat": 37.53715749,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 3,
		"dd": 9,
		"by": 1919,
		"bd": 19,
		"bm": 12,
		"nm": "Jessie",
		"nf": "Frank",
		"nl": "Stevenson",
		"url": "https://findagrave.com/memorial/150637833",
		"id": 150637833,
		"lng": -77.38644155,
		"lat": 37.53595354,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 12,
		"dd": 23,
		"by": 1900,
		"bd": 24,
		"bm": 3,
		"nm": "",
		"nf": "Novella",
		"nl": "Stevenson",
		"url": "https://findagrave.com/memorial/130538996",
		"id": 130538996,
		"lng": -77.38638585,
		"lat": 37.53690693,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 11,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Maria",
		"nl": "Steward",
		"url": "https://findagrave.com/memorial/113626543",
		"id": 113626543,
		"lng": -77.38644318,
		"lat": 37.53657103,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 7,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Steward",
		"url": "https://findagrave.com/memorial/142469242",
		"id": 142469242,
		"lng": -77.38565209,
		"lat": 37.53743362,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 12,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "Charles",
		"nl": "Stewart",
		"url": "https://findagrave.com/memorial/146772750",
		"id": 146772750,
		"lng": -77.38635137,
		"lat": 37.53729469,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Ethel",
		"nl": "Stewart",
		"url": "https://findagrave.com/memorial/159886722",
		"id": 159886722,
		"lng": -77.38789348,
		"lat": 37.5376713,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 4,
		"dd": 5,
		"by": 1895,
		"bd": 23,
		"bm": 8,
		"nm": "C.",
		"nf": "Frank",
		"nl": "Stewart",
		"url": "https://findagrave.com/memorial/144226188",
		"id": 144226188,
		"lng": -77.3862456,
		"lat": 37.53743594,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 1,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jane",
		"nl": "Stewart",
		"url": "https://findagrave.com/memorial/119240903",
		"id": 119240903,
		"lng": -77.3859086,
		"lat": 37.5368462,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 15,
		"by": 1911,
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Obie",
		"nl": "Stinson",
		"url": "https://findagrave.com/memorial/169905175",
		"id": 169905175,
		"lng": -77.38661918,
		"lat": 37.53712466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 2,
		"dd": 19,
		"by": 1897,
		"bd": 5,
		"bm": 3,
		"nm": "",
		"nf": "Ethel",
		"nl": "Stith",
		"url": "https://findagrave.com/memorial/154304010",
		"id": 154304010,
		"lng": -77.38690712,
		"lat": 37.53549452,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 1,
		"dd": 3,
		"by": 1912,
		"bd": 9,
		"bm": 5,
		"nm": "Bell",
		"nf": "Minnie",
		"nl": "Stokes",
		"url": "https://findagrave.com/memorial/160277988",
		"id": 160277988,
		"lng": -77.38601711,
		"lat": 37.53636095,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 6,
		"dd": 23,
		"by": 1861,
		"bd": 10,
		"bm": 11,
		"nm": "L.",
		"nf": "Robert",
		"nl": "Stokes",
		"url": "https://findagrave.com/memorial/125844014",
		"id": 125844014,
		"lng": -77.38610475,
		"lat": 37.53681069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 5,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Stokes",
		"url": "https://findagrave.com/memorial/123850471",
		"id": 123850471,
		"lng": -77.38609718,
		"lat": 37.53682455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 3,
		"dd": 13,
		"by": 1903,
		"bd": 25,
		"bm": 8,
		"nm": "",
		"nf": "Viola",
		"nl": "Stokes",
		"url": "https://findagrave.com/memorial/113633317",
		"id": 113633317,
		"lng": -77.38741808,
		"lat": 37.53701242,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1888,
		"dm": 6,
		"dd": 6,
		"by": 1813,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Caroline",
		"nl": "Storrs",
		"url": "https://findagrave.com/memorial/154223081",
		"id": 154223081,
		"lng": -77.38657151,
		"lat": 37.5355554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1886,
		"dm": 2,
		"dd": 20,
		"by": 1809,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Claiborne",
		"nl": "Storrs",
		"url": "https://findagrave.com/memorial/154222721",
		"id": 154222721,
		"lng": -77.3865708,
		"lat": 37.53557456,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 12,
		"by": 1919,
		"bd": 19,
		"bm": 6,
		"nm": "",
		"nf": "Willie",
		"nl": "Stradford",
		"url": "https://findagrave.com/memorial/172683602",
		"id": 172683602,
		"lng": -77.38726896,
		"lat": 37.53732856,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 4,
		"by": 1897,
		"bd": 4,
		"bm": 4,
		"nm": "",
		"nf": "Linwood",
		"nl": "Strange",
		"url": "https://findagrave.com/memorial/143866261",
		"id": 143866261,
		"lng": -77.38601468,
		"lat": 37.53729376,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 3,
		"dd": 24,
		"by": 1938,
		"bd": 16,
		"bm": 6,
		"nm": "Junior",
		"nf": "Richard",
		"nl": "Sturtevant",
		"url": "https://findagrave.com/memorial/153708826",
		"id": 153708826,
		"lng": -77.38625121,
		"lat": 37.53746207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 3,
		"dd": 14,
		"by": 1896,
		"bd": 10,
		"bm": 12,
		"nm": "",
		"nf": "Frances",
		"nl": "Suarez",
		"url": "https://findagrave.com/memorial/173742917",
		"id": 173742917,
		"lng": -77.38737776,
		"lat": 37.53716944,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 10,
		"dd": 4,
		"by": 1908,
		"bd": 15,
		"bm": 6,
		"nm": "T.",
		"nf": "Freeman",
		"nl": "Suggs",
		"url": "https://findagrave.com/memorial/163611760",
		"id": 163611760,
		"lng": -77.38763018,
		"lat": 37.53760728,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Shirley",
		"nl": "Sukens",
		"url": "https://findagrave.com/memorial/170839602",
		"id": 170839602,
		"lng": -77.38642622,
		"lat": 37.53706188,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 11,
		"dd": 16,
		"by": 1896,
		"bd": 10,
		"bm": 3,
		"nm": "Edward",
		"nf": "Charles",
		"nl": "Sullivan",
		"url": "https://findagrave.com/memorial/153511428",
		"id": 153511428,
		"lng": -77.38655511,
		"lat": 37.53750117,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 10,
		"dd": 26,
		"by": 1919,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Edward",
		"nl": "Sully",
		"url": "https://findagrave.com/memorial/122794910",
		"id": 122794910,
		"lng": -77.38590038,
		"lat": 37.53694977,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 3,
		"dd": 23,
		"by": 1889,
		"bd": 6,
		"bm": 10,
		"nm": "Stuart",
		"nf": "Richard",
		"nl": "Sully",
		"url": "https://findagrave.com/memorial/125313109",
		"id": 125313109,
		"lng": -77.38589556,
		"lat": 37.53697398,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 5,
		"dd": 11,
		"by": 1888,
		"bd": 26,
		"bm": 12,
		"nm": "Lee",
		"nf": "Sarah",
		"nl": "Sully",
		"url": "https://findagrave.com/memorial/125643998",
		"id": 125643998,
		"lng": -77.38589147,
		"lat": 37.53698117,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 27,
		"by": 1905,
		"bd": 25,
		"bm": 10,
		"nm": "",
		"nf": "Ollie",
		"nl": "Sutton",
		"url": "https://findagrave.com/memorial/167073475",
		"id": 167073475,
		"lng": -77.38683476,
		"lat": 37.53716739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 9,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "K.",
		"nf": "Frankie",
		"nl": "Sweat",
		"url": "https://findagrave.com/memorial/138181537",
		"id": 138181537,
		"lng": -77.3863842,
		"lat": 37.53707666,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 12,
		"dd": 2,
		"by": 1927,
		"bd": 16,
		"bm": 4,
		"nm": "Allen",
		"nf": "Linwood",
		"nl": "Tabb",
		"url": "https://findagrave.com/memorial/150637841",
		"id": 150637841,
		"lng": -77.38640175,
		"lat": 37.535935,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 7,
		"dd": 18,
		"by": 1906,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sadie",
		"nl": "Talbert",
		"url": "https://findagrave.com/memorial/175610176",
		"id": 175610176,
		"lng": -77.38768565,
		"lat": 37.53705487,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 29,
		"by": 1919,
		"bd": 17,
		"bm": 12,
		"nm": "",
		"nf": "Henry",
		"nl": "Taliaferro",
		"url": "https://findagrave.com/memorial/141701313",
		"id": 141701313,
		"lng": -77.38644564,
		"lat": 37.5373103,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 10,
		"by": 1893,
		"bd": 10,
		"bm": 2,
		"nm": "",
		"nf": "Herman",
		"nl": "Tally",
		"url": "https://findagrave.com/memorial/176983871",
		"id": 176983871,
		"lng": -77.38758064,
		"lat": 37.53557668,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 3,
		"dd": 22,
		"by": 1892,
		"bd": "",
		"bm": 7,
		"nm": "L.",
		"nf": "Mary",
		"nl": "Tancil",
		"url": "https://findagrave.com/memorial/133668082",
		"id": 133668082,
		"lng": -77.38610474,
		"lat": 37.53583418,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 8,
		"by": 1860,
		"bd": 20,
		"bm": 10,
		"nm": "Fillmore",
		"nf": "Richard",
		"nl": "Tancil",
		"url": "https://findagrave.com/memorial/143635987",
		"id": 143635987,
		"lng": -77.3861066,
		"lat": 37.53582741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 4,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ella",
		"nl": "Tate",
		"url": "https://findagrave.com/memorial/186917466",
		"id": 186917466,
		"lng": -77.38748712,
		"lat": 37.53698686,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 10,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Albert",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/154304015",
		"id": 154304015,
		"lng": -77.38682971,
		"lat": 37.53553875,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Alton",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/150792701",
		"id": 150792701,
		"lng": -77.38644085,
		"lat": 37.53557132,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby boy",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/142797055",
		"id": 142797055,
		"lng": -77.3860789,
		"lat": 37.53744044,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 8,
		"dd": 5,
		"by": 1858,
		"bd": 7,
		"bm": 6,
		"nm": "",
		"nf": "Capitola",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/142475112",
		"id": 142475112,
		"lng": -77.38576137,
		"lat": 37.53735378,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 3,
		"dd": 23,
		"by": 1922,
		"bd": 11,
		"bm": 7,
		"nm": "",
		"nf": "Catherine",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/158946002",
		"id": 158946002,
		"lng": -77.38693507,
		"lat": 37.53749775,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 3,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/145596034",
		"id": 145596034,
		"lng": -77.38793103,
		"lat": 37.53728283,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1997,
		"dm": 12,
		"dd": 19,
		"by": 1942,
		"bd": 24,
		"bm": 11,
		"nm": "Stanley",
		"nf": "Clarence",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/76611076",
		"id": 76611076,
		"lng": -77.38629726,
		"lat": 37.53721941,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cora",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/146682168",
		"id": 146682168,
		"lng": -77.3861095,
		"lat": 37.53579169,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 4,
		"by": 1954,
		"bd": 1,
		"bm": 12,
		"nm": "G.",
		"nf": "Devon",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/147853901",
		"id": 147853901,
		"lng": -77.38599703,
		"lat": 37.53631828,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 9,
		"dd": 17,
		"by": 1910,
		"bd": 29,
		"bm": 7,
		"nm": "",
		"nf": "Edner",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/140625016",
		"id": 140625016,
		"lng": -77.38723555,
		"lat": 37.53565571,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 8,
		"by": 1920,
		"bd": 13,
		"bm": 8,
		"nm": "",
		"nf": "Elnora",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/177768021",
		"id": 177768021,
		"lng": -77.38759016,
		"lat": 37.53761605,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 2,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Gertrude",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/132764955",
		"id": 132764955,
		"lng": -77.38588637,
		"lat": 37.53704228,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 13,
		"by": 1900,
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Gracie",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/142106265",
		"id": 142106265,
		"lng": -77.38577403,
		"lat": 37.53741699,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 16,
		"by": 1932,
		"bd": 29,
		"bm": 10,
		"nm": "William",
		"nf": "Henry",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/169904899",
		"id": 169904899,
		"lng": -77.38664119,
		"lat": 37.53717735,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 8,
		"dd": 26,
		"by": 1894,
		"bd": 19,
		"bm": 12,
		"nm": "",
		"nf": "Hiram",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/142106317",
		"id": 142106317,
		"lng": -77.38577649,
		"lat": 37.53741004,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 6,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hughey",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/147853909",
		"id": 147853909,
		"lng": -77.38604054,
		"lat": 37.53624392,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 5,
		"dd": 16,
		"by": 1848,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isaiah",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/154201784",
		"id": 154201784,
		"lng": -77.38726585,
		"lat": 37.53553103,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 17,
		"by": 1905,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Isaiah",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/144558768",
		"id": 144558768,
		"lng": -77.38753069,
		"lat": 37.53733438,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 7,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "James",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/76611095",
		"id": 76611095,
		"lng": -77.38603943,
		"lat": 37.5366593,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 5,
		"dd": 17,
		"by": 1880,
		"bd": 24,
		"bm": 3,
		"nm": "Solomon",
		"nf": "James",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/126772114",
		"id": 126772114,
		"lng": -77.38586626,
		"lat": 37.53667429,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 8,
		"by": 1884,
		"bd": 10,
		"bm": 6,
		"nm": "B.",
		"nf": "Jennie",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/151112011",
		"id": 151112011,
		"lng": -77.38648274,
		"lat": 37.53548967,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 2,
		"dd": 21,
		"by": 1862,
		"bd": 14,
		"bm": 4,
		"nm": "",
		"nf": "John",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/144373069",
		"id": 144373069,
		"lng": -77.38696381,
		"lat": 37.53557679,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 11,
		"dd": 15,
		"by": 1905,
		"bd": 12,
		"bm": 4,
		"nm": "Henry",
		"nf": "John",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/76611107",
		"id": 76611107,
		"lng": -77.38630811,
		"lat": 37.53719175,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 4,
		"dd": 12,
		"by": 1859,
		"bd": "",
		"bm": 1,
		"nm": "B.",
		"nf": "John",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/142106321",
		"id": 142106321,
		"lng": -77.38575867,
		"lat": 37.53734156,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 10,
		"by": 1876,
		"bd": 16,
		"bm": 5,
		"nm": "L.",
		"nf": "Joseph",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/154242966",
		"id": 154242966,
		"lng": -77.38638292,
		"lat": 37.53550788,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Josephine",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/123850488",
		"id": 123850488,
		"lng": -77.38604585,
		"lat": 37.53664693,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 5,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louisa",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/154304019",
		"id": 154304019,
		"lng": -77.38696075,
		"lat": 37.53550823,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 9,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Lucy",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/119391329",
		"id": 119391329,
		"lng": -77.38588217,
		"lat": 37.53666774,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 2,
		"by": 1893,
		"bd": 26,
		"bm": 3,
		"nm": "J.",
		"nf": "Mabel",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/119391346",
		"id": 119391346,
		"lng": -77.38586716,
		"lat": 37.53666335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 8,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maggie",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/125313131",
		"id": 125313131,
		"lng": -77.38800637,
		"lat": 37.537277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 6,
		"by": 1900,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Mamie",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/123850495",
		"id": 123850495,
		"lng": -77.38599584,
		"lat": 37.53669831,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 9,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/175820947",
		"id": 175820947,
		"lng": -77.38758144,
		"lat": 37.53699632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 24,
		"by": 1873,
		"bd": 14,
		"bm": 2,
		"nm": "",
		"nf": "Mary",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/120726156",
		"id": 120726156,
		"lng": -77.38566176,
		"lat": 37.53691329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 9,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Missouri",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/130539006",
		"id": 130539006,
		"lng": -77.38634547,
		"lat": 37.53697362,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 5,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Moses",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/150037846",
		"id": 150037846,
		"lng": -77.38644872,
		"lat": 37.53628715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 12,
		"dd": 28,
		"by": 1910,
		"bd": 18,
		"bm": 11,
		"nm": "",
		"nf": "Moses",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/161052442",
		"id": 161052442,
		"lng": -77.38714456,
		"lat": 37.53706558,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/177149493",
		"id": 177149493,
		"lng": -77.38786676,
		"lat": 37.53703817,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Nettie",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/136306549",
		"id": 136306549,
		"lng": -77.38586198,
		"lat": 37.53706976,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 6,
		"by": 1907,
		"bd": 12,
		"bm": 4,
		"nm": "",
		"nf": "Ora",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/76611140",
		"id": 76611140,
		"lng": -77.38630674,
		"lat": 37.53719712,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 10,
		"dd": 19,
		"by": 1860,
		"bd": "",
		"bm": 1,
		"nm": "Beecher",
		"nf": "Robert",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/151112022",
		"id": 151112022,
		"lng": -77.3864781,
		"lat": 37.53550315,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 4,
		"dd": 14,
		"by": 1893,
		"bd": "",
		"bm": 7,
		"nm": "Beecher",
		"nf": "Robert",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/151112035",
		"id": 151112035,
		"lng": -77.38646847,
		"lat": 37.5354863,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 6,
		"dd": 3,
		"by": 1909,
		"bd": 11,
		"bm": 11,
		"nm": "Lee",
		"nf": "Rosa",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/144227103",
		"id": 144227103,
		"lng": -77.38603109,
		"lat": 37.53738466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 8,
		"dd": 21,
		"by": 1921,
		"bd": 29,
		"bm": 5,
		"nm": "L.",
		"nf": "Roscoe",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/158479769",
		"id": 158479769,
		"lng": -77.38675133,
		"lat": 37.53754032,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 12,
		"by": 1878,
		"bd": 23,
		"bm": 2,
		"nm": "",
		"nf": "Sarah",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/159598354",
		"id": 159598354,
		"lng": -77.38716457,
		"lat": 37.53760212,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 14,
		"by": 1892,
		"bd": 7,
		"bm": 12,
		"nm": "A.",
		"nf": "Sarah",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/138572981",
		"id": 138572981,
		"lng": -77.38627546,
		"lat": 37.53679705,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": 1866,
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Serena",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/151112042",
		"id": 151112042,
		"lng": -77.38646795,
		"lat": 37.53550281,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 6,
		"dd": 2,
		"by": 1943,
		"bd": 15,
		"bm": 4,
		"nm": "Gayzelle",
		"nf": "Shirley",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/142475125",
		"id": 142475125,
		"lng": -77.3860111,
		"lat": 37.53736781,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 6,
		"dd": 5,
		"by": 1901,
		"bd": 1,
		"bm": 2,
		"nm": "",
		"nf": "Viola",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/155989142",
		"id": 155989142,
		"lng": -77.38638635,
		"lat": 37.5369984,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 9,
		"dd": 30,
		"by": 1889,
		"bd": 19,
		"bm": 7,
		"nm": "T.",
		"nf": "William",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/123851379",
		"id": 123851379,
		"lng": -77.38599384,
		"lat": 37.5367027,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/119391357",
		"id": 119391357,
		"lng": -77.38587249,
		"lat": 37.5366866,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 6,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Johnson",
		"nf": "Charlotte",
		"nl": "Teasley",
		"url": "https://findagrave.com/memorial/136107652",
		"id": 136107652,
		"lng": -77.38604624,
		"lat": 37.53691488,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 2000,
		"dm": 12,
		"dd": 1,
		"by": 1899,
		"bd": 17,
		"bm": 2,
		"nm": "E.",
		"nf": "Eliza",
		"nl": "Temple",
		"url": "https://findagrave.com/memorial/76611153",
		"id": 76611153,
		"lng": -77.3860467,
		"lat": 37.53724547,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 1,
		"dd": 22,
		"by": 1917,
		"bd": 1,
		"bm": 3,
		"nm": "E.",
		"nf": "Gladys",
		"nl": "Temple",
		"url": "https://findagrave.com/memorial/76611187",
		"id": 76611187,
		"lng": -77.38601915,
		"lat": 37.53723894,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1999,
		"dm": 9,
		"dd": 29,
		"by": 1910,
		"bd": 26,
		"bm": 8,
		"nm": "H.",
		"nf": "James",
		"nl": "Temple",
		"url": "https://findagrave.com/memorial/76611174",
		"id": 76611174,
		"lng": -77.38602689,
		"lat": 37.53724122,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 3,
		"dd": 23,
		"by": 1901,
		"bd": 3,
		"bm": 7,
		"nm": "",
		"nf": "Josephine",
		"nl": "Temple",
		"url": "https://findagrave.com/memorial/128452660",
		"id": 128452660,
		"lng": -77.38589532,
		"lat": 37.53694549,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 11,
		"dd": 15,
		"by": 1895,
		"bd": 3,
		"bm": 7,
		"nm": "J.",
		"nf": "William",
		"nl": "Temple",
		"url": "https://findagrave.com/memorial/125408710",
		"id": 125408710,
		"lng": -77.38588401,
		"lat": 37.53667894,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 1,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luke",
		"nl": "Terrell",
		"url": "https://findagrave.com/memorial/177768026",
		"id": 177768026,
		"lng": -77.38790399,
		"lat": 37.53727449,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 6,
		"dd": 16,
		"by": 1859,
		"bd": 26,
		"bm": 3,
		"nm": "Henry",
		"nf": "William",
		"nl": "Tharps",
		"url": "https://findagrave.com/memorial/119241100",
		"id": 119241100,
		"lng": -77.38580928,
		"lat": 37.53667452,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 3,
		"by": 1896,
		"bd": 5,
		"bm": 3,
		"nm": "",
		"nf": "Bessie",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/117449120",
		"id": 117449120,
		"lng": -77.38570903,
		"lat": 37.53670951,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/159600776",
		"id": 159600776,
		"lng": -77.38710061,
		"lat": 37.53749968,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/179534889",
		"id": 179534889,
		"lng": -77.38792568,
		"lat": 37.53771914,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 9,
		"dd": 16,
		"by": 1900,
		"bd": 18,
		"bm": 6,
		"nm": "",
		"nf": "Haywood",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/128452670",
		"id": 128452670,
		"lng": -77.38641964,
		"lat": 37.53730061,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 5,
		"dd": 30,
		"by": 1935,
		"bd": 5,
		"bm": 9,
		"nm": "Melinda",
		"nf": "Inez",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/159973287",
		"id": 159973287,
		"lng": -77.38708832,
		"lat": 37.53747069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 29,
		"by": 1900,
		"bd": 9,
		"bm": 1,
		"nm": "James",
		"nf": "Johnnie",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/173793409",
		"id": 173793409,
		"lng": -77.3871458,
		"lat": 37.53732719,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 8,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Joseph",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/142505846",
		"id": 142505846,
		"lng": -77.38573867,
		"lat": 37.5373562,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 4,
		"by": 1878,
		"bd": 20,
		"bm": 2,
		"nm": "",
		"nf": "Lillie",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/142505855",
		"id": 142505855,
		"lng": -77.3856997,
		"lat": 37.53732922,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1903,
		"dm": 7,
		"dd": 19,
		"by": 1902,
		"bd": 5,
		"bm": 9,
		"nm": "J.",
		"nf": "Lucy",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/133137564",
		"id": 133137564,
		"lng": -77.38707211,
		"lat": 37.53655169,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 11,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Luther",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/144227113",
		"id": 144227113,
		"lng": -77.38594599,
		"lat": 37.53730534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 5,
		"dd": 1,
		"by": 1881,
		"bd": 4,
		"bm": 7,
		"nm": "Catherine",
		"nf": "Mary",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/185717336",
		"id": 185717336,
		"lng": -77.38722585,
		"lat": 37.53771198,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 12,
		"dd": 18,
		"by": 1896,
		"bd": 27,
		"bm": 12,
		"nm": "",
		"nf": "Ophelia",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/160934060",
		"id": 160934060,
		"lng": -77.38647243,
		"lat": 37.53685277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 12,
		"dd": 17,
		"by": 1910,
		"bd": 10,
		"bm": 12,
		"nm": "A.",
		"nf": "Samuel",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/162672313",
		"id": 162672313,
		"lng": -77.38659634,
		"lat": 37.53700745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 2,
		"dd": 20,
		"by": 1905,
		"bd": 13,
		"bm": 2,
		"nm": "H.",
		"nf": "Samuel",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/142505861",
		"id": 142505861,
		"lng": -77.38574396,
		"lat": 37.53733827,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 5,
		"by": 1903,
		"bd": 13,
		"bm": 7,
		"nm": "",
		"nf": "Willie",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/142505868",
		"id": 142505868,
		"lng": -77.38574058,
		"lat": 37.5373464,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 10,
		"dd": 28,
		"by": 1879,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Leroy",
		"nl": "Thompkins",
		"url": "https://findagrave.com/memorial/173079259",
		"id": 173079259,
		"lng": -77.38702357,
		"lat": 37.53734341,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 1,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Alice",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/155539567",
		"id": 155539567,
		"lng": -77.38731304,
		"lat": 37.53561537,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 5,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/150864489",
		"id": 150864489,
		"lng": -77.38678537,
		"lat": 37.53583261,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 16,
		"by": 1880,
		"bd": 5,
		"bm": 6,
		"nm": "Bohannon",
		"nf": "Charles",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/144373090",
		"id": 144373090,
		"lng": -77.38661125,
		"lat": 37.53578011,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 1,
		"dd": 22,
		"by": 1902,
		"bd": 10,
		"bm": 9,
		"nm": "",
		"nf": "Claudine",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/179130823",
		"id": 179130823,
		"lng": -77.38636885,
		"lat": 37.53756907,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 6,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Columbia",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/139146954",
		"id": 139146954,
		"lng": -77.38615345,
		"lat": 37.53657248,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 8,
		"dd": 31,
		"by": 1905,
		"bd": 1,
		"bm": 2,
		"nm": "Lee",
		"nf": "Cora",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/158450807",
		"id": 158450807,
		"lng": -77.38770723,
		"lat": 37.53757904,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 11,
		"dd": 3,
		"by": 1875,
		"bd": 7,
		"bm": 6,
		"nm": "W.",
		"nf": "George",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/155021719",
		"id": 155021719,
		"lng": -77.38678476,
		"lat": 37.53584253,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 3,
		"dd": 21,
		"by": 1891,
		"bd": 21,
		"bm": 3,
		"nm": "K.",
		"nf": "George",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/150865632",
		"id": 150865632,
		"lng": -77.38723983,
		"lat": 37.53777285,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Harry",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/150864840",
		"id": 150864840,
		"lng": -77.38678881,
		"lat": 37.53580539,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 7,
		"dd": 19,
		"by": 1870,
		"bd": "",
		"bm": 10,
		"nm": "",
		"nf": "Ida",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/173471935",
		"id": 173471935,
		"lng": -77.38730557,
		"lat": 37.5370855,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lula",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/125859672",
		"id": 125859672,
		"lng": -77.38600544,
		"lat": 37.53744454,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 6,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luvenia",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/183921383",
		"id": 183921383,
		"lng": -77.3874016,
		"lat": 37.53698358,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": "",
		"dd": "",
		"by": 1910,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mamie",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/138181541",
		"id": 138181541,
		"lng": -77.38620054,
		"lat": 37.5371058,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 12,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Dudley",
		"nf": "Maria",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/125859678",
		"id": 125859678,
		"lng": -77.38606703,
		"lat": 37.53596057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 10,
		"dd": 31,
		"by": 1882,
		"bd": "",
		"bm": 5,
		"nm": "L.",
		"nf": "Martha",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/150865747",
		"id": 150865747,
		"lng": -77.38678425,
		"lat": 37.53585367,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 12,
		"dd": 23,
		"by": 1890,
		"bd": 12,
		"bm": 9,
		"nm": "R.",
		"nf": "Maude",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/144821937",
		"id": 144821937,
		"lng": -77.38748321,
		"lat": 37.53775057,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 4,
		"by": 1887,
		"bd": 31,
		"bm": 10,
		"nm": "",
		"nf": "Minnie",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/76611200",
		"id": 76611200,
		"lng": -77.38619209,
		"lat": 37.5357258,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 2,
		"dd": 6,
		"by": 1886,
		"bd": 5,
		"bm": 5,
		"nm": "",
		"nf": "Oliver",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/150864696",
		"id": 150864696,
		"lng": -77.38679254,
		"lat": 37.5358145,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Peter",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/150864330",
		"id": 150864330,
		"lng": -77.38678616,
		"lat": 37.53582441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 10,
		"dd": 28,
		"by": 1931,
		"bd": 31,
		"bm": 10,
		"nm": "Ransome",
		"nf": "Raymond",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/183718583",
		"id": 183718583,
		"lng": -77.38704224,
		"lat": 37.53684751,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 1,
		"dd": 10,
		"by": 1913,
		"bd": 31,
		"bm": 10,
		"nm": "",
		"nf": "Robert",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/144373096",
		"id": 144373096,
		"lng": -77.38662353,
		"lat": 37.53702444,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 31,
		"by": 1905,
		"bd": 5,
		"bm": 5,
		"nm": "Luke",
		"nf": "Roosevelt",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/161179875",
		"id": 161179875,
		"lng": -77.38644182,
		"lat": 37.53701402,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 23,
		"by": 1883,
		"bd": 30,
		"bm": 4,
		"nm": "L.",
		"nf": "Sallie",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/144373077",
		"id": 144373077,
		"lng": -77.38661089,
		"lat": 37.53577543,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 5,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/193428743",
		"id": 193428743,
		"lng": -77.38757175,
		"lat": 37.53709668,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": "",
		"dd": "",
		"by": 1905,
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Winston",
		"nl": "Thorne",
		"url": "https://findagrave.com/memorial/144821946",
		"id": 144821946,
		"lng": -77.38624091,
		"lat": 37.53726431,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 19,
		"by": 1892,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hattie",
		"nl": "Thornton",
		"url": "https://findagrave.com/memorial/177240224",
		"id": 177240224,
		"lng": -77.38729256,
		"lat": 37.53739163,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 7,
		"dd": 28,
		"by": "",
		"bd": 15,
		"bm": 2,
		"nm": "",
		"nf": "Willie",
		"nl": "Thornton",
		"url": "https://findagrave.com/memorial/171368383",
		"id": 171368383,
		"lng": -77.38701492,
		"lat": 37.53671069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 11,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Bell",
		"nf": "Ann",
		"nl": "Tillman",
		"url": "https://findagrave.com/memorial/171100288",
		"id": 171100288,
		"lng": -77.38618984,
		"lat": 37.53597971,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mable",
		"nl": "Timmons",
		"url": "https://findagrave.com/memorial/154228765",
		"id": 154228765,
		"lng": -77.38631533,
		"lat": 37.53740641,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 8,
		"dd": 14,
		"by": 1860,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ann",
		"nl": "Tinsley",
		"url": "https://findagrave.com/memorial/151944846",
		"id": 151944846,
		"lng": -77.38661759,
		"lat": 37.53572531,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 11,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Bertha",
		"nl": "Tinsley",
		"url": "https://findagrave.com/memorial/132046788",
		"id": 132046788,
		"lng": -77.38777039,
		"lat": 37.53646036,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1906,
		"dm": 5,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ellen",
		"nl": "Tinsley",
		"url": "https://findagrave.com/memorial/160934063",
		"id": 160934063,
		"lng": -77.38644219,
		"lat": 37.53636465,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 8,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Tinsley",
		"url": "https://findagrave.com/memorial/149696139",
		"id": 149696139,
		"lng": -77.3864544,
		"lat": 37.53635458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 1,
		"dd": 30,
		"by": 1912,
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "William",
		"nl": "Tinsley",
		"url": "https://findagrave.com/memorial/151944722",
		"id": 151944722,
		"lng": -77.3866102,
		"lat": 37.53572779,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 30,
		"by": 1903,
		"bd": 23,
		"bm": 6,
		"nm": "",
		"nf": "Mabel",
		"nl": "Tippett",
		"url": "https://findagrave.com/memorial/183587542",
		"id": 183587542,
		"lng": -77.38694702,
		"lat": 37.53713515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 4,
		"dd": 11,
		"by": 1891,
		"bd": 28,
		"bm": 2,
		"nm": "R.",
		"nf": "Adell",
		"nl": "Toast",
		"url": "https://findagrave.com/memorial/137430857",
		"id": 137430857,
		"lng": -77.38619544,
		"lat": 37.5370965,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Adlaide",
		"nl": "Toast",
		"url": "https://findagrave.com/memorial/158946011",
		"id": 158946011,
		"lng": -77.38715218,
		"lat": 37.53758687,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 10,
		"dd": 21,
		"by": 1889,
		"bd": 12,
		"bm": 6,
		"nm": "Henry",
		"nf": "William",
		"nl": "Toast",
		"url": "https://findagrave.com/memorial/137835772",
		"id": 137835772,
		"lng": -77.38619136,
		"lat": 37.53710575,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 1,
		"dd": 29,
		"by": 1906,
		"bd": 3,
		"bm": 4,
		"nm": "",
		"nf": "Bessie",
		"nl": "Toliver",
		"url": "https://findagrave.com/memorial/183718587",
		"id": 183718587,
		"lng": -77.38704639,
		"lat": 37.53719809,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 7,
		"dd": 19,
		"by": 1913,
		"bd": 28,
		"bm": 7,
		"nm": "",
		"nf": "Amanda",
		"nl": "Tolliver",
		"url": "https://findagrave.com/memorial/158464391",
		"id": 158464391,
		"lng": -77.38691551,
		"lat": 37.53765555,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 11,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Tolliver",
		"url": "https://findagrave.com/memorial/191381376",
		"id": 191381376,
		"lng": -77.38773494,
		"lat": 37.53788583,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 12,
		"dd": 11,
		"by": 1890,
		"bd": 16,
		"bm": 5,
		"nm": "",
		"nf": "Matilda",
		"nl": "Tolliver",
		"url": "https://findagrave.com/memorial/150637843",
		"id": 150637843,
		"lng": -77.38640416,
		"lat": 37.53597822,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Tomlin",
		"url": "https://findagrave.com/memorial/160639670",
		"id": 160639670,
		"lng": -77.38596222,
		"lat": 37.53690212,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 3,
		"dd": 23,
		"by": 1858,
		"bd": 20,
		"bm": 5,
		"nm": "H.",
		"nf": "William",
		"nl": "Tomlin",
		"url": "https://findagrave.com/memorial/160639672",
		"id": 160639672,
		"lng": -77.38604691,
		"lat": 37.53680245,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 28,
		"by": 1878,
		"bd": 1,
		"bm": 1,
		"nm": "",
		"nf": "Richard",
		"nl": "Tompkins",
		"url": "https://findagrave.com/memorial/169904901",
		"id": 169904901,
		"lng": -77.38682645,
		"lat": 37.53709902,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 11,
		"dd": 15,
		"by": 1903,
		"bd": 3,
		"bm": 10,
		"nm": "",
		"nf": "Alice",
		"nl": "Towles",
		"url": "https://findagrave.com/memorial/150637844",
		"id": 150637844,
		"lng": -77.38638517,
		"lat": 37.53597931,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 9,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "David",
		"nl": "Townson",
		"url": "https://findagrave.com/memorial/172068272",
		"id": 172068272,
		"lng": -77.38740044,
		"lat": 37.53682988,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 12,
		"by": 1868,
		"bd": 22,
		"bm": 9,
		"nm": "",
		"nf": "Archer",
		"nl": "Trent",
		"url": "https://findagrave.com/memorial/168088700",
		"id": 168088700,
		"lng": -77.38654463,
		"lat": 37.53689399,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 5,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Lelia",
		"nl": "Trent",
		"url": "https://findagrave.com/memorial/139424771",
		"id": 139424771,
		"lng": -77.38780868,
		"lat": 37.53722339,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Trent",
		"url": "https://findagrave.com/memorial/162203623",
		"id": 162203623,
		"lng": -77.38781118,
		"lat": 37.53706567,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Trent",
		"url": "https://findagrave.com/memorial/138181586",
		"id": 138181586,
		"lng": -77.38644018,
		"lat": 37.53702688,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 12,
		"dd": 20,
		"by": 1880,
		"bd": "",
		"bm": 3,
		"nm": "E.",
		"nf": "Joseph",
		"nl": "Trice",
		"url": "https://findagrave.com/memorial/155539577",
		"id": 155539577,
		"lng": -77.38671259,
		"lat": 37.53592637,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 12,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Wiley",
		"nl": "Trice",
		"url": "https://findagrave.com/memorial/185564850",
		"id": 185564850,
		"lng": -77.38727703,
		"lat": 37.53685486,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 4,
		"dd": 17,
		"by": 1910,
		"bd": 2,
		"bm": 10,
		"nm": "",
		"nf": "Magnolia",
		"nl": "Trueheart",
		"url": "https://findagrave.com/memorial/187898190",
		"id": 187898190,
		"lng": -77.38593321,
		"lat": 37.53632661,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 11,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "K.",
		"nf": "Mary",
		"nl": "Trueheart",
		"url": "https://findagrave.com/memorial/184376606",
		"id": 184376606,
		"lng": -77.38772889,
		"lat": 37.53664785,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Trueheart",
		"url": "https://findagrave.com/memorial/184477155",
		"id": 184477155,
		"lng": -77.38771276,
		"lat": 37.53665583,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 28,
		"by": 1892,
		"bd": 1,
		"bm": 10,
		"nm": "",
		"nf": "Amy",
		"nl": "Tuck",
		"url": "https://findagrave.com/memorial/153629930",
		"id": 153629930,
		"lng": -77.38650393,
		"lat": 37.53744715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 9,
		"dd": 29,
		"by": 1910,
		"bd": 6,
		"bm": 5,
		"nm": "",
		"nf": "Edward",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/177118841",
		"id": 177118841,
		"lng": -77.38794167,
		"lat": 37.53692498,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 9,
		"dd": 5,
		"by": 1898,
		"bd": 10,
		"bm": 12,
		"nm": "Baptist",
		"nf": "John",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/167338965",
		"id": 167338965,
		"lng": -77.38688118,
		"lat": 37.53730431,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/145167330",
		"id": 145167330,
		"lng": -77.38622009,
		"lat": 37.53712407,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 11,
		"dd": 26,
		"by": 1897,
		"bd": 23,
		"bm": 8,
		"nm": "",
		"nf": "Lillie",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/167337995",
		"id": 167337995,
		"lng": -77.38687456,
		"lat": 37.53733595,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 6,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Nichols",
		"nf": "Nettie",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/155539590",
		"id": 155539590,
		"lng": -77.38655716,
		"lat": 37.53682818,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 10,
		"dd": 23,
		"by": 1892,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Robert",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/151268213",
		"id": 151268213,
		"lng": -77.38687648,
		"lat": 37.53733028,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 2,
		"dd": 14,
		"by": 1882,
		"bd": 7,
		"bm": 1,
		"nm": "Eliza",
		"nf": "Annie",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/174782927",
		"id": 174782927,
		"lng": -77.3874031,
		"lat": 37.5370141,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 7,
		"dd": 28,
		"by": 1968,
		"bd": 25,
		"bm": 6,
		"nm": "",
		"nf": "baby boy",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/159663333",
		"id": 159663333,
		"lng": -77.38590305,
		"lat": 37.53740513,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 3,
		"dd": 4,
		"by": 1924,
		"bd": 5,
		"bm": 2,
		"nm": "",
		"nf": "Beatrice",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/144013924",
		"id": 144013924,
		"lng": -77.38724412,
		"lat": 37.53764376,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 1,
		"dd": 17,
		"by": 1926,
		"bd": 10,
		"bm": 1,
		"nm": "Lee",
		"nf": "Daisy",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/127134101",
		"id": 127134101,
		"lng": -77.38610479,
		"lat": 37.53638237,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Emily",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/150153232",
		"id": 150153232,
		"lng": -77.38617377,
		"lat": 37.53604916,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 6,
		"dd": 1,
		"by": 1935,
		"bd": 19,
		"bm": 6,
		"nm": "",
		"nf": "Emmaline",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/144373105",
		"id": 144373105,
		"lng": -77.38751181,
		"lat": 37.53782524,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 12,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ethel",
		"nf": "Estelle",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/179529676",
		"id": 179529676,
		"lng": -77.38796563,
		"lat": 37.53773625,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 8,
		"dd": 7,
		"by": 1907,
		"bd": 24,
		"bm": 8,
		"nm": "Washington",
		"nf": "George",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/128452673",
		"id": 128452673,
		"lng": -77.38680844,
		"lat": 37.53740121,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 1,
		"dd": 26,
		"by": 1915,
		"bd": 5,
		"bm": 8,
		"nm": "",
		"nf": "Isaac",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/147853925",
		"id": 147853925,
		"lng": -77.38703618,
		"lat": 37.53699447,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 8,
		"dd": 23,
		"by": 1913,
		"bd": 25,
		"bm": 9,
		"nm": "",
		"nf": "James",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/176059955",
		"id": 176059955,
		"lng": -77.38733471,
		"lat": 37.53704267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 8,
		"dd": 4,
		"by": 1877,
		"bd": 9,
		"bm": 2,
		"nm": "Bruce",
		"nf": "James",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/152646372",
		"id": 152646372,
		"lng": -77.38634917,
		"lat": 37.53706417,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 12,
		"dd": 30,
		"by": 1910,
		"bd": 10,
		"bm": 4,
		"nm": "Leroy",
		"nf": "John",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/158946019",
		"id": 158946019,
		"lng": -77.38693751,
		"lat": 37.53736215,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 11,
		"dd": 11,
		"by": 1922,
		"bd": 17,
		"bm": 4,
		"nm": "Marie",
		"nf": "Lola",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/158946026",
		"id": 158946026,
		"lng": -77.38693315,
		"lat": 37.5373691,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 8,
		"dd": 29,
		"by": 1909,
		"bd": 26,
		"bm": 9,
		"nm": "Elizabeth",
		"nf": "Martha",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/171369939",
		"id": 171369939,
		"lng": -77.38702241,
		"lat": 37.53670149,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 1,
		"dd": 27,
		"by": 1881,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Rosa",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/157646360",
		"id": 157646360,
		"lng": -77.38734221,
		"lat": 37.53763027,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 1,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Sarah",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/150036814",
		"id": 150036814,
		"lng": -77.38651264,
		"lat": 37.53561443,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 8,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Walter",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/186818119",
		"id": 186818119,
		"lng": -77.38736092,
		"lat": 37.53699238,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 8,
		"dd": 3,
		"by": 1882,
		"bd": 1,
		"bm": 9,
		"nm": "H.",
		"nf": "Frank",
		"nl": "Twine",
		"url": "https://findagrave.com/memorial/140290927",
		"id": 140290927,
		"lng": -77.38659374,
		"lat": 37.53551241,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 3,
		"dd": 20,
		"by": 1851,
		"bd": "",
		"bm": 9,
		"nm": "H.",
		"nf": "James",
		"nl": "Twine",
		"url": "https://findagrave.com/memorial/151112054",
		"id": 151112054,
		"lng": -77.38657234,
		"lat": 37.53552006,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 8,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ann",
		"nl": "Tyler",
		"url": "https://findagrave.com/memorial/132764962",
		"id": 132764962,
		"lng": -77.38778023,
		"lat": 37.53657864,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 3,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Beatrice",
		"nl": "Tyler",
		"url": "https://findagrave.com/memorial/187368555",
		"id": 187368555,
		"lng": -77.38780958,
		"lat": 37.53632203,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 7,
		"dd": 6,
		"by": 1882,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cora",
		"nl": "Tyler",
		"url": "https://findagrave.com/memorial/142505873",
		"id": 142505873,
		"lng": -77.3873021,
		"lat": 37.53787884,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 3,
		"by": 1892,
		"bd": 28,
		"bm": 9,
		"nm": "L.",
		"nf": "Mildred",
		"nl": "Tyler",
		"url": "https://findagrave.com/memorial/138572991",
		"id": 138572991,
		"lng": -77.38623973,
		"lat": 37.53660091,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 10,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Oliver",
		"nl": "Tyler",
		"url": "https://findagrave.com/memorial/175476419",
		"id": 175476419,
		"lng": -77.38564282,
		"lat": 37.53684064,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 6,
		"by": 1908,
		"bd": "",
		"bm": 11,
		"nm": "",
		"nf": "Mary",
		"nl": "Valentine",
		"url": "https://findagrave.com/memorial/160934070",
		"id": 160934070,
		"lng": -77.38639904,
		"lat": 37.53681877,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 5,
		"dd": 27,
		"by": 1892,
		"bd": 17,
		"bm": 8,
		"nm": "",
		"nf": "Thomas",
		"nl": "Valentine",
		"url": "https://findagrave.com/memorial/157311980",
		"id": 157311980,
		"lng": -77.38655119,
		"lat": 37.53713862,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 3,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Samuel",
		"nl": "Van Hook",
		"url": "https://findagrave.com/memorial/169810315",
		"id": 169810315,
		"lng": -77.38672359,
		"lat": 37.53706691,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 9,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Burrell",
		"nf": "Henrietta",
		"nl": "Vaughan",
		"url": "https://findagrave.com/memorial/142106357",
		"id": 142106357,
		"lng": -77.38672413,
		"lat": 37.53667518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 5,
		"dd": 24,
		"by": 1875,
		"bd": 7,
		"bm": 3,
		"nm": "Robert",
		"nf": "James",
		"nl": "Vaughan",
		"url": "https://findagrave.com/memorial/24865570",
		"id": 24865570,
		"lng": -77.38575564,
		"lat": 37.53673893,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 7,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jefford",
		"nl": "Vaughan",
		"url": "https://findagrave.com/memorial/168088710",
		"id": 168088710,
		"lng": -77.38656209,
		"lat": 37.53689998,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "H",
		"nl": "Venable",
		"url": "https://findagrave.com/memorial/207135117",
		"id": 207135117,
		"lng": -77.38623596,
		"lat": 37.53539208,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 20,
		"by": 1880,
		"bd": 5,
		"bm": 5,
		"nm": "Linwood",
		"nf": "John",
		"nl": "Venable",
		"url": "https://findagrave.com/memorial/113416726",
		"id": 113416726,
		"lng": -77.38569957,
		"lat": 37.53683204,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 25,
		"by": 1888,
		"bd": 25,
		"bm": 9,
		"nm": "",
		"nf": "Inez",
		"nl": "Waddell",
		"url": "https://findagrave.com/memorial/172687590",
		"id": 172687590,
		"lng": -77.38730217,
		"lat": 37.53730032,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 6,
		"dd": 4,
		"by": 1946,
		"bd": 3,
		"bm": 12,
		"nm": "Eugene",
		"nf": "Melvin",
		"nl": "Waddell",
		"url": "https://findagrave.com/memorial/161180433",
		"id": 161180433,
		"lng": -77.38671125,
		"lat": 37.53704479,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 28,
		"by": 1918,
		"bd": 23,
		"bm": 6,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Waddy",
		"url": "https://findagrave.com/memorial/134374533",
		"id": 134374533,
		"lng": -77.38629742,
		"lat": 37.53705055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 25,
		"by": 1872,
		"bd": 12,
		"bm": 7,
		"nm": "Washington",
		"nf": "George",
		"nl": "Wade",
		"url": "https://findagrave.com/memorial/117307721",
		"id": 117307721,
		"lng": -77.38575113,
		"lat": 37.53675844,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 3,
		"dd": 26,
		"by": 1912,
		"bd": 1,
		"bm": 10,
		"nm": "Amelia",
		"nf": "Naomi",
		"nl": "Wafer",
		"url": "https://findagrave.com/memorial/175700271",
		"id": 175700271,
		"lng": -77.3875569,
		"lat": 37.53707822,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 10,
		"dd": 27,
		"by": 1897,
		"bd": 15,
		"bm": 9,
		"nm": "W.",
		"nf": "Thomas",
		"nl": "Waith",
		"url": "https://findagrave.com/memorial/177673468",
		"id": 177673468,
		"lng": -77.3875331,
		"lat": 37.53693564,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Amanda",
		"nl": "Walden",
		"url": "https://findagrave.com/memorial/180846246",
		"id": 180846246,
		"lng": -77.38813185,
		"lat": 37.53757883,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 9,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Tim",
		"nf": "William",
		"nl": "Walden",
		"url": "https://findagrave.com/memorial/173512215",
		"id": 173512215,
		"lng": -77.38752999,
		"lat": 37.537091,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 1,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/143900182",
		"id": 143900182,
		"lng": -77.38617012,
		"lat": 37.53647442,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 13,
		"by": 1881,
		"bd": 29,
		"bm": 1,
		"nm": "",
		"nf": "Annie",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/155539607",
		"id": 155539607,
		"lng": -77.38760157,
		"lat": 37.53762869,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 11,
		"dd": 10,
		"by": 1875,
		"bd": "",
		"bm": 4,
		"nm": "",
		"nf": "Ella",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/144383158",
		"id": 144383158,
		"lng": -77.38660453,
		"lat": 37.53537558,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 2,
		"dd": 23,
		"by": 1909,
		"bd": 13,
		"bm": 12,
		"nm": "H.",
		"nf": "Eva",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/158450809",
		"id": 158450809,
		"lng": -77.38678085,
		"lat": 37.53739107,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 8,
		"dd": 18,
		"by": 1904,
		"bd": 28,
		"bm": 3,
		"nm": "Virginia",
		"nf": "Frances",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/163611787",
		"id": 163611787,
		"lng": -77.3875801,
		"lat": 37.53759168,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 12,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fred",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/184293117",
		"id": 184293117,
		"lng": -77.38704786,
		"lat": 37.53759886,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 4,
		"dd": 20,
		"by": 1898,
		"bd": 27,
		"bm": 11,
		"nm": "M.",
		"nf": "Hazel",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/142106360",
		"id": 142106360,
		"lng": -77.38585563,
		"lat": 37.53736068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Henry",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/140291072",
		"id": 140291072,
		"lng": -77.38619196,
		"lat": 37.53648449,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 10,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/166103955",
		"id": 166103955,
		"lng": -77.38707144,
		"lat": 37.53665672,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Mildred",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/144558771",
		"id": 144558771,
		"lng": -77.3868573,
		"lat": 37.53662366,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 2,
		"dd": 7,
		"by": 1892,
		"bd": 5,
		"bm": 1,
		"nm": "Henry",
		"nf": "Richard",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/138181592",
		"id": 138181592,
		"lng": -77.38645202,
		"lat": 37.53697085,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 30,
		"by": 1882,
		"bd": 4,
		"bm": 7,
		"nm": "",
		"nf": "Sam",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/155021731",
		"id": 155021731,
		"lng": -77.3871194,
		"lat": 37.53774238,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 3,
		"by": 1902,
		"bd": 25,
		"bm": 2,
		"nm": "",
		"nf": "Thomas",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/138573013",
		"id": 138573013,
		"lng": -77.3862852,
		"lat": 37.53671492,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 12,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willard",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/155539610",
		"id": 155539610,
		"lng": -77.38760109,
		"lat": 37.53763524,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Wall",
		"url": "https://findagrave.com/memorial/186818095",
		"id": 186818095,
		"lng": -77.38734628,
		"lat": 37.53694153,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 13,
		"by": 1883,
		"bd": 24,
		"bm": 12,
		"nm": "M.",
		"nf": "Carrie",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/167271241",
		"id": 167271241,
		"lng": -77.38655725,
		"lat": 37.53742434,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 3,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Georgia",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/188301115",
		"id": 188301115,
		"lng": -77.3879252,
		"lat": 37.53703476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 12,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jacob",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/146207097",
		"id": 146207097,
		"lng": -77.38586992,
		"lat": 37.53672533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 5,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/156215186",
		"id": 156215186,
		"lng": -77.38650139,
		"lat": 37.53580049,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 8,
		"dd": 13,
		"by": 1864,
		"bd": 30,
		"bm": 10,
		"nm": "",
		"nf": "John",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/156215201",
		"id": 156215201,
		"lng": -77.38650173,
		"lat": 37.53578896,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 9,
		"dd": 16,
		"by": 1925,
		"bd": 15,
		"bm": 5,
		"nm": "Fleming",
		"nf": "Kenneth",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/177768035",
		"id": 177768035,
		"lng": -77.38799205,
		"lat": 37.53736529,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/156215211",
		"id": 156215211,
		"lng": -77.38650144,
		"lat": 37.53579252,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 10,
		"dd": 23,
		"by": 1835,
		"bd": 26,
		"bm": 6,
		"nm": "Etta",
		"nf": "Mary",
		"nl": "Waller",
		"url": "https://findagrave.com/memorial/153263664",
		"id": 153263664,
		"lng": -77.38672467,
		"lat": 37.53542633,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 5,
		"dd": 18,
		"by": 1882,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Aaron",
		"nl": "Walters",
		"url": "https://findagrave.com/memorial/150981690",
		"id": 150981690,
		"lng": -77.38675351,
		"lat": 37.53546137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 2,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Olivia",
		"nl": "Walters",
		"url": "https://findagrave.com/memorial/150981848",
		"id": 150981848,
		"lng": -77.38678282,
		"lat": 37.53544333,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 3,
		"dd": 8,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillian",
		"nl": "Ware",
		"url": "https://findagrave.com/memorial/144383168",
		"id": 144383168,
		"lng": -77.38705556,
		"lat": 37.53551617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 1,
		"dd": 20,
		"by": 1884,
		"bd": 19,
		"bm": 2,
		"nm": "Burnett",
		"nf": "Nelson",
		"nl": "Ware",
		"url": "https://findagrave.com/memorial/192444591",
		"id": 192444591,
		"lng": -77.38704733,
		"lat": 37.53552503,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Georgiana",
		"nl": "Warwick",
		"url": "https://findagrave.com/memorial/146207105",
		"id": 146207105,
		"lng": -77.38629801,
		"lat": 37.53667955,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 7,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Addie",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/187074955",
		"id": 187074955,
		"lng": -77.38752196,
		"lat": 37.53685207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 3,
		"dd": 1,
		"by": 1922,
		"bd": 3,
		"bm": 4,
		"nm": "Jean",
		"nf": "Anna",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/178265731",
		"id": 178265731,
		"lng": -77.38800213,
		"lat": 37.537445,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Carrie",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/144227117",
		"id": 144227117,
		"lng": -77.387151,
		"lat": 37.53783141,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 2,
		"dd": 21,
		"by": 1881,
		"bd": 25,
		"bm": 11,
		"nm": "W.",
		"nf": "Daniel",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/146341636",
		"id": 146341636,
		"lng": -77.3864256,
		"lat": 37.53580471,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 12,
		"dd": 13,
		"by": 1897,
		"bd": "",
		"bm": 2,
		"nm": "",
		"nf": "Ernest",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/181157336",
		"id": 181157336,
		"lng": -77.38803443,
		"lat": 37.53741608,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 1,
		"dd": 2,
		"by": 1895,
		"bd": 30,
		"bm": 6,
		"nm": "M.",
		"nf": "Eva",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/127992107",
		"id": 127992107,
		"lng": -77.38610518,
		"lat": 37.53657331,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 8,
		"dd": 23,
		"by": 1888,
		"bd": 8,
		"bm": 3,
		"nm": "",
		"nf": "Fannie",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/119593483",
		"id": 119593483,
		"lng": -77.385708,
		"lat": 37.53669734,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 4,
		"dd": 4,
		"by": 1908,
		"bd": 19,
		"bm": 11,
		"nm": "Douglas",
		"nf": "Fred",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/190118371",
		"id": 190118371,
		"lng": -77.38746541,
		"lat": 37.53719533,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 31,
		"by": 1905,
		"bd": 2,
		"bm": 8,
		"nm": "",
		"nf": "George",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/183909978",
		"id": 183909978,
		"lng": -77.38640424,
		"lat": 37.53680674,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 16,
		"by": 1939,
		"bd": 11,
		"bm": 11,
		"nm": "",
		"nf": "George",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/144227143",
		"id": 144227143,
		"lng": -77.38598448,
		"lat": 37.53740956,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 1,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isabelle",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/143635996",
		"id": 143635996,
		"lng": -77.38603877,
		"lat": 37.53601342,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 7,
		"dd": 24,
		"by": 1910,
		"bd": 1,
		"bm": 4,
		"nm": "Everett",
		"nf": "John",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/139566628",
		"id": 139566628,
		"lng": -77.38594559,
		"lat": 37.53638041,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 10,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Laura",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/141924969",
		"id": 141924969,
		"lng": -77.38599408,
		"lat": 37.53668545,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 7,
		"dd": 2,
		"by": 1894,
		"bd": 26,
		"bm": 8,
		"nm": "Andrew",
		"nf": "Lee",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/157686094",
		"id": 157686094,
		"lng": -77.38678914,
		"lat": 37.53744464,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 2,
		"dd": 12,
		"by": 1917,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Mary",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/170724567",
		"id": 170724567,
		"lng": -77.385961,
		"lat": 37.53631664,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 11,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Priscilla",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/143696149",
		"id": 143696149,
		"lng": -77.38602047,
		"lat": 37.53607316,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 7,
		"dd": 21,
		"by": 1924,
		"bd": 1,
		"bm": 2,
		"nm": "Richard",
		"nf": "Robert",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/127992118",
		"id": 127992118,
		"lng": -77.38610056,
		"lat": 37.53658296,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 12,
		"by": 1958,
		"bd": 20,
		"bm": 12,
		"nm": "Arletha",
		"nf": "Romanta",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/122027622",
		"id": 122027622,
		"lng": -77.38648449,
		"lat": 37.53660909,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 8,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Bell",
		"nf": "Rosa",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/183863021",
		"id": 183863021,
		"lng": -77.38735625,
		"lat": 37.53701214,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 4,
		"dd": 9,
		"by": 1841,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Van",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/156215218",
		"id": 156215218,
		"lng": -77.38647547,
		"lat": 37.53580227,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 3,
		"dd": 1,
		"by": 1859,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virginia",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/156215227",
		"id": 156215227,
		"lng": -77.38647743,
		"lat": 37.53579434,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 8,
		"dd": 30,
		"by": 1953,
		"bd": 9,
		"bm": 6,
		"nm": "",
		"nf": "Wesley",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/141701329",
		"id": 141701329,
		"lng": -77.38723682,
		"lat": 37.5378729,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 12,
		"by": 1963,
		"bd": 29,
		"bm": 12,
		"nm": "",
		"nf": "William",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/151929650",
		"id": 151929650,
		"lng": -77.38599604,
		"lat": 37.53745374,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 4,
		"dd": 0,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Waters",
		"url": "https://findagrave.com/memorial/207174240",
		"id": 207174240,
		"lng": -77.38628669,
		"lat": 37.53674672,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Adolphus",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/137835776",
		"id": 137835776,
		"lng": -77.38619315,
		"lat": 37.53714358,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 11,
		"dd": 7,
		"by": 1892,
		"bd": 7,
		"bm": 3,
		"nm": "",
		"nf": "Albert",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/177545582",
		"id": 177545582,
		"lng": -77.38698182,
		"lat": 37.53776114,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 3,
		"by": 1889,
		"bd": 28,
		"bm": 2,
		"nm": "Thomas",
		"nf": "Benjamin",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/157164236",
		"id": 157164236,
		"lng": -77.38641804,
		"lat": 37.53585461,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/146341782",
		"id": 146341782,
		"lng": -77.38642178,
		"lat": 37.5358463,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 20,
		"by": 1895,
		"bd": 15,
		"bm": 11,
		"nm": "",
		"nf": "Charles",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/144227152",
		"id": 144227152,
		"lng": -77.38759681,
		"lat": 37.53781719,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clifton",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/174697689",
		"id": 174697689,
		"lng": -77.38748882,
		"lat": 37.53710903,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 12,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Edward",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/174711640",
		"id": 174711640,
		"lng": -77.3876312,
		"lat": 37.53694451,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 5,
		"dd": 27,
		"by": 1899,
		"bd": 21,
		"bm": 8,
		"nm": "H.",
		"nf": "Ivan",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/76611215",
		"id": 76611215,
		"lng": -77.38618886,
		"lat": 37.53718373,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 1,
		"dd": 17,
		"by": 1880,
		"bd": 11,
		"bm": 9,
		"nm": "Booker",
		"nf": "John",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/176134722",
		"id": 176134722,
		"lng": -77.3876812,
		"lat": 37.53715142,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 5,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/146207113",
		"id": 146207113,
		"lng": -77.38644317,
		"lat": 37.5358302,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 9,
		"by": 1873,
		"bd": 10,
		"bm": 1,
		"nm": "",
		"nf": "Joshua",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/76611240",
		"id": 76611240,
		"lng": -77.38619442,
		"lat": 37.53717075,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 9,
		"dd": 30,
		"by": 1900,
		"bd": 15,
		"bm": 12,
		"nm": "",
		"nf": "Marie",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/168872082",
		"id": 168872082,
		"lng": -77.38757356,
		"lat": 37.53692521,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/37602491",
		"id": 37602491,
		"lng": -77.38728627,
		"lat": 37.53695991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 5,
		"by": 1893,
		"bd": 13,
		"bm": 4,
		"nm": "Elizabeth",
		"nf": "Mary",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/178249279",
		"id": 178249279,
		"lng": -77.38773201,
		"lat": 37.53750266,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 6,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/144383180",
		"id": 144383180,
		"lng": -77.38705684,
		"lat": 37.53550069,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 5,
		"dd": 20,
		"by": 1907,
		"bd": 27,
		"bm": 4,
		"nm": "E.",
		"nf": "Mary",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/170604709",
		"id": 170604709,
		"lng": -77.38686685,
		"lat": 37.53693805,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nellie",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/184512829",
		"id": 184512829,
		"lng": -77.38749469,
		"lat": 37.53682651,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 10,
		"dd": 26,
		"by": 1900,
		"bd": 10,
		"bm": 3,
		"nm": "",
		"nf": "Robert",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/170129851",
		"id": 170129851,
		"lng": -77.38677411,
		"lat": 37.53692866,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 12,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sarah",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/111589858",
		"id": 111589858,
		"lng": -77.38619195,
		"lat": 37.53717752,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 11,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Silas",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/154304043",
		"id": 154304043,
		"lng": -77.3870169,
		"lat": 37.53549865,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 10,
		"by": 1899,
		"bd": 13,
		"bm": 10,
		"nm": "",
		"nf": "Willie",
		"nl": "Watkins",
		"url": "https://findagrave.com/memorial/184302504",
		"id": 184302504,
		"lng": -77.38612425,
		"lat": 37.53681968,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 11,
		"dd": 25,
		"by": 1951,
		"bd": 29,
		"bm": 1,
		"nm": "",
		"nf": "Clovia",
		"nl": "Watson",
		"url": "https://findagrave.com/memorial/144558773",
		"id": 144558773,
		"lng": -77.38792506,
		"lat": 37.53745221,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 5,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Watson",
		"url": "https://findagrave.com/memorial/173847288",
		"id": 173847288,
		"lng": -77.38740737,
		"lat": 37.53709559,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 1,
		"dd": 21,
		"by": 1923,
		"bd": 18,
		"bm": 8,
		"nm": "Taylor",
		"nf": "George",
		"nl": "Watson",
		"url": "https://findagrave.com/memorial/177998689",
		"id": 177998689,
		"lng": -77.38799437,
		"lat": 37.53760742,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 20,
		"by": 1913,
		"bd": 6,
		"bm": 3,
		"nm": "",
		"nf": "Helen",
		"nl": "Watson",
		"url": "https://findagrave.com/memorial/172683157",
		"id": 172683157,
		"lng": -77.38725231,
		"lat": 37.53731325,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 7,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Junius",
		"nf": "James",
		"nl": "Watson",
		"url": "https://findagrave.com/memorial/185658504",
		"id": 185658504,
		"lng": -77.38743059,
		"lat": 37.53709964,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 9,
		"dd": 24,
		"by": 1921,
		"bd": 18,
		"bm": 10,
		"nm": "Rebecca",
		"nf": "Sarah",
		"nl": "Watson",
		"url": "https://findagrave.com/memorial/179570809",
		"id": 179570809,
		"lng": -77.38792444,
		"lat": 37.53772882,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 27,
		"by": 1908,
		"bd": 15,
		"bm": 8,
		"nm": "",
		"nf": "Matt",
		"nl": "Watts",
		"url": "https://findagrave.com/memorial/169397396",
		"id": 169397396,
		"lng": -77.38652423,
		"lat": 37.5368036,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 9,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Lelia",
		"nl": "Webb",
		"url": "https://findagrave.com/memorial/137431002",
		"id": 137431002,
		"lng": -77.38620364,
		"lat": 37.53706753,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 2,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eliza",
		"nl": "Wells",
		"url": "https://findagrave.com/memorial/123587278",
		"id": 123587278,
		"lng": -77.38575158,
		"lat": 37.5370053,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 7,
		"dd": 4,
		"by": 1888,
		"bd": 8,
		"bm": 9,
		"nm": "",
		"nf": "Preston",
		"nl": "Wells",
		"url": "https://findagrave.com/memorial/158960469",
		"id": 158960469,
		"lng": -77.38774163,
		"lat": 37.53776373,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 8,
		"dd": 28,
		"by": 1914,
		"bd": 8,
		"bm": 4,
		"nm": "B.",
		"nf": "Annie",
		"nl": "West",
		"url": "https://findagrave.com/memorial/157757373",
		"id": 157757373,
		"lng": -77.38564499,
		"lat": 37.53729432,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 5,
		"by": 1921,
		"bd": 21,
		"bm": 9,
		"nm": "E.",
		"nf": "Catherine",
		"nl": "West",
		"url": "https://findagrave.com/memorial/158960474",
		"id": 158960474,
		"lng": -77.38712674,
		"lat": 37.53740254,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 6,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "West",
		"url": "https://findagrave.com/memorial/142511366",
		"id": 142511366,
		"lng": -77.385589,
		"lat": 37.53736309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elizabeth",
		"nl": "West",
		"url": "https://findagrave.com/memorial/166447800",
		"id": 166447800,
		"lng": -77.38709991,
		"lat": 37.53664839,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1902,
		"dm": 5,
		"dd": 21,
		"by": 1844,
		"bd": 21,
		"bm": 3,
		"nm": "W.",
		"nf": "John",
		"nl": "West",
		"url": "https://findagrave.com/memorial/166448786",
		"id": 166448786,
		"lng": -77.38709484,
		"lat": 37.53664723,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 5,
		"dd": 8,
		"by": 1876,
		"bd": 30,
		"bm": 1,
		"nm": "H.",
		"nf": "John",
		"nl": "West",
		"url": "https://findagrave.com/memorial/171360813",
		"id": 171360813,
		"lng": -77.38709106,
		"lat": 37.53662653,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 4,
		"dd": 17,
		"by": 1920,
		"bd": 28,
		"bm": 10,
		"nm": "M.",
		"nf": "Joseph",
		"nl": "West",
		"url": "https://findagrave.com/memorial/145344938",
		"id": 145344938,
		"lng": -77.38557711,
		"lat": 37.53734325,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 12,
		"dd": 22,
		"by": 1891,
		"bd": 16,
		"bm": 5,
		"nm": "",
		"nf": "Lena",
		"nl": "West",
		"url": "https://findagrave.com/memorial/142511372",
		"id": 142511372,
		"lng": -77.38568171,
		"lat": 37.53731149,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucinda",
		"nl": "West",
		"url": "https://findagrave.com/memorial/159859262",
		"id": 159859262,
		"lng": -77.38811395,
		"lat": 37.53741586,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "West",
		"url": "https://findagrave.com/memorial/142511380",
		"id": 142511380,
		"lng": -77.3856028,
		"lat": 37.53735001,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 4,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "West",
		"url": "https://findagrave.com/memorial/191780033",
		"id": 191780033,
		"lng": -77.38684197,
		"lat": 37.53581226,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 12,
		"dd": 24,
		"by": 1899,
		"bd": 24,
		"bm": 7,
		"nm": "",
		"nf": "Mary",
		"nl": "West",
		"url": "https://findagrave.com/memorial/177118750",
		"id": 177118750,
		"lng": -77.38784595,
		"lat": 37.5370263,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 3,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Melchia",
		"nl": "West",
		"url": "https://findagrave.com/memorial/157621878",
		"id": 157621878,
		"lng": -77.38677144,
		"lat": 37.53740483,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 12,
		"dd": 20,
		"by": 1893,
		"bd": 22,
		"bm": 2,
		"nm": "B.",
		"nf": "Rosa",
		"nl": "West",
		"url": "https://findagrave.com/memorial/176239469",
		"id": 176239469,
		"lng": -77.38721932,
		"lat": 37.53704321,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Waverly",
		"nl": "West",
		"url": "https://findagrave.com/memorial/177019642",
		"id": 177019642,
		"lng": -77.38793509,
		"lat": 37.53727472,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 1,
		"dd": 23,
		"by": 1888,
		"bd": 26,
		"bm": 12,
		"nm": "H.",
		"nf": "William",
		"nl": "West",
		"url": "https://findagrave.com/memorial/175328079",
		"id": 175328079,
		"lng": -77.38740721,
		"lat": 37.53708133,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 12,
		"dd": 6,
		"by": 1890,
		"bd": 22,
		"bm": 11,
		"nm": "",
		"nf": "Ella",
		"nl": "Westinghouse",
		"url": "https://findagrave.com/memorial/144013925",
		"id": 144013925,
		"lng": -77.3869684,
		"lat": 37.53738886,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 24,
		"by": 1886,
		"bd": 12,
		"bm": 1,
		"nm": "A.",
		"nf": "Nora",
		"nl": "Wheaton",
		"url": "https://findagrave.com/memorial/172045099",
		"id": 172045099,
		"lng": -77.38693015,
		"lat": 37.53715601,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 28,
		"by": 1894,
		"bd": 15,
		"bm": 5,
		"nm": "",
		"nf": "Rosa",
		"nl": "Whitaker",
		"url": "https://findagrave.com/memorial/168032334",
		"id": 168032334,
		"lng": -77.38693468,
		"lat": 37.53728609,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 12,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Albert",
		"nl": "White",
		"url": "https://findagrave.com/memorial/187763273",
		"id": 187763273,
		"lng": -77.38790881,
		"lat": 37.53713518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 7,
		"dd": 6,
		"by": 1906,
		"bd": 29,
		"bm": 1,
		"nm": "",
		"nf": "Arline",
		"nl": "White",
		"url": "https://findagrave.com/memorial/156126626",
		"id": 156126626,
		"lng": -77.38611034,
		"lat": 37.53696173,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 20,
		"by": 1903,
		"bd": 5,
		"bm": 9,
		"nm": "C.",
		"nf": "Calvin",
		"nl": "White",
		"url": "https://findagrave.com/memorial/145167332",
		"id": 145167332,
		"lng": -77.38628497,
		"lat": 37.53713287,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 1,
		"by": 1897,
		"bd": 12,
		"bm": 12,
		"nm": "H.",
		"nf": "Charles",
		"nl": "White",
		"url": "https://findagrave.com/memorial/76611268",
		"id": 76611268,
		"lng": -77.38608243,
		"lat": 37.53698842,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 6,
		"by": 1900,
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Cora",
		"nl": "White",
		"url": "https://findagrave.com/memorial/153629449",
		"id": 153629449,
		"lng": -77.38652125,
		"lat": 37.53742739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 3,
		"by": 1893,
		"bd": 3,
		"bm": 6,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "White",
		"url": "https://findagrave.com/memorial/159416179",
		"id": 159416179,
		"lng": -77.38609776,
		"lat": 37.53740575,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 3,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Ethel",
		"nl": "White",
		"url": "https://findagrave.com/memorial/130737031",
		"id": 130737031,
		"lng": -77.38571657,
		"lat": 37.5371722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Evelyn",
		"nl": "White",
		"url": "https://findagrave.com/memorial/147853936",
		"id": 147853936,
		"lng": -77.38634869,
		"lat": 37.53722925,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 7,
		"dd": 15,
		"by": 1900,
		"bd": 13,
		"bm": 10,
		"nm": "T.",
		"nf": "Everett",
		"nl": "White",
		"url": "https://findagrave.com/memorial/156126636",
		"id": 156126636,
		"lng": -77.38609341,
		"lat": 37.53697186,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 7,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Georgia",
		"nl": "White",
		"url": "https://findagrave.com/memorial/149250595",
		"id": 149250595,
		"lng": -77.38625587,
		"lat": 37.53584102,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 27,
		"by": 1919,
		"bd": 17,
		"bm": 12,
		"nm": "Virginia",
		"nf": "Iva",
		"nl": "White",
		"url": "https://findagrave.com/memorial/171203066",
		"id": 171203066,
		"lng": -77.38761569,
		"lat": 37.53778145,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 16,
		"by": 1921,
		"bd": 6,
		"bm": 3,
		"nm": "Christopher Columbus",
		"nf": "James",
		"nl": "White",
		"url": "https://findagrave.com/memorial/183319922",
		"id": 183319922,
		"lng": -77.38659983,
		"lat": 37.53706569,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 10,
		"dd": 8,
		"by": 1910,
		"bd": 22,
		"bm": 1,
		"nm": "Samuel",
		"nf": "James",
		"nl": "White",
		"url": "https://findagrave.com/memorial/185308250",
		"id": 185308250,
		"lng": -77.38681339,
		"lat": 37.53768714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 12,
		"dd": 30,
		"by": 1932,
		"bd": 4,
		"bm": 11,
		"nm": "",
		"nf": "James",
		"nl": "White",
		"url": "https://findagrave.com/memorial/153864056",
		"id": 153864056,
		"lng": -77.38623824,
		"lat": 37.5374054,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "White",
		"url": "https://findagrave.com/memorial/126652599",
		"id": 126652599,
		"lng": -77.38594098,
		"lat": 37.53648584,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 6,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "White",
		"url": "https://findagrave.com/memorial/187368560",
		"id": 187368560,
		"lng": -77.38802108,
		"lat": 37.53731801,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Joseph",
		"nl": "White",
		"url": "https://findagrave.com/memorial/145344944",
		"id": 145344944,
		"lng": -77.38558296,
		"lat": 37.53726467,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 12,
		"dd": 26,
		"by": 1934,
		"bd": 7,
		"bm": 11,
		"nm": "",
		"nf": "Lawrence",
		"nl": "White",
		"url": "https://findagrave.com/memorial/150637846",
		"id": 150637846,
		"lng": -77.38641668,
		"lat": 37.53597999,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 15,
		"by": 1929,
		"bd": 27,
		"bm": 3,
		"nm": "C.",
		"nf": "Lewis",
		"nl": "White",
		"url": "https://findagrave.com/memorial/175449604",
		"id": 175449604,
		"lng": -77.38736902,
		"lat": 37.53731582,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Lillian",
		"nl": "White",
		"url": "https://findagrave.com/memorial/156126645",
		"id": 156126645,
		"lng": -77.38601438,
		"lat": 37.53691409,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 7,
		"by": 1890,
		"bd": 9,
		"bm": 4,
		"nm": "",
		"nf": "Lillie",
		"nl": "White",
		"url": "https://findagrave.com/memorial/139424782",
		"id": 139424782,
		"lng": -77.38795568,
		"lat": 37.53698781,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 11,
		"dd": 23,
		"by": 1922,
		"bd": 14,
		"bm": 8,
		"nm": "Mae",
		"nf": "Lottie",
		"nl": "White",
		"url": "https://findagrave.com/memorial/176939610",
		"id": 176939610,
		"lng": -77.38709927,
		"lat": 37.53756722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucille",
		"nl": "White",
		"url": "https://findagrave.com/memorial/189200293",
		"id": 189200293,
		"lng": -77.38739518,
		"lat": 37.53740437,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 3,
		"dd": 13,
		"by": 1913,
		"bd": 28,
		"bm": 8,
		"nm": "",
		"nf": "Lula",
		"nl": "White",
		"url": "https://findagrave.com/memorial/184276323",
		"id": 184276323,
		"lng": -77.38766324,
		"lat": 37.5373745,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 6,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "White",
		"url": "https://findagrave.com/memorial/156480539",
		"id": 156480539,
		"lng": -77.38633677,
		"lat": 37.53569043,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 7,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "White",
		"url": "https://findagrave.com/memorial/185151787",
		"id": 185151787,
		"lng": -77.38775876,
		"lat": 37.53667434,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 6,
		"dd": 9,
		"by": 1870,
		"bd": 28,
		"bm": 3,
		"nm": "C.",
		"nf": "Mary",
		"nl": "White",
		"url": "https://findagrave.com/memorial/125644015",
		"id": 125644015,
		"lng": -77.38609436,
		"lat": 37.53699222,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": 11,
		"nm": "",
		"nf": "Meaky",
		"nl": "White",
		"url": "https://findagrave.com/memorial/176133126",
		"id": 176133126,
		"lng": -77.3874453,
		"lat": 37.53728149,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 3,
		"dd": 4,
		"by": 1900,
		"bd": 15,
		"bm": 10,
		"nm": "May",
		"nf": "Ottie",
		"nl": "White",
		"url": "https://findagrave.com/memorial/130737033",
		"id": 130737033,
		"lng": -77.38568448,
		"lat": 37.53719637,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 11,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "Patrick",
		"nl": "White",
		"url": "https://findagrave.com/memorial/134474473",
		"id": 134474473,
		"lng": -77.38611029,
		"lat": 37.53697228,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 7,
		"dd": 19,
		"by": 1886,
		"bd": 14,
		"bm": 5,
		"nm": "Emmett",
		"nf": "Robert",
		"nl": "White",
		"url": "https://findagrave.com/memorial/155989195",
		"id": 155989195,
		"lng": -77.38698518,
		"lat": 37.53549178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 17,
		"by": 1902,
		"bd": 18,
		"bm": 5,
		"nm": "",
		"nf": "Richard",
		"nl": "White",
		"url": "https://findagrave.com/memorial/138181595",
		"id": 138181595,
		"lng": -77.38650305,
		"lat": 37.53700646,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 11,
		"dd": 30,
		"by": 1884,
		"bd": 25,
		"bm": 10,
		"nm": "T.",
		"nf": "Robert",
		"nl": "White",
		"url": "https://findagrave.com/memorial/117804456",
		"id": 117804456,
		"lng": -77.38556601,
		"lat": 37.53722866,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 18,
		"by": 1908,
		"bd": 5,
		"bm": 1,
		"nm": "Bell",
		"nf": "Rosa",
		"nl": "White",
		"url": "https://findagrave.com/memorial/176060955",
		"id": 176060955,
		"lng": -77.387468,
		"lat": 37.53730734,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 8,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Rosa",
		"nl": "White",
		"url": "https://findagrave.com/memorial/139424787",
		"id": 139424787,
		"lng": -77.38796899,
		"lat": 37.53712514,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 1,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "White",
		"url": "https://findagrave.com/memorial/147853941",
		"id": 147853941,
		"lng": -77.38600802,
		"lat": 37.53629999,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 3,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Sallie",
		"nl": "White",
		"url": "https://findagrave.com/memorial/146682170",
		"id": 146682170,
		"lng": -77.38615709,
		"lat": 37.53577463,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 8,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "White",
		"url": "https://findagrave.com/memorial/177768036",
		"id": 177768036,
		"lng": -77.38777309,
		"lat": 37.53757622,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "D.",
		"nf": "Samuel",
		"nl": "White",
		"url": "https://findagrave.com/memorial/119328069",
		"id": 119328069,
		"lng": -77.38550328,
		"lat": 37.53732739,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 12,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Sarah",
		"nl": "White",
		"url": "https://findagrave.com/memorial/144821957",
		"id": 144821957,
		"lng": -77.38554281,
		"lat": 37.53723433,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Scott",
		"nl": "White",
		"url": "https://findagrave.com/memorial/142511383",
		"id": 142511383,
		"lng": -77.38571449,
		"lat": 37.53719233,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 19,
		"by": 1880,
		"bd": 4,
		"bm": 10,
		"nm": "",
		"nf": "Selena",
		"nl": "White",
		"url": "https://findagrave.com/memorial/130737039",
		"id": 130737039,
		"lng": -77.38571095,
		"lat": 37.53719888,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee",
		"nf": "Walter",
		"nl": "White",
		"url": "https://findagrave.com/memorial/175449924",
		"id": 175449924,
		"lng": -77.38748265,
		"lat": 37.53700576,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 8,
		"by": 1908,
		"bd": 10,
		"bm": 1,
		"nm": "Jack",
		"nf": "Wellington",
		"nl": "White",
		"url": "https://findagrave.com/memorial/170815007",
		"id": 170815007,
		"lng": -77.38630396,
		"lat": 37.53681196,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 1,
		"dd": 31,
		"by": 1903,
		"bd": 14,
		"bm": 9,
		"nm": "Hamilton",
		"nf": "William",
		"nl": "White",
		"url": "https://findagrave.com/memorial/150033853",
		"id": 150033853,
		"lng": -77.38627469,
		"lat": 37.53586226,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 9,
		"by": 1886,
		"bd": 15,
		"bm": 3,
		"nm": "W.",
		"nf": "John",
		"nl": "Whitfield",
		"url": "https://findagrave.com/memorial/138573019",
		"id": 138573019,
		"lng": -77.38622693,
		"lat": 37.53666423,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 7,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Whiting",
		"url": "https://findagrave.com/memorial/119328233",
		"id": 119328233,
		"lng": -77.3855196,
		"lat": 37.53730727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 17,
		"by": 1892,
		"bd": 1,
		"bm": 5,
		"nm": "",
		"nf": "Channie",
		"nl": "Whitlow",
		"url": "https://findagrave.com/memorial/144383187",
		"id": 144383187,
		"lng": -77.38606721,
		"lat": 37.53730676,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 9,
		"dd": 15,
		"by": 1893,
		"bd": 12,
		"bm": 7,
		"nm": "",
		"nf": "Albert",
		"nl": "Wickham",
		"url": "https://findagrave.com/memorial/152526999",
		"id": 152526999,
		"lng": -77.38582729,
		"lat": 37.5371722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 10,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Rosa",
		"nl": "Wickham",
		"url": "https://findagrave.com/memorial/160906583",
		"id": 160906583,
		"lng": -77.38700318,
		"lat": 37.53704103,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 10,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "John",
		"nl": "Wiggin",
		"url": "https://findagrave.com/memorial/126456570",
		"id": 126456570,
		"lng": -77.38581546,
		"lat": 37.53640476,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 12,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Cornelius",
		"nl": "Wiley",
		"url": "https://findagrave.com/memorial/157757377",
		"id": 157757377,
		"lng": -77.38575704,
		"lat": 37.53733139,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 30,
		"by": 1905,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ethel",
		"nl": "Wiley",
		"url": "https://findagrave.com/memorial/173793418",
		"id": 173793418,
		"lng": -77.38704396,
		"lat": 37.53720503,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 2,
		"dd": 11,
		"by": 1902,
		"bd": 10,
		"bm": 12,
		"nm": "",
		"nf": "Hercules",
		"nl": "Wiley",
		"url": "https://findagrave.com/memorial/142514773",
		"id": 142514773,
		"lng": -77.38579105,
		"lat": 37.5373134,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 22,
		"by": 1911,
		"bd": 3,
		"bm": 7,
		"nm": "W.",
		"nf": "John",
		"nl": "Wiley",
		"url": "https://findagrave.com/memorial/161179877",
		"id": 161179877,
		"lng": -77.38644955,
		"lat": 37.53707047,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillie",
		"nl": "Wiley",
		"url": "https://findagrave.com/memorial/144227275",
		"id": 144227275,
		"lng": -77.385923,
		"lat": 37.53733135,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 11,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virginia",
		"nl": "Wiley",
		"url": "https://findagrave.com/memorial/142514789",
		"id": 142514789,
		"lng": -77.38576267,
		"lat": 37.53731681,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 9,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ada",
		"nl": "Wilkerson",
		"url": "https://findagrave.com/memorial/151113042",
		"id": 151113042,
		"lng": -77.38657983,
		"lat": 37.53547878,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 24,
		"by": 1872,
		"bd": 1,
		"bm": 1,
		"nm": "",
		"nf": "Elijah",
		"nl": "Wilkerson",
		"url": "https://findagrave.com/memorial/130378954",
		"id": 130378954,
		"lng": -77.38599447,
		"lat": 37.53652139,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Napoleon",
		"nl": "Wilkerson",
		"url": "https://findagrave.com/memorial/123696575",
		"id": 123696575,
		"lng": -77.38596123,
		"lat": 37.53650786,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 7,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Theodore",
		"nl": "Wilkerson",
		"url": "https://findagrave.com/memorial/137431016",
		"id": 137431016,
		"lng": -77.3859432,
		"lat": 37.53703154,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 7,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "William",
		"url": "https://findagrave.com/memorial/187075580",
		"id": 187075580,
		"lng": -77.38755252,
		"lat": 37.53687581,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 4,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Adeline",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/145085246",
		"id": 145085246,
		"lng": -77.38563359,
		"lat": 37.5369957,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 2,
		"by": 1904,
		"bd": 17,
		"bm": 8,
		"nm": "",
		"nf": "Alease",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/177897674",
		"id": 177897674,
		"lng": -77.38759559,
		"lat": 37.53729093,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 10,
		"dd": 22,
		"by": 1913,
		"bd": 15,
		"bm": 1,
		"nm": "",
		"nf": "Anita",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/161179880",
		"id": 161179880,
		"lng": -77.38600908,
		"lat": 37.53628587,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 2,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Ann",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/185357179",
		"id": 185357179,
		"lng": -77.3878403,
		"lat": 37.53628725,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Augustus",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/134474480",
		"id": 134474480,
		"lng": -77.38621846,
		"lat": 37.53702981,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Benjamin",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/175403069",
		"id": 175403069,
		"lng": -77.38759778,
		"lat": 37.53695983,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1992,
		"dm": "",
		"dd": "",
		"by": 1905,
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "Bernice",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/127569758",
		"id": 127569758,
		"lng": -77.38619611,
		"lat": 37.53703518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 4,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bertha",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/155539619",
		"id": 155539619,
		"lng": -77.38753753,
		"lat": 37.53766458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 7,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bertha",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/150677881",
		"id": 150677881,
		"lng": -77.38630839,
		"lat": 37.53572164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 9,
		"dd": 4,
		"by": 1891,
		"bd": 17,
		"bm": 7,
		"nm": "",
		"nf": "Callie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/167327393",
		"id": 167327393,
		"lng": -77.386848,
		"lat": 37.53729526,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1905,
		"dm": 2,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Caroline",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/132046793",
		"id": 132046793,
		"lng": -77.38777487,
		"lat": 37.53636897,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 23,
		"by": 1900,
		"bd": 27,
		"bm": 12,
		"nm": "",
		"nf": "Catherine",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/159876285",
		"id": 159876285,
		"lng": -77.38773993,
		"lat": 37.53752867,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 12,
		"dd": 22,
		"by": 1900,
		"bd": 14,
		"bm": 3,
		"nm": "",
		"nf": "Charles",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/138012354",
		"id": 138012354,
		"lng": -77.38667585,
		"lat": 37.53707952,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 4,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Thomas",
		"nf": "Charles",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/175328151",
		"id": 175328151,
		"lng": -77.38743012,
		"lat": 37.53711008,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 11,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clarence",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/128452679",
		"id": 128452679,
		"lng": -77.38563424,
		"lat": 37.53700347,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 8,
		"dd": 2,
		"by": 1901,
		"bd": 3,
		"bm": 6,
		"nm": "",
		"nf": "Cora",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/155539701",
		"id": 155539701,
		"lng": -77.3866361,
		"lat": 37.53754694,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 8,
		"dd": 19,
		"by": 1939,
		"bd": "",
		"bm": 7,
		"nm": "",
		"nf": "Delores",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/154202723",
		"id": 154202723,
		"lng": -77.38632579,
		"lat": 37.5352597,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 6,
		"dd": 17,
		"by": 1958,
		"bd": 13,
		"bm": 3,
		"nm": "Laverne",
		"nf": "Doris",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/184099616",
		"id": 184099616,
		"lng": -77.38713542,
		"lat": 37.53763436,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Earnest",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/146207125",
		"id": 146207125,
		"lng": -77.38659414,
		"lat": 37.53665934,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 4,
		"dd": 2,
		"by": 1898,
		"bd": 29,
		"bm": 12,
		"nm": "",
		"nf": "Edward",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/176477094",
		"id": 176477094,
		"lng": -77.38717875,
		"lat": 37.53700073,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 12,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/144227277",
		"id": 144227277,
		"lng": -77.3858434,
		"lat": 37.53744775,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 6,
		"dd": 24,
		"by": 1904,
		"bd": 15,
		"bm": 7,
		"nm": "D.",
		"nf": "Eliza",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/161052628",
		"id": 161052628,
		"lng": -77.38714696,
		"lat": 37.53710407,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 10,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Eliza",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/150792715",
		"id": 150792715,
		"lng": -77.38653805,
		"lat": 37.53551648,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 9,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/154304057",
		"id": 154304057,
		"lng": -77.38696214,
		"lat": 37.53542094,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 10,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fannie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/131428545",
		"id": 131428545,
		"lng": -77.38744968,
		"lat": 37.53659882,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 12,
		"dd": 19,
		"by": 1881,
		"bd": 14,
		"bm": 3,
		"nm": "",
		"nf": "Fannie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/114399883",
		"id": 114399883,
		"lng": -77.38581441,
		"lat": 37.53682894,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 9,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Florence",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/152210951",
		"id": 152210951,
		"lng": -77.3858141,
		"lat": 37.53693198,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 10,
		"by": 1930,
		"bd": 10,
		"bm": 9,
		"nm": "E.",
		"nf": "Florence",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/142531418",
		"id": 142531418,
		"lng": -77.3859367,
		"lat": 37.53737825,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1902,
		"dm": 3,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fountain",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/175103285",
		"id": 175103285,
		"lng": -77.38751233,
		"lat": 37.53643593,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 25,
		"by": 1919,
		"bd": 13,
		"bm": 1,
		"nm": "Carlton",
		"nf": "Frank",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/159877053",
		"id": 159877053,
		"lng": -77.38811867,
		"lat": 37.53747435,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 24,
		"by": 1905,
		"bd": 6,
		"bm": 3,
		"nm": "",
		"nf": "Gardenia",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/138012358",
		"id": 138012358,
		"lng": -77.38667297,
		"lat": 37.53708998,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 10,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Georgianna",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/188245085",
		"id": 188245085,
		"lng": -77.38789554,
		"lat": 37.53719137,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 12,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C.",
		"nf": "Gilford",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/175464601",
		"id": 175464601,
		"lng": -77.3875079,
		"lat": 37.53702976,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "U.",
		"nf": "Harrison",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/152298549",
		"id": 152298549,
		"lng": -77.38578754,
		"lat": 37.53695118,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 2,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/114399886",
		"id": 114399886,
		"lng": -77.38581175,
		"lat": 37.53683279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 12,
		"by": 1905,
		"bd": 30,
		"bm": 7,
		"nm": "",
		"nf": "Isabell",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/154516737",
		"id": 154516737,
		"lng": -77.38654898,
		"lat": 37.53701629,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isabelle",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/144227284",
		"id": 144227284,
		"lng": -77.38604905,
		"lat": 37.53728872,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 8,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/149353934",
		"id": 149353934,
		"lng": -77.38633614,
		"lat": 37.53709535,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 10,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jeff",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/173793426",
		"id": 173793426,
		"lng": -77.38725541,
		"lat": 37.53752678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 1,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/135741748",
		"id": 135741748,
		"lng": -77.38562884,
		"lat": 37.53696623,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 3,
		"dd": 12,
		"by": 1893,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jesse",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/127569768",
		"id": 127569768,
		"lng": -77.3857314,
		"lat": 37.53713276,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "John",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/186917627",
		"id": 186917627,
		"lng": -77.3874916,
		"lat": 37.53695518,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 21,
		"by": 1903,
		"bd": 26,
		"bm": 2,
		"nm": "T.",
		"nf": "John",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/173066363",
		"id": 173066363,
		"lng": -77.3870688,
		"lat": 37.53729522,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 12,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/148285811",
		"id": 148285811,
		"lng": -77.38645657,
		"lat": 37.53723138,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 4,
		"dd": 10,
		"by": 1884,
		"bd": 27,
		"bm": 10,
		"nm": "A.",
		"nf": "Junius",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/156286053",
		"id": 156286053,
		"lng": -77.38588671,
		"lat": 37.53710382,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 5,
		"by": 1888,
		"bd": 29,
		"bm": 2,
		"nm": "",
		"nf": "Katie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/138366563",
		"id": 138366563,
		"lng": -77.38633016,
		"lat": 37.53678094,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 5,
		"dd": 15,
		"by": 1864,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Kemp",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/150932506",
		"id": 150932506,
		"lng": -77.38676174,
		"lat": 37.53573762,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 10,
		"dd": 29,
		"by": 1927,
		"bd": 18,
		"bm": 2,
		"nm": "",
		"nf": "Lillian",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/144227352",
		"id": 144227352,
		"lng": -77.38644858,
		"lat": 37.53741481,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/162642628",
		"id": 162642628,
		"lng": -77.3866125,
		"lat": 37.53703292,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 3,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louis",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/155539723",
		"id": 155539723,
		"lng": -77.38630468,
		"lat": 37.5360906,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luberta",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/154228786",
		"id": 154228786,
		"lng": -77.38635753,
		"lat": 37.53739206,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 11,
		"dd": 18,
		"by": 1863,
		"bd": 10,
		"bm": 3,
		"nm": "B.",
		"nf": "Lucy",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/144383198",
		"id": 144383198,
		"lng": -77.38724259,
		"lat": 37.53777959,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 8,
		"dd": 15,
		"by": 1884,
		"bd": 1,
		"bm": 4,
		"nm": "Virginia",
		"nf": "Lula",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/142514805",
		"id": 142514805,
		"lng": -77.38573843,
		"lat": 37.53732566,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 8,
		"dd": 18,
		"by": 1914,
		"bd": 15,
		"bm": 6,
		"nm": "H.",
		"nf": "Mary",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/128452686",
		"id": 128452686,
		"lng": -77.38623327,
		"lat": 37.53681736,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 1,
		"dd": 28,
		"by": 1910,
		"bd": 25,
		"bm": 12,
		"nm": "Alice",
		"nf": "Maxie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/144227356",
		"id": 144227356,
		"lng": -77.38732164,
		"lat": 37.53783415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 2,
		"dd": 19,
		"by": 1884,
		"bd": 9,
		"bm": 7,
		"nm": "",
		"nf": "Mozelle",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/145838789",
		"id": 145838789,
		"lng": -77.38675822,
		"lat": 37.53577363,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nellie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/145167335",
		"id": 145167335,
		"lng": -77.38624474,
		"lat": 37.5371428,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Oliver",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/145838803",
		"id": 145838803,
		"lng": -77.38674639,
		"lat": 37.53578446,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 10,
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ottaway",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/158118883",
		"id": 158118883,
		"lng": -77.38785603,
		"lat": 37.53723873,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 6,
		"dd": 19,
		"by": 1889,
		"bd": 21,
		"bm": 11,
		"nm": "B.",
		"nf": "Pinkie",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/137431022",
		"id": 137431022,
		"lng": -77.3858892,
		"lat": 37.53709892,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 2,
		"dd": 28,
		"by": 1852,
		"bd": 3,
		"bm": 6,
		"nm": "",
		"nf": "Randolph",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/125644059",
		"id": 125644059,
		"lng": -77.38574838,
		"lat": 37.53666565,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 8,
		"dd": 15,
		"by": 1910,
		"bd": 25,
		"bm": 4,
		"nm": "E.",
		"nf": "Reginald",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/142514817",
		"id": 142514817,
		"lng": -77.38574972,
		"lat": 37.5373277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/159884839",
		"id": 159884839,
		"lng": -77.38655454,
		"lat": 37.5374483,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 28,
		"by": 1910,
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "Robert",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/171780427",
		"id": 171780427,
		"lng": -77.38696557,
		"lat": 37.53715648,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 12,
		"by": 1961,
		"bd": 8,
		"bm": 10,
		"nm": "Dexter",
		"nf": "Ronald",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/153865052",
		"id": 153865052,
		"lng": -77.38622369,
		"lat": 37.53744469,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 10,
		"dd": 10,
		"by": 1933,
		"bd": 7,
		"bm": 10,
		"nm": "",
		"nf": "Rosa",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/158960475",
		"id": 158960475,
		"lng": -77.38685839,
		"lat": 37.53736585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 5,
		"dd": 16,
		"by": 1909,
		"bd": 10,
		"bm": 9,
		"nm": "",
		"nf": "Ruth",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/123851397",
		"id": 123851397,
		"lng": -77.38602461,
		"lat": 37.53669143,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 30,
		"by": 1906,
		"bd": 29,
		"bm": 6,
		"nm": "",
		"nf": "Sarah",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/173793430",
		"id": 173793430,
		"lng": -77.38707691,
		"lat": 37.53722642,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Sonja",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/142106366",
		"id": 142106366,
		"lng": -77.3859505,
		"lat": 37.53743484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 4,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Susan",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/154259824",
		"id": 154259824,
		"lng": -77.38647226,
		"lat": 37.53551017,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": "",
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Thomas",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/185357198",
		"id": 185357198,
		"lng": -77.38782773,
		"lat": 37.53630164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 4,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Thomas",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/130737044",
		"id": 130737044,
		"lng": -77.38564246,
		"lat": 37.53695949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Virgil",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/127134221",
		"id": 127134221,
		"lng": -77.38659402,
		"lat": 37.5366699,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 1,
		"dd": 23,
		"by": 1892,
		"bd": "",
		"bm": 7,
		"nm": "",
		"nf": "James",
		"nl": "Williamson",
		"url": "https://findagrave.com/memorial/185151799",
		"id": 185151799,
		"lng": -77.38627387,
		"lat": 37.53661973,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 3,
		"dd": 15,
		"by": 1871,
		"bd": 25,
		"bm": 1,
		"nm": "S.",
		"nf": "Joseph",
		"nl": "Williamson",
		"url": "https://findagrave.com/memorial/141701467",
		"id": 141701467,
		"lng": -77.38640554,
		"lat": 37.5373188,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 1,
		"dd": 24,
		"by": 1910,
		"bd": 23,
		"bm": 10,
		"nm": "Harold",
		"nf": "John",
		"nl": "Willingham",
		"url": "https://findagrave.com/memorial/187368568",
		"id": 187368568,
		"lng": -77.38800659,
		"lat": 37.53746666,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 1,
		"dd": 16,
		"by": 1901,
		"bd": 25,
		"bm": 3,
		"nm": "",
		"nf": "Eugene",
		"nl": "Willis",
		"url": "https://findagrave.com/memorial/155769023",
		"id": 155769023,
		"lng": -77.38717811,
		"lat": 37.53553643,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 9,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hardinia",
		"nl": "Willis",
		"url": "https://findagrave.com/memorial/125859692",
		"id": 125859692,
		"lng": -77.38591467,
		"lat": 37.53619024,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 1,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Gibbs",
		"nf": "Julian",
		"nl": "Willis",
		"url": "https://findagrave.com/memorial/187571445",
		"id": 187571445,
		"lng": -77.3876484,
		"lat": 37.53689715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 10,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Willis",
		"url": "https://findagrave.com/memorial/152354853",
		"id": 152354853,
		"lng": -77.38626648,
		"lat": 37.5355515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 1,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pauline",
		"nl": "Willis",
		"url": "https://findagrave.com/memorial/174782793",
		"id": 174782793,
		"lng": -77.38739458,
		"lat": 37.53703125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 5,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Annie",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/162203680",
		"id": 162203680,
		"lng": -77.38775765,
		"lat": 37.53663888,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 23,
		"by": 1881,
		"bd": 21,
		"bm": 8,
		"nm": "",
		"nf": "Charles",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/176247568",
		"id": 176247568,
		"lng": -77.38774405,
		"lat": 37.53741709,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 2,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Columbia",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/173106674",
		"id": 173106674,
		"lng": -77.38773652,
		"lat": 37.53661365,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 7,
		"dd": 17,
		"by": 1968,
		"bd": 17,
		"bm": 7,
		"nm": "Yvette",
		"nf": "Jacqueline",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/142516304",
		"id": 142516304,
		"lng": -77.38591814,
		"lat": 37.53740488,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 6,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "James",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/173106536",
		"id": 173106536,
		"lng": -77.38773678,
		"lat": 37.53660662,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 11,
		"dd": 12,
		"by": 1898,
		"bd": 2,
		"bm": 12,
		"nm": "",
		"nf": "James",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/158960480",
		"id": 158960480,
		"lng": -77.38714043,
		"lat": 37.53738513,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 9,
		"dd": 29,
		"by": 1930,
		"bd": 16,
		"bm": 8,
		"nm": "W.",
		"nf": "John",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/114466982",
		"id": 114466982,
		"lng": -77.38652578,
		"lat": 37.5369515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 7,
		"dd": 12,
		"by": 1969,
		"bd": 1,
		"bm": 6,
		"nm": "Dion",
		"nf": "Johnathan",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/148648739",
		"id": 148648739,
		"lng": -77.38591063,
		"lat": 37.53742361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 1,
		"dd": 28,
		"by": 1950,
		"bd": 11,
		"bm": 7,
		"nm": "Ann",
		"nf": "Mary",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/153709044",
		"id": 153709044,
		"lng": -77.3862926,
		"lat": 37.53748807,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 12,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mollie",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/185246163",
		"id": 185246163,
		"lng": -77.38731436,
		"lat": 37.536273,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 12,
		"dd": 13,
		"by": 1906,
		"bd": 12,
		"bm": 7,
		"nm": "",
		"nf": "Mollie",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/182649705",
		"id": 182649705,
		"lng": -77.38676894,
		"lat": 37.53769644,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 7,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pinkie",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/185151817",
		"id": 185151817,
		"lng": -77.38777876,
		"lat": 37.53661329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 8,
		"dd": 1,
		"by": 1879,
		"bd": 12,
		"bm": 1,
		"nm": "",
		"nf": "Savannah",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/177750417",
		"id": 177750417,
		"lng": -77.38775752,
		"lat": 37.5374101,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "William",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/185151828",
		"id": 185151828,
		"lng": -77.38777559,
		"lat": 37.53662179,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 3,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Washington",
		"nf": "George",
		"nl": "Winchester",
		"url": "https://findagrave.com/memorial/162203456",
		"id": 162203456,
		"lng": -77.38780536,
		"lat": 37.53709617,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 6,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elijah",
		"nl": "Wingfield",
		"url": "https://findagrave.com/memorial/119391371",
		"id": 119391371,
		"lng": -77.38581537,
		"lat": 37.53666441,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 10,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eva",
		"nl": "Wingfield",
		"url": "https://findagrave.com/memorial/125408720",
		"id": 125408720,
		"lng": -77.38797546,
		"lat": 37.53700925,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1904,
		"dm": 6,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "John",
		"nl": "Wingfield",
		"url": "https://findagrave.com/memorial/127134266",
		"id": 127134266,
		"lng": -77.38641506,
		"lat": 37.53639715,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 8,
		"dd": 3,
		"by": 1879,
		"bd": "",
		"bm": 10,
		"nm": "W.",
		"nf": "Junius",
		"nl": "Wingfield",
		"url": "https://findagrave.com/memorial/158960487",
		"id": 158960487,
		"lng": -77.38660323,
		"lat": 37.53754046,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 10,
		"by": 1895,
		"bd": 15,
		"bm": 1,
		"nm": "B.",
		"nf": "Mary",
		"nl": "Wingfield",
		"url": "https://findagrave.com/memorial/119391378",
		"id": 119391378,
		"lng": -77.38581878,
		"lat": 37.53665728,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 6,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Robert",
		"nl": "Wingfield",
		"url": "https://findagrave.com/memorial/160934073",
		"id": 160934073,
		"lng": -77.38646735,
		"lat": 37.53639602,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 2,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Carolyn",
		"nl": "Winn",
		"url": "https://findagrave.com/memorial/149352234",
		"id": 149352234,
		"lng": -77.38644406,
		"lat": 37.53710622,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 11,
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Celista",
		"nl": "Winslow",
		"url": "https://findagrave.com/memorial/151448729",
		"id": 151448729,
		"lng": -77.3868061,
		"lat": 37.53542315,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 5,
		"dd": 4,
		"by": 1900,
		"bd": 27,
		"bm": 10,
		"nm": "Wesly",
		"nf": "Willie",
		"nl": "Winstead",
		"url": "https://findagrave.com/memorial/181882745",
		"id": 181882745,
		"lng": -77.3855406,
		"lat": 37.53729081,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 8,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "baby boy",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/125859697",
		"id": 125859697,
		"lng": -77.38599519,
		"lat": 37.53746592,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 7,
		"dd": 4,
		"by": 1887,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Charlie",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/159762374",
		"id": 159762374,
		"lng": -77.38765539,
		"lat": 37.53783743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 9,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Emma",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/117449125",
		"id": 117449125,
		"lng": -77.38578084,
		"lat": 37.53674594,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ernestine",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/144227410",
		"id": 144227410,
		"lng": -77.3859967,
		"lat": 37.53731408,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 12,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Julia",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/117449127",
		"id": 117449127,
		"lng": -77.38577685,
		"lat": 37.53675638,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 4,
		"dd": 8,
		"by": 1893,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Lillie",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/160433764",
		"id": 160433764,
		"lng": -77.38584906,
		"lat": 37.53686058,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 5,
		"dd": 18,
		"by": 1894,
		"bd": 2,
		"bm": 4,
		"nm": "",
		"nf": "Marie",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/130968039",
		"id": 130968039,
		"lng": -77.38569476,
		"lat": 37.5372109,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 8,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Louise",
		"nf": "Mary",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/159762381",
		"id": 159762381,
		"lng": -77.38765183,
		"lat": 37.53784618,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 10,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Michael",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/142531432",
		"id": 142531432,
		"lng": -77.38647579,
		"lat": 37.53531565,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/144383208",
		"id": 144383208,
		"lng": -77.38754703,
		"lat": 37.53729484,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 9,
		"dd": 9,
		"by": 1906,
		"bd": 6,
		"bm": 1,
		"nm": "E.",
		"nf": "Morrell",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/126772137",
		"id": 126772137,
		"lng": -77.38592385,
		"lat": 37.53637269,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 3,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nicholson",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/176983174",
		"id": 176983174,
		"lng": -77.38748722,
		"lat": 37.53567991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Patrick",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/185523371",
		"id": 185523371,
		"lng": -77.38663166,
		"lat": 37.53593066,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 2,
		"dd": 16,
		"by": 1881,
		"bd": 4,
		"bm": "",
		"nm": "J.",
		"nf": "Emma",
		"nl": "Wise",
		"url": "https://findagrave.com/memorial/137332656",
		"id": 137332656,
		"lng": -77.38596901,
		"lat": 37.53708515,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 7,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Fred",
		"nl": "Wise",
		"url": "https://findagrave.com/memorial/137431034",
		"id": 137431034,
		"lng": -77.38596563,
		"lat": 37.53709186,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 5,
		"dd": 29,
		"by": 1894,
		"bd": 20,
		"bm": 11,
		"nm": "",
		"nf": "Joanna",
		"nl": "Wise",
		"url": "https://findagrave.com/memorial/128675516",
		"id": 128675516,
		"lng": -77.38576268,
		"lat": 37.53718339,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 9,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Wise",
		"url": "https://findagrave.com/memorial/137332694",
		"id": 137332694,
		"lng": -77.38594249,
		"lat": 37.53706886,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 8,
		"dd": 20,
		"by": 1898,
		"bd": 4,
		"bm": 7,
		"nm": "",
		"nf": "Herbert",
		"nl": "Withers",
		"url": "https://findagrave.com/memorial/158960493",
		"id": 158960493,
		"lng": -77.38745996,
		"lat": 37.53756862,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 11,
		"dd": 24,
		"by": 1873,
		"bd": 3,
		"bm": 7,
		"nm": "",
		"nf": "Alexander",
		"nl": "Womack",
		"url": "https://findagrave.com/memorial/133668090",
		"id": 133668090,
		"lng": -77.38594722,
		"lat": 37.53615502,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 28,
		"by": 1887,
		"bd": 20,
		"bm": 8,
		"nm": "",
		"nf": "Florence",
		"nl": "Womack",
		"url": "https://findagrave.com/memorial/156480548",
		"id": 156480548,
		"lng": -77.38594956,
		"lat": 37.53614554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 4,
		"dd": 29,
		"by": 1880,
		"bd": 22,
		"bm": 9,
		"nm": "",
		"nf": "Lula",
		"nl": "Womble",
		"url": "https://findagrave.com/memorial/167182314",
		"id": 167182314,
		"lng": -77.38660118,
		"lat": 37.53685212,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 6,
		"dd": 14,
		"by": 1908,
		"bd": 16,
		"bm": 1,
		"nm": "R.",
		"nf": "Andrea",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/168819857",
		"id": 168819857,
		"lng": -77.38631855,
		"lat": 37.5369855,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 2,
		"dd": 8,
		"by": 1931,
		"bd": 2,
		"bm": 5,
		"nm": "Aristotle",
		"nf": "Andrea",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/130737051",
		"id": 130737051,
		"lng": -77.38634914,
		"lat": 37.53696316,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 10,
		"dd": 5,
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Charles",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/151423918",
		"id": 151423918,
		"lng": -77.38678139,
		"lat": 37.53542142,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 3,
		"dd": 23,
		"by": 1908,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Charles",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/175464172",
		"id": 175464172,
		"lng": -77.38749708,
		"lat": 37.53720279,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 6,
		"dd": 25,
		"by": 1874,
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Ellen",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/151448116",
		"id": 151448116,
		"lng": -77.38678398,
		"lat": 37.53542147,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 10,
		"dd": 8,
		"by": 1875,
		"bd": 5,
		"bm": 5,
		"nm": "Virginia",
		"nf": "Ida",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/38456109",
		"id": 38456109,
		"lng": -77.38570304,
		"lat": 37.53707267,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 7,
		"dd": 26,
		"by": 1871,
		"bd": "",
		"bm": "",
		"nm": "Peyton",
		"nf": "James",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/151491268",
		"id": 151491268,
		"lng": -77.38570503,
		"lat": 37.53706485,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1987,
		"dm": 1,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Ruth",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/38455711",
		"id": 38455711,
		"lng": -77.38572692,
		"lat": 37.53695216,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H",
		"nf": "William",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/170838967",
		"id": 170838967,
		"lng": -77.38650472,
		"lat": 37.53716901,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 27,
		"by": 1885,
		"bd": 7,
		"bm": 7,
		"nm": "L.",
		"nf": "Gertrude",
		"nl": "Wooden",
		"url": "https://findagrave.com/memorial/179854704",
		"id": 179854704,
		"lng": -77.38598787,
		"lat": 37.53733083,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 13,
		"by": 1904,
		"bd": 4,
		"bm": 1,
		"nm": "C.",
		"nf": "Joseph",
		"nl": "Wooden",
		"url": "https://findagrave.com/memorial/174622150",
		"id": 174622150,
		"lng": -77.38686613,
		"lat": 37.53710048,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 9,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lottie",
		"nl": "Woodley",
		"url": "https://findagrave.com/memorial/142516312",
		"id": 142516312,
		"lng": -77.38589467,
		"lat": 37.53728207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 6,
		"dd": 22,
		"by": 1893,
		"bd": 16,
		"bm": 7,
		"nm": "Lee",
		"nf": "Clarence",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/177119422",
		"id": 177119422,
		"lng": -77.38654627,
		"lat": 37.53573063,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 7,
		"dd": 3,
		"by": 1956,
		"bd": 26,
		"bm": 4,
		"nm": "Nathaniel",
		"nf": "Emmett",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/177545585",
		"id": 177545585,
		"lng": -77.38732156,
		"lat": 37.53792345,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 12,
		"dd": 12,
		"by": 1864,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Floyd",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/125094164",
		"id": 125094164,
		"lng": -77.38618225,
		"lat": 37.53684306,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 3,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Harriett",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/146020052",
		"id": 146020052,
		"lng": -77.38654769,
		"lat": 37.53573985,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 10,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henrietta",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/127134241",
		"id": 127134241,
		"lng": -77.38641682,
		"lat": 37.53639758,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 8,
		"dd": 11,
		"by": 1899,
		"bd": 7,
		"bm": 1,
		"nm": "Bell",
		"nf": "Ida",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/158335478",
		"id": 158335478,
		"lng": -77.38584541,
		"lat": 37.53739142,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 8,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/187586853",
		"id": 187586853,
		"lng": -77.38768786,
		"lat": 37.53701386,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 11,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Alfred",
		"nf": "James",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/144383226",
		"id": 144383226,
		"lng": -77.3866131,
		"lat": 37.53572767,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 12,
		"dd": 19,
		"by": 1889,
		"bd": "",
		"bm": 12,
		"nm": "T.",
		"nf": "James",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/158335483",
		"id": 158335483,
		"lng": -77.3858424,
		"lat": 37.53739519,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 12,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Lucy",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/156480554",
		"id": 156480554,
		"lng": -77.38655009,
		"lat": 37.53575036,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 10,
		"dd": 14,
		"by": 1866,
		"bd": 5,
		"bm": 6,
		"nm": "",
		"nf": "Mary",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/125094169",
		"id": 125094169,
		"lng": -77.38617863,
		"lat": 37.53684222,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 10,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Woodson",
		"url": "https://findagrave.com/memorial/177151547",
		"id": 177151547,
		"lng": -77.38798559,
		"lat": 37.53704278,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 6,
		"dd": 23,
		"by": 1926,
		"bd": 5,
		"bm": 6,
		"nm": "",
		"nf": "Isabelle",
		"nl": "Woody",
		"url": "https://findagrave.com/memorial/160851131",
		"id": 160851131,
		"lng": -77.38778871,
		"lat": 37.53772705,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 2,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Fannie",
		"nf": "Mary",
		"nl": "Woody",
		"url": "https://findagrave.com/memorial/144558774",
		"id": 144558774,
		"lng": -77.38749951,
		"lat": 37.53733614,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1980,
		"dm": 1,
		"dd": 22,
		"by": 1926,
		"bd": 8,
		"bm": 6,
		"nm": "Louis",
		"nf": "Robert",
		"nl": "Woody",
		"url": "https://findagrave.com/memorial/150637850",
		"id": 150637850,
		"lng": -77.38641889,
		"lat": 37.53595963,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 2,
		"dd": 12,
		"by": 1887,
		"bd": 10,
		"bm": 8,
		"nm": "Ann",
		"nf": "Alice",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/148519048",
		"id": 148519048,
		"lng": -77.3866992,
		"lat": 37.53540338,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 29,
		"by": 1894,
		"bd": 9,
		"bm": 1,
		"nm": "Richard",
		"nf": "Edgar",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/172031050",
		"id": 172031050,
		"lng": -77.38698161,
		"lat": 37.53726108,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 12,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ellie",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/134474489",
		"id": 134474489,
		"lng": -77.38621129,
		"lat": 37.53703827,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1984,
		"dm": 9,
		"dd": 11,
		"by": 1913,
		"bd": 18,
		"bm": 2,
		"nm": "A.",
		"nf": "John",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/127569773",
		"id": 127569773,
		"lng": -77.38622376,
		"lat": 37.53701809,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 2,
		"dd": 12,
		"by": 1908,
		"bd": 16,
		"bm": 10,
		"nm": "",
		"nf": "Silas",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/122027633",
		"id": 122027633,
		"lng": -77.38598652,
		"lat": 37.53672787,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 8,
		"dd": 24,
		"by": 1859,
		"bd": 7,
		"bm": 8,
		"nm": "",
		"nf": "Walter",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/130737057",
		"id": 130737057,
		"lng": -77.38564836,
		"lat": 37.53694446,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 6,
		"dd": 27,
		"by": 1885,
		"bd": "",
		"bm": "",
		"nm": "Thomas",
		"nf": "William",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/151172091",
		"id": 151172091,
		"lng": -77.38670155,
		"lat": 37.535415,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 9,
		"dd": 18,
		"by": 1881,
		"bd": 17,
		"bm": 8,
		"nm": "H.",
		"nf": "William",
		"nl": "Wooldridge",
		"url": "https://findagrave.com/memorial/134474499",
		"id": 134474499,
		"lng": -77.38621234,
		"lat": 37.53704965,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 8,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louisa",
		"nl": "Woolfolk",
		"url": "https://findagrave.com/memorial/151694129",
		"id": 151694129,
		"lng": -77.38681179,
		"lat": 37.53572768,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 2,
		"dd": 17,
		"by": 1923,
		"bd": 25,
		"bm": 1,
		"nm": "",
		"nf": "Claude",
		"nl": "Worsley",
		"url": "https://findagrave.com/memorial/161636479",
		"id": 161636479,
		"lng": -77.38611764,
		"lat": 37.53631193,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 2,
		"dd": 2,
		"by": 1960,
		"bd": 27,
		"bm": 12,
		"nm": "",
		"nf": "Darlene",
		"nl": "Worsley",
		"url": "https://findagrave.com/memorial/153627305",
		"id": 153627305,
		"lng": -77.38635094,
		"lat": 37.53759126,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 3,
		"dd": 28,
		"by": 1931,
		"bd": 1,
		"bm": 8,
		"nm": "C.",
		"nf": "Angie",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/158450812",
		"id": 158450812,
		"lng": -77.38667941,
		"lat": 37.53744414,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 2,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "F.",
		"nf": "Annie",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/76611325",
		"id": 76611325,
		"lng": -77.38625123,
		"lat": 37.53580621,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 6,
		"dd": 24,
		"by": "",
		"bd": 19,
		"bm": 12,
		"nm": "",
		"nf": "Ella Mae",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/160851652",
		"id": 160851652,
		"lng": -77.38676098,
		"lat": 37.53739348,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 4,
		"dd": 8,
		"by": 1917,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Grady",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/176713896",
		"id": 176713896,
		"lng": -77.38754218,
		"lat": 37.53721455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 28,
		"by": 1868,
		"bd": "",
		"bm": 5,
		"nm": "F.",
		"nf": "Jacob",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/76611334",
		"id": 76611334,
		"lng": -77.38624691,
		"lat": 37.53580944,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 5,
		"dd": 2,
		"by": 1916,
		"bd": "",
		"bm": "",
		"nm": "Mae",
		"nf": "Lily",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/127992141",
		"id": 127992141,
		"lng": -77.38594798,
		"lat": 37.53671565,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 6,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louis",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/120726166",
		"id": 120726166,
		"lng": -77.38566411,
		"lat": 37.53690576,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": 3,
		"dd": "",
		"by": 1848,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Mary",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/125859701",
		"id": 125859701,
		"lng": -77.38624666,
		"lat": 37.53580185,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 6,
		"dd": 7,
		"by": 1872,
		"bd": 4,
		"bm": 3,
		"nm": "L.",
		"nf": "Susan",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/125859702",
		"id": 125859702,
		"lng": -77.38624281,
		"lat": 37.53580573,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1977,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/166825737",
		"id": 166825737,
		"lng": -77.38800833,
		"lat": 37.53748794,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/185357204",
		"id": 185357204,
		"lng": -77.38723455,
		"lat": 37.5373585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 4,
		"dd": 22,
		"by": 1890,
		"bd": 13,
		"bm": 3,
		"nm": "James",
		"nf": "Benjamin",
		"nl": "Wyche",
		"url": "https://findagrave.com/memorial/191401045",
		"id": 191401045,
		"lng": -77.38600619,
		"lat": 37.53730557,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maria",
		"nl": "Yarborough",
		"url": "https://findagrave.com/memorial/142516326",
		"id": 142516326,
		"lng": -77.38559973,
		"lat": 37.53738098,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Jane",
		"nf": "Ellen",
		"nl": "Yates",
		"url": "https://findagrave.com/memorial/175820719",
		"id": 175820719,
		"lng": -77.38770357,
		"lat": 37.53714135,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 9,
		"dd": 29,
		"by": 1888,
		"bd": 3,
		"bm": 5,
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Yates",
		"url": "https://findagrave.com/memorial/184094555",
		"id": 184094555,
		"lng": -77.38707582,
		"lat": 37.53754046,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 1,
		"dd": 9,
		"by": 1892,
		"bd": 21,
		"bm": 8,
		"nm": "C.",
		"nf": "Owen",
		"nl": "Yates",
		"url": "https://findagrave.com/memorial/173511546",
		"id": 173511546,
		"lng": -77.38753423,
		"lat": 37.53708164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bessie",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/152042556",
		"id": 152042556,
		"lng": -77.38789149,
		"lat": 37.53736365,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 12,
		"dd": 10,
		"by": 1966,
		"bd": "",
		"bm": 11,
		"nm": "Renee",
		"nf": "Deborah",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/145596097",
		"id": 145596097,
		"lng": -77.38596897,
		"lat": 37.5374339,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 4,
		"dd": 22,
		"by": 1889,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Fannie",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/175465867",
		"id": 175465867,
		"lng": -77.38755981,
		"lat": 37.5370455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1929,
		"dm": 5,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Laura",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/177100548",
		"id": 177100548,
		"lng": -77.38791034,
		"lat": 37.53692819,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 13,
		"by": 1910,
		"bd": 26,
		"bm": 5,
		"nm": "H.",
		"nf": "Mary",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/173071274",
		"id": 173071274,
		"lng": -77.38703536,
		"lat": 37.53733143,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 4,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Vernell",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/144821970",
		"id": 144821970,
		"lng": -77.38692709,
		"lat": 37.5366417,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 7,
		"dd": 11,
		"by": 1884,
		"bd": "",
		"bm": 6,
		"nm": "H.",
		"nf": "William",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/182089290",
		"id": 182089290,
		"lng": -77.38668861,
		"lat": 37.53766436,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 11,
		"dd": 16,
		"by": 1909,
		"bd": 19,
		"bm": 1,
		"nm": "",
		"nf": "Major",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/145596114",
		"id": 145596114,
		"lng": -77.38634584,
		"lat": 37.53734907,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 9,
		"by": 1927,
		"bd": 2,
		"bm": 3,
		"nm": "Flora",
		"nf": "Bernice",
		"nl": "Jefferson",
		"url": "https://findagrave.com/memorial/193504531",
		"id": 193504531,
		"lng": -77.38712055,
		"lat": 37.53719803,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 24,
		"by": 1893,
		"bd": 20,
		"bm": 7,
		"nm": "Duqro",
		"nf": "Isaac",
		"nl": "Niles",
		"url": "https://findagrave.com/memorial/192995452",
		"id": 192995452,
		"lng": -77.38679766,
		"lat": 37.53748727,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Margaret",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/193802120",
		"id": 193802120,
		"lng": -77.38660572,
		"lat": 37.5376748,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 10,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Sadie",
		"nl": "Archer",
		"url": "https://findagrave.com/memorial/193802128",
		"id": 193802128,
		"lng": -77.38656558,
		"lat": 37.53765055,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 9,
		"dd": 11,
		"by": 1880,
		"bd": "",
		"bm": 3,
		"nm": "",
		"nf": "Zack",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/193802130",
		"id": 193802130,
		"lng": -77.38733502,
		"lat": 37.53713466,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 5,
		"dd": 19,
		"by": 1912,
		"bd": 1,
		"bm": 10,
		"nm": "Edward",
		"nf": "Leslie",
		"nl": "Atkinson",
		"url": "https://findagrave.com/memorial/193699204",
		"id": 193699204,
		"lng": -77.38726156,
		"lat": 37.53711084,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 9,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louis",
		"nl": "Beverly",
		"url": "https://findagrave.com/memorial/193699211",
		"id": 193699211,
		"lng": -77.38745446,
		"lat": 37.53696609,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 2,
		"dd": 21,
		"by": 1898,
		"bd": 13,
		"bm": 9,
		"nm": "",
		"nf": "Ernest",
		"nl": "Gordon",
		"url": "https://findagrave.com/memorial/193802139",
		"id": 193802139,
		"lng": -77.38728942,
		"lat": 37.53705701,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 10,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Willie",
		"nl": "Poindexter",
		"url": "https://findagrave.com/memorial/193699222",
		"id": 193699222,
		"lng": -77.38746824,
		"lat": 37.53698334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 6,
		"dd": 3,
		"by": 1893,
		"bd": 24,
		"bm": 10,
		"nm": "",
		"nf": "Edward",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/7810737",
		"id": 7810737,
		"lng": -77.38744107,
		"lat": 37.53697743,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 3,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bernard",
		"nl": "Wallace",
		"url": "https://findagrave.com/memorial/193802147",
		"id": 193802147,
		"lng": -77.38728362,
		"lat": 37.53702549,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 2,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "William",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/194265386",
		"id": 194265386,
		"lng": -77.38761185,
		"lat": 37.53720184,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 12,
		"dd": 6,
		"by": 1879,
		"bd": 10,
		"bm": 3,
		"nm": "M.",
		"nf": "Joseph",
		"nl": "Trice",
		"url": "https://findagrave.com/memorial/194334703",
		"id": 194334703,
		"lng": -77.38761928,
		"lat": 37.53706094,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 7,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/194265406",
		"id": 194265406,
		"lng": -77.38760308,
		"lat": 37.5372106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 12,
		"dd": 4,
		"by": 1927,
		"bd": 28,
		"bm": 1,
		"nm": "Edward",
		"nf": "William",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/161053061",
		"id": 161053061,
		"lng": -77.3871659,
		"lat": 37.53705998,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 8,
		"by": 1887,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Katie",
		"nl": "Chambers",
		"url": "https://findagrave.com/memorial/194393404",
		"id": 194393404,
		"lng": -77.38731474,
		"lat": 37.53699937,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 8,
		"dd": 30,
		"by": 1896,
		"bd": 21,
		"bm": 6,
		"nm": "",
		"nf": "Montague",
		"nl": "Clarke",
		"url": "https://findagrave.com/memorial/194393416",
		"id": 194393416,
		"lng": -77.3873673,
		"lat": 37.53698289,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Minnie",
		"nl": "Craig",
		"url": "https://findagrave.com/memorial/194393436",
		"id": 194393436,
		"lng": -77.38731885,
		"lat": 37.53695573,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 8,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/194393463",
		"id": 194393463,
		"lng": -77.3872959,
		"lat": 37.53691614,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 1,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Glover",
		"url": "https://findagrave.com/memorial/194393513",
		"id": 194393513,
		"lng": -77.38729952,
		"lat": 37.5369741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Annie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/194393522",
		"id": 194393522,
		"lng": -77.38731242,
		"lat": 37.53696796,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 9,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Louise Manson",
		"nf": "Mary",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/194334698",
		"id": 194334698,
		"lng": -77.38746063,
		"lat": 37.53705295,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 4,
		"dd": 13,
		"by": 1898,
		"bd": 18,
		"bm": 9,
		"nm": "P.",
		"nf": "Blanche",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/183872875",
		"id": 183872875,
		"lng": -77.38739303,
		"lat": 37.53699056,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 5,
		"dd": 8,
		"by": 1881,
		"bd": 16,
		"bm": 2,
		"nm": "",
		"nf": "Walter",
		"nl": "Wall",
		"url": "https://findagrave.com/memorial/194393630",
		"id": 194393630,
		"lng": -77.38731907,
		"lat": 37.53694799,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 9,
		"dd": 26,
		"by": 1905,
		"bd": 1,
		"bm": 5,
		"nm": "",
		"nf": "Ida",
		"nl": "Hatcher",
		"url": "https://findagrave.com/memorial/192791543",
		"id": 192791543,
		"lng": -77.38652338,
		"lat": 37.53741731,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 1,
		"dd": 5,
		"by": 1894,
		"bd": 2,
		"bm": 4,
		"nm": "",
		"nf": "Eddie",
		"nl": "Fisher",
		"url": "https://findagrave.com/memorial/192995022",
		"id": 192995022,
		"lng": -77.38671742,
		"lat": 37.53754756,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 10,
		"dd": 23,
		"by": 1858,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "George",
		"nl": "Herbert",
		"url": "https://findagrave.com/memorial/192991194",
		"id": 192991194,
		"lng": -77.38655573,
		"lat": 37.53752288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 16,
		"by": 1877,
		"bd": "",
		"bm": 11,
		"nm": "",
		"nf": "Betty",
		"nl": "Hunt",
		"url": "https://findagrave.com/memorial/193037827",
		"id": 193037827,
		"lng": -77.38677785,
		"lat": 37.53672352,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "John",
		"nl": "Fauntleroy",
		"url": "https://findagrave.com/memorial/193257610",
		"id": 193257610,
		"lng": -77.38599564,
		"lat": 37.53597199,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1912,
		"dm": 4,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennie",
		"nl": "Liggins",
		"url": "https://findagrave.com/memorial/193407090",
		"id": 193407090,
		"lng": -77.38670473,
		"lat": 37.53585317,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 9,
		"dd": 27,
		"by": 1876,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Annie",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/194987763",
		"id": 194987763,
		"lng": -77.38708365,
		"lat": 37.53698074,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 3,
		"dd": 30,
		"by": 1897,
		"bd": 10,
		"bm": 1,
		"nm": "",
		"nf": "Henry",
		"nl": "Fields",
		"url": "https://findagrave.com/memorial/194987768",
		"id": 194987768,
		"lng": -77.38712285,
		"lat": 37.53688247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 7,
		"dd": 19,
		"by": 1890,
		"bd": 21,
		"bm": 3,
		"nm": "H.",
		"nf": "Henry",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/194987774",
		"id": 194987774,
		"lng": -77.38707774,
		"lat": 37.53700277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 4,
		"dd": 10,
		"by": 1897,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Mack",
		"nl": "McCoy",
		"url": "https://findagrave.com/memorial/194987782",
		"id": 194987782,
		"lng": -77.38723768,
		"lat": 37.5369778,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 12,
		"dd": 24,
		"by": 1924,
		"bd": 7,
		"bm": 4,
		"nm": "Alice",
		"nf": "Mary",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/194987788",
		"id": 194987788,
		"lng": -77.38709703,
		"lat": 37.53693282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 7,
		"dd": 6,
		"by": 1891,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Moses",
		"nl": "Fauntleroy",
		"url": "https://findagrave.com/memorial/195244811",
		"id": 195244811,
		"lng": -77.38733969,
		"lat": 37.53555893,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1928,
		"dm": 5,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "May",
		"nf": "Alice",
		"nl": "Ford",
		"url": "https://findagrave.com/memorial/155989104",
		"id": 155989104,
		"lng": -77.38715633,
		"lat": 37.53548703,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 9,
		"dd": 29,
		"by": 1904,
		"bd": 30,
		"bm": 1,
		"nm": "",
		"nf": "Signolia",
		"nl": "Haley",
		"url": "https://findagrave.com/memorial/191781162",
		"id": 191781162,
		"lng": -77.38709337,
		"lat": 37.5358179,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 9,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/195188506",
		"id": 195188506,
		"lng": -77.38691018,
		"lat": 37.53566534,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 5,
		"dd": 10,
		"by": 1861,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Johnson",
		"nl": "Lancaster",
		"url": "https://findagrave.com/memorial/195188582",
		"id": 195188582,
		"lng": -77.38692186,
		"lat": 37.53566409,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 5,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Squire",
		"nl": "Lee",
		"url": "https://findagrave.com/memorial/195092364",
		"id": 195092364,
		"lng": -77.38716101,
		"lat": 37.53567562,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 7,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Merritt",
		"url": "https://findagrave.com/memorial/195188596",
		"id": 195188596,
		"lng": -77.38697652,
		"lat": 37.53566747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 3,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nathan",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/195188602",
		"id": 195188602,
		"lng": -77.38690091,
		"lat": 37.53587916,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 1,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bettie",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/194338409",
		"id": 194338409,
		"lng": -77.38740972,
		"lat": 37.53565571,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 7,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "John",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/195188608",
		"id": 195188608,
		"lng": -77.38697337,
		"lat": 37.53569171,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Robert",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/195107884",
		"id": 195107884,
		"lng": -77.38715087,
		"lat": 37.5355741,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 12,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "V.",
		"nf": "Queen",
		"nl": "White",
		"url": "https://findagrave.com/memorial/195188661",
		"id": 195188661,
		"lng": -77.38691458,
		"lat": 37.53596006,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 9,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ida",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/195188668",
		"id": 195188668,
		"lng": -77.3872314,
		"lat": 37.53564917,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 1,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "William",
		"nl": "Young",
		"url": "https://findagrave.com/memorial/99305969",
		"id": 99305969,
		"lng": -77.38763828,
		"lat": 37.53747544,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 5,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emma",
		"nl": "Faulk",
		"url": "https://findagrave.com/memorial/150882708",
		"id": 150882708,
		"lng": -77.38623518,
		"lat": 37.53584172,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 6,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Israel",
		"nl": "Mickins",
		"url": "https://findagrave.com/memorial/195459849",
		"id": 195459849,
		"lng": -77.38749322,
		"lat": 37.53760625,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Lula",
		"nl": "Eaddy",
		"url": "https://findagrave.com/memorial/195538675",
		"id": 195538675,
		"lng": -77.38659357,
		"lat": 37.53713335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 21,
		"by": 1889,
		"bd": 26,
		"bm": 11,
		"nm": "G.",
		"nf": "Louise",
		"nl": "Davis",
		"url": "https://findagrave.com/memorial/195656322",
		"id": 195656322,
		"lng": -77.38681614,
		"lat": 37.53692455,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 2,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "John",
		"nl": "Dunn",
		"url": "https://findagrave.com/memorial/195575102",
		"id": 195575102,
		"lng": -77.38683762,
		"lat": 37.53669531,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 7,
		"dd": 2,
		"by": 1893,
		"bd": 28,
		"bm": 7,
		"nm": "Estelle",
		"nf": "Beatrice",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/195656326",
		"id": 195656326,
		"lng": -77.3868179,
		"lat": 37.53691161,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 3,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Rainey",
		"url": "https://findagrave.com/memorial/195656330",
		"id": 195656330,
		"lng": -77.38680332,
		"lat": 37.53671265,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 2,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "William",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/195995269",
		"id": 195995269,
		"lng": -77.38700359,
		"lat": 37.53572812,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Louvenia",
		"nl": "Francis",
		"url": "https://findagrave.com/memorial/195995406",
		"id": 195995406,
		"lng": -77.38641514,
		"lat": 37.53707435,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 13,
		"by": 1890,
		"bd": 22,
		"bm": 10,
		"nm": "Green",
		"nf": "William",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/182319646",
		"id": 182319646,
		"lng": -77.38672572,
		"lat": 37.53764459,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 6,
		"dd": 22,
		"by": 1916,
		"bd": 20,
		"bm": 3,
		"nm": "",
		"nf": "Pauline",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/185929366",
		"id": 185929366,
		"lng": -77.38712528,
		"lat": 37.5371578,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 5,
		"by": 1891,
		"bd": 19,
		"bm": 12,
		"nm": "",
		"nf": "Joseph",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/195841624",
		"id": 195841624,
		"lng": -77.38745383,
		"lat": 37.53735011,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 11,
		"dd": 5,
		"by": 1918,
		"bd": 13,
		"bm": 1,
		"nm": "",
		"nf": "William",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/195841635",
		"id": 195841635,
		"lng": -77.38759535,
		"lat": 37.53745488,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 26,
		"by": 1906,
		"bd": 6,
		"bm": 7,
		"nm": "Leroy",
		"nf": "Ernest",
		"nl": "Pollard",
		"url": "https://findagrave.com/memorial/195841638",
		"id": 195841638,
		"lng": -77.38714694,
		"lat": 37.5372343,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 12,
		"dd": 11,
		"by": 1882,
		"bd": 25,
		"bm": 2,
		"nm": "S.",
		"nf": "Sarah",
		"nl": "Trent",
		"url": "https://findagrave.com/memorial/195841641",
		"id": 195841641,
		"lng": -77.38721477,
		"lat": 37.53723895,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 5,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Mary",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/195728289",
		"id": 195728289,
		"lng": -77.38699821,
		"lat": 37.53570963,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eddie",
		"nl": "Finch",
		"url": "https://findagrave.com/memorial/196266085",
		"id": 196266085,
		"lng": -77.38687971,
		"lat": 37.53678051,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sallie",
		"nl": "White",
		"url": "https://findagrave.com/memorial/196266138",
		"id": 196266138,
		"lng": -77.38687866,
		"lat": 37.53680052,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 6,
		"dd": 20,
		"by": 1879,
		"bd": "",
		"bm": 4,
		"nm": "H.",
		"nf": "Percy",
		"nl": "Nichols",
		"url": "https://findagrave.com/memorial/196499829",
		"id": 196499829,
		"lng": -77.38702327,
		"lat": 37.53672572,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 3,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bessie",
		"nl": "Anderson",
		"url": "https://findagrave.com/memorial/196433322",
		"id": 196433322,
		"lng": -77.38759133,
		"lat": 37.53785355,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 7,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Daisy",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/196433334",
		"id": 196433334,
		"lng": -77.38721256,
		"lat": 37.53773071,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 5,
		"dd": 14,
		"by": 1902,
		"bd": 27,
		"bm": 1,
		"nm": "W.",
		"nf": "Thomas",
		"nl": "China",
		"url": "https://findagrave.com/memorial/196372788",
		"id": 196372788,
		"lng": -77.38757625,
		"lat": 37.53790928,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 4,
		"dd": 7,
		"by": 1894,
		"bd": 9,
		"bm": 1,
		"nm": "",
		"nf": "Henrietta",
		"nl": "Fisher",
		"url": "https://findagrave.com/memorial/196377821",
		"id": 196377821,
		"lng": -77.38749055,
		"lat": 37.53787684,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 31,
		"by": 1910,
		"bd": 17,
		"bm": 5,
		"nm": "",
		"nf": "Williett",
		"nl": "Flack",
		"url": "https://findagrave.com/memorial/196374302",
		"id": 196374302,
		"lng": -77.38749317,
		"lat": 37.53790486,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 12,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Junius",
		"nl": "Meredith",
		"url": "https://findagrave.com/memorial/196499820",
		"id": 196499820,
		"lng": -77.38777136,
		"lat": 37.53791134,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 15,
		"by": 1957,
		"bd": 11,
		"bm": 7,
		"nm": "Anthony",
		"nf": "Michael",
		"nl": "Murphy",
		"url": "https://findagrave.com/memorial/196374132",
		"id": 196374132,
		"lng": -77.38755913,
		"lat": 37.53791918,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 9,
		"dd": 4,
		"by": 1957,
		"bd": 4,
		"bm": 9,
		"nm": "",
		"nf": "Leroy",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/196433348",
		"id": 196433348,
		"lng": -77.38751636,
		"lat": 37.53795162,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 12,
		"dd": 25,
		"by": 1890,
		"bd": 2,
		"bm": 10,
		"nm": "Major",
		"nf": "Samuel",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/196373791",
		"id": 196373791,
		"lng": -77.38761943,
		"lat": 37.53796731,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 3,
		"dd": 3,
		"by": 1912,
		"bd": 8,
		"bm": 10,
		"nm": "P.",
		"nf": "Naomi",
		"nl": "Rustin",
		"url": "https://findagrave.com/memorial/196373301",
		"id": 196373301,
		"lng": -77.38749353,
		"lat": 37.53792915,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": 2,
		"nm": "",
		"nf": "Floyd",
		"nl": "Simms",
		"url": "https://findagrave.com/memorial/196433358",
		"id": 196433358,
		"lng": -77.38706399,
		"lat": 37.53775266,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 1,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "China",
		"nf": "Pearl",
		"nl": "Staves",
		"url": "https://findagrave.com/memorial/190638021",
		"id": 190638021,
		"lng": -77.38752732,
		"lat": 37.53791335,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 8,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Freddie",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/196433377",
		"id": 196433377,
		"lng": -77.38759611,
		"lat": 37.5378427,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 8,
		"dd": 14,
		"by": 1910,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "John",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/196433388",
		"id": 196433388,
		"lng": -77.38763473,
		"lat": 37.53784624,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 1,
		"dd": 17,
		"by": 1905,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Lottie",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/196622215",
		"id": 196622215,
		"lng": -77.38700818,
		"lat": 37.53685848,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 6,
		"dd": 7,
		"by": 1862,
		"bd": 4,
		"bm": 3,
		"nm": "",
		"nf": "Harriet",
		"nl": "Minnis",
		"url": "https://findagrave.com/memorial/196499824",
		"id": 196499824,
		"lng": -77.38696465,
		"lat": 37.53685244,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Angie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/196499832",
		"id": 196499832,
		"lng": -77.38756714,
		"lat": 37.53767237,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 2,
		"dd": 5,
		"by": 1925,
		"bd": 13,
		"bm": 1,
		"nm": "A.",
		"nf": "Philip",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/196499836",
		"id": 196499836,
		"lng": -77.38696072,
		"lat": 37.53681033,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/196561423",
		"id": 196561423,
		"lng": -77.38778559,
		"lat": 37.53781037,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 1,
		"dd": 8,
		"by": 1900,
		"bd": 26,
		"bm": 12,
		"nm": "A.",
		"nf": "Pearl",
		"nl": "Kelley",
		"url": "https://findagrave.com/memorial/196622218",
		"id": 196622218,
		"lng": -77.38746828,
		"lat": 37.53777771,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 9,
		"dd": 22,
		"by": 1918,
		"bd": 24,
		"bm": 3,
		"nm": "",
		"nf": "Lillian",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/196622232",
		"id": 196622232,
		"lng": -77.38754066,
		"lat": 37.5377828,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 3,
		"dd": 29,
		"by": 1891,
		"bd": 1,
		"bm": 10,
		"nm": "",
		"nf": "Mary",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/196561488",
		"id": 196561488,
		"lng": -77.38777468,
		"lat": 37.53776546,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 12,
		"dd": 23,
		"by": 1932,
		"bd": 28,
		"bm": 3,
		"nm": "Mae",
		"nf": "Audrey",
		"nl": "Alston",
		"url": "https://findagrave.com/memorial/196770374",
		"id": 196770374,
		"lng": -77.3878454,
		"lat": 37.53776718,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 10,
		"dd": 15,
		"by": 1907,
		"bd": 11,
		"bm": 11,
		"nm": "",
		"nf": "Evelyn",
		"nl": "Christian Wooldridge",
		"url": "https://findagrave.com/memorial/196770478",
		"id": 196770478,
		"lng": -77.38551282,
		"lat": 37.53727447,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 3,
		"dd": 19,
		"by": 1934,
		"bd": 10,
		"bm": 6,
		"nm": "Morton",
		"nf": "John",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/196770497",
		"id": 196770497,
		"lng": -77.38550227,
		"lat": 37.53727078,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 1,
		"dd": 5,
		"by": 1896,
		"bd": 21,
		"bm": 4,
		"nm": "E.",
		"nf": "Clarence",
		"nl": "Franklin",
		"url": "https://findagrave.com/memorial/197014967",
		"id": 197014967,
		"lng": -77.3865722,
		"lat": 37.53593264,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 10,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Jenkins",
		"url": "https://findagrave.com/memorial/196770503",
		"id": 196770503,
		"lng": -77.38799182,
		"lat": 37.5377851,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Carol",
		"nf": "Frank",
		"nl": "Lovings",
		"url": "https://findagrave.com/memorial/196050183",
		"id": 196050183,
		"lng": -77.38617994,
		"lat": 37.53599903,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 26,
		"by": 1890,
		"bd": 8,
		"bm": 9,
		"nm": "",
		"nf": "Ella",
		"nl": "Nash",
		"url": "https://findagrave.com/memorial/187768534",
		"id": 187768534,
		"lng": -77.38774891,
		"lat": 37.53795529,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 11,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rosa",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/196965309",
		"id": 196965309,
		"lng": -77.38667171,
		"lat": 37.53585656,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1903,
		"dm": 10,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isabella",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/196050646",
		"id": 196050646,
		"lng": -77.38620046,
		"lat": 37.53599826,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 10,
		"dd": 23,
		"by": 1900,
		"bd": "",
		"bm": 12,
		"nm": "H.",
		"nf": "Marion",
		"nl": "Small",
		"url": "https://findagrave.com/memorial/196928281",
		"id": 196928281,
		"lng": -77.38773754,
		"lat": 37.5377865,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 11,
		"dd": 6,
		"by": 1880,
		"bd": 12,
		"bm": 6,
		"nm": "",
		"nf": "John",
		"nl": "Stevenson",
		"url": "https://findagrave.com/memorial/196770518",
		"id": 196770518,
		"lng": -77.38704187,
		"lat": 37.53750648,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 6,
		"dd": 11,
		"by": 1939,
		"bd": 18,
		"bm": 6,
		"nm": "Henry",
		"nf": "Cleveland",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/196770524",
		"id": 196770524,
		"lng": -77.38748128,
		"lat": 37.53786512,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 6,
		"dd": 23,
		"by": 1890,
		"bd": 23,
		"bm": 5,
		"nm": "",
		"nf": "Rosa",
		"nl": "Thornton",
		"url": "https://findagrave.com/memorial/196770531",
		"id": 196770531,
		"lng": -77.38740581,
		"lat": 37.53772438,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 5,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Junius",
		"nl": "Townsend",
		"url": "https://findagrave.com/memorial/196770538",
		"id": 196770538,
		"lng": -77.38816924,
		"lat": 37.53788309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 2,
		"dd": 12,
		"by": 1919,
		"bd": 1,
		"bm": 12,
		"nm": "",
		"nf": "Clarence",
		"nl": "Walker",
		"url": "https://findagrave.com/memorial/196928290",
		"id": 196928290,
		"lng": -77.38785038,
		"lat": 37.53779449,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 8,
		"dd": 15,
		"by": 1885,
		"bd": 5,
		"bm": 9,
		"nm": "",
		"nf": "Austin",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/197199939",
		"id": 197199939,
		"lng": -77.38747493,
		"lat": 37.53678247,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 3,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Anna",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/197199943",
		"id": 197199943,
		"lng": -77.38761,
		"lat": 37.53672387,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 5,
		"dd": 30,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Beverly",
		"nl": "Wright",
		"url": "https://findagrave.com/memorial/197199948",
		"id": 197199948,
		"lng": -77.38753289,
		"lat": 37.53681698,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 10,
		"by": 1894,
		"bd": 2,
		"bm": 3,
		"nm": "",
		"nf": "Daniel",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/197320074",
		"id": 197320074,
		"lng": -77.3878385,
		"lat": 37.53780129,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 3,
		"dd": 24,
		"by": 1915,
		"bd": 22,
		"bm": 10,
		"nm": "",
		"nf": "Hunter",
		"nl": "Hewlett",
		"url": "https://findagrave.com/memorial/197320082",
		"id": 197320082,
		"lng": -77.38795229,
		"lat": 37.53786174,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 5,
		"dd": 16,
		"by": 1880,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/197320379",
		"id": 197320379,
		"lng": -77.3877584,
		"lat": 37.53722914,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 12,
		"dd": 16,
		"by": 1906,
		"bd": "",
		"bm": 11,
		"nm": "",
		"nf": "Elijah",
		"nl": "McClain",
		"url": "https://findagrave.com/memorial/197320390",
		"id": 197320390,
		"lng": -77.38777549,
		"lat": 37.53755063,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 7,
		"dd": 25,
		"by": 1886,
		"bd": 4,
		"bm": 6,
		"nm": "R.",
		"nf": "Israel",
		"nl": "Ross",
		"url": "https://findagrave.com/memorial/197320063",
		"id": 197320063,
		"lng": -77.38774821,
		"lat": 37.53743464,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 3,
		"dd": 23,
		"by": 1910,
		"bd": 13,
		"bm": 8,
		"nm": "Mae",
		"nf": "Edith",
		"nl": "Rowlett",
		"url": "https://findagrave.com/memorial/197320400",
		"id": 197320400,
		"lng": -77.38790254,
		"lat": 37.53787576,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 6,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Moses",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/197320422",
		"id": 197320422,
		"lng": -77.38788572,
		"lat": 37.53783271,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 9,
		"dd": 17,
		"by": 1911,
		"bd": 15,
		"bm": 9,
		"nm": "",
		"nf": "Ida",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/197320682",
		"id": 197320682,
		"lng": -77.38764466,
		"lat": 37.53731128,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 3,
		"dd": 26,
		"by": 1867,
		"bd": 1,
		"bm": 1,
		"nm": "E.",
		"nf": "William",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/197320685",
		"id": 197320685,
		"lng": -77.38791372,
		"lat": 37.5378678,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 7,
		"dd": 9,
		"by": 1904,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "James",
		"nl": "Thompson",
		"url": "https://findagrave.com/memorial/197320697",
		"id": 197320697,
		"lng": -77.38794217,
		"lat": 37.53785872,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 7,
		"dd": 7,
		"by": 1876,
		"bd": "",
		"bm": 8,
		"nm": "",
		"nf": "Ardelia",
		"nl": "Washington",
		"url": "https://findagrave.com/memorial/197320705",
		"id": 197320705,
		"lng": -77.38735915,
		"lat": 37.53778519,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1926,
		"dm": 11,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Robert",
		"nl": "Cross",
		"url": "https://findagrave.com/memorial/197320068",
		"id": 197320068,
		"lng": -77.38783735,
		"lat": 37.53706833,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 9,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Luke",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/197320406",
		"id": 197320406,
		"lng": -77.3878954,
		"lat": 37.5372027,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1925,
		"dm": 4,
		"dd": 6,
		"by": 1882,
		"bd": "",
		"bm": 1,
		"nm": "",
		"nf": "Lucy",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/197320716",
		"id": 197320716,
		"lng": -77.38792706,
		"lat": 37.53700478,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isaac",
		"nl": "Berry",
		"url": "https://findagrave.com/memorial/197499473",
		"id": 197499473,
		"lng": -77.38683977,
		"lat": 37.53749333,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 1,
		"dd": 16,
		"by": 1886,
		"bd": 27,
		"bm": 11,
		"nm": "T.",
		"nf": "James",
		"nl": "Birchett",
		"url": "https://findagrave.com/memorial/197499478",
		"id": 197499478,
		"lng": -77.38795721,
		"lat": 37.53782526,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 5,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Virginia",
		"nl": "Breedlove",
		"url": "https://findagrave.com/memorial/197499482",
		"id": 197499482,
		"lng": -77.38805941,
		"lat": 37.53776318,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 6,
		"dd": 4,
		"by": 1875,
		"bd": 5,
		"bm": 7,
		"nm": "",
		"nf": "Rosa",
		"nl": "Christian",
		"url": "https://findagrave.com/memorial/197483316",
		"id": 197483316,
		"lng": -77.38791606,
		"lat": 37.53789649,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 3,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Quarles",
		"nf": "Louise",
		"nl": "Dance",
		"url": "https://findagrave.com/memorial/197499488",
		"id": 197499488,
		"lng": -77.3878833,
		"lat": 37.53788142,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1942,
		"dm": 2,
		"dd": 27,
		"by": 1920,
		"bd": 6,
		"bm": 5,
		"nm": "",
		"nf": "Elnora",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/197499493",
		"id": 197499493,
		"lng": -77.38788082,
		"lat": 37.53788821,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 7,
		"dd": 22,
		"by": 1893,
		"bd": 20,
		"bm": 2,
		"nm": "",
		"nf": "Daniel",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/197499499",
		"id": 197499499,
		"lng": -77.3877828,
		"lat": 37.53766337,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 7,
		"dd": 20,
		"by": 1888,
		"bd": 19,
		"bm": 8,
		"nm": "B.",
		"nf": "Pearl",
		"nl": "Mayo",
		"url": "https://findagrave.com/memorial/197499502",
		"id": 197499502,
		"lng": -77.38775705,
		"lat": 37.53766182,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 28,
		"by": 1932,
		"bd": 23,
		"bm": 4,
		"nm": "Mae",
		"nf": "Esther",
		"nl": "Scott",
		"url": "https://findagrave.com/memorial/197499514",
		"id": 197499514,
		"lng": -77.38775268,
		"lat": 37.53786467,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 10,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucretia",
		"nl": "Garrison",
		"url": "https://findagrave.com/memorial/169431610",
		"id": 169431610,
		"lng": -77.38771825,
		"lat": 37.53695564,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 3,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pauline",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/190857203",
		"id": 190857203,
		"lng": -77.38800477,
		"lat": 37.5370431,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 3,
		"dd": 27,
		"by": 1909,
		"bd": 14,
		"bm": 11,
		"nm": "",
		"nf": "Madeline",
		"nl": "Williams",
		"url": "https://findagrave.com/memorial/197602152",
		"id": 197602152,
		"lng": -77.3878385,
		"lat": 37.53700165,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 3,
		"dd": 11,
		"by": 1876,
		"bd": "",
		"bm": 10,
		"nm": "",
		"nf": "Amelia",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/197708636",
		"id": 197708636,
		"lng": -77.38793757,
		"lat": 37.53721967,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Adeline",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/197602135",
		"id": 197602135,
		"lng": -77.38673776,
		"lat": 37.53603693,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Edward",
		"nf": "Thomas",
		"nl": "Cheatham",
		"url": "https://findagrave.com/memorial/193030492",
		"id": 193030492,
		"lng": -77.3868849,
		"lat": 37.53746172,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 11,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Rena",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/197708619",
		"id": 197708619,
		"lng": -77.38756356,
		"lat": 37.53699132,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 1,
		"dd": 27,
		"by": 1918,
		"bd": 27,
		"bm": 4,
		"nm": "R.",
		"nf": "Louis",
		"nl": "Clark",
		"url": "https://findagrave.com/memorial/197708628",
		"id": 197708628,
		"lng": -77.38756822,
		"lat": 37.53696949,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 12,
		"dd": 14,
		"by": "",
		"bd": 6,
		"bm": 1,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Bowler",
		"url": "https://findagrave.com/memorial/187098753",
		"id": 187098753,
		"lng": -77.38713077,
		"lat": 37.53628666,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 4,
		"dd": 6,
		"by": 1933,
		"bd": 30,
		"bm": 9,
		"nm": "M.",
		"nf": "Royal",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/186733007",
		"id": 186733007,
		"lng": -77.38606793,
		"lat": 37.53627783,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charity",
		"nl": "Archer",
		"url": "https://findagrave.com/memorial/197767026",
		"id": 197767026,
		"lng": -77.38772452,
		"lat": 37.53779768,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 7,
		"dd": 8,
		"by": 1891,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Paul",
		"nl": "Butts",
		"url": "https://findagrave.com/memorial/197765999",
		"id": 197765999,
		"lng": -77.38770791,
		"lat": 37.53774623,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 9,
		"by": 1889,
		"bd": "",
		"bm": "",
		"nm": "W",
		"nf": "John",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/197761685",
		"id": 197761685,
		"lng": -77.38675128,
		"lat": 37.53765164,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 11,
		"dd": 30,
		"by": 1897,
		"bd": 20,
		"bm": 1,
		"nm": "Mary",
		"nf": "Estelle",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/197783592",
		"id": 197783592,
		"lng": -77.38674948,
		"lat": 37.53773102,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1911,
		"dm": 5,
		"dd": 20,
		"by": 1869,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emma",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/197770462",
		"id": 197770462,
		"lng": -77.38684517,
		"lat": 37.53604781,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 3,
		"dd": 2,
		"by": 1937,
		"bd": "",
		"bm": "",
		"nm": "Yvonne",
		"nf": "Celeste",
		"nl": "Dennis",
		"url": "https://findagrave.com/memorial/197879210",
		"id": 197879210,
		"lng": -77.38738662,
		"lat": 37.53689932,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 6,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Delia",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/177223800",
		"id": 177223800,
		"lng": -77.38742582,
		"lat": 37.53687422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 28,
		"by": 1905,
		"bd": 6,
		"bm": 12,
		"nm": "",
		"nf": "Ruth",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/198109392",
		"id": 198109392,
		"lng": -77.38716202,
		"lat": 37.53729369,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 5,
		"dd": 29,
		"by": 1923,
		"bd": 19,
		"bm": 11,
		"nm": "",
		"nf": "Pernett",
		"nl": "Anthony",
		"url": "https://findagrave.com/memorial/197965214",
		"id": 197965214,
		"lng": -77.38730901,
		"lat": 37.53735894,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 3,
		"by": 1902,
		"bd": 30,
		"bm": 8,
		"nm": "Maryland",
		"nf": "James",
		"nl": "Bradshaw",
		"url": "https://findagrave.com/memorial/197962198",
		"id": 197962198,
		"lng": -77.38718203,
		"lat": 37.53732034,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 8,
		"by": 1912,
		"bd": 28,
		"bm": 7,
		"nm": "Mathew",
		"nf": "Parker",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/177286849",
		"id": 177286849,
		"lng": -77.38729047,
		"lat": 37.5372404,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "John",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/198067476",
		"id": 198067476,
		"lng": -77.38795265,
		"lat": 37.53783906,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 14,
		"by": 1929,
		"bd": 27,
		"bm": 2,
		"nm": "Elmore",
		"nf": "Walter",
		"nl": "Hinton",
		"url": "https://findagrave.com/memorial/192391148",
		"id": 192391148,
		"lng": -77.38738165,
		"lat": 37.53727259,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 21,
		"by": 1915,
		"bd": 3,
		"bm": 11,
		"nm": "",
		"nf": "Maxton",
		"nl": "Hooker",
		"url": "https://findagrave.com/memorial/198017038",
		"id": 198017038,
		"lng": -77.38739384,
		"lat": 37.53733291,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 6,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Florence",
		"nl": "Mickens",
		"url": "https://findagrave.com/memorial/198109395",
		"id": 198109395,
		"lng": -77.38733597,
		"lat": 37.53738671,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 1,
		"dd": 24,
		"by": 1903,
		"bd": 7,
		"bm": 9,
		"nm": "",
		"nf": "Nellie",
		"nl": "Pegeas",
		"url": "https://findagrave.com/memorial/198016709",
		"id": 198016709,
		"lng": -77.38721741,
		"lat": 37.53725786,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 9,
		"dd": 10,
		"by": 1897,
		"bd": 21,
		"bm": 3,
		"nm": "",
		"nf": "Charlie",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/197932492",
		"id": 197932492,
		"lng": -77.38735316,
		"lat": 37.53686528,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 20,
		"by": 1931,
		"bd": 17,
		"bm": 2,
		"nm": "",
		"nf": "Josephine",
		"nl": "Tucker",
		"url": "https://findagrave.com/memorial/197962851",
		"id": 197962851,
		"lng": -77.38734673,
		"lat": 37.53721153,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 22,
		"by": 1905,
		"bd": 14,
		"bm": 6,
		"nm": "Allen",
		"nf": "Jones",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/179531348",
		"id": 179531348,
		"lng": -77.38738562,
		"lat": 37.53734346,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hattie",
		"nl": "Adkins",
		"url": "https://www.findagrave.com/memorial/198148125/hattie-adkins",
		"id": 198148125,
		"lng": -77.38706331,
		"lat": 37.53726692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 8,
		"dd": 31,
		"by": 1926,
		"bd": 9,
		"bm": 3,
		"nm": "",
		"nf": "Mary",
		"nl": "Andrews",
		"url": "https://findagrave.com/memorial/198148131",
		"id": 198148131,
		"lng": -77.38718776,
		"lat": 37.53727079,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 3,
		"by": 1895,
		"bd": 28,
		"bm": 2,
		"nm": "",
		"nf": "Meril",
		"nl": "Avant",
		"url": "https://findagrave.com/memorial/198148138",
		"id": 198148138,
		"lng": -77.38719366,
		"lat": 37.53724432,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 3,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pruden",
		"nl": "Crew",
		"url": "https://findagrave.com/memorial/198157349",
		"id": 198157349,
		"lng": -77.38723843,
		"lat": 37.53627847,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 3,
		"dd": 5,
		"by": 1877,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Margaret",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/198157352",
		"id": 198157352,
		"lng": -77.38713298,
		"lat": 37.53684439,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 7,
		"dd": 24,
		"by": 1891,
		"bd": 2,
		"bm": 6,
		"nm": "P. M.",
		"nf": "Charles",
		"nl": "Lipscomb",
		"url": "https://findagrave.com/memorial/198157357",
		"id": 198157357,
		"lng": -77.38719599,
		"lat": 37.53730703,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 10,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Felix",
		"nf": "James",
		"nl": "Randall",
		"url": "https://findagrave.com/memorial/198157364",
		"id": 198157364,
		"lng": -77.38710365,
		"lat": 37.53627991,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 3,
		"by": 1926,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Charlie",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/198199714",
		"id": 198199714,
		"lng": -77.38685302,
		"lat": 37.5368516,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 10,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Roberta",
		"nl": "Richardson",
		"url": "https://findagrave.com/memorial/198109405",
		"id": 198109405,
		"lng": -77.38782905,
		"lat": 37.53628531,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 12,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ruby",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/185740526",
		"id": 185740526,
		"lng": -77.38700942,
		"lat": 37.53689457,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 10,
		"dd": 6,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lee",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/194337551",
		"id": 194337551,
		"lng": -77.38742585,
		"lat": 37.53560585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1901,
		"dm": "",
		"dd": "",
		"by": 1836,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Braxton",
		"url": "https://findagrave.com/memorial/201803892",
		"id": 201803892,
		"lng": -77.38758865,
		"lat": 37.53627995,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 10,
		"dd": 30,
		"by": 1908,
		"bd": 8,
		"bm": 11,
		"nm": "J.",
		"nf": "Robert",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/201798289",
		"id": 201798289,
		"lng": -77.38740564,
		"lat": 37.53685159,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 29,
		"by": 1912,
		"bd": 4,
		"bm": 7,
		"nm": "Ann",
		"nf": "Lucy",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/202608026",
		"id": 202608026,
		"lng": -77.38668068,
		"lat": 37.53715578,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 2,
		"dd": 24,
		"by": 1899,
		"bd": 18,
		"bm": 9,
		"nm": "W.",
		"nf": "Waverly",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/201437687",
		"id": 201437687,
		"lng": -77.38662483,
		"lat": 37.53585481,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 7,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Julia",
		"nl": "Covington",
		"url": "https://findagrave.com/memorial/198146675",
		"id": 198146675,
		"lng": -77.38614894,
		"lat": 37.5360206,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1910,
		"dm": 1,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Elvira",
		"nl": "Harvey",
		"url": "https://findagrave.com/memorial/202198435",
		"id": 202198435,
		"lng": -77.38683385,
		"lat": 37.53592098,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 1,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "S.",
		"nf": "Alice",
		"nl": "Hicks",
		"url": "https://findagrave.com/memorial/202608036",
		"id": 202608036,
		"lng": -77.38672233,
		"lat": 37.53714391,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1960,
		"dm": 10,
		"dd": 23,
		"by": 1881,
		"bd": 31,
		"bm": 7,
		"nm": "",
		"nf": "Eddie",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/200905346",
		"id": 200905346,
		"lng": -77.38657841,
		"lat": 37.5375394,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 6,
		"dd": 8,
		"by": 1893,
		"bd": 1,
		"bm": 6,
		"nm": "",
		"nf": "Carrie",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/200769360",
		"id": 200769360,
		"lng": -77.38641735,
		"lat": 37.53754162,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 11,
		"dd": 1,
		"by": 1906,
		"bd": 25,
		"bm": 11,
		"nm": "",
		"nf": "Samuel",
		"nl": "McKeever",
		"url": "https://findagrave.com/memorial/201128955",
		"id": 201128955,
		"lng": -77.38698689,
		"lat": 37.53775286,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 2,
		"by": 1908,
		"bd": 24,
		"bm": 12,
		"nm": "",
		"nf": "Floyd",
		"nl": "Onley",
		"url": "https://findagrave.com/memorial/201228267",
		"id": 201228267,
		"lng": -77.38714037,
		"lat": 37.5372564,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 12,
		"by": 1909,
		"bd": 23,
		"bm": 11,
		"nm": "",
		"nf": "Raymond",
		"nl": "Ragland",
		"url": "https://findagrave.com/memorial/200595635",
		"id": 200595635,
		"lng": -77.38649806,
		"lat": 37.53726572,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 2,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Clara",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/195078232",
		"id": 195078232,
		"lng": -77.38734469,
		"lat": 37.53549351,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 12,
		"by": 1889,
		"bd": 19,
		"bm": 2,
		"nm": "",
		"nf": "Callie",
		"nl": "Saunders",
		"url": "https://findagrave.com/memorial/202608050",
		"id": 202608050,
		"lng": -77.38660567,
		"lat": 37.53714744,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 10,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "George",
		"nl": "Stevens",
		"url": "https://findagrave.com/memorial/201798297",
		"id": 201798297,
		"lng": -77.38735106,
		"lat": 37.53685242,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 6,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ulysses",
		"nl": "Sullivan",
		"url": "https://findagrave.com/memorial/202273647",
		"id": 202273647,
		"lng": -77.38636028,
		"lat": 37.53558851,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1971,
		"dm": 1,
		"dd": 2,
		"by": 1910,
		"bd": 20,
		"bm": 9,
		"nm": "",
		"nf": "Richard",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/201333200",
		"id": 201333200,
		"lng": -77.38702347,
		"lat": 37.53738437,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 8,
		"dd": 1,
		"by": 1874,
		"bd": 14,
		"bm": 9,
		"nm": "",
		"nf": "Ardelia",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/203190617",
		"id": 203190617,
		"lng": -77.38704892,
		"lat": 37.53771769,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 8,
		"dd": 18,
		"by": 1908,
		"bd": 23,
		"bm": 7,
		"nm": "Edward",
		"nf": "James",
		"nl": "Fant",
		"url": "https://findagrave.com/memorial/203190270",
		"id": 203190270,
		"lng": -77.38704987,
		"lat": 37.53773011,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 6,
		"by": 1898,
		"bd": 3,
		"bm": 4,
		"nm": "",
		"nf": "Sampson",
		"nl": "Melvin",
		"url": "https://findagrave.com/memorial/203191135",
		"id": 203191135,
		"lng": -77.38721222,
		"lat": 37.53761838,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 11,
		"dd": 7,
		"by": 1931,
		"bd": 3,
		"bm": 6,
		"nm": "Ray",
		"nf": "Billie",
		"nl": "Monroe",
		"url": "https://findagrave.com/memorial/203190024",
		"id": 203190024,
		"lng": -77.3870356,
		"lat": 37.53774959,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 22,
		"by": 1912,
		"bd": 21,
		"bm": 4,
		"nm": "Roselle",
		"nf": "Edith",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/203190761",
		"id": 203190761,
		"lng": -77.38701512,
		"lat": 37.53772133,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 7,
		"dd": 3,
		"by": 189,
		"bd": 7,
		"bm": 1,
		"nm": "",
		"nf": "Cary",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/203371954",
		"id": 203371954,
		"lng": -77.3869938,
		"lat": 37.53756054,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 31,
		"by": 1901,
		"bd": 15,
		"bm": 12,
		"nm": "",
		"nf": "Edward",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/203050886",
		"id": 203050886,
		"lng": -77.38712973,
		"lat": 37.53766308,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 4,
		"dd": 15,
		"by": 1931,
		"bd": 28,
		"bm": 3,
		"nm": "",
		"nf": "Willie",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/202737916",
		"id": 202737916,
		"lng": -77.38656006,
		"lat": 37.53708576,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 19,
		"by": 1915,
		"bd": 17,
		"bm": 1,
		"nm": "",
		"nf": "Frank",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/170838980",
		"id": 170838980,
		"lng": -77.3864498,
		"lat": 37.53717942,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 9,
		"dd": 17,
		"by": 1893,
		"bd": 26,
		"bm": 11,
		"nm": "G.",
		"nf": "Richard",
		"nl": "Burton",
		"url": "https://findagrave.com/memorial/203818334",
		"id": 203818334,
		"lng": -77.3867812,
		"lat": 37.53692496,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 5,
		"dd": 25,
		"by": 1913,
		"bd": 15,
		"bm": 3,
		"nm": "",
		"nf": "Louvenia",
		"nl": "Coleman",
		"url": "https://findagrave.com/memorial/203029258",
		"id": 203029258,
		"lng": -77.38702778,
		"lat": 37.53767832,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 9,
		"dd": 24,
		"by": 1896,
		"bd": 2,
		"bm": 9,
		"nm": "",
		"nf": "Jannie",
		"nl": "Cooper",
		"url": "https://findagrave.com/memorial/203999525",
		"id": 203999525,
		"lng": -77.38769669,
		"lat": 37.53776995,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 2,
		"dd": 28,
		"by": 1901,
		"bd": 17,
		"bm": 3,
		"nm": "L.",
		"nf": "Joseph",
		"nl": "Dabney",
		"url": "https://findagrave.com/memorial/203839116",
		"id": 203839116,
		"lng": -77.38670532,
		"lat": 37.53717816,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 14,
		"by": 1903,
		"bd": 26,
		"bm": 7,
		"nm": "",
		"nf": "James",
		"nl": "Dunston",
		"url": "https://findagrave.com/memorial/170838932",
		"id": 170838932,
		"lng": -77.38649643,
		"lat": 37.53717722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 27,
		"by": 1891,
		"bd": 2,
		"bm": 3,
		"nm": "Robinson",
		"nf": "Mary",
		"nl": "Fenderson",
		"url": "https://findagrave.com/memorial/170838949",
		"id": 170838949,
		"lng": -77.38649621,
		"lat": 37.53718288,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "George",
		"nl": "Foster",
		"url": "https://findagrave.com/memorial/203984744",
		"id": 203984744,
		"lng": -77.38744952,
		"lat": 37.53737932,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 4,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Gardner",
		"url": "https://findagrave.com/memorial/204136637",
		"id": 204136637,
		"lng": -77.38751448,
		"lat": 37.53568508,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 8,
		"dd": 7,
		"by": 1895,
		"bd": 12,
		"bm": 10,
		"nm": "Lee",
		"nf": "Roscoe",
		"nl": "Grinaway",
		"url": "https://findagrave.com/memorial/203029889",
		"id": 203029889,
		"lng": -77.38708466,
		"lat": 37.53769954,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 2,
		"dd": 25,
		"by": 1883,
		"bd": 6,
		"bm": 7,
		"nm": "J.",
		"nf": "Sarah",
		"nl": "Gwathmy",
		"url": "https://findagrave.com/memorial/203974376",
		"id": 203974376,
		"lng": -77.38763524,
		"lat": 37.53798197,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 8,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sallie",
		"nl": "Hailey",
		"url": "https://findagrave.com/memorial/185308083",
		"id": 185308083,
		"lng": -77.38698302,
		"lat": 37.53757706,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1921,
		"dm": 12,
		"dd": 28,
		"by": 1841,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Benjamin",
		"nl": "Hall",
		"url": "https://findagrave.com/memorial/204137322",
		"id": 204137322,
		"lng": -77.38753979,
		"lat": 37.53563853,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 11,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ernest",
		"nf": "Richard",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/202834474",
		"id": 202834474,
		"lng": -77.38648592,
		"lat": 37.53722282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 5,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Herndon",
		"url": "https://findagrave.com/memorial/203999532",
		"id": 203999532,
		"lng": -77.38768574,
		"lat": 37.53769908,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 6,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Allen",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/170838988",
		"id": 170838988,
		"lng": -77.3864578,
		"lat": 37.53716439,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 3,
		"dd": 13,
		"by": 1952,
		"bd": 2,
		"bm": 8,
		"nm": "Lucille",
		"nf": "Gayle",
		"nl": "Langhorne",
		"url": "https://findagrave.com/memorial/203011746",
		"id": 203011746,
		"lng": -77.38708583,
		"lat": 37.537714,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 10,
		"dd": 29,
		"by": 1907,
		"bd": 28,
		"bm": 12,
		"nm": "Edward",
		"nf": "Willis",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/203785011",
		"id": 203785011,
		"lng": -77.38696486,
		"lat": 37.53696824,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 6,
		"dd": 9,
		"by": 1910,
		"bd": 5,
		"bm": 7,
		"nm": "",
		"nf": "Henry",
		"nl": "Mills",
		"url": "https://findagrave.com/memorial/203028689",
		"id": 203028689,
		"lng": -77.38702299,
		"lat": 37.53768885,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 7,
		"dd": 22,
		"by": 1882,
		"bd": 8,
		"bm": 2,
		"nm": "",
		"nf": "Elijah",
		"nl": "Pinnex",
		"url": "https://findagrave.com/memorial/203012368",
		"id": 203012368,
		"lng": -77.38704724,
		"lat": 37.53770315,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 3,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lucy",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/204577702",
		"id": 204577702,
		"lng": -77.38731177,
		"lat": 37.53559695,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 6,
		"dd": 13,
		"by": 1903,
		"bd": 2,
		"bm": 1,
		"nm": "",
		"nf": "Nelson",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/203584547",
		"id": 203584547,
		"lng": -77.38678867,
		"lat": 37.53773353,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 3,
		"dd": 12,
		"by": 1923,
		"bd": 20,
		"bm": 8,
		"nm": "",
		"nf": "Celestine",
		"nl": "Smoot",
		"url": "https://findagrave.com/memorial/203026257",
		"id": 203026257,
		"lng": -77.38697193,
		"lat": 37.53767106,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 10,
		"dd": 31,
		"by": 1932,
		"bd": 7,
		"bm": 4,
		"nm": "",
		"nf": "Betty",
		"nl": "Stovall",
		"url": "https://findagrave.com/memorial/170838884",
		"id": 170838884,
		"lng": -77.3864849,
		"lat": 37.53720129,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 2,
		"dd": 11,
		"by": 1895,
		"bd": 2,
		"bm": 7,
		"nm": "",
		"nf": "William",
		"nl": "Wade",
		"url": "https://findagrave.com/memorial/195168940",
		"id": 195168940,
		"lng": -77.38736594,
		"lat": 37.53761146,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 6,
		"dd": 6,
		"by": 1958,
		"bd": 14,
		"bm": 4,
		"nm": "Artell",
		"nf": "Larry",
		"nl": "Winston",
		"url": "https://findagrave.com/memorial/203975014",
		"id": 203975014,
		"lng": -77.38756379,
		"lat": 37.53796784,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 6,
		"dd": 27,
		"by": 1941,
		"bd": 9,
		"bm": 3,
		"nm": "L.",
		"nf": "Sterling",
		"nl": "Allen",
		"url": "https://findagrave.com/memorial/204783830",
		"id": 204783830,
		"lng": -77.38729454,
		"lat": 37.53560377,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 5,
		"dd": 19,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lewis",
		"nl": "Bentley",
		"url": "https://findagrave.com/memorial/204783851",
		"id": 204783851,
		"lng": -77.38713913,
		"lat": 37.53567596,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 1,
		"by": 1897,
		"bd": 21,
		"bm": 12,
		"nm": "",
		"nf": "Calvin",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/205759210",
		"id": 205759210,
		"lng": -77.38680525,
		"lat": 37.53679417,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 5,
		"dd": 15,
		"by": 1919,
		"bd": 29,
		"bm": 1,
		"nm": "",
		"nf": "Wilbur",
		"nl": "Brooks",
		"url": "https://findagrave.com/memorial/206005409",
		"id": 206005409,
		"lng": -77.3868059,
		"lat": 37.53677584,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 4,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Beulah",
		"nl": "Brown",
		"url": "https://findagrave.com/memorial/204784411",
		"id": 204784411,
		"lng": -77.38736485,
		"lat": 37.53551329,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 4,
		"dd": 9,
		"by": 1865,
		"bd": 10,
		"bm": 9,
		"nm": "W.",
		"nf": "George",
		"nl": "Carrington",
		"url": "https://findagrave.com/memorial/205854376",
		"id": 205854376,
		"lng": -77.38667126,
		"lat": 37.53556497,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 9,
		"dd": 18,
		"by": 1868,
		"bd": 19,
		"bm": 7,
		"nm": "Washington",
		"nf": "George",
		"nl": "Clay",
		"url": "https://findagrave.com/memorial/204784439",
		"id": 204784439,
		"lng": -77.3873962,
		"lat": 37.53549744,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 9,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lizzie",
		"nl": "Dickerson",
		"url": "https://findagrave.com/memorial/204517186",
		"id": 204517186,
		"lng": -77.38763783,
		"lat": 37.53558021,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 4,
		"dd": 9,
		"by": 1893,
		"bd": 30,
		"bm": 5,
		"nm": "Thomas",
		"nf": "Wilbur",
		"nl": "Gayles",
		"url": "https://findagrave.com/memorial/204784476",
		"id": 204784476,
		"lng": -77.38740906,
		"lat": 37.53554634,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 1,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "George",
		"nl": "Henderson",
		"url": "https://findagrave.com/memorial/204787137",
		"id": 204787137,
		"lng": -77.38736127,
		"lat": 37.53550889,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 1,
		"dd": 30,
		"by": 1895,
		"bd": 10,
		"bm": 1,
		"nm": "William",
		"nf": "John",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/195168508",
		"id": 195168508,
		"lng": -77.38795343,
		"lat": 37.53719277,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 12,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Amanda",
		"nl": "Jones",
		"url": "https://findagrave.com/memorial/204787143",
		"id": 204787143,
		"lng": -77.38749399,
		"lat": 37.53550886,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1919,
		"dm": 7,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alberta",
		"nl": "Meekins",
		"url": "https://findagrave.com/memorial/204577828",
		"id": 204577828,
		"lng": -77.38739838,
		"lat": 37.5354877,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 4,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Mccue",
		"nf": "Ada",
		"nl": "Nicholas",
		"url": "https://findagrave.com/memorial/205758544",
		"id": 205758544,
		"lng": -77.38694326,
		"lat": 37.53682138,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1922,
		"dm": 8,
		"dd": 31,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Richard",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/204787154",
		"id": 204787154,
		"lng": -77.38743612,
		"lat": 37.53553654,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Pattie",
		"nl": "Randolph",
		"url": "https://findagrave.com/memorial/204787217",
		"id": 204787217,
		"lng": -77.38726533,
		"lat": 37.53569022,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 8,
		"dd": 7,
		"by": 1900,
		"bd": 1,
		"bm": 4,
		"nm": "Henry",
		"nf": "William",
		"nl": "Wilson",
		"url": "https://findagrave.com/memorial/205758165",
		"id": 205758165,
		"lng": -77.38690707,
		"lat": 37.53686054,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1948,
		"dm": 4,
		"dd": 1,
		"by": 1889,
		"bd": 26,
		"bm": 12,
		"nm": "",
		"nf": "Lula",
		"nl": "Suitts El",
		"url": "https://findagrave.com/memorial/205786683",
		"id": 205786683,
		"lng": -77.3869276,
		"lat": 37.53680682,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 5,
		"dd": 10,
		"by": 1890,
		"bd": 21,
		"bm": 2,
		"nm": "",
		"nf": "Robert",
		"nl": "Cunningham",
		"url": "https://findagrave.com/memorial/206558611",
		"id": 206558611,
		"lng": -77.38664175,
		"lat": 37.53697607,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 12,
		"dd": 13,
		"by": 1870,
		"bd": 16,
		"bm": 3,
		"nm": "",
		"nf": "Richard",
		"nl": "Price",
		"url": "https://findagrave.com/memorial/206558641",
		"id": 206558641,
		"lng": -77.38668931,
		"lat": 37.53698707,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 2,
		"dd": 26,
		"by": 1928,
		"bd": 28,
		"bm": 1,
		"nm": "",
		"nf": "Eulalia",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/206729312",
		"id": 206729312,
		"lng": -77.38641557,
		"lat": 37.53666027,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 3,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Bessie",
		"nl": "Hilton",
		"url": "https://findagrave.com/memorial/206737320",
		"id": 206737320,
		"lng": -77.38744839,
		"lat": 37.5373692,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 1,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "M.",
		"nf": "James",
		"nl": "Singleton",
		"url": "https://findagrave.com/memorial/206737326",
		"id": 206737326,
		"lng": -77.38618298,
		"lat": 37.53683909,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 7,
		"dd": 27,
		"by": 1892,
		"bd": 18,
		"bm": 4,
		"nm": "M.",
		"nf": "Sallie",
		"nl": "Patton",
		"url": "https://findagrave.com/memorial/206962630",
		"id": 206962630,
		"lng": -77.38657665,
		"lat": 37.53716239,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 10,
		"dd": 27,
		"by": 1854,
		"bd": 1,
		"bm": 11,
		"nm": "B.",
		"nf": "Luvenia",
		"nl": "Lewis",
		"url": "https://findagrave.com/memorial/198673724",
		"id": 198673724,
		"lng": -77.3861424,
		"lat": 37.53572458,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 4,
		"dd": 21,
		"by": 1847,
		"bd": 16,
		"bm": 8,
		"nm": "",
		"nf": "Fannie",
		"nl": "Roane",
		"url": "https://findagrave.com/memorial/204951016",
		"id": 204951016,
		"lng": -77.38756713,
		"lat": 37.53651763,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 2,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isham",
		"nl": "Lawrence",
		"url": "https://findagrave.com/memorial/205054411",
		"id": 205054411,
		"lng": -77.38707936,
		"lat": 37.5356791,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 4,
		"dd": 22,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Eddie",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/205201107",
		"id": 205201107,
		"lng": -77.3875745,
		"lat": 37.53562417,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 3,
		"dd": 20,
		"by": 1913,
		"bd": 23,
		"bm": 2,
		"nm": "Nataniel",
		"nf": "Robert",
		"nl": "Thomas",
		"url": "https://findagrave.com/memorial/205484021",
		"id": 205484021,
		"lng": -77.38595212,
		"lat": 37.53629843,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lemuel",
		"nl": "Carter",
		"url": "https://findagrave.com/memorial/206017331",
		"id": 206017331,
		"lng": -77.38690274,
		"lat": 37.53665598,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 5,
		"dd": 24,
		"by": 180,
		"bd": 8,
		"bm": 4,
		"nm": "",
		"nf": "Laura",
		"nl": "Calloway",
		"url": "https://findagrave.com/memorial/206159296",
		"id": 206159296,
		"lng": -77.38724736,
		"lat": 37.53696246,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1945,
		"dm": 4,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "G.",
		"nf": "Lettie",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/206160530",
		"id": 206160530,
		"lng": -77.38720362,
		"lat": 37.53695967,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 3,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Evrie",
		"nl": "Ellis",
		"url": "https://findagrave.com/memorial/206423623",
		"id": 206423623,
		"lng": -77.38812055,
		"lat": 37.53745632,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 5,
		"dd": 8,
		"by": 1887,
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Sophia",
		"nl": "Trent",
		"url": "https://findagrave.com/memorial/206423629",
		"id": 206423629,
		"lng": -77.38706174,
		"lat": 37.53688418,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 8,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Randolph",
		"nl": "Turner",
		"url": "https://findagrave.com/memorial/207044917",
		"id": 207044917,
		"lng": -77.38668451,
		"lat": 37.53664459,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nathan",
		"nl": "Aytes",
		"url": "https://findagrave.com/memorial/198908126",
		"id": 198908126,
		"lng": -77.38603168,
		"lat": 37.53615712,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 11,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "B.",
		"nf": "Lucy",
		"nl": "King",
		"url": "https://findagrave.com/memorial/198907802",
		"id": 198907802,
		"lng": -77.38612103,
		"lat": 37.53607433,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 2,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Littleton",
		"nl": "Britton",
		"url": "https://findagrave.com/memorial/173908791",
		"id": 173908791,
		"lng": -77.38759325,
		"lat": 37.53717207,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 4,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isaac",
		"nl": "Crump",
		"url": "https://findagrave.com/memorial/203645514",
		"id": 203645514,
		"lng": -77.38642924,
		"lat": 37.53632998,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 1,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Frank",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/195877147",
		"id": 195877147,
		"lng": -77.3859896,
		"lat": 37.53598586,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1954,
		"dm": 7,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Nancy",
		"nl": "Robinson",
		"url": "https://findagrave.com/memorial/205362251",
		"id": 205362251,
		"lng": -77.3865704,
		"lat": 37.5364753,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 8,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Frances",
		"nf": "Mary",
		"nl": "Smith",
		"url": "https://findagrave.com/memorial/188624291",
		"id": 188624291,
		"lng": -77.38651691,
		"lat": 37.53589611,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 11,
		"dd": 10,
		"by": 1899,
		"bd": 26,
		"bm": 3,
		"nm": "",
		"nf": "William",
		"nl": "Pierce",
		"url": "https://findagrave.com/memorial/203786208",
		"id": 203786208,
		"lng": -77.38690918,
		"lat": 37.53730747,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 6,
		"dd": 4,
		"by": 1885,
		"bd": 28,
		"bm": 5,
		"nm": "Henry Miles",
		"nf": "John",
		"nl": "Farrar",
		"url": "https://findagrave.com/memorial/142470744",
		"id": 142470744,
		"lng": -77.38725332,
		"lat": 37.53695376,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 8,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Maria",
		"nl": "Randall",
		"url": "https://findagrave.com/memorial/142470793",
		"id": 142470793,
		"lng": -77.38724351,
		"lat": 37.53695334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 4,
		"dd": 24,
		"by": 1903,
		"bd": 22,
		"bm": 10,
		"nm": "Newton",
		"nf": "Samuel",
		"nl": "Barr",
		"url": "https://findagrave.com/memorial/207174199",
		"id": 207174199,
		"lng": -77.3871693,
		"lat": 37.53684018,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 19,
		"by": 1902,
		"bd": 2,
		"bm": 3,
		"nm": "Roy",
		"nf": "James",
		"nl": "Harris",
		"url": "https://findagrave.com/memorial/207174212",
		"id": 207174212,
		"lng": -77.38709633,
		"lat": 37.53735364,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 8,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gertrude",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/207174232",
		"id": 207174232,
		"lng": -77.38715083,
		"lat": 37.5371995,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 10,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Wooden",
		"nf": "Isabelle",
		"nl": "Moore",
		"url": "https://findagrave.com/memorial/205663574",
		"id": 205663574,
		"lng": -77.38761675,
		"lat": 37.53727605,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1920,
		"dm": 1,
		"dd": 1,
		"by": 1849,
		"bd": 23,
		"bm": 12,
		"nm": "",
		"nf": "Kate",
		"nl": "Holmes",
		"url": "https://findagrave.com/memorial/207712871",
		"id": 207712871,
		"lng": -77.38781104,
		"lat": 37.53639422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 17,
		"by": 1923,
		"bd": 17,
		"bm": 6,
		"nm": "Mae",
		"nf": "Ethel",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/207344637",
		"id": 207344637,
		"lng": -77.38745807,
		"lat": 37.53787218,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 3,
		"dd": 13,
		"by": 1897,
		"bd": 17,
		"bm": 1,
		"nm": "",
		"nf": "Zemora",
		"nl": "Monteeth",
		"url": "https://findagrave.com/memorial/207540740",
		"id": 207540740,
		"lng": -77.3867741,
		"lat": 37.53687514,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 4,
		"dd": 11,
		"by": 1957,
		"bd": 8,
		"bm": 10,
		"nm": "",
		"nf": "Monanstao",
		"nl": "Small",
		"url": "https://findagrave.com/memorial/207382121",
		"id": 207382121,
		"lng": -77.3876297,
		"lat": 37.537899,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 5,
		"dd": 8,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sim",
		"nl": "Taylor",
		"url": "https://findagrave.com/memorial/207281725",
		"id": 207281725,
		"lng": -77.38711255,
		"lat": 37.5367499,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1930,
		"dm": 1,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "William",
		"nl": "Anderson",
		"url": "https://www.findagrave.com/memorial/211706867/william-r.-anderson",
		"id": 211706867,
		"lng": -77.386681,
		"lat": 37.53544304,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 9,
		"dd": 23,
		"by": 1913,
		"bd": 2,
		"bm": 7,
		"nm": "Mollie",
		"nf": "Mary",
		"nl": "Wingo",
		"url": "https://www.findagrave.com/memorial/215059747/mary-mollie-wingo",
		"id": 215059747,
		"lng": -77.38624632,
		"lat": 37.5354645,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 4,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Dolly",
		"nl": "Chavers",
		"url": "https://www.findagrave.com/memorial/179307773/dolly-chavers",
		"id": 179307773,
		"lng": -77.38613434,
		"lat": 37.53567392,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 10,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "C. Evans",
		"nf": "Elizabeth",
		"nl": "Payne",
		"url": "https://www.findagrave.com/memorial/169921982/elizabeth-c-payne",
		"id": 169921982,
		"lng": -77.38652047,
		"lat": 37.53571537,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 7,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "T.",
		"nf": "Letitia",
		"nl": "Dabbs",
		"url": "https://www.findagrave.com/memorial/211869014/letitia-t.-dabbs",
		"id": 211869014,
		"lng": -77.38673997,
		"lat": 37.53569889,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1914,
		"dm": 6,
		"dd": 16,
		"by": 1894,
		"bd": 25,
		"bm": 1,
		"nm": "Beatrice",
		"nf": "Annie",
		"nl": "Allen",
		"url": "https://www.findagrave.com/memorial/207804066/annie-beatrice-allen",
		"id": 207804066,
		"lng": -77.38696052,
		"lat": 37.5357922,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1933,
		"dm": 3,
		"dd": 29,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Gertrude",
		"nl": "Sparks",
		"url": "https://www.findagrave.com/memorial/212207968/gertrude-sparks",
		"id": 212207968,
		"lng": -77.38667473,
		"lat": 37.53582409,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1908,
		"dm": 4,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Irene",
		"nf": "Lottie",
		"nl": "Brown",
		"url": "https://www.findagrave.com/memorial/176388847/lottie-irene-brown",
		"id": 176388847,
		"lng": -77.38625853,
		"lat": 37.53583237,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1909,
		"dm": 11,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Brabby",
		"url": "https://www.findagrave.com/memorial/211854588/mary-brabby",
		"id": 211854588,
		"lng": -77.38675603,
		"lat": 37.53598548,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1913,
		"dm": 1,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "P.",
		"nf": "Lewis",
		"nl": "Cheatham",
		"url": "https://www.findagrave.com/memorial/168967225/lewis-p.-cheatham",
		"id": 168967225,
		"lng": -77.38622092,
		"lat": 37.53601778,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 3,
		"dd": 2,
		"by": 1918,
		"bd": 17,
		"bm": 2,
		"nm": "Pollard",
		"nf": "Lincoln",
		"nl": "Johnson",
		"url": "https://www.findagrave.com/memorial/209266417/lincoln-pollard-johnson",
		"id": 209266417,
		"lng": -77.3859875,
		"lat": 37.53600009,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1940,
		"dm": 2,
		"dd": 27,
		"by": 1857,
		"bd": 20,
		"bm": 5,
		"nm": "McPherson",
		"nf": "Christopher",
		"nl": "Kemp",
		"url": "https://www.findagrave.com/memorial/170268764/christopher-mcpherson-kemp",
		"id": 170268764,
		"lng": -77.38601689,
		"lat": 37.53608339,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 6,
		"dd": 9,
		"by": 1886,
		"bd": 10,
		"bm": 10,
		"nm": "",
		"nf": "Paul",
		"nl": "Thompson",
		"url": "https://www.findagrave.com/memorial/211045902/paul-thompson",
		"id": 211045902,
		"lng": -77.38622663,
		"lat": 37.53615076,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 6,
		"dd": 25,
		"by": 1876,
		"bd": 18,
		"bm": 5,
		"nm": "",
		"nf": "Cora",
		"nl": "Thompson",
		"url": "https://www.findagrave.com/memorial/205121222/cora-thompson",
		"id": 205121222,
		"lng": -77.38600695,
		"lat": 37.53626343,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1915,
		"dm": 6,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Henry",
		"nl": "Williams",
		"url": "https://www.findagrave.com/memorial/150037966/henry-williams",
		"id": 150037966,
		"lng": -77.38626291,
		"lat": 37.53641111,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1904,
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "William",
		"nl": "Ferguson",
		"url": "https://www.findagrave.com/memorial/187074826/william-ferguson",
		"id": 187074826,
		"lng": -77.38626871,
		"lat": 37.53642527,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1924,
		"dm": 2,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hazel",
		"nl": "Vanhook",
		"url": "https://www.findagrave.com/memorial/211936988/hazel-vanhook",
		"id": 211936988,
		"lng": -77.38663033,
		"lat": 37.53625824,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 12,
		"dd": 10,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "L.",
		"nf": "Abram",
		"nl": "Harris",
		"url": "https://www.findagrave.com/memorial/194636088/abram-l.-harris",
		"id": 194636088,
		"lng": -77.38773777,
		"lat": 37.5364077,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1944,
		"dm": 3,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Briggs",
		"url": "https://www.findagrave.com/memorial/134403100/mary-briggs",
		"id": 134403100,
		"lng": -77.3877603,
		"lat": 37.53658178,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1927,
		"dm": 3,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "William",
		"nl": "Liggins",
		"url": "https://www.findagrave.com/memorial/207787291/william-henry-liggins",
		"id": 207787291,
		"lng": -77.38775682,
		"lat": 37.53658722,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1943,
		"dm": 4,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Harris",
		"url": "https://www.findagrave.com/memorial/184478696/mary-harris",
		"id": 184478696,
		"lng": -77.38769084,
		"lat": 37.53662392,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1946,
		"dm": 6,
		"dd": 27,
		"by": 1849,
		"bd": 15,
		"bm": 1,
		"nm": "P.",
		"nf": "John",
		"nl": "Clarke",
		"url": "https://www.findagrave.com/memorial/205830048/john-p.-clarke",
		"id": 205830048,
		"lng": -77.38762265,
		"lat": 37.53661748,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1917,
		"dm": 8,
		"dd": 19,
		"by": 1915,
		"bd": 28,
		"bm": 6,
		"nm": "Helen",
		"nf": "Mary",
		"nl": "Perry",
		"url": "https://www.findagrave.com/memorial/211945672/mary-helen-perry",
		"id": 211945672,
		"lng": -77.38757217,
		"lat": 37.5366004,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Isaiah",
		"nl": "Dabney",
		"url": "https://www.findagrave.com/memorial/208044806/isaiah-dabney",
		"id": 208044806,
		"lng": -77.38752999,
		"lat": 37.53662016,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "A.",
		"nf": "Benjamin",
		"nl": "Harris",
		"url": "https://www.findagrave.com/memorial/207963111/benjamin-a.-harris",
		"id": 207963111,
		"lng": -77.38767274,
		"lat": 37.5367677,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1918,
		"dm": 2,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Ann",
		"nf": "Ellen",
		"nl": "Briggs",
		"url": "https://www.findagrave.com/memorial/215345550/ellen-ann-briggs",
		"id": 215345550,
		"lng": -77.3876116,
		"lat": 37.53676588,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 7,
		"dd": 21,
		"by": 1894,
		"bd": 9,
		"bm": 4,
		"nm": "",
		"nf": "Richard",
		"nl": "Washington",
		"url": "https://www.findagrave.com/memorial/215610216/richard-washington",
		"id": 215610216,
		"lng": -77.38747981,
		"lat": 37.53677427,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 11,
		"dd": 27,
		"by": 1906,
		"bd": 8,
		"bm": "",
		"nm": "May",
		"nf": "Lottie",
		"nl": "Green",
		"url": "https://www.findagrave.com/memorial/208672682/lottie-may-green",
		"id": 208672682,
		"lng": -77.38752594,
		"lat": 37.53683663,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1935,
		"dm": 1,
		"dd": 9,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Arthur",
		"nl": "White",
		"url": "https://www.findagrave.com/memorial/212453526/arthur-white",
		"id": 212453526,
		"lng": -77.38700178,
		"lat": 37.53669203,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 1,
		"dd": 10,
		"by": 1891,
		"bd": 11,
		"bm": 12,
		"nm": "Lottie",
		"nf": "Mary",
		"nl": "Smith",
		"url": "https://www.findagrave.com/memorial/215611682/mary-smith",
		"id": 215611682,
		"lng": -77.38686166,
		"lat": 37.53676556,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1938,
		"dm": 1,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Beatrice",
		"nf": "Sarah",
		"nl": "Jonathan",
		"url": "https://www.findagrave.com/memorial/168963625/sarah-beatrice-jonathan",
		"id": 168963625,
		"lng": -77.38665562,
		"lat": 37.53660453,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 7,
		"dd": 24,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clara",
		"nl": "Starke",
		"url": "https://www.findagrave.com/memorial/213036460/clara-starke",
		"id": 213036460,
		"lng": -77.38654082,
		"lat": 37.53665751,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 5,
		"dd": 19,
		"by": 1910,
		"bd": 22,
		"bm": 5,
		"nm": "C.",
		"nf": "William",
		"nl": "Smith",
		"url": "https://www.findagrave.com/memorial/208373118/william-c.-smith",
		"id": 208373118,
		"lng": -77.38641353,
		"lat": 37.5367737,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 12,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Infant Daughter",
		"nl": "Robinson",
		"url": "https://www.findagrave.com/memorial/208372707/infant-robinson",
		"id": 208372707,
		"lng": -77.38644224,
		"lat": 37.5367972,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1947,
		"dm": 9,
		"dd": 15,
		"by": 1947,
		"bd": 14,
		"bm": 9,
		"nm": "",
		"nf": "Baby Girl",
		"nl": "Person",
		"url": "https://www.findagrave.com/memorial/206778715/infant-female-person",
		"id": 206778715,
		"lng": -77.3871406,
		"lat": 37.53682577,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1937,
		"dm": 3,
		"dd": 14,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Sallie",
		"nl": "Hundley",
		"url": "https://www.findagrave.com/memorial/212749787/sallie-hundley",
		"id": 212749787,
		"lng": -77.38719984,
		"lat": 37.53684049,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 7,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edward",
		"nl": "Vaden",
		"url": "https://www.findagrave.com/memorial/173919689/edward-vaden",
		"id": 173919689,
		"lng": -77.38754199,
		"lat": 37.53715174,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1923,
		"dm": 12,
		"dd": 13,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Margaret",
		"nl": "Butcher",
		"url": "https://www.findagrave.com/memorial/214111896/margaret-butcher",
		"id": 214111896,
		"lng": -77.38793257,
		"lat": 37.53729109,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1979,
		"dm": 3,
		"dd": 16,
		"by": 1914,
		"bd": 6,
		"bm": 4,
		"nm": "Matthew",
		"nf": "John",
		"nl": "Crump",
		"url": "https://www.findagrave.com/memorial/5254135/john-matthew-crump",
		"id": 5254135,
		"lng": -77.38658638,
		"lat": 37.53696666,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 1,
		"dd": 1,
		"by": 1944,
		"bd": 19,
		"bm": 5,
		"nm": "Edward",
		"nf": "Warren",
		"nl": "Preston",
		"url": "https://www.findagrave.com/memorial/208372385/warren-edward-preston",
		"id": 208372385,
		"lng": -77.38639804,
		"lat": 37.53691259,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 6,
		"dd": 7,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Thomas",
		"nf": "William",
		"nl": "Kelly",
		"url": "https://www.findagrave.com/memorial/201040691/william-thomas-kelly",
		"id": 201040691,
		"lng": -77.38570909,
		"lat": 37.53674605,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1931,
		"dm": 6,
		"dd": 15,
		"by": 1879,
		"bd": 6,
		"bm": 7,
		"nm": "R.",
		"nf": "Joshua",
		"nl": "Griffin",
		"url": "https://www.findagrave.com/memorial/208040250/joshua-r.-griffin",
		"id": 208040250,
		"lng": -77.38556814,
		"lat": 37.53702607,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1951,
		"dm": 10,
		"dd": 24,
		"by": 1906,
		"bd": 7,
		"bm": 2,
		"nm": "Wilbur",
		"nf": "Richard",
		"nl": "Holmes",
		"url": "https://www.findagrave.com/memorial/207843554/richard-wilbur-holmes",
		"id": 207843554,
		"lng": -77.38564788,
		"lat": 37.53715781,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1968,
		"dm": 6,
		"dd": 13,
		"by": 1900,
		"bd": 17,
		"bm": 4,
		"nm": "",
		"nf": "Harvey",
		"nl": "Lightfoot",
		"url": "https://www.findagrave.com/memorial/214628741/harvey-lightfoot",
		"id": 214628741,
		"lng": -77.38587788,
		"lat": 37.53745165,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 5,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Stacy",
		"nl": "Lewis",
		"url": "https://www.findagrave.com/memorial/211363873/stacy-lewis",
		"id": 211363873,
		"lng": -77.38597894,
		"lat": 37.53735906,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 4,
		"dd": 23,
		"by": 1963,
		"bd": 23,
		"bm": 4,
		"nm": "Charles",
		"nf": "Christopher",
		"nl": "Harris",
		"url": "https://www.findagrave.com/memorial/214566183/christopher-charles-harris",
		"id": 214566183,
		"lng": -77.38619894,
		"lat": 37.53751325,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1966,
		"dm": 10,
		"dd": 12,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Peter",
		"nf": "Doctor",
		"nl": "Martin",
		"url": "https://www.findagrave.com/memorial/130927225/doctor-peter-martin",
		"id": 130927225,
		"lng": -77.38636644,
		"lat": 37.53710683,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 4,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "W.",
		"nf": "Sarah",
		"nl": "Hopkins",
		"url": "https://www.findagrave.com/memorial/170838995/sarah-w-hopkins",
		"id": 170838995,
		"lng": -77.38642085,
		"lat": 37.53716585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 1,
		"dd": 5,
		"by": 1909,
		"bd": 9,
		"bm": 7,
		"nm": "",
		"nf": "Walter",
		"nl": "Scott",
		"url": "https://www.findagrave.com/memorial/177326276/walter-scott",
		"id": 177326276,
		"lng": -77.38754054,
		"lat": 37.53731556,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 11,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clarence",
		"nl": "Mason",
		"url": "https://www.findagrave.com/memorial/197483388/clarence-mason",
		"id": 197483388,
		"lng": -77.38802642,
		"lat": 37.53781689,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1941,
		"dm": 5,
		"dd": 30,
		"by": 1922,
		"bd": 15,
		"bm": 6,
		"nm": "Herman",
		"nf": "Charles",
		"nl": "Spears",
		"url": "https://www.findagrave.com/memorial/214198064/charles-herman-spears",
		"id": 214198064,
		"lng": -77.38789285,
		"lat": 37.53782422,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 1,
		"dd": 20,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lestine",
		"nf": "Agnes",
		"nl": "Langston",
		"url": "https://www.findagrave.com/memorial/214237195/agnes-lestine-langston",
		"id": 214237195,
		"lng": -77.38764008,
		"lat": 37.5379004,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 5,
		"dd": 15,
		"by": 1905,
		"bd": 14,
		"bm": 4,
		"nm": "",
		"nf": "Thomas",
		"nl": "Pettis",
		"url": "https://www.findagrave.com/memorial/207130609/thomas-pettis",
		"id": 207130609,
		"lng": -77.38747882,
		"lat": 37.53774029,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 9,
		"dd": 17,
		"by": 1910,
		"bd": 10,
		"bm": 6,
		"nm": "",
		"nf": "Rozella",
		"nl": "Maroney",
		"url": "https://www.findagrave.com/memorial/184476104/rozella-maroney",
		"id": 184476104,
		"lng": -77.38731951,
		"lat": 37.53758921,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 9,
		"dd": 28,
		"by": 1884,
		"bd": 15,
		"bm": 5,
		"nm": "",
		"nf": "Robert",
		"nl": "Henderson",
		"url": "https://www.findagrave.com/memorial/188065506/robert-henderson",
		"id": 188065506,
		"lng": -77.38720458,
		"lat": 37.53760538,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 11,
		"dd": 14,
		"by": 1938,
		"bd": 17,
		"bm": 8,
		"nm": "",
		"nf": "Delores",
		"nl": "Williams",
		"url": "https://www.findagrave.com/memorial/214980948/delores-williams",
		"id": 214980948,
		"lng": -77.38695717,
		"lat": 37.5377554,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 6,
		"dd": 25,
		"by": 1886,
		"bd": 15,
		"bm": 2,
		"nm": "",
		"nf": "Grant",
		"nl": "Wingfield",
		"url": "https://www.findagrave.com/memorial/207345998/grant-wingfield",
		"id": 207345998,
		"lng": -77.38693093,
		"lat": 37.53773948,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Claiborne",
		"nf": "William",
		"nl": "Jones",
		"url": "https://www.findagrave.com/memorial/214995732/william-claiborne-jones",
		"id": 214995732,
		"lng": -77.38641152,
		"lat": 37.53749227,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 7,
		"dd": 26,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Alice",
		"nl": "Albright",
		"url": "https://www.findagrave.com/memorial/215753501/alice-albright",
		"id": 215753501,
		"lng": -77.38723668,
		"lat": 37.53556336,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 1,
		"dd": 23,
		"by": 1918,
		"bd": 27,
		"bm": 6,
		"nm": "",
		"nf": "Laura",
		"nl": "Brown",
		"url": "https://www.findagrave.com/memorial/216110923/laura-brown",
		"id": 216110923,
		"lng": -77.38642137,
		"lat": 37.53756309,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 6,
		"dd": 17,
		"by": 1888,
		"bd": 24,
		"bm": 5,
		"nm": "",
		"nf": "Ida",
		"nl": "Johnson",
		"url": "https://www.findagrave.com/memorial/216505410/ida-johnson",
		"id": 216505410,
		"lng": -77.38682941,
		"lat": 37.53773282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 8,
		"dd": 10,
		"by": 1870,
		"bd": 6,
		"bm": 8,
		"nm": "",
		"nf": "William",
		"nl": "Christian",
		"url": "https://www.findagrave.com/memorial/216539622/william-christian",
		"id": 216539622,
		"lng": -77.38760195,
		"lat": 37.53770995,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": 8,
		"dd": 17,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Emmett",
		"nl": "Haskins",
		"url": "https://www.findagrave.com/memorial/216541230/emmett-haskins",
		"id": 216541230,
		"lng": -77.38760613,
		"lat": 37.53772048,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 5,
		"dd": 31,
		"by": 1959,
		"bd": 14,
		"bm": 3,
		"nm": "",
		"nf": "Jimmy",
		"nl": "Quarles",
		"url": "https://www.findagrave.com/memorial/203578517/jimmy-quarles",
		"id": 203578517,
		"lng": -77.38677086,
		"lat": 37.53775334,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1958,
		"dm": 2,
		"dd": 16,
		"by": 1896,
		"bd": 13,
		"bm": 5,
		"nm": "",
		"nf": "Sadie",
		"nl": "Hamm",
		"url": "https://www.findagrave.com/memorial/196561439/sadie-hamm",
		"id": 196561439,
		"lng": -77.38777001,
		"lat": 37.53780125,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1957,
		"dm": 12,
		"dd": 7,
		"by": 1990,
		"bd": 15,
		"bm": 8,
		"nm": "",
		"nf": "Viola",
		"nl": "Roberts",
		"url": "https://www.findagrave.com/memorial/196374820/viola-roberts",
		"id": 196374820,
		"lng": -77.38764905,
		"lat": 37.53796173,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 9,
		"dd": 1,
		"by": 1875,
		"bd": 12,
		"bm": 10,
		"nm": "B.",
		"nf": "John",
		"nl": "Braxton",
		"url": "https://www.findagrave.com/memorial/159846368/john-baptist-braxton",
		"id": 159846368,
		"lng": -77.38737786,
		"lat": 37.53756996,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 5,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Mary",
		"nl": "Murray",
		"url": "https://www.findagrave.com/memorial/159846968/mary-jackson-murray",
		"id": 159846968,
		"lng": -77.38738334,
		"lat": 37.53755146,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 3,
		"dd": 18,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Jennifer",
		"nl": "Scarborough",
		"url": "https://www.findagrave.com/memorial/144226025/jennifer-l.-scarborough",
		"id": 144226025,
		"lng": -77.38592784,
		"lat": 37.53743327,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 0,
		"dm": 0,
		"dd": 0,
		"by": 0,
		"bd": 0,
		"bm": 0,
		"nm": "",
		"nf": "Baby Girl",
		"nl": "Unknown",
		"url": "https://www.findagrave.com/memorial/219723070/baby_girl-unknown",
		"id": 219723070,
		"lng": -77.38595864,
		"lat": 37.5374282,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 0,
		"dm": 0,
		"dd": 0,
		"by": 0,
		"bd": 0,
		"bm": 0,
		"nm": "",
		"nf": "Baby",
		"nl": "Unknown",
		"url": "https://www.findagrave.com/memorial/219723522/baby-unknown",
		"id": 219723522,
		"lng": -77.38621908,
		"lat": 37.53745943,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 22,
		"by": 1930,
		"bd": 26,
		"bm": 5,
		"nm": "",
		"nf": "Kate",
		"nl": "Taylor",
		"url": "https://www.findagrave.com/memorial/179091015/kate-taylor",
		"id": 179091015,
		"lng": -77.38788577,
		"lat": 37.53747588,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 12,
		"dd": 3,
		"by": 1890,
		"bd": 4,
		"bm": 2,
		"nm": "V.",
		"nf": "Eugene",
		"nl": "Love",
		"url": "https://www.findagrave.com/memorial/179091004/eugene-v.-love",
		"id": 179091004,
		"lng": -77.38785669,
		"lat": 37.53749589,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 6,
		"dd": 12,
		"by": 1929,
		"bd": 22,
		"bm": 2,
		"nm": "J.",
		"nf": "Harvey",
		"nl": "Teasley",
		"url": "https://www.findagrave.com/memorial/179091022/harvey-j.-teasley",
		"id": 179091022,
		"lng": -77.38773642,
		"lat": 37.53734182,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1963,
		"dm": 4,
		"dd": 17,
		"by": 1920,
		"bd": 18,
		"bm": 8,
		"nm": "Thompson",
		"nf": "Mary",
		"nl": "West",
		"url": "https://www.findagrave.com/memorial/177761153/mary-west",
		"id": 177761153,
		"lng": -77.38768567,
		"lat": 37.53733646,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1952,
		"dm": 10,
		"dd": 2,
		"by": 1900,
		"bd": 16,
		"bm": 1,
		"nm": "L.",
		"nf": "Caroline",
		"nl": "Manson",
		"url": "https://www.findagrave.com/memorial/148285748/caroline-l.-manson",
		"id": 148285748,
		"lng": -77.38702502,
		"lat": 37.53713068,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 12,
		"dd": 19,
		"by": 1913,
		"bd": 13,
		"bm": 3,
		"nm": "",
		"nf": "Julian",
		"nl": "Glover",
		"url": "https://www.findagrave.com/memorial/172693003/julian-glover",
		"id": 172693003,
		"lng": -77.38606381,
		"lat": 37.53623581,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 2,
		"dd": 17,
		"by": 1922,
		"bd": 13,
		"bm": 9,
		"nm": "",
		"nf": "Charles",
		"nl": "Goodson",
		"url": "https://www.findagrave.com/memorial/219983916/charles-goodson",
		"id": 219983916,
		"lng": -77.38609225,
		"lat": 37.53628165,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1974,
		"dm": 9,
		"dd": 30,
		"by": 1896,
		"bd": 27,
		"bm": 4,
		"nm": "",
		"nf": "Clarence",
		"nl": "Rudd",
		"url": "https://www.findagrave.com/memorial/160335463/clarence-j._windy-rudd",
		"id": 160335463,
		"lng": -77.38610988,
		"lat": 37.53633036,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1975,
		"dm": 1,
		"dd": 4,
		"by": 1892,
		"bd": 16,
		"bm": 11,
		"nm": "",
		"nf": "Charles",
		"nl": "Davis",
		"url": "https://www.findagrave.com/memorial/219985007/charles-davis",
		"id": 219985007,
		"lng": -77.38605473,
		"lat": 37.53623032,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 7,
		"dd": 30,
		"by": 1924,
		"bd": 1,
		"bm": 12,
		"nm": "",
		"nf": "Edna",
		"nl": "Tolliver",
		"url": "https://www.findagrave.com/memorial/155989152/edna-tolliver",
		"id": 155989152,
		"lng": -77.38631598,
		"lat": 37.53529407,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 3,
		"dd": 29,
		"by": 1950,
		"bd": 29,
		"bm": 3,
		"nm": "",
		"nf": "Baby",
		"nl": "Lewis",
		"url": "https://www.findagrave.com/memorial/125313034/baby-lewis",
		"id": 125313034,
		"lng": -77.38590004,
		"lat": 37.53688939,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1964,
		"dm": 4,
		"dd": 8,
		"by": 1883,
		"bd": 3,
		"bm": 12,
		"nm": "A.",
		"nf": "Willie",
		"nl": "Sessoms",
		"url": "https://www.findagrave.com/memorial/197602147/willie-a.-sessoms",
		"id": 197602147,
		"lng": -77.38746256,
		"lat": 37.53741863,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1961,
		"dm": 8,
		"dd": 23,
		"by": 1908,
		"bd": 12,
		"bm": 2,
		"nm": "Theo",
		"nf": "Nancy",
		"nl": "Epps",
		"url": "https://www.findagrave.com/memorial/191519035/nancy-theo-epps",
		"id": 191519035,
		"lng": -77.38636522,
		"lat": 37.53752445,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1936,
		"dm": 4,
		"dd": 2,
		"by": 1922,
		"bd": 12,
		"bm": 6,
		"nm": "",
		"nf": "Alfred",
		"nl": "Hamilton",
		"url": "https://www.findagrave.com/memorial/171761588/alfred-e.-hamilton",
		"id": 171761588,
		"lng": -77.38723283,
		"lat": 37.53680709,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 12,
		"dd": 12,
		"by": 1908,
		"bd": 15,
		"bm": 6,
		"nm": "",
		"nf": "Willie",
		"nl": "Bryant",
		"url": "https://www.findagrave.com/memorial/210408018/willie-bryant",
		"id": 210408018,
		"lng": -77.38655108,
		"lat": 37.5369212,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1978,
		"dm": 11,
		"dd": 27,
		"by": 1909,
		"bd": 16,
		"bm": 3,
		"nm": "",
		"nf": "Roosevelt",
		"nl": "Williams",
		"url": "https://www.findagrave.com/memorial/183718595/roosevelt-williams",
		"id": 183718595,
		"lng": -77.3869022,
		"lat": 37.53704871,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1976,
		"dm": 12,
		"dd": 4,
		"by": 1912,
		"bd": 23,
		"bm": 6,
		"nm": "Mae",
		"nf": "Beulah",
		"nl": "Jackson",
		"url": "https://www.findagrave.com/memorial/220346559/beulah-mae-jackson",
		"id": 220346559,
		"lng": -77.38802375,
		"lat": 37.53739563,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 26,
		"by": 1912,
		"bd": 24,
		"bm": 4,
		"nm": "D.",
		"nf": "Douglas",
		"nl": "Bluford",
		"url": "https://www.findagrave.com/memorial/220346845/douglas-d.-bluford",
		"id": 220346845,
		"lng": -77.38634767,
		"lat": 37.53669815,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 9,
		"dd": 9,
		"by": 1892,
		"bd": 14,
		"bm": 9,
		"nm": "",
		"nf": "Jeroline",
		"nl": "Hill",
		"url": "https://www.findagrave.com/memorial/220501464/jeroline-hill",
		"id": 220501464,
		"lng": -77.38641238,
		"lat": 37.53717896,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1932,
		"dm": 1,
		"dd": 21,
		"by": 1861,
		"bd": 22,
		"bm": 2,
		"nm": "Taylor",
		"nf": "Alice",
		"nl": "Haywood",
		"url": "https://www.findagrave.com/memorial/220538220/alice-taylor-haywood",
		"id": 220538220,
		"lng": -77.38806919,
		"lat": 37.53745599,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1959,
		"dm": 4,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Lewis",
		"nl": "Lacy",
		"url": "https://www.findagrave.com/memorial/220596925/lewis-j.-lacy",
		"id": 220596925,
		"lng": -77.38681504,
		"lat": 37.53747925,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 7,
		"dd": 14,
		"by": 1910,
		"bd": 10,
		"bm": 5,
		"nm": "",
		"nf": "Charlie",
		"nl": "Bines",
		"url": "https://www.findagrave.com/memorial/184094501/charlie-bines",
		"id": 184094501,
		"lng": -77.38724361,
		"lat": 37.53750509,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1955,
		"dm": 2,
		"dd": 5,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Nannie",
		"nl": "Barner",
		"url": "https://www.findagrave.com/memorial/220598285/nannie-barner",
		"id": 220598285,
		"lng": -77.38745629,
		"lat": 37.53761541,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 3,
		"dd": 3,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ernest",
		"nl": "Lewis",
		"url": "https://www.findagrave.com/memorial/220908969/ernest-lewis",
		"id": 220908969,
		"lng": -77.38666177,
		"lat": 37.53692966,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1950,
		"dm": 10,
		"dd": 18,
		"by": 1890,
		"bd": 4,
		"bm": 2,
		"nm": "",
		"nf": "Sallie",
		"nl": "Harper",
		"url": "https://www.findagrave.com/memorial/168953101/sallie-harper",
		"id": 168953101,
		"lng": -77.386552,
		"lat": 37.53691579,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1965,
		"dm": 3,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Floyd",
		"nl": "McQuinn",
		"url": "https://www.findagrave.com/memorial/183818858/floyd-unknown",
		"id": 183818858,
		"lng": -77.38644395,
		"lat": 37.53666671,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1956,
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Baby",
		"nl": "Everett",
		"url": "https://www.findagrave.com/memorial/220945797/baby-everett",
		"id": 220945797,
		"lng": -77.38732005,
		"lat": 37.53792027,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1972,
		"dm": 8,
		"dd": 3,
		"by": "",
		"bd": 8,
		"bm": 1,
		"nm": "",
		"nf": "Leslie",
		"nl": "Freeman",
		"url": "https://www.findagrave.com/memorial/220945161/leslie-freeman",
		"id": 220945161,
		"lng": -77.38741707,
		"lat": 37.53754669,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1967,
		"dm": 8,
		"dd": 26,
		"by": "",
		"bd": 25,
		"bm": 12,
		"nm": "",
		"nf": "Mary",
		"nl": "Bennett",
		"url": "https://www.findagrave.com/memorial/221662211/mary-starke-bennett",
		"id": 221662211,
		"lng": -77.38661395,
		"lat": 37.53721585,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1962,
		"dm": 9,
		"dd": 2,
		"by": 1897,
		"bd": 27,
		"bm": 1,
		"nm": "H.",
		"nf": "Annie",
		"nl": "Porter",
		"url": "https://www.findagrave.com/memorial/158450806/annie-h.-porter",
		"id": 158450806,
		"lng": -77.387661,
		"lat": 37.53755596,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1969,
		"dm": 2,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Shelman",
		"url": "https://www.findagrave.com/memorial/195459855/mary-shelman",
		"id": 195459855,
		"lng": -77.3875175,
		"lat": 37.5376467,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1949,
		"dm": 2,
		"dd": 26,
		"by": 1923,
		"bd": 13,
		"bm": 1,
		"nm": "",
		"nf": "Orrin",
		"nl": "Scott",
		"url": "https://www.findagrave.com/memorial/186083752/orrin-scott",
		"id": 186083752,
		"lng": -77.38675759,
		"lat": 37.53688504,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1939,
		"dm": 11,
		"dd": 8,
		"by": 1858,
		"bd": 22,
		"bm": 2,
		"nm": "",
		"nf": "Junius",
		"nl": "Corbett",
		"url": "https://www.findagrave.com/memorial/223286961/unknown-unknown",
		"id": 223286961,
		"lng": -77.38629903,
		"lat": 37.53550652,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1973,
		"dm": 11,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Unknown",
		"nl": "Unknown",
		"url": "https://www.findagrave.com/memorial/215186538/junius-corbett",
		"id": 215186538,
		"lng": -77.38617578,
		"lat": 37.53737783,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 4,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Charles",
		"nl": "White",
		"url": "https://www.findagrave.com/memorial/224682343/charles-white",
		"id": 224682343,
		"lng": -77.38649977,
		"lat": 37.53556195,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1916,
		"dm": 4,
		"dd": 23,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Joseph",
		"nl": "Morgan",
		"url": "https://www.findagrave.com/memorial/225145676/joseph-morgan",
		"id": 225145676,
		"lng": -77.38650829,
		"lat": 37.53557601,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1934,
		"dm": 8,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "H.",
		"nf": "P.",
		"nl": "Allen",
		"url": "https://www.findagrave.com/memorial/225286384/patrick-henry-allen",
		"id": 225286384,
		"lng": -77.38648579,
		"lat": 37.5355512,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1970,
		"dm": 7,
		"dd": 14,
		"by": 1901,
		"bd": 22,
		"bm": 1,
		"nm": "",
		"nf": "Pearl",
		"nl": "Allen",
		"url": "https://www.findagrave.com/memorial/225286636/pearl-allen",
		"id": 225286636,
		"lng": -77.38648387,
		"lat": 37.53555507,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1907,
		"dm": "",
		"dd": "",
		"by": 1831,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Martha",
		"nl": "Fields",
		"url": "https://www.findagrave.com/memorial/228424126/martha-fields",
		"id": 228424126,
		"lng": -77.38684145,
		"lat": 37.53590361,
		"n": "",
		"t": "Highly Accurate"
	},
	{
		"dy": 1953,
		"dm": 6,
		"dd": 27,
		"by": 1878,
		"bd": 3,
		"bm": 4,
		"nm": "",
		"nf": "Mary",
		"nl": "Harris",
		"url": "https://www.findagrave.com/memorial/144370317/mary-harris",
		"id": 144370317,
		"lng": -77.38583873,
		"lat": 37.53680061,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1953,
		"dm": 1,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Henry",
		"nf": "Charles",
		"nl": "Bryde",
		"url": "https://findagrave.com/memorial/185307467",
		"id": 185307467,
		"lng": -77.38721,
		"lat": 37.53764,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": 1961,
		"dm": 11,
		"dd": 19,
		"by": 1900,
		"bd": 7,
		"bm": 6,
		"nm": "Fariall",
		"nf": "Marion",
		"nl": "Gary",
		"url": "https://findagrave.com/memorial/177617281",
		"id": 177617281,
		"lng": -77.38662,
		"lat": 37.537449,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": 1977,
		"dm": 8,
		"dd": 16,
		"by": 1891,
		"bd": 31,
		"bm": 12,
		"nm": "",
		"nf": "Elizabeth",
		"nl": "Jackson",
		"url": "https://findagrave.com/memorial/183587453",
		"id": 183587453,
		"lng": -77.386162,
		"lat": 37.53685,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": 1964,
		"dm": "",
		"dd": "",
		"by": 1889,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Samuel",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/187354570",
		"id": 187354570,
		"lng": -77.38755,
		"lat": 37.537437,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": 1976,
		"dm": 2,
		"dd": 11,
		"by": 1900,
		"bd": 1,
		"bm": 7,
		"nm": "",
		"nf": "Odessa",
		"nl": "Vines",
		"url": "https://findagrave.com/memorial/172693016",
		"id": 172693016,
		"lng": -77.386004,
		"lat": 37.536324,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Freddie",
		"nl": "Peterson",
		"url": "https://www.findagrave.com/memorial/170838280/freddie-peterson",
		"id": 170838280,
		"lng": -77.386431,
		"lat": 37.537201,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mary",
		"nl": "Farrell",
		"url": "https://www.findagrave.com/memorial/187351671/mary-farrell",
		"id": 187351671,
		"lng": -77.38743,
		"lat": 37.53731,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Find A Grave"
	},
	{
		"dy": 1966,
		"dm": 3,
		"dd": 9,
		"by": 1966,
		"bd": 1,
		"bm": 3,
		"nm": "Denise",
		"nf": "Sharon",
		"nl": "Anthony",
		"url": "https://findagrave.com/memorial/151929431",
		"id": 151929431,
		"lng": -77.38577011,
		"lat": 37.53678583,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1977,
		"dm": 2,
		"dd": 20,
		"by": 1903,
		"bd": 3,
		"bm": 3,
		"nm": "C.",
		"nf": "Ernest",
		"nl": "Bates",
		"url": "https://findagrave.com/memorial/159877888",
		"id": 159877888,
		"lng": -77.38577579,
		"lat": 37.53678402,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1977,
		"dm": 8,
		"dd": 9,
		"by": 1903,
		"bd": 3,
		"bm": 11,
		"nm": "M.",
		"nf": "Henry",
		"nl": "Booker",
		"url": "https://findagrave.com/memorial/128632046",
		"id": 128632046,
		"lng": -77.38577905,
		"lat": 37.53678795,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1956,
		"dm": 9,
		"dd": 9,
		"by": 1895,
		"bd": 23,
		"bm": 3,
		"nm": "",
		"nf": "Jane",
		"nl": "Bridy",
		"url": "https://findagrave.com/memorial/144367905",
		"id": 144367905,
		"lng": -77.38578366,
		"lat": 37.53678595,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1972,
		"dm": 2,
		"dd": 27,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Lillian",
		"nl": "Cobb",
		"url": "https://findagrave.com/memorial/161563065",
		"id": 161563065,
		"lng": -77.38578695,
		"lat": 37.5367898,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1978,
		"dm": 2,
		"dd": 8,
		"by": 1924,
		"bd": 15,
		"bm": 12,
		"nm": "S.",
		"nf": "Malachai",
		"nl": "Damon",
		"url": "https://findagrave.com/memorial/117180898",
		"id": 117180898,
		"lng": -77.38579189,
		"lat": 37.53678794,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1964,
		"dm": 10,
		"dd": 3,
		"by": 1925,
		"bd": 24,
		"bm": 11,
		"nm": "",
		"nf": "Carolyn",
		"nl": "Fisher",
		"url": "https://findagrave.com/memorial/173106918",
		"id": 173106918,
		"lng": -77.38579489,
		"lat": 37.53679166,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1954,
		"dm": 11,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lucille",
		"nf": "Pearlie",
		"nl": "Green",
		"url": "https://findagrave.com/memorial/141658020",
		"id": 141658020,
		"lng": -77.38579956,
		"lat": 37.53679002,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1963,
		"dm": 8,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Edgar",
		"nl": "Haskins",
		"url": "https://findagrave.com/memorial/192002722",
		"id": 192002722,
		"lng": -77.3858029,
		"lat": 37.53679362,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1948,
		"dm": 6,
		"dd": 15,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Theodore",
		"nl": "Hill",
		"url": "https://findagrave.com/memorial/146339064",
		"id": 146339064,
		"lng": -77.38580819,
		"lat": 37.53679237,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1972,
		"dm": 8,
		"dd": 7,
		"by": 1947,
		"bd": 6,
		"bm": 5,
		"nm": "",
		"nf": "Nathaniel",
		"nl": "Hope",
		"url": "https://findagrave.com/memorial/159850640",
		"id": 159850640,
		"lng": -77.38581164,
		"lat": 37.53679638,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1964,
		"dm": 9,
		"dd": 27,
		"by": 1917,
		"bd": 17,
		"bm": 5,
		"nm": "Edward",
		"nf": "William",
		"nl": "Howard",
		"url": "https://findagrave.com/memorial/172999043",
		"id": 172999043,
		"lng": -77.3858177,
		"lat": 37.53679498,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1962,
		"dm": 2,
		"dd": 22,
		"by": 1923,
		"bd": 7,
		"bm": 5,
		"nm": "",
		"nf": "Mary",
		"nl": "Hubbard",
		"url": "https://findagrave.com/memorial/177354172",
		"id": 177354172,
		"lng": -77.38582157,
		"lat": 37.53679904,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1960,
		"dm": 1,
		"dd": 2,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Clarice",
		"nl": "James",
		"url": "https://findagrave.com/memorial/160053484",
		"id": 160053484,
		"lng": -77.38582804,
		"lat": 37.5367977,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1978,
		"dm": 2,
		"dd": 16,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Lee Dennis",
		"nf": "Walter",
		"nl": "Johnson",
		"url": "https://findagrave.com/memorial/130693683",
		"id": 130693683,
		"lng": -77.38583192,
		"lat": 37.5368022,
		"n": "This point is a placeholder for a marker that could not be located again after initial documentation.",
		"t": "No GPS"
	},
	{
		"dy": 1979,
		"dm": 2,
		"dd": 11,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "J.",
		"nf": "Mary",
		"nl": "Wood",
		"url": "https://findagrave.com/memorial/130737053",
		"id": 130737053,
		"lng": -77.38633592,
		"lat": 37.53695892,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Assumed"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "Abdul",
		"nf": "Rahman",
		"nl": "Williamson",
		"url": "https://www.findagrave.com/memorial/125644026/rahman-abdul-williamson",
		"id": 125644026,
		"lng": -77.38621305,
		"lat": 37.53686115,
		"n": "This marker was originally documented near this point but could not be located when confirming points for accuracy.",
		"t": "Assumed"
	},
	{
		"dy": 1918,
		"dm": 10,
		"dd": 11,
		"by": 1872,
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Celista",
		"nl": "Winslow",
		"url": "https://www.findagrave.com/memorial/151448729/celista-winslow",
		"id": 151448729,
		"lng": -77.38691295,
		"lat": 37.53554458,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1915,
		"dm": 3,
		"dd": 21,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Mildred",
		"nl": "Coles",
		"url": "https://www.findagrave.com/memorial/155984790/mildred-coles",
		"id": 155984790,
		"lng": -77.38725571,
		"lat": 37.5355603,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1920,
		"dm": 9,
		"dd": 28,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Hardinia",
		"nl": "Willis",
		"url": "https://www.findagrave.com/memorial/125859692/hardinia-willis",
		"id": 125859692,
		"lng": -77.38659775,
		"lat": 37.53586968,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": "",
		"dm": "",
		"dd": "",
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "R.",
		"nf": "Hugh",
		"nl": "Williams",
		"url": "https://www.findagrave.com/memorial/78060051/hugh-r-williams",
		"id": 78060051,
		"lng": -77.38743582,
		"lat": 37.5366122,
		"n": "This person is buried in a different cemetery but is noted on the family plot sill.",
		"t": "Named Memorial"
	},
	{
		"dy": 1928,
		"dm": 3,
		"dd": 1,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "E.",
		"nf": "Mary",
		"nl": "Tomlin",
		"url": "https://www.findagrave.com/memorial/160639670/mary-e.-tomlin",
		"id": 160639670,
		"lng": -77.38604429,
		"lat": 37.53680872,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1928,
		"dm": 6,
		"dd": 25,
		"by": "",
		"bd": "",
		"bm": "",
		"nm": "",
		"nf": "Ella",
		"nl": "Gray",
		"url": "https://www.findagrave.com/memorial/145638801/ella-gray",
		"id": 145638801,
		"lng": -77.38776424,
		"lat": 37.53698323,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1979,
		"dm": 3,
		"dd": 16,
		"by": 1919,
		"bd": 4,
		"bm": 10,
		"nm": "C.",
		"nf": "Raymond",
		"nl": "Chapman",
		"url": "https://www.findagrave.com/memorial/150078581/raymond-c.-chapman",
		"id": 150078581,
		"lng": -77.38802753,
		"lat": 37.53753343,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1966,
		"dm": 7,
		"dd": 7,
		"by": 1914,
		"bd": 3,
		"bm": 8,
		"nm": "",
		"nf": "Sandy",
		"nl": "Hudson",
		"url": "https://www.findagrave.com/memorial/125820817/sandy-hudson",
		"id": 125820817,
		"lng": -77.38633143,
		"lat": 37.53707049,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1947,
		"dm": 11,
		"dd": 15,
		"by": 1895,
		"bd": 3,
		"bm": 7,
		"nm": "J.",
		"nf": "William",
		"nl": "Temple",
		"url": "https://www.findagrave.com/memorial/125408710/william-j.-temple",
		"id": 125408710,
		"lng": -77.3858972,
		"lat": 37.53693854,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1966,
		"dm": 11,
		"dd": 11,
		"by": 1937,
		"bd": 10,
		"bm": 11,
		"nm": "",
		"nf": "Victoria",
		"nl": "Arrington",
		"url": "https://www.findagrave.com/memorial/145167317/victoria-arrington",
		"id": 145167317,
		"lng": -77.38620841,
		"lat": 37.53713679,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	},
	{
		"dy": 1965,
		"dm": 6,
		"dd": 25,
		"by": 1963,
		"bd": 28,
		"bm": 12,
		"nm": "",
		"nf": "Kelvin",
		"nl": "Moore",
		"url": "https://www.findagrave.com/memorial/144558536/kelvin-moore",
		"id": 144558536,
		"lng": -77.38607169,
		"lat": 37.53744495,
		"n": "This person has another marker in a different section of the cemetery.",
		"t": "Duplicate"
	}
];


//////////////////
// WEBPACK FOOTER
// ./public/data/gravestones.json
// module id = 186
// module chunks = 0